/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_TouchPanel_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_string_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Random_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_addEventListener_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_setZeroTimeout_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Logger_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_copyToClipboard_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_binarySearch_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Heap_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Element_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_config_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Encoding_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_SubWindow_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Menu_js__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TouchPanel", function() { return __WEBPACK_IMPORTED_MODULE_0__util_TouchPanel_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S2D", function() { return __WEBPACK_IMPORTED_MODULE_1__util_string_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DateToString", function() { return __WEBPACK_IMPORTED_MODULE_1__util_string_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D2S", function() { return __WEBPACK_IMPORTED_MODULE_1__util_string_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N2S", function() { return __WEBPACK_IMPORTED_MODULE_1__util_string_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S2N", function() { return __WEBPACK_IMPORTED_MODULE_1__util_string_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Random", function() { return __WEBPACK_IMPORTED_MODULE_2__util_Random_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addEventListener", function() { return __WEBPACK_IMPORTED_MODULE_3__util_addEventListener_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setZeroTimeout", function() { return __WEBPACK_IMPORTED_MODULE_4__util_setZeroTimeout_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return __WEBPACK_IMPORTED_MODULE_5__util_Logger_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "copyToClipboard", function() { return __WEBPACK_IMPORTED_MODULE_6__util_copyToClipboard_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "binarySearch", function() { return __WEBPACK_IMPORTED_MODULE_7__util_binarySearch_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Heap", function() { return __WEBPACK_IMPORTED_MODULE_8__util_Heap_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Element", function() { return __WEBPACK_IMPORTED_MODULE_9__util_Element_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return __WEBPACK_IMPORTED_MODULE_10__config_config_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Encoding", function() { return __WEBPACK_IMPORTED_MODULE_11__util_Encoding_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubWindow", function() { return __WEBPACK_IMPORTED_MODULE_12__util_SubWindow_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_13__util_Menu_js__["a"]; });











 // #82
 // #95
 // #95




/** ie11 互換用 * */
if(!Number.MAX_SAFE_INTEGER) Number.MAX_SAFE_INTEGER = 9007199254740991; // #59
if(!Number.MIN_SAFE_INTEGER) Number.MIN_SAFE_INTEGER = -9007199254740991;

if(!Uint8Array.prototype.indexOf){
    Uint8Array.prototype.indexOf = function(target,index){
        index = (index === undefined) ? 0 : index;  // #29
        for(var i = index, last = index + 4096; i < last; i++){ // 暫定：1レコード4KBまでチェック
            if(this[i] === target) return i;
        }
        return -1;
    };
}
if (!Uint8Array.prototype.slice) {  // #29
    Uint8Array.prototype.slice = function(begin, end) {
        return this.subarray(begin, end);
    };
}
// https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function(predicate) {
      if (this === null) throw new TypeError('Array.prototype.findIndex called on null or undefined');
      if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
      var list = Object(this), length = list.length >>> 0, thisArg = arguments[1], value;
      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) return i;
      }
      return -1;
    };
  }
// https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/find
if (!Array.prototype.find) {
    Array.prototype.find = function(predicate) {
      if (this === null) throw new TypeError('Array.prototype.find called on null or undefined');
      if (typeof predicate !== 'function')  throw new TypeError('predicate must be a function');
      var list = Object(this), length = list.length >>> 0, thisArg = arguments[1], value;
      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list))  return value;
      }
      return undefined;
    };
  }

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = Graph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__simulator_simulator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tatLogDiver_Menu_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_Init_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timeSeries_timeSeries_js__ = __webpack_require__(5);







/* ******1*********2*********3*********4*********5*********6*********7****** */

/**
 * インスタンス内の定数を設定する。併せて性能対策として頻繁に使うDOM要素を取り込む
 * 
 * @memberof tatLogDiver
 * @class Graph
 * @classdesc TAT(Turnaround time)ログ分析用グラフ
 * @param {string}
 *            chartIdName グラフを作成するHTML要素のID
 * @param {string}
 *            [globalName="HJN.chartD"] グラフのID
 * @param {Object}
 *            [config] グラフの設定
 * @example HJN.chart = new HJN(chartName, "HJN.chart"); HJN.chart.init();
 *          HJN.chartD = new HJN(chartName + "Detail", "HJN.chartD");
 *          HJN.chartD.init();
 */
function Graph(chartIdName, globalName, config) {
    /* メンバ変数 */
    this.seriesSet = [];
    this.chartIdName = chartIdName; // arg0 "chart","chartD"
    this.globalName = globalName || "HJN.chartD"; // arg1
    if (!config) { // arg2
        var isMain = (globalName === "HJN.chart") ? true : false;
        config = {
            SERIESES: [ 
                { n: HJN.Tat.CONC.N, process: !isMain, visiblity: !isMain, renderer: 'area' },
                { n: HJN.Tat.CTPS.N, process: true,    visiblity: true,    renderer: isMain ? 'scatterplot' : 'bar' },
                { n: HJN.Tat.ETPS.N, process: true,    visiblity: isMain,  renderer: 'line' },
                { n: HJN.Tat.STAT.N, process: !isMain, visiblity: !isMain, renderer: 'scatterplot' },
                { n: HJN.Tat.ETAT.N, process: !isMain, visiblity: !isMain, renderer: 'scatterplot' },
                { n: HJN.Tat.EMPS.N, process: true,    visiblity: true,    renderer: 'line' }, 
                { n: HJN.Tat.EAPS.N, process: true,    visiblity: isMain,  renderer: 'line' } ],
            height : 0.40,
            isVisiblity : true
        };
    }

    // File.Parserを設定する
    this.fileParser = __WEBPACK_IMPORTED_MODULE_4__timeSeries_timeSeries_js__["b" /* FileParser */](); // #24
   
    // グラフ定義領域の宣言
    this.windowId = document.getElementById("hjn_chart");
    this.menuId = document.getElementById("hjnBoxBuger");
    this.menuPlaceOnId = document.getElementById("hjnBoxPlaceOn");
    this.chartId = document.getElementById(this.chartIdName);
    this.dyData = [];
    this.dySeries = {};

    this.scale = [ null, null ];
    this.graph = null;
    this.cTpsUnit = __WEBPACK_IMPORTED_MODULE_4__timeSeries_timeSeries_js__["e" /* Tat */].UNIT_CTPS[0]; // #75

    // グラフの設定(処理対象データの設定のみ this.SERIESES[] に取り込む）
    this.SERIESES = [];
    this.labels = [ 'Date' ];
    for (var i = 0, j = 0; i < config.SERIESES.length; i++) {
        if (config.SERIESES[i].process === true) {
            this.SERIESES[j] = {
                key : '',
                name : '',
                visiblity : false,
                renderer : '',
                order : 0,
                scale : 0,
                color : ''
            };
            // 定数(HJN.Tat.seriesConfig)指定項目を設定する
            for ( var attr in HJN.Tat.seriesConfig[i]) {
                this.SERIESES[j][attr] = HJN.Tat.seriesConfig[i][attr];
            }
            // 引数(config)指定項目を設定する
            this.SERIESES[j].visiblity = config.SERIESES[i].visiblity;
            this.SERIESES[j].renderer = config.SERIESES[i].renderer;

            var renderer = config.SERIESES[i].renderer;
            if (renderer === 'scatterplot') {
                this.dySeries[this.SERIESES[j].key] = {
                    strokeWidth : 0.0,
                    drawPoints : true
                };
            } else if (renderer === 'line') {
                this.dySeries[this.SERIESES[j].key] = {
                    strokeWidth : 2.0,
                    connectSeparatedPoints : true,
                    stepPlot : true
                };
            } else if (renderer === 'area') {
                this.dySeries[this.SERIESES[j].key] = {
                    strokeWidth : 0.0,
                    stepPlot : true,
                    fillGraph : true
                };
            } else { // if (renderer === 'bar' ) {
                this.dySeries[this.SERIESES[j].key] = {
                    strokeWidth : 0.0,
                    connectSeparatedPoints : true,
                    stepPlot : true,
                    fillGraph : true
                };
            }
            this.dySeries[this.SERIESES[j].key].color = this.SERIESES[j].color;

            if (this.SERIESES[j].scale === 1) {
                this.dySeries[this.SERIESES[j].key].axis = 'y2';
            }

            this.labels.push(this.SERIESES[j].key);
            j++;
        }
    }

    this.height = config.height;
    this.isVisiblity = config.isVisiblity;
};

/**
 * クラス定数
 */
// Graph.prototype = {};

/**
 * クラスメソッド：menuのFilterのｘｙ幅指定エリアにグラフのｘｙ幅を設定する<br>
 * dygraphのdrawCallbackに設定する関数<br>
 * menuのRadio(F_SYNC)選択時に呼び出す関数（このためにクラスメソッド）
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.DrawCallback = function (g, is_initial) { // #50 #51
    // 初期表示時は、メニューを設定しない
    if (is_initial)
        return;
    // Filterメニューで指定されている F_SYNC の状態を取得する
    var syncMode = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].Filter.getValueByKey("F_SYNC"); // #59
    // "F_SYNC_UPPER"かつ上段グラフ もしくは、"F_SYNC_DETAIL"かつ下段グラフのとき処理する
    if ((syncMode === "F_SYNC_UPPER" && g.HJN === HJN.chart)
            || (syncMode === "F_SYNC_DETAIL" && g.HJN === HJN.chartD)) {
        // ｘ軸の幅をFilterメニューフェールドに反映する
        setText("Filter.F_TIME_FROM", __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](g.xAxisRange()[0],
                "yyyy/MM/dd hh:mm:ss.000", true)); // #92
        setText("Filter.F_TIME_TO", __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](g.xAxisRange()[1],
                "yyyy/MM/dd hh:mm:ss.000", true)); // #92
        // ｙ軸(右)の幅をFilterメニューフェールドに反映する
        setText("Filter.F_TAT_FROM", +(g.yAxisRange(1)[0].toPrecision(4)));
        setText("Filter.F_TAT_TO", +(g.yAxisRange(1)[1].toPrecision(4)));
    }

    function setText(id, val) {
        document.getElementById(id).value = val;
        document.getElementById(id).onchange();
    }
};

/**
 * グラフを初期化する
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.prototype.init = function () {
    // メニューを作成する
    Object(__WEBPACK_IMPORTED_MODULE_2__tatLogDiver_Menu_js__["default"])(this);
    // 凡例を作成する
    if (this.isVisiblity)
        addLegend(this);
    // 既にグラフがあるときは削除する
    if (this.graph) {
        this.graph.HJN = null; // （注：循環参照対策
        this.graph.destroy();
    }
    // ウィンドウ枠に合わせて描画領域をリサイズするイベントを登録し、リサイズする
    window.addEventListener("resize", this.resize.bind(this));
    // tablet回転時も、リサイズする #22
    window.addEventListener("orientationchange", this.resize.bind(this));
    var resizes = document.getElementsByClassName("hjnResize");
    for (var i = 0; i < resizes.length; i++) {
        resizes[i].addEventListener("change", this.resize.bind(this)); // メニュ－の開閉
        // #31
    }

    // legendを追加する（内部関数）
    function addLegend(that) { // arg0 : this
        var chartIdName = that.chartIdName;
        var serieses = that.SERIESES;
        var divLegend = document.getElementById(chartIdName + "_legend");
        var formName = chartIdName + "_LegendForm";
        var htmlText = '<form name="' + formName + '">';
        for (var i = 0; i < serieses.length; i++) {
            var ckBox = serieses[i].visiblity ? 'checked="checked"' : '';
            htmlText += '<label class="legend" style="background:'
                        + serieses[i].color + ';">' 
                    + '<input type="checkbox" '
                        + 'name="' + serieses[i].key + '"' + 'onclick="'
                        + that.globalName + '.onClickSetVisibility(' + i + ');" '
                        + ckBox + '>' 
                    + serieses[i].name 
                    + '</label><BR>';
        }
        htmlText += '</form>';
        divLegend.innerHTML = htmlText;
    }
};

/**
 * legendの表示指定をグラフに反映する(onclick呼出用）
 * 
 * @memberof tatLogDiver.Graph
 * @param {index}
 *            i seriesSet配列の設定変更するグラフのインデックス
 */
Graph.prototype.onClickSetVisibility = function (i) { //
    var formName = this.chartIdName + "_LegendForm";
    var ck = document[formName].elements[i].checked;
    this.graph.setVisibility(i, ck);
};

/**
 * ウィンドウ枠に合わせて描画領域をリサイズする（dygraphは幅は自動、高さは指定）
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.prototype.resize = function () {
    // 幅（メニューの状態に合わせて計算） #31
    var dWidth = 0;
    if (this.menuId.checked && !this.menuPlaceOnId.checked) {
        dWidth = this.menuId.parentNode.clientWidth;
    }
    var width = window.innerWidth - dWidth;
    this.windowId.style.width = width + "px";
    // 高さ（ウィンドウサイズの比率(this.height)をかけて算出）
    var height = Math.floor(window.innerHeight * this.height);
    this.chartId.style.height = height + "px";

    if (this.graph)
        this.graph.resize(width, height);
    return height;
};

/**
 * seriesSetを取り込む
 * 
 * @memberof tatLogDiver.Graph
 * @param {Obcjet}
 *            [tat] 応答時間(Turnaround time)の時系列データ管理クラス
 * @param {array}
 *            [seriesSet] tat内の応答時間の時系列データ管理配列
 */
Graph.prototype.setSeriesSet = function (tat, seriesSet) { // #30
    if(tat) {
        this.seriesSet = tat.getSeriesSet();
        this.cTpsUnit = tat.getCTpsUnit(); // #75
    }
    if(seriesSet){
        this.seriesSet = seriesSet;
    }
    HJN.Tat.seriesConfig.forEach(function (e) {
        this[e.key] = this.seriesSet[e.N];
    }, this);
};


/**
 * データを変更し描画する
 * 
 * @memberof tatLogDiver.Graph
 * @param {seriesSet}
 *            seriesSet dygraph用時系列データ配列
 * @param {Integer}
 *            n 選択されたグラフのseriesSet配列位置
 */
Graph.prototype.update = function (seriesSet, n) {
    // 指定データがあるとき取り込む
    if (seriesSet) this.setSeriesSet(undefined, seriesSet);
    // dygraph用表示データを作成する
    var xy = [[{x:0,y:0}],[{x:0,y:0}],[{x:0,y:0}],[{x:0,y:0}]], // グラフデータの一覧（グラフ１本が配列要素）
        idx = [], // グラフデータの処理中配列位置を保有する配列
        x = [], // グラフデータの処理中配列のｘ(時刻)の値を保有する配列
        row = [], // dygraph１レコードワーク配列：（[x,y0,y1...]の配列）の一レコード分を保持する配列
        minX = 0,
        i = 0; // グラフ番号用ワーク
    // 表示対象データがないとき空データのdygraphを表示する #72
    if (this.seriesSet.length === 0) {
        var cols = [0]; // 日時（ミリ秒）
        for (i = 0; i < this.SERIESES.length; i++) cols[i+1] = null;
        this.dyData = [cols];
        if (this.graph) {
            // 既にグラフがあるときはデータのみ変更する（注：ここでdestroy()すると下段のpointClickCallback時にエラー）
            this.graph.updateOptions( {
                file : this.dyData
            } );
            this.graph.resetZoom(); // #51
        }
        return;
    }


    // xy[] に処理対象seriesを指定する
    for (i = 0; i < this.SERIESES.length; i++) {
        xy[i] = this.seriesSet[this.SERIESES[i].N];
        idx[i] = 0;
    }
    // dygraph表示時間帯を設定する（上段グラフは全期間が処理対象）
    var xRangeMin = Number.MIN_VALUE;
    var xRangeMax = Number.MAX_VALUE;
    var xRangeUnit = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_UNIT"); // #61
    if (HJN.chartD === this) { // 詳細（下段グラフ）のとき画面で指定された期間を設定する // ミリ秒
        var detailRangePlus = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_RANGE_PLUS"); // #27
        var detailRangeMinus = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_RANGE_MINUS");
        var detailRangeUnit = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_UNIT");
        var detailDateTime = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_TIME");
        if ((n === HJN.Tat.ETPS.N || n === HJN.Tat.EMPS.N || n === HJN.Tat.EAPS.N)  // #57
                && xRangeUnit < __WEBPACK_IMPORTED_MODULE_4__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE){ // #61
            var dt = Math.floor(detailDateTime / __WEBPACK_IMPORTED_MODULE_4__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE) * __WEBPACK_IMPORTED_MODULE_4__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE;
            xRangeMin = dt - detailRangeMinus * detailRangeUnit;
            xRangeMax = dt + detailRangePlus * detailRangeUnit;
        } else { // undefined, HJN.Tat.CTPS.N, HJN.Tat.CONC.N,
                    // HJN.Tat.STAT.N, HJN.Tat.ETAT.N
            var dt = Math.floor(detailDateTime / xRangeUnit) * xRangeUnit; // #61
            xRangeMin = dt - detailRangeMinus * detailRangeUnit; // #48
            xRangeMax = dt + detailRangePlus * detailRangeUnit; // #48
        }
    }

    // dygraph用arrayを空にする
    this.dyData = [];

    // 指定範囲の先頭が秒単位の端数のとき、dygraph用arrayに、先頭ワークデータを登録する #3
    var xVal = Math.floor(xRangeMin / 1000) * 1000;
    if (Number.MIN_VALUE < xRangeMin && xRangeMin !== xVal) { // 範囲指定（＝下段）
        var firstRow = [ xRangeMin ]; // 先頭はx（時刻）
        xy.forEach(function (xyData, i) {
            // 秒間最大値系のyは最大値or０を、他はnullを設定する
            var yVal = null;
            if (this.SERIESES[i].key === HJN.Tat.CTPS.key) {
                // 始端時刻を含む秒の値（最大値）を、始端時刻にセットする
                var j = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["binarySearch"](xVal, xyData, function (e) {
                    return e.x;
                });
                yVal = (0 <= j) ? xyData[j].y : 0;
            }
            firstRow.push(yVal);
        }, this);
        this.dyData.push(firstRow);
    }

    // dygraph用arrayに表示データを登録する
    while (xy.some(function (e, i) {
        return (idx[i] < e.length);
    })) {
        // dygraph１レコードワーク配列 を空にする
        row = [];
        // dygraph１レコードワーク配列 の先頭に、次に追加するｘ（時刻＝各ｘｙ処理位置が持つｘの最小値）を設定する
        xy.forEach(function (e, i) {
            x[i] = (idx[i] < e.length) ? e[idx[i]].x : Number.MAX_VALUE;
        });
        minX = x[0]; // minX = Math.min.apply(null, x);
        for (i = 1; i < x.length; i++) {
            if (x[i] < minX)
                minX = x[i];
        }
        row.push(minX); // ミリ秒
        // dygraph１レコードワーク配列 の２番目以降に、各ｘｙのｘを設定する
        xy.forEach(function (e, i) {
            if (e.length <= idx[i]) {
                row.push(null); // 末尾を過ぎたｘｙのyはnull
            } else if (e[idx[i]].x === minX) {
                // ｘｙのｘ(e[idx[i]].x)が、出力するｘ(minX)と同じとき、ｙを設定し、ｘｙの処理位置(idx[i])を次に進める
                row.push(e[idx[i]].y);
                idx[i]++;
            } else {
                row.push(null); // xと ｘｙのｘが異なる場合 null
            }
        });
        // dygraph用arrayに、編集したdygraph１レコードワーク配列 を登録する
        if (xRangeMin <= minX && minX <= xRangeMax) {
            this.dyData.push(row);
        }
    }
    // 指定範囲の先頭が秒単位の端数のとき、dygraph用arrayに、末尾ワークデータを登録する #3
    if (xRangeMax < Number.MAX_VALUE && // 範囲指定（＝下段）
    xRangeMax !== Math.floor(xRangeMax / 1000) * 1000) {
        var lastRow = [ xRangeMax ]; // 先頭はx（時刻）
        xy.forEach(function (e, i) { // 秒間最大値系のyは始端：最大値、終端：０を、他はnullを設定
            lastRow.push((this.SERIESES[i].key === HJN.Tat.CTPS.key) ? 0 : null);
        }, this);
        this.dyData.push(lastRow);
    }

    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[7:dygraph data created] "
            + this.dyData.length + " rows", "calc");

    // グラフの設定
    var visibility = [];
    if (this.isVisiblity) {
        // visiblity指定できるとき画面の表示指定を取り込む
        var inputs = document[this.chartIdName + "_LegendForm"];
        for (i = 0; i < this.SERIESES.length; i++) {
            visibility.push(inputs[this.SERIESES[i].key].checked);
        }
    } else {
        // visiblity指定できないとき、デフォルト設定を取り込む
        for (i = 0; i < this.SERIESES.length; i++) {
            visibility.push(this.SERIESES[i].visiblity);
        }
    }

    // グラフの作成
    if (this.graph) {
        // 既にグラフがあるときはデータのみ変更する（注：ここでdestroy()すると下段のpointClickCallback時にエラー）
        this.graph.updateOptions( {
            file : this.dyData
        } );
        this.graph.resetZoom(); // #51
    } else {
        // グラフが無いときは新規作成する
        this.graph = new Dygraph(this.chartId, this.dyData, {
            height : this.resize(),
            labels : this.labels,
            title : this === HJN.chart ? '' : '', // タイトル
            titleHeight : 10, // タイトルの高さ＆フォントサイズ（デフォルト18px)
            legend : 'always', // 'follow', //
            showLabelsOnHighlight : false, // 効果不明
            // labelsDiv : document.getElementById(HJN.chartName + 'Labels'), //
            // ラベル表示先の変更
            labelsSeparateLines : false,
            // legendFormatter: this.legendFormatter, // コメントアウトでlegendが非表示
            axes : {  // 軸の設定
                x : { // X軸の設定
                    axisLabelFormatter : xAxisLabelFormatter, // ラベル表示文字列編集関数
                    axisLabelWidth : 100        // X軸ラベルの表示幅（幅が不足すると文字が切れる）
                },
                y : { // Y2（左）軸の設定
                    independentTicks : true,    // 目盛合わせ（falseはY2軸に合わせる）
                    axisLabelWidth : 40,        // ラベル表示幅
                    // axisLineColor : 'rgb(0,0,0)',// 軸の色
                    // axisLabelFontSize : 14, // ラベルのフォントサイズ(デフォルト:14)
                    logscale : false            // 対数軸
                },
                y2 : { // Y2（右）軸の設定
                    axisLabelFormatter : yAxisLabelFormatter, // ラベル表示文字列編集関数
                    independentTicks : true,    // 目盛合わせ（falseはY1軸に合わせる）
                    axisLabelWidth : 65,        // ラベル表示幅
                    drawGrid : true,            // 横罫線
                    gridLinePattern : [ 1, 2 ], // 罫線形状（破線）
                    logscale : false            // 対数軸
                }
            },
            includeZero : true,
            // axisLabelFontSize: 10,
            axisLineColor : 'rgba(0, 0, 0, 0.2)',
            gridLineColor : 'rgba(0, 0, 0, 0.2)',
            strokeWidth : 2,
            pointSize : 3,
            ylabel: 'Number of transactions',
            y2label : 'Sec', // this === HJN.chart ? '' : 'Sec',
            // rollPeriod: 7,
            // errorBars: true,
            // showRangeSelector: true
            // drawPointCallback: drawPointCallback,
            drawHighlightPointCallback : drawHighlightPointCallback,
            highlightCircleSize : 3,
            highlightCallback : highlightCallback,
            pointClickCallback : pointClickCallback,
            annotationClickHandler : annotationClickHandler,
            annotationDblClickHandler : annotationDblClickHandler,
            // clickCallback: clickCallback,
            drawCallback : Graph.DrawCallback, // #50 #51
            highlightSeriesOpts : {
            // strokeWidth: 3,
            // strokeBorderWidth: 1,
            // highlightCircleSize: 5
            },
            series : this.dySeries,
            labelsKMB : true,
            visibility : visibility,
            interactionModel: { // #22
                mousedown: Dygraph.defaultInteractionModel.mousedown,
                willDestroyContextMyself: true,
                // touchstart: function(){}, 空functionと未登録は同じ効果
                // touchmove: function(){},
                // touchend: function(){},
                dblclick: Dygraph.defaultInteractionModel.dblclick
            },
            animatedZooms : true, // ズームするときのアニメーション有無（デフォルト:false）
            connectSeparatedPoints : true
        });
        // dygraphイベント処理でHJJを取れるように（注：循環参照）
        this.graph.HJN = this;
        // スマフォ対応 #22
        __WEBPACK_IMPORTED_MODULE_0__util_util_js__["TouchPanel"].DispatchEventTouchToMouse(this.graph.canvas_);
        __WEBPACK_IMPORTED_MODULE_0__util_util_js__["TouchPanel"].DispatchEventTouchToMouse(this.graph.canvas_ctx_.canvas);
    }
    // zoom reset ボタン追加 #22
    // this.addIcon_ZoomReset(); #78 グラフ毎から全体で一つに変更に伴いcall停止
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[8:dygraph showen] ", "calc");

    // 初期表示の不活性グラフの設定
    function xAxisLabelFormatter(d, gran, opts) {
        // return Dygraph.dateAxisLabelFormatter(new Date(d), gran, opts); #63
        var isTop = (this.xAxisRange()[0] === d);
        var format = "";
        var diffTime = this.xAxisRange()[1] - this.xAxisRange()[0];
        if (diffTime < 60000) { 
            format = isTop ? "hh:mm:ss.000" : "ss.000"; // #92
        } else if (diffTime < 86400000) { // 1日未満
            format = "hh:mm:ss";
        } else if (diffTime < 31536000000) { // 365日未満
            format = isTop ? "yyyy/MM/dd": "MM/dd hh";
        } else { // 365日以上
            format = "yyyy/MM/dd";
        }
        return __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](d,format,true);
    }
    function yAxisLabelFormatter(d, gran, opts) { // #63
        var range = this.yAxisRanges()[1];
        var format = "";
        var diff = range[1] - range[0];
        if (diff < 300000) { // 300秒未満
            return "" + d / 1000;
        } else if (diff < 86400000) { // 1日未満
            return __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](d, "hh:mm:ss", true);
        } else if (diff < 172800000) { // 2日未満
            var hours = Math.ceil(d / 3600000) + ":";
            return hours + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](d, "mm:ss", true);
        } else { // 2日以上
            var days = Math.ceil(d / 86400000) + " days+";
            var time = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](d, " hh:mm:ss", false);
            return (d < 172800000) ? time : days; // 2日未満？
        }
    }

    // 再描画する
    this.showBalloon();
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[9:balloon showen] ", "calc");

    // updateメソッド内部関数宣言
    // 点がハイライトになったときの描画処理（内部関数宣言） g:{dygraph} HJN.chartD.graph
    function drawHighlightPointCallback(g, name, ctx, cx, cy, color, r, idx) {
        // file dropのとき、新グラフデータに更新後に、旧グラフのidx値が引き渡されたとき 処理しない #12
        if (!g.rawData_ || g.rawData_.length - 1 < idx)
            return;
        var x = g.rawData_[idx][HJN.Tat.CONC.N]; // 選択されている点(時刻)のCONCのxの値（無いときundefined)
        var eTat = HJN.chart.eTat;
        var sTat = HJN.chart.sTat;
        var n = 0;

        // ETAT,STATのときlogレコードを表示する #28
        if ((name === HJN.Tat.STAT.key || name === HJN.Tat.ETAT.key)
                && typeof x != 'undefined') { // #41
            // eTatの配列位置をを求める
            if (name === HJN.Tat.ETAT.key) {
                // ETATのとき、終了時刻(x)からeTatの配列位置(n)を検索する
                n = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["binarySearch"](x, eTat, 
                                    function (e) { return e.x; });
            } else {
                // STATのとき、開始時刻(x)からsTatの配列位置(sTatN)を検索し、sTatからeTatの配列位置を取得する
                var sTatN = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["binarySearch"](x, sTat, 
                                    function (e) { return e.x; });
                n = sTat[sTatN].eTatIdx;
            }
            // ログデータを表示し、線を引く
            if (0 <= n) {
                // ログデータを取得する
                var e = eTat[n];
                var logRow = this.HJN.fileParser.getRecordAsText(e);
                // シミュレータ生成データでないとき、文字コード変換する #82
                if (typeof e.pos != "undefined") { 
                    var charset = HJN.Config.File.getConfig("CHAR");
                    logRow = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Encoding"].charset.convert(logRow, "Unicode", charset); 
                }
                // ログデータを表示する #62
                var iHtml = document.getElementById("lineViewer");
                iHtml.textContent = ""; // #82
                iHtml.insertAdjacentHTML('afterBegin', logRow);
                // 線を引く #30
                drawTatLine(ctx, e.x, e.y, 2, color);
                ctx.stroke();
            }
        }

        // CONCのとき同時処理の線を引く
        if (name === HJN.Tat.CONC.key && typeof eTat.tatMap != 'undefined') { // #17
            // #41
            // 指定時刻に動いているeTatの一覧(trans)を取得する
            var trans = eTat.tatMap.search(x, x, 1000); // #18
            // 以前に選択した線を消す
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            // 同時処理の線を引く
            if (0 <= i && 0 < trans.length) {
                // TRANS分の線を引く
                trans.forEach(function (e) {
                    drawTatLine(ctx, e.x, e.y, 1, HJN.Tat.CONC.color);
                });
            }
            ctx.stroke();
        }

        // 選択点の点と数値を表示する
        var val = "";
        var time = "";
        if (0 <= idx) {
            time = g.rawData_[idx][0]; // #60
            val = name ? g.rawData_[idx][g.setIndexByName_[name]] : "";
            // valが時間のとき、 時間表記に文字列編集する
            if (name === HJN.Tat.STAT.key || name === HJN.Tat.ETAT.key 
                    || name === HJN.Tat.EMPS.key || name === HJN.Tat.EAPS.key) {
                val = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](val);
            }
        }
        drawPoint(ctx, cx, cy, r, color, val, time);
        // 縦線を引く
        drawLine(ctx, [ {
            x : cx,
            y : 0
        }, {
            x : cx,
            y : ctx.canvas.height
        } ], 1, "rgba(127,127,127,0.5)", [ 1, 2 ]);

        // drawHighlightPointCallback 内部関数宣言
        // TAT線を表示する（内部関数）
        function drawTatLine(ctx, x, y, heigth, color) {
            // isXend指定の始点(false)／終点（true)に合わせて、線の座標を求める
            var tXs = g.toDomXCoord(x - y), // ミリ秒
            tXe = g.toDomXCoord(x), // ミリ秒
            tY = g.toDomYCoord(y, 1); // 第二軸:1
            drawLine(ctx, [ {
                x : tXs,
                y : tY
            }, {
                x : tXe,
                y : tY
            } ], heigth, color);
            drawPoint(ctx, tXs, tY, r, HJN.Tat.STAT.color);
            drawPoint(ctx, tXe, tY, r, HJN.Tat.ETAT.color);
        }

        // 線を表示する（内部関数）
        function drawLine(ctx, plots, r, color, lineDashSegments) {
            ctx.beginPath();
            ctx.lineWidth = r;
            ctx.lineCap = "round";
            ctx.strokeStyle = color;
            if (lineDashSegments)
                ctx.setLineDash(lineDashSegments); // lineDashは[num]
            ctx.moveTo(plots[0].x, plots[0].y);
            plots.forEach(function (p) {
                ctx.lineTo(p.x, p.y);
            });
            ctx.stroke();
        }

        // 点を表示する（内部関数）
        function drawPoint(ctx, cx, cy, r, color, val, time) {
            ctx.beginPath();
            ctx.strokeStyle = color;
            ctx.fillStyle = color;
            ctx.arc(cx, cy, r, 0, 2 * Math.PI, false);
            ctx.fill();
            ctx.stroke();
            var text = "";
            if (val || time) {
                if (typeof(val) === "number") {
                    text += Math.round(val * 10) / 10;
                } else if (typeof(val) === "string") { // #60
                    text += val;
                }
                if (val && time) text += " ";
                if (time) text += "[" + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](time, "hh:mm:ss.000", true) + "]"; // #60
                                                                                    // #92
                ctx.beginPath();
                ctx.fillStyle = color.replace(/\,[\s\.0-9]*\)/,",1)"); // #60
                ctx.textAlign = "left"; // "rigth" "center" #60
                ctx.fillText(text, cx, cy - 12);
                ctx.stroke();
            }
        }
    }

    // 点がハイライトになったときの処理（内部関数宣言）
    function highlightCallback(e, x, pts, row, seriesName) {
        // マウスクリック用に座標をHJN.hoverXYに退避する
        HJN.hoverXY = {
            x : x,
            pts : pts,
            row : row,
            seriesName : seriesName
        };
    }

    // 点をクリックしたときの処理(内部関数宣言）
    function pointClickCallback(event, p) {
        if (!p.annotation)
            HJN.Plot.PointClickCallback(p);
    }

    // アノテーション（グラフ中の吹出し）をクリックしたときの処理(内部関数宣言）
    function annotationClickHandler() { // annotation, p, dygraph, event
        HJN.Plot.PointClickCallback(arguments[1]);
    }

    // アノテーション（グラフ中の吹出し）をダブルクリックしたときの処理(内部関数宣言）
    function annotationDblClickHandler() { // annotation, p, dygraph, event
        // 指定ポイントを削除する
        HJN.Plot.PointDblClickCallback(arguments[1]);
    }

    // グラフをクリックしたときの処理(内部関数宣言）
    // function clickCallback(e, x, pts) {}
};

/**
 * dygraphのBalloonを再描画する
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.prototype.showBalloon = function () {
    if (this.cTps.length === 0)
        return; // ctpsが空の時何もしない

    var ann = {
        series : "",
        xval : 0,
        shortText : "",
        text : ""
    }, anns = [];
    // 表示時間帯を求める
    var ctps = this.cTps, minX = ctps[0].x, maxX = ctps[ctps.length - 1].x;
    // アノテーションをdygparhに追加する
    HJN.Plot.List.forEach(function (e) {
        if (minX <= e.x && e.x <= maxX) {
            ann = {
                series : HJN.Tat.seriesConfig[e.n].key,
                xval : e.x, // ミリ秒
                shortText : e.y,
                text : e.label
            };
            anns.push(ann);
            // 詳細Plot＆詳細グラフデータが無いとき、詳細Plot内のTPS Plotを追加する #7
            if ("tpsPlot" in e) { // 詳細plotのとき
                if (this.SERIESES.findIndex(function (s) {
                    return s.N === e.n;
                }) < 0) { // 詳細グラフデータが無いとき
                    ann = {
                        series : HJN.Tat.seriesConfig[e.tpsPlot.n].key,
                        xval : e.tpsPlot.x, // ミリ秒
                        shortText : e.tpsPlot.y,
                        text : e.tpsPlot.label
                    };
                    anns.push(ann);
                }
            }
        }
    }, this);
    // dygraphの残描画処理が完了してからアノテーションをセットする
    this.graph.ready(function () {
        this.setAnnotations(anns);
    });
};

/**
 * dygraphのlegendを編集する(dygraph オプション登録用関数）
 * {@link http://dygraphs.com/options.html#legendFormatter}
 * 
 * @memberof tatLogDiver.Graph
 * @param {ETAT}
 *            data [[終了時刻(ms), 処理時間(sec), （任意）ログレコード等], ...]
 * @return {string} dygraphのlegendに表示する文字（HTML)
 */
Graph.prototype.legendFormatter = function (data) {
    // legend: 'always'指定のとき、マウスがグラフ外にあると dataに値が設定されていなことを考慮
    var html = (typeof data.x === "undefined") ? '' : __WEBPACK_IMPORTED_MODULE_0__util_util_js__["DateToString"](
            new Date(data.xHTML), "yyyy/MM/dd hh:mm:ss.000"); // #92
    html = '<label class="datetime">' + html + '</label>';
    data.series
            .forEach(function (series) {
                if (!series.isVisible)
                    return;
                var val = (typeof series.yHTML === "undefined") ? ""
                        : series.yHTML, text = '<label '
                        + getStyle(series.label)
                        + '">'
                        + "&nbsp;"
                        + series.labelHTML
                        + ':'
                        + ('####' + val.replace(/\.[0-9]*/, "")).slice(-4)
                                .replace(/#/g, "&nbsp;") + '</label>';
                html += series.isHighlighted ? '<b>' + text + '</b>' : text;
                html += '&nbsp;';
            });
    return html;
    // keyに設定された色指定するstyle文字列を取得する（legendFormatter内部関数宣言）
    function getStyle(key) {
        var i = HJN.Tat.seriesConfig.findIndex(function (e) {
            return (e.key === key);
        });
        return 'style="background:' + HJN.Tat.seriesConfig[i].color + ';';
    }
};



/**
 * メニュー機能：CSVデータファイルを開く
 * 
 * @memberof tatLogDiver.Graph
 * @param {evt}
 *            evt ファイルオープンイペント
 */
Graph.prototype.menuOpenCsv = function (evt) {
    var file_list = evt.target.files;
    // 指定されたファイルを処理する
    HJN.init.FileReader(file_list);
};

/**
 * メニュー機能：画面設定をJSON形式のセーブファイルとしてダウンロードする
 * 
 * @memberof tatLogDiver.Graph
 * @param {String}
 *            menuId Chrome, FireFoxのときに使用：ダウンロードファイルの一時作成に使うHTMLタグ
 * @param {String}
 *            fileName ie11以降のときに使用：ダウンロードファイル名
 */
Graph.prototype.menuSaveConfig = function (menuId, fileName) {
    // plotsをjsonに変換する
    var save = {
        "HJN.Plot.List" : HJN.Plot.List,
        "HJN.Config.File" : HJN.Config.File.__config, // #76
        "HJN.Config.Filter" : HJN.Config.Filter.__config
    };
    var json = JSON.stringify(save, null, 4);
    // ダウンロードする
    this.menuDownloadBlob(this.menuBuffToBlob(json), menuId, fileName);
};
/**
 * メニュー機能：JSON形式の画面設定ファイルをロードし画面表示に反映する TODO
 * 
 * @memberof tatLogDiver.Graph
 * @param {String}
 *            menuId Chrome, FireFoxのときに使用：ダウンロードファイルの一時作成に使うHTMLタグ？
 * @param {String}
 *            fileName ie11以降のときに使用：ダウンロードファイル名 ？
 */
Graph.prototype.menuLoadConfig = function (evt) { // #10
    // 指定されたファイルを開く
    var files = evt.target.files;
    for (var i = 0; i < files.length; i++) { // データを順番に取得する
        try {
            // ファイルを取得する
            var file = files[i];
            // ログ出力用にファイル名（サイズ）を編集する
            if (10000 < file.size) {
                var msg = "Too large(>10KB) " + file.name + " [" + file.size
                        + "byte]";
                __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowText([ "<mark>" + msg + "</mark>" ]);
                return;
            }
            // ファイルの読み込みに成功したら、その内容をドロップエリアに追記して表示する
            var reader = new FileReader();
            reader.onloadend = funcOnloadend.bind(this, files[i], i);
            // ファイルにArrayBufferで参照を取得する（onloadendイベントを起こす）
            reader.readAsArrayBuffer(files[i]);
        } catch (e) {
            // 第一引数のテキストアレイの内容を#fileInfoのiframeに表示する
            var msg = "The " + i + "th dropped object is not a file";
            __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowText([ "<mark>" + msg + "</mark>" ]);
            console.error("[%o]%o", msg, e);
        }
    }

    // 内部関数：ファイルを読み込み後の処理（指定ファイルを読み込んだ後に呼び出される）
    function funcOnloadend(file, i, evt) {
        if (evt.target.readyState === FileReader.DONE) {
            // ファイルからjsonを読み込む
            var filesArrayBuffer = evt.target.result;
            var buf = new Uint8Array(filesArrayBuffer);
            var json = String.fromCharCode.apply(null, buf);
            alert(json);
            var jsonObj = JSON.parse(json);

            // jsonからHJN.chartD.fileParserに登録されているConfig の定義を作成する
            var conf = jsonObj["HJN.chart.fileParser"];
            HJN.chart.fileParser._config_File.__config = conf;
            var confD = jsonObj["HJN.chartD.fileParser"];
            HJN.chartD.fileParser._config_File.__config = confD;

            // jsonからHJN.Plot.Listを作成する
            var tmpPlots = jsonObj["HJN.Plot.List"];
            var plots = [];
            // フォーマットに合致する項目のみ抽出する
            if (isSameType([], tmpPlots)) { // 最上位が配列
                tmpPlots.forEach(function (e) { // 2層目がオブジェクト
                    if (isSameType(0, e.x))
                        plots.push(e);
                });
            }
            if (0 < plots.length) {
                HJN.Plot.List = plots;
            }
            HJN.Plot.Render();
            // グラフ内の吹き出しを再表示する
            HJN.Plot.ShowBalloon();

            // 型判定
            function isSameType(sample, obj) {
                var clas0 = Object.prototype.toString.call(sample);
                var clas1 = Object.prototype.toString.call(obj);
                return clas0 === clas1;
            }
        }
    }

};

/**
 * メニュー機能：メニューで指定されたフィルタの条件で再描画する
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.prototype.menuFilterApply = function () { // #34
    if (HJN.files && HJN.files.length === 0) {
        // 自動生成データのグラフを表示しているとき
        HJN.init.ChartShow(HJN.chart.eTatOriginal)
    } else {
        // ファイル指定のグラフを表示しているとき
        HJN.init.FileReader(HJN.files);
    }
};
/**
 * メニュー機能：フィルタ条件を初期値にし、再描画する
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.prototype.menuFilterReset = function () { // #34
    __WEBPACK_IMPORTED_MODULE_4__timeSeries_timeSeries_js__["d" /* MenuConfigFilter */].reset();
};

/**
 * メニュー機能：シミュレータ 指定JSONでシミュレートする
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.prototype.menuSimulatorSimulate = function () { // #53
    // グラフを再生成する
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ResetTimestamp(); // #79
    var json = document.getElementById("SimulatorEditor").value;
    HJN.files = []; // #61
    HJN.Plot.List = [];
    Object(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_Init_js__["CreateSampleTatLogAndChartShow"])(json);

};
/**
 * メニュー機能：シミュレータ JSON入力エリアを広げる
 * 
 */
Graph.prototype.menuSimulatorEditor = function () { // #53
    var divSimulator = document.getElementById("Simulator");
    var divSimulatorEditor = document.getElementById("SimulatorEditor");
    if (divSimulator.style.height === "100%") { // #60
        // 開いているとき、textareaの親を閉じる
        divSimulator.style.visibility = "hidden"; // #79
        divSimulator.style.height = "0";
        divSimulator.style.width = "190px";
    } else{ // 閉じているとき
        // textareaを一度閉じる（textareaが大きいとき親が大きくなりスクロールが出るため）
        divSimulatorEditor.style.height = "0";
        // textareaの親を開く
        divSimulator.style.height = "100%";
        divSimulator.style.width = "70%";
// divSimulatorEditor.style.height = (divSimulator.scrollHeight - 10) + "px";
        divSimulatorEditor.style.height = divSimulator.clientHeight + "px";
        divSimulator.style.visibility = "visible"; // #79
    }
};


/**
 * メニュー機能：canvas画像をファイルとしてダウンロードする
 * 
 * @memberof tatLogDiver.Graph
 * @param {String}
 *            menuId Chrome, FireFoxのときに使用：ダウンロードファイルの一時作成に使うHTMLタグ
 * @param {String}
 *            fileName ie11以降のときに使用：ダウンロードファイル名
 */
Graph.prototype.menuDownloadImg = function (menuId, fileName) {
    var type = 'image/png';
    // canvas から DataURL で画像を出力
    var canvas = this.chartId.getElementsByTagName('canvas')[0], dataurl = canvas
            .toDataURL(type);
    // DataURL のデータ部分を抜き出し、Base64からバイナリに変換
    var bin = atob(dataurl.split(',')[1]);
    // Uint8Array ビューに 1 バイトずつ値を埋める
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }
    // Uint8Array ビューのバッファーを抜き出し、それを元に Blob を作る
    var blob = new Blob([ buffer.buffer ], {
        type : type
    });
    // var url = window.URL.createObjectURL(blob);

    // ダウンロードする
    this.menuDownloadBlob(blob, menuId, fileName);
};

/**
 * メニュー機能：グラフ全データをCSVファイルとしてダウンロードする
 * 
 * @memberof tatLogDiver.Graph
 * @param {String}
 *            menuId Chrome, FireFoxのときに使用：ダウンロードファイルの一時作成に使うHTMLタグ
 * @param {String}
 *            fileName ie11以降のときに使用：ダウンロードファイル名
 */
Graph.prototype.menuDownloadCsv = function (menuId, fileName) {
    var bom = new Uint8Array([ 0xEF, 0xBB, 0xBF ]), // Excel対応UTF8のBOMコード指定
    csv = this.labels.join(','); // csvヘッダ行の作成
    this.dyData.forEach(function (e) {
        csv += "\r\n" + e.join(',');
    }); // csvデータ展開
    var blob = new Blob([ bom, csv ], {
        "type" : "text/csv"
    }); // blob変換
    // ダウンロードする
    this.menuDownloadBlob(blob, menuId, fileName);
};

/**
 * メニュー機能：グラフ全データの編集元に該当するTATログの該当行をCSVファイルとしてダウンロードする
 * 
 * @memberof tatLogDiver.Graph
 * @param {String}
 *            menuId Chrome, FireFoxのときに使用：ダウンロードファイルの一時作成に使うHTMLタグ
 * @param {String}
 *            fileName ie11以降のときに使用：ダウンロードファイル名
 */
Graph.prototype.menuDownloadLog = function (menuId, fileName) {
    var eTat = this.eTat;
    if (0 < eTat.length) { // 出力対象データがあるとき
        if (typeof eTat[0].pos === "undefined") { // 生成データのとき
            // 生成データをCSVに編集する #88
            var delimiter = '';
            var separator = delimiter + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getConfig("SEP") + delimiter; // #76
            var eTatCsv = delimiter + '終了年月日 時分秒ミリ秒' 
                        + separator + '処理時間(ms)'
                        + separator + 'シミューレート情報'
                        + delimiter + '\r\n';
            eTat.forEach(function (e) {
                eTatCsv += delimiter + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](e.x, 'yyyy/MM/dd hh:mm:ss.000') // #92
                        + separator + e.y 
                        + separator + e.message 
                        + delimiter + '\r\n'; // #61
            });
            // ダウンロードする
            this.menuDownloadBlob(this.menuBuffToBlob(eTatCsv), menuId,
                    fileName);
        } else { // ファイル読込のとき
            // 出力データを元ファイルのpos順にソートする（改行コードのないファイル末尾レコートがある場合も最後に来るように） #45
            eTat.sort(function (a, b) {
                return a.pos - b.pos;
            });
            // 最大作業領域として元ファイルサイズの合計分のメモリを確保する #23
            var maxSize = HJN.filesArrayBuffer.reduce(function (p, c) {
                return p + c.byteLength + 2;
            }, 0);
            var buff = new Uint8Array(maxSize), offset = 0;
            // ファイルの該当行を Uint8Arrayに登録する
            eTat.forEach(function (e) {
                buff.set(new Uint8Array(HJN.filesArrayBuffer[e.fileIdx], e.pos,
                        Math.min(e.len + 2,
                                HJN.filesArrayBuffer[e.fileIdx].byteLength
                                        - e.pos)), offset);
                offset += (e.len + 2);
            });
            // 未使用作業領域を削除する
            var buff2 = new Uint8Array(buff.slice(0, offset));
            // ダウンロードする
            this.menuDownloadBlob(this.menuBuffToBlob(buff2), menuId, fileName);
        }
    } else { // 出力対象データがないとき
        var str = "No log in the time.";
        // ダウンロードする
        this.menuDownloadBlob(this.menuBuffToBlob(str), menuId, fileName);
    }
};

/**
 * メニュー機能：plotsでconcが選択されているとき、同時処理に該当するTATログの該当行をCSVファイルとしてダウンロードする
 * 
 * @memberof tatLogDiver.Graph
 * @param {String}
 *            menuId Chrome, FireFoxのときに使用：ダウンロードファイルの一時作成に使うHTMLタグ
 * @param {String}
 *            fileName ie11以降のときに使用：ダウンロードファイル名
 */
Graph.prototype.menuDownloadConc = function (menuId, fileName) {
    var plot = HJN.Plot.List.find(function (e) {
        return e.radio;
    });
    if (plot.n === HJN.Tat.CONC.N || plot.n === HJN.Tat.STAT.N || plot.n === HJN.Tat.ETAT.N) {
        // CONC|STAT|ETATが選択されているとき
        var trans = this.eTat.tatMap.search(plot.x); // #18
        if (0 < trans.length) { // 出力テキストを編集する
            if (typeof trans[0].pos === "undefined") {
                // 初期表示データのとき、CSVを編集する
                // 生成データをCSVに編集する #88
                var delimiter = '';
                var separator = delimiter + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getConfig("SEP") + delimiter; // #76
                var csv = delimiter + '終了年月日 時分秒ミリ秒'
                        + separator + '処理時間(ms)'
                        + delimiter + '\r\n';
                trans.forEach(function (e) {
                    csv += delimiter + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](e.x, "yyyy/MM/dd hh:mm:ss.000") // #92
                        + separator + e.y
                        + delimiter + '\r\n';
                });
                // ダウンロードする
                this.menuDownloadBlob(this.menuBuffToBlob(csv), menuId,
                        fileName);
            } else {
                // ファイル読み込みの時、対象レコードを表示する
                // 出力データを元ファイルのpos順にソートする（改行コードのないファイル末尾レコートがある場合も最後に来るように） #45
                trans.sort(function (a, b) {
                    return a.pos - b.pos;
                });
                // 最大作業領域として元ファイルサイズの合計分のメモリを確保する #23
                var maxSize = HJN.filesArrayBuffer.reduce(function (p, c) {
                    return p + c.byteLength + 2;
                }, 0);
                var buff = new Uint8Array(maxSize), offset = 0;
                // ファイルの該当行を Uint8Arrayに登録する
                trans.forEach(function (e) {
                    buff.set(new Uint8Array(HJN.filesArrayBuffer[e.fileIdx],
                            e.pos, Math.min(e.len + 2,
                                    HJN.filesArrayBuffer[e.fileIdx].byteLength
                                            - e.pos)), offset);
                    offset += (e.len + 2);
                });
                // 未使用作業領域を削除する
                var buff2 = new Uint8Array(buff.slice(0, offset));
                // ダウンロードする
                this.menuDownloadBlob(this.menuBuffToBlob(buff2), menuId,
                        fileName);
            }
        }

    } else { // CONCが選択されていないとき
        var msg = "抽出対象データがありません。空データがダウンロードされます\r\n"
                + "conc：多重度（詳細）の点を選択した状態で行ってください";
        alert(msg);
        this.menuDownloadBlob(this.menuBuffToBlob(msg), menuId, fileName);
    }
};

/**
 * メニュー共通機能：BinaryString, UintXXArray, ArrayBuffer をBlobに変換する
 * 
 * @memberof tatLogDiver.Graph
 * @param {Object}
 *            arrayBuffer 変換元
 * @return {Blob} 変換後
 */
Graph.prototype.menuBuffToBlob = function (arrayBuffer) {
    return new Blob([ arrayBuffer ], {
        type : "application/octet-stream"
    });
};

/**
 * メニュー共通機能：指定blobをファイルとしてダウンロードする
 * 
 * @memberof tatLogDiver.Graph
 * @param {Objcet}
 *            blob ダウンロードさせるblogデータ
 * @param {String}
 *            menuId Chrome, FireFoxのときに使用：ダウンロードファイルの一時作成に使うHTMLタグ
 * @param {String}
 *            fileName ie11以降のときに使用：ダウンロードファイル名
 */
Graph.prototype.menuDownloadBlob = function (blob, menuId, fileName) {
    if (window.navigator.msSaveBlob) { // ie11以降のとき
        window.navigator.msSaveBlob(blob, fileName);
        // msSaveOrOpenBlobの場合はファイルを保存せずに開ける
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else { // Chrome, FireFoxのとき
        document.getElementById(menuId).href = window.URL.createObjectURL(blob);
    }
};

/**
 * Zoomリセットアイコンを追加する
 * 
 * @memberof tatLogDiver.Graph
 */
Graph.prototype.addIcon_ZoomReset = function () {
    var divChart = this.chartId; // document.getElementById("Icons");
    var idName = this.chartIdName + "Zoom";
    var input = document.getElementById(idName);
    if (input !== null) { // 既にある場合削除する
        var div = input.parentElement;
        div.parentElement.removeChild(div);
    }

    if (divChart) {
        var div = document.createElement('div');
        var htmlText = '<input id="' + idName + '" type="buttom" class="hjnBoxSwitch hjnResize" '
                                + 'onClick="HJN.' + this.chartIdName + '.graph.resetZoom()">'
                     + '<label for="' + idName + '" class="hjnCtrlBox"><span></span></label>';
        div.innerHTML = htmlText;
        divChart.insertBefore(div, divChart.firstChild);
    }
};


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HJN", function() { return HJN; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_Tat_js__ = __webpack_require__(14);
/* ******1*********2*********3*********4*********5*********6*********7****** */



/**
 * @namespace
 * @prop {function} init - 初期登録処理関連（Init で、イベントハンドラ呼出し関数を登録する先）
 * @prop {Objcet} Tat - timeSeries#Tat
 * @prop {Objcet} chart - 上段グラフ
 * @prop {Objcet} chartD - 下段詳細グラフ
 * @prop {String} chartName - グラフオブジェクトの名称
 * @prop {Array} files - データファイル一覧
 * @prop {Array} filesArrayBuffer - データ読込領域
 * @prop {Date} timer - 前回ログ出力時刻退避領域（処理時間計算用）
 */
var HJN = {};
window.HJN = HJN; // #67

/**
 * @namespace
 */
HJN.init = {}; // 初期登録処理関連

HJN.Config = HJN.Config || __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"]; // #76
HJN.Tat = __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_Tat_js__["a" /* default */];

HJN.chart = HJN.chartD = null;
HJN.chartName = "chart";

HJN.files = [];
HJN.filesArrayBuffer = [];

HJN.timer = {};
__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"]("DetailGraph").setValueByKey("D_TIME", +(new Date()));  // 下段表示時刻
                                                                    // #27


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = Init;
/* harmony export (immutable) */ __webpack_exports__["CreateSampleTatLogAndChartShow"] = CreateSampleTatLogAndChartShow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__simulator_simulator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tatLogDiver_Copyright_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tatLogDiver_Graph_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tatLogDiver_Plot_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tatLogDiver_MenuConfigDetailGraph_js__ = __webpack_require__(10);










/* *****1*********2*********3*********4*********5*********6*********7******* */
/**
 * HTMLから呼び出すAPI
 * 
 * @memberof HJN
 * @class Init
 * @param {string}
 *            [chartName=HJN.chartName="chart"] グラフを作成するHTMLタグ名
 * @return {ETAT} 終了時刻のTAT（応答時間）時系列データ
 * @example <!doctype html> <html> <head> <meta charset="UTF-8"> <link
 *          type="text/css" rel="stylesheet" href="../libs/dygraph.css"> <link
 *          type="text/css" rel="stylesheet" href="./tatLogDiver.css"> </head>
 *          <body> <div id="hjn_chart"></div> <script src="../libs/dygraph.js"></script>
 *          <script src="../libs/extras/synchronizer.js"></script> <script
 *          type="module"> import {HJN_init_ChartRegist} from
 *          "./tatLogDiver-Init.js";
 *          window.addEventListener("DOMContentLoaded",function(eve){
 *          Bundle("chart"); // チャートを作成する }); </script> </body> </html>
 */
function Init(chartName){ // #70
    // グローバル登録
    __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].Util = __WEBPACK_IMPORTED_MODULE_0__util_util_js__; // #95
	// 引数１ ：デフォルトHJN.chartName("chart")
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartName = chartName = chartName || __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartName;
	// タイトルを設定する #57
	document.title = "tat log diver " + __WEBPACK_IMPORTED_MODULE_4__tatLogDiver_Copyright_js__["Copyright"].Version;
	// htmlを作成する #52
	var html_chart = document.getElementById("hjn_" + chartName) || document.body;
	html_chart.innerHTML = ''
		+ '<div id="' + chartName + '"></div>'
		+ '<div id="' + chartName + 'D"></div>'
	// CONCデータ表示領域 #78
		+ '<div class="lineViewer hjnDraggableBox hjnCode" >' // #79
		+ '<div id="lineViewer" readonly>logdata</div></div>';
	// 手前にメニュ－用htmlを作成する #52
	var html_nav = document.createElement('nav');
	html_nav.innerHTML = ''
		+ '<header>'
		// シミュレータ JSON Edit画面 領域 #53
		+ '<div id="Simulator" class="hjnDraggableBox" style="visibility:hidden"></div>'
		// ハンバーガーメニュー 領域
		+ '<div class="hjnBurgerTray">'
			// ステータスバー（ログ表示）領域
		+	'<div class="statusbar hjnDraggableBox">'
		+	'<iframe id="fileInfo" style="height:100%;"></iframe></div>' // #79
			// ×ボタン
		+	'<input id="hjnBoxBuger" type="checkbox" class="hjnBurger hjnResize" checked="checked" />'
		+	 '<label for="hjnBoxBuger" class="hjnCtrlBox"><span></span></label>'
		// グラフZoomリセットボタン #78
		+	 '<input id="chartZoom" type="buttom" class="hjnBoxSwitch hjnResize" '
		+	 'onClick="HJN.init.ResetStyle();" />'
		+		'<label for="chartZoom" class="hjnCtrlBox"><span></span></label>'
			// メニュー上部タイトル
		+	'<div class="hjnBurgerTitle">'
				// メニューオーバレイモード変更 ボタン
		+	 '<input id="hjnBoxPlaceOn" type="checkbox" class="hjnBoxSwitch hjnResize" />'
		+		'<label for="hjnBoxPlaceOn" class="hjnCtrlBox"><span></span></label>'
				// メニュー上部テキスト 領域
		+	 '<p>'
					// ツール名称＆JSDocリンク
		+		'<a class="hjnLabel4Input" href="../jsdoc/index.html" '
		+				 'target=”_hirosejnJSDoc3”>TAT log diver</a><BR>'
		+	 '</p>'
		+	'</div>'
		// メニュー画面本体（左右開閉ラッパー）
		+	'<div class="hjnBurgerWrap">'
			// アコーディオンメニュー
		+	 '<div class="hjnAccordion">'
		+		'<div id="' + chartName + '_menu"></div>'
		+		'<div id="' + chartName + 'D_menu"></div>'
		+	 '</div>'
		+	'</div>'
		+ '</div>'
		+ '</header>';
	html_chart.parentNode.insertBefore(html_nav, html_chart);
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.ResetStyle(true); // #79

	var dropFieldName = chartName;	// ファイルドロップを受け付けるタグ名
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogTextInit(); // 処理時間計測の初期化

	// コンフィグプロパティを初期化する #74
	// HJN.Config = HJN.Config || Util.Config;
	__WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__["c" /* MenuConfigFile */].config();
	__WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__["d" /* MenuConfigFilter */].config();
	__WEBPACK_IMPORTED_MODULE_2__simulator_simulator_js__["a" /* MenuConfig */].config();
	__WEBPACK_IMPORTED_MODULE_7__tatLogDiver_MenuConfigDetailGraph_js__["default"].config();

	// グラフのインスタンスを作成し初期化する
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart = new __WEBPACK_IMPORTED_MODULE_5__tatLogDiver_Graph_js__["default"](chartName, "HJN.chart");
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.init();
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD = new __WEBPACK_IMPORTED_MODULE_5__tatLogDiver_Graph_js__["default"](chartName + "D", "HJN.chartD");
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.init();
	// ドロップフィールドに、処理を登録する(注：dygraphはイベントリスナーを登録しないとクリック時にエラーが出る）
	Init.DropField(dropFieldName);
	Init.DropField(dropFieldName+ "D");

	// 初期表示データを自動生成する // #53
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].GetConfig("Simulator").getFunctionByKey("S_SIMU")(); // #53

	// イベントハンドラを登録する
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Element"].enableDraggableClass();
}

/**
 * スタイルを初期設定する（Reset zoomボタンからも呼ばれる）
 * 
 * @memberof HJN.init
 * @param {Boolean}
 *            [isInit=false] リセット時true：初期設定値も再設定する
 *            シミュレーション条件JSONテキスト、もしくはサンプルJSON番号
 * 
 */
__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.ResetStyle = Init.ResetStyle = function(isInit){ // #79
	// 指定クラス名が設定された要素にスタイルを設定する
	var elements = document.getElementsByClassName("lineViewer");
	for(var i = 0; i < elements.length; i++){
		__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Element"].SetStyles(elements[i],
				{ bottom: 0, left: "", top: "", width: "70%", height: "10vh"});
	}
	elements = document.getElementsByClassName("statusbar");
	for(var i = 0; i < elements.length; i++){
		__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Element"].SetStyles(elements[i],
				{ left: "10px", top: 0, width: "155px", height: "40px"});
	}
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Element"].SetStyles(document.getElementById("Simulator"),
				{ left: 0, top: 0, width: "190px", height: 0});
	// 別途初期設定される値を再設定する
	if (!isInit) {
		__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.graph.resetZoom();
		__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.graph.resetZoom();
	}
}
/**
 * データを自動生成し表示する
 * 
 * @memberof HJN.init
 * @param {String|Number}
 *            [json = Simulator.virtualSystemByJson.GetJsonConfig(0)]
 *            シミュレーション条件JSONテキスト、もしくはサンプルJSON番号
 */
function CreateSampleTatLogAndChartShow(json){ // #53
	var jsonText;
	if (typeof(json) === "number") { // #53
		jsonText = __WEBPACK_IMPORTED_MODULE_2__simulator_simulator_js__["d" /* virtualSystemByJson */].GetJsonConfig(json);
	} else{
		jsonText = json || __WEBPACK_IMPORTED_MODULE_2__simulator_simulator_js__["d" /* virtualSystemByJson */].GetJsonConfig(0);
	}
	// JSON Editorを更新する
	document.getElementById("SimulatorEditor").value = jsonText;
	// 初期表示データを自動生成する
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTatOriginal = __WEBPACK_IMPORTED_MODULE_2__simulator_simulator_js__["d" /* virtualSystemByJson */].Execute(jsonText);
	// データを表示する
	Init.ChartShow(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTatOriginal);
}

/**
 * 終了時刻とtatの配列をグラフ表示する（Menuイベントから呼び出される）
 * 
 * @memberof HJN.init
 * @param {ETAT}
 *            HJN.chart.eTatOriginal 終了時刻とtatを含む配列
 */
__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.ChartShow = Init.ChartShow = function(eTatOriginal){
	// フィルタしたeTatを取得する #34
	var eTat = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.fileParser.createFilter().filter(eTatOriginal);

	// グラフを初期表示する
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].Plot.List = []; // #53
	// 上段
	if (eTat.length === 0) eTat = [{x:0, y:0}]; // #72
	var tat = new __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__["e" /* Tat */](eTat); // #75
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.setSeriesSet(tat);
	__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.update();
	showLogForUpperGraph("Simulator"); // #79

	// 下段(非同期）
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["setZeroTimeout"]( function(){
		__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.update(Init.ChartRegistDetail(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.cTps));
		__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.showBalloon();	// 上段のBalloonを描画する
		if (__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.eTat){
			showLogForLowerGraph("Simulator"); // #79
		} else { // #72
			__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("<mark>表示データがありません</mark>", "msg");
		}
		// 上下段のマウス操作同期設定 #49
		var sync = Dygraph.synchronize(
				 [ __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.graph, __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.graph ],
				 {selection: true, zoom: false});
	});
}
function showLogForUpperGraph(fileName){
	// 上段グラフの処理時間をログに出力
	// Util.Logger.ShowLogText("+ ", "elaps");
}
function showLogForLowerGraph(fileName){
	// 下段グラフの処理時間をログに出力
	// Util.Logger.ShowLogText("", "elaps", true);

	// ファイル名、取込レコード数のログ編集
	var text = "<mark>" + /* fileName + */ " ["
			+ (__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTat.length.toString() + "")
				.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // 整数文字列のカンマ編集
			+ "]行</mark> ";
	// 下段の表示レコード数をログに出力
	if (__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.eTat){
		text += "下段["
				+ (__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.eTat.length + "")
					.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // 整数文字列のカンマ編集
				+ "]行";
	}else{
		text = "" +
				"表示データなし　要確認：Charset, delimiter, Line feed code"
	}
	// ログ出力
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText(text, "msg");
}

/**
 * HTMLタグに、CSVファイルのドロップを受付けイベントを登録する
 * 
 * @memberof HJN.init
 * @param {string}
 *            dropFieldName ファイルのドロップイベントを受けるフィールド名
 */
Init.DropField = function (dropFieldName) {
	// 第一引数で指定された名前の ID 属性のエレメントを取得する
	var element = document.getElementById(dropFieldName);

	// ドラッグ操作中に実行されるイベント（マウスカーソルが要素内に滞在中）
	element.addEventListener("dragover" , function (e){
		e.preventDefault();	// ドロップを許可し受け入れを表明
	});

	// ドロップ時に実行されるイベント
	element.addEventListener("drop", function (e){
			var data_transfer = e.dataTransfer;		// DataTransfer オブジェクトを取得する
			if(!data_transfer.types) return;		// ファイルのコンテンツタイプを取得できたことを確認する
			var files = data_transfer.files;	// ファイルのリストを取得する
			Init.FileReader(files);
			e.preventDefault();		// デフォルトのドロップ機能を無効化
	});
};

/**
 * 指定されたファイルを読込んで処理する
 * 
 * @memberof HJN.init
 * @param {Object}
 *            files ファイルハンドラ
 */
__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.FileReader = Init.FileReader = function (files){  // #15
	for(var i = 0; i < files.length; i++){	// データを順番に取得する
		try{
			// ファイルを取得する
			var file = files[i];
			// ログ出力用にファイル名、ファイルサイズ、ファイル更新日時を編集する
			var textArray = "<mark><b>" + file.name + "</b></mark><BR>"
						+ (file.size + "")
							.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // 整数文字列のカンマ編集
						+ "Kbyte<BR>"
						+ file.lastModifiedDate.toLocaleString() + "<BR>";
			// ファイルの読み込みに成功したら、その内容をドロップエリアに追記して表示する
			var reader = new FileReader();
			reader.onloadend = funcOnloadend.bind(this, files[i], i);
			// ファイルにArrayBufferで参照を取得する（loadイベントを起こす）
			reader.readAsArrayBuffer(files[i]);
		}catch(e){
			// 第一引数のテキストアレイの内容を#fileInfoのiframeに表示する
			var msg = "The " + i + "th dropped object is not a file";
			__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowText( ["<mark>"+msg+"</mark>"] );
			console.error("[%o]%o",msg,e );
		}
	}

	// 内部関数：ファイルを読み込みｸﾞﾗﾌを表示する（指定ファイルを読み込んだ後に呼び出される） #23
	function funcOnloadend(file, i, evt) {
		if (evt.target.readyState === FileReader.DONE) { // DONE == 2
			var filesIdx = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].files.length;
			// ファイルの先頭2行をログ表示する
			__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].filesArrayBuffer[filesIdx] = evt.target.result;
			__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ResetTimestamp();			  // 情報表示 : 初期化
			__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText(textArray, "msg");  // 情報表示：ドロップファイル情報
			// 指定ファイルを読み込む
			// CSVファイルを上段用eTatに展開する[{x:, y:,pos:,len:},...] 全件展開する
			if (i === 0 && __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.fileParser.isNewETAT()){
				// 新規モードかつ、同時複数ファイル指定時の最初のファイルのとき、新たに作成する
				__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].files = [file];
				__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTatOriginal = getTatLogArray(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].filesArrayBuffer, filesIdx);
			} else { // 2件目以降のファイルのとき、もしくは、追加モード"ADDDATA"のとき、追加する
				__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].files.push(file);
				__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTatOriginal = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTatOriginal.concat(
						getTatLogArray(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].filesArrayBuffer, filesIdx));
			}

			// 全ファイルを読み込んだらグラフを描画する
			if (__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].files[__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].files.length - 1] === file){ // 指定ファイル群の最後のファイルを処理しているとき
				// フィルタしたeTatを取得する #34
				var eTat = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.fileParser.createFilter().filter(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTatOriginal);

				// 上段グラフを描画する（ eTatから上段用 時系列分析データ(seriesSet)を展開する）
				if (eTat.length === 0) eTat = [{x:0, y:0}]; // #72
				var tat = new __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__["e" /* Tat */](eTat); // #75
				__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.setSeriesSet(tat);
				__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.update();
				showLogForUpperGraph(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].files[0].name); // #79

				// 下段用データの展開とグラフ描画（非同期処理）
				__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].Plot.List = [];
				__WEBPACK_IMPORTED_MODULE_0__util_util_js__["setZeroTimeout"](function(){
					if (__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.cTps) {
						// 下段グラフを描画する（下段用 時系列分析データ(seriesSet)を展開する）
						__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.update(Init.ChartRegistDetail(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.cTps));
						// 上段のBalloonを描画する(上段update時にはplots登録されていないので、ここで処理）
						__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.showBalloon();
						showLogForLowerGraph(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].files[0].name); // #79
					} else { // #72
						__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("<mark>表示データがありません</mark>", "msg");
					}
				});
			}
		}
	}

	// 内部関数： 指定ファイルの先頭ｎ行を、改行文字<BR> のテキストに変換してリターンする
	function topLines(file, n) {
		var fileInfo = "",
			line;
		try{	// 先頭からnレコード取得
			var getterOfLine = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.fileParser.createGetterOfLine(file);
			for (var i = 0; i < n; i++) {
				line = getterOfLine.next();
				fileInfo += line.str + "<BR>";
			}
		}catch (e) {
			alert("[Init.DropField 改行コードの無いファイルは扱えません]");
			console.error(e);
		}
		return fileInfo;
	}

	// 内部関数： CSVファイルを読み込み、TatLog用アレイ[{x:日時, y:値, pos:レコード開始位置,
	// len:レコード長},...]に展開する
	function getTatLogArray(files, idx) { // arg0:csvﾌｧｲﾙのファイルﾊﾟｽ
		__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("----- read file -----------------------------","calc");
		var file = files[idx], // #23
			eTat = [],
			xy = {date: 0, value: 0, isError: false },
			i = 0,  // timelog用
			getterOfLine = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.fileParser.createGetterOfLine(file),
			getterOfXY = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.fileParser.createGetterOfXY(),
			isDataType_TatStart = (__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getConfig("DATATYPE") == "DATATYPE_TATSTART"),
			isDataType_StartEnd = (__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getConfig("DATATYPE") == "DATATYPE_START_END"), // #89
			line = getterOfLine.next(), // 先頭行の初期処理
			lineNum = 0,
			errorNum = 0,
			charset = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].Config.File.getConfig("CHAR");
		while (!line.isEoF) {				// 以降最終行まで処理する
		    lineNum++;
			try {
				__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ByInterval(i++, line); // 一定時刻毎に進捗を出力する
				xy = getterOfXY.parse(line);
				if(!xy.isError){
					if (isDataType_TatStart){ // #81 DATATYPE_TATSTART
						eTat.push( {x: (xy.x + xy.y), y: xy.y, fileIdx: idx, // #93
							pos: line.pos, len: line.array.byteLength, sTatIdx: 0} );
					} else { // DATATYPE_TATEND
						eTat.push( {x: xy.x, y: xy.y, fileIdx: idx, // #23
							pos: line.pos, len: line.array.byteLength, sTatIdx: 0} );
					}
					// 先頭４行までパース結果をログ出力する
					if (lineNum < 5){
					    log(true, xy, line);
					}
				} else {
				    log(false, xy, line);
				}
			} catch (e) {	/* 改行だけレコードをスキップ */
			    log(false, xy, line);
	            if (e) console.log(e); // #93
			}
            line = getterOfLine.next(); // #24 #96
		}
		// エラーレコード数をログ出力する
        if (!errorNum){
            __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText(errorNum + " times failed to parse as CSV.", "msg");
        }
		__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[0:file readed & got eTat]---------------","calc");
		return eTat;

		// ログ出力する（内部関数）
		function log(okng, xy, line){
            if (okng){
                // 正常ログの出力は、５行目まで
                if (lineNum > 5) return;
                else __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("<br>OK:line " + lineNum + " <br>"
                        + " [" +  window.HJN.Util.D2S(xy.x, "yyyy/MM/dd hh:mm:ss.000")
                        + ", " + window.HJN.Util.N2S(xy.y) + "]<br>"
                        + window.HJN.Util.Encoding.charset.convert(line.str, "Unicode", charset)
                        , "msg");
            } else {
                errorNum++;
                // エラーログの出力は、５回まで
                if  (errorNum > 5) return;
                else __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("<br>NG:line " + lineNum + " <br>" 
                        + window.HJN.Util.Encoding.charset.convert(line.str, "Unicode", charset)
                        , "msg");
            }
		}
	}
};


/**
 * 詳細グラフ用機能： 表示対象期間のcTpsから、eTps範囲を取得し、詳細Seriesを生成する。併せてPlotsを登録する。
 * 
 * @memberof HJN.init
 * @param {xMs}
 *            cTps 日時（ミリ秒単位）
 * @return {seriesSet} dygraph用時系列データ配列
 */
Init.ChartRegistDetail = function(cTps){
	// CTPSの最大値となるplotを取得する
	var maxY =Number.MIN_VALUE,
		maxYIdx = -1;
	cTps.forEach(function(c, i){
		if (maxY < c.y){
			maxY = c.y;
			maxYIdx = i;
		}
	});
	if(0 <= maxYIdx){	// #26
		// 秒単位より大きいとき、最大値を含む時刻(秒)に補正する #38
		var x = cTps[maxYIdx].x;
		if(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.cTpsUnit.unit >= 1000){
			var cTpsIdx = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.conc.findIndex(function(e,i){return e.y === cTps[maxYIdx].y;});
			x = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.conc[cTpsIdx].x;
		}
		// slider rangeに、下段の表示時刻を設定する
		__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.SetDetailDateTime(x);
		// eTpsの範囲を取得し、詳細用seriesSet(HJN.chartD.seriesSet）を設定する
		var tat = new __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__["e" /* Tat */](__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.GetSliderRangedEtat()); // #75
		__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.setSeriesSet(tat);
		// plotsアイコン用 HJN.Plot.Listに、下段表示したplotを登録する
		__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].Plot.Add(__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].Tat.CTPS.N, cTps[maxYIdx].x, cTps[maxYIdx].y);
	}
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[6:Plot added] " + __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].Plot.List.length + " plots","calc");

	return __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chartD.seriesSet;
};
/**
 * 詳細グラフ用機能： sliderRangeで指定された範囲のeTatを返却する（グラフの点クリックイベント時に呼び出される）
 * 
 * @memberof HJN.init
 * @return {ETAT} 詳細グラフ用eTat
 */
__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.GetSliderRangedEtat = function() {
	// 指定時刻（ｄｔ ± range）を取得し、HJNグローバル変数に退避する #27
	var rangeTagPlus  = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_RANGE_PLUS");
	var rangeTagMinus = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_RANGE_MINUS");
	var rangeTagUnit  = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_UNIT"); // #48
	var rangeCycle = __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.cTpsUnit.unit / 1000; // 変動する #38

	rangeTagPlus = rangeTagPlus  ? +rangeTagPlus : 1 + rangeCycle;	 // 幅（秒）
	rangeTagMinus = rangeTagMinus ? +rangeTagMinus : rangeCycle;	 // 幅（秒）
	rangeTagUnit = rangeTagUnit  ? +rangeTagUnit : __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE; // #48

	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setValueByKey("D_RANGE_PLUS",rangeTagPlus);
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setValueByKey("D_RANGE_MINUS",rangeTagMinus);
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setValueByKey("D_UNIT",rangeTagUnit);

	var detailDateTime = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getValueByKey("D_TIME");
	var eTatDetail = (new __WEBPACK_IMPORTED_MODULE_1__timeSeries_timeSeries_js__["a" /* ETat */](__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].chart.eTat)).sliceByRangeUnit(detailDateTime,
				rangeTagMinus, rangeTagPlus, rangeTagUnit); // #75

	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[0:HJN.init.GetSliderRangedEtat] ","calc");
	return eTatDetail;  // 詳細グラフ用eTatを返却する
};
/**
 * 詳細グラフ用機能： 指定日時を秒単位に丸めて、FORMのslider Rangeに設定する（Plotから呼び出される）
 * 
 * @memberof HJN.init
 * @param {xMs}
 *            date 日時（ミリ秒単位）
 */
__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.SetDetailDateTime=function(date) {
	__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setValueByKey("D_TIME",
			Math.floor(date / 1000) * 1000); // 秒単位に丸める #27
};

/**
 * 使い方HTMLを取得する（Menuイベントから呼び出される） #84
 * 
 * @memberof HJN.init
 * @return {String} str 使い方HTML
 */
__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.Usage=function(){
    var UsageHtmlFile = "tatLogDiver-Usage.html";
    var UsageHtmlURL = "./tatLogDiver/" + UsageHtmlFile;
    // requireメソッドの有無で、webpack環境下か判定する
    if (false) {
        // webpack でパッケージ化していないとき、ダイアログ内にhtmlへのパスを表示する
        var url = "https://github.com/hirosejn/HJN/wiki/Usage(JP)";
        var label = "GitHub wiki : " + url;
        var html = 'Usage of TAT log diver'
            + '<br>'
            + 'webpack 未適用モード'
            + '<br>'
            + '<a class="hjnLabel4Input" href="' + url + '"'
            + 'target=”_hirosejnUsage”>' + label +'</a><BR>'
            + '<br>'
            + '<a class="hjnLabel4Input" href="' + UsageHtmlURL + '"'
            + 'target=”_hirosejnUsage”>' + UsageHtmlURL +'</a><BR>';
        return html;
    } else {
        // webpack でパッケージ化するとき、ダイアログ内にhtmlを表示する
        return __webpack_require__(45)("./" + UsageHtmlFile); // #94
    }
};

/**
 * 著作権表記文字を取得する（Menuイベントから呼び出される）
 * 
 * @memberof HJN.init
 * @return {String} str 著作権表記文字
 */
__WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__["HJN"].init.Copyright=function(){
	return __WEBPACK_IMPORTED_MODULE_4__tatLogDiver_Copyright_js__["Copyright"].getAboutText();
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__simulator_VirtualSystem_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__simulator_VirtualApp_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__simulator_VirtualResource_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulator_VirtualSystemByJson_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__simulator_MenuConfig_js__ = __webpack_require__(43);
/* unused harmony reexport VirtualSystem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__simulator_VirtualApp_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__simulator_VirtualResource_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__simulator_VirtualSystemByJson_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__simulator_MenuConfig_js__["a"]; });








/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timeSeries_Tat_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeSeries_ETat_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeSeries_FileParser_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timeSeries_MenuConfigFile_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timeSeries_MenuConfigFilter_js__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__timeSeries_Tat_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__timeSeries_ETat_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__timeSeries_FileParser_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__timeSeries_MenuConfigFile_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__timeSeries_MenuConfigFilter_js__["a"]; });








/**
 * seriesSet: dygraph用時系列データ配列
 * 
 * @typedef {array.<CONC, CTPS, ETPS, STAT, ETAT, EMPS, EAPS>} seriesSet
 */

/**
 * CONC:多重度の時系列データ<br>
 * [{x:変化時刻(ms) ,y:多重度数 }]
 * 
 * @typedef {array.<xMs, yInt>} CONC
 */

/**
 * CTPS: 秒間最大多重度の時系列データ<br>
 * [{x:秒毎時刻(ms), y:秒内最大多重度数 }]
 * 
 * @typedef {array.<xMs, index>} CTPS
 */

/**
 * ETPS: 秒間終了件数の時系列データ<br>
 * [{x:秒毎時刻(ms), y:秒内終了件数 }]
 * 
 * @typedef {array.<xMs, yInt>} ETPS
 */

/**
 * STAT: 開始時刻のTAT（応答時間）時系列データ<br>
 * [{x:開始時刻(ms) ,y:レスポンス(sec), eTatIdx: eTatの配列位置 }]
 * 
 * @typedef {array.<xMs, ySec, index>} STAT
 */

/**
 * ETAT: 終了時刻のTAT（応答時間）時系列データ<br>
 * [{x:変化時刻(ms) ,y:レスポンス(sec), fileIdx:ファイル配列位置, pos:レコード位置, len:レコード長, sTatIdx:
 * sTatの配列位置 }]
 * 
 * @typedef {array.<xMs, ySec, index, index, number, index>} ETAT
 */

/**
 * EMPS: 秒間最大TAT（応答時間）時系列データ（終了時刻ベース）<br>
 * [{x:秒毎時刻(ms), y:秒内最大レスポンス(sec) }]
 * 
 * @typedef {array.<xMs, ySec>} EMPS
 */

/**
 * EAPS: 秒間平均TAT（応答時間）時系列データ（終了時刻ベース）<br>
 * [{x:秒毎時刻(ms), y:秒内平均レスポンス(sec) }]
 * 
 * @typedef {array.<xMs, ySec>} EAPS
 */



/**
 * xMs: x軸に用いる時刻(ms)
 * 
 * @typedef {number} xMs
 */
/**
 * ySec: y軸に用いる秒単位の時間（応答時間など）
 * 
 * @typedef {number} ySec
 */



/**
 * yInt: y軸に用いる整数（個数など）
 * 
 * @typedef {number} yInt
 */
/**
 * index: 配列の位置（インデックス）に用いる整数
 * 
 * @typedef {number} index
 */

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_dygraph_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_dygraph_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__libs_dygraph_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tatLogDiver_Init_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tatLogDiver_HJN_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tatLogDiver_Graph_js__ = __webpack_require__(1);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Init", function() { return __WEBPACK_IMPORTED_MODULE_2__tatLogDiver_Init_js__["default"]; });






window.addEventListener("DOMContentLoaded",function(eve){
    Object(__WEBPACK_IMPORTED_MODULE_2__tatLogDiver_Init_js__["default"])("chart");      // チャートを作成する
});



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = Menu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__simulator_simulator_js__ = __webpack_require__(4);



/**
 * tatLogDiverのメニューを追加する
 * 
 * @memberof tatLogDiver
 * @class Menu
 * @param {Object}
 *            that グラフへの参照
 */
function Menu(that) {
    // メニュー用のエレメントを取得する
    var divMenuId = that.chartIdName + "_menu";
    var divMenu = document.getElementById(divMenuId);
    // menu用divがないとき、chartの直前に追加する #13
    if (!divMenu) {
        var div = document.createElement('div');
        div.id = divMenuId;
        div.className = "menuBar";
        divMenu = that.chartId.parentNode.insertBefore(div, that.chartId);
    }
    // メニューボタン定義を登録する
    var g = that.globalName;
    // 上下段共通ボタンの定義(Download Menu)
    var menuDownloadImg = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // ATag
                divMenuId + "_DownloadImg",
                "graph image(.png)",
                g + ".menuDownloadImg"))
            .makeDownloadable("graph.png");
    var menuDownloadCsv = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // ATag
                divMenuId + "_DownloadCsv",
                "graph data(.csv)",
                g + ".menuDownloadLog"))
            .makeDownloadable("graph.csv");
    var menuDownloadLog = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // ATag
                divMenuId + "_DownloadLog",
                "graph log records(.csv)",
                g + ".menuDownloadLog"))
            .makeDownloadable("tatlog.csv");
    var menuDownloadConc = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // ATag
                divMenuId + "_DownloadConc",
                "conc log records(.csv)",
                g + ".menuDownloadConc"))
            .makeDownloadable("conclog.csv");
    
    // メニューを追加する
    var accordion = document.createElement('div'); // 要素の作成
    var _id = 0;
    if (HJN.chart.chartId === that.chartId) { // 上段グラフ用機能のメニュー追加
        // File Menu
        var menuOpenCsv = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // FileOpenTag
                divMenuId + "_OpenCsv ",
                "Open csv data file",
                g + ".menuOpenCsv"));
        var menuSaveConfig = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // ATag
                divMenuId + "_SaveCongig",
                "save format (.json)",
                g + ".menuSaveConfig"))
            .makeDownloadable("hjnconfig.json");
        var menuLoadConfig = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // FileOpenTag
                divMenuId + "_LoadCongig", // #10
                "load format (.json)",
                g + ".menuLoadConfig"));
        accordion.innerHTML = '<li class="hjnMenuLv1">'
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"].getAccordionTag(that, ++_id, "File", true)
                + '<ul class="hjnMenuLv2">'
                + menuOpenCsv.getFileOpenTag()     // オープンボタン #24
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getHtml()       // 設定HTML #76
                + menuSaveConfig.getATag()         // セーブボタン
                + menuLoadConfig.getFileOpenTag()  // ロードボタン #10
                + '</ul>' + '</li>';

        // Filter Menu #34
        var menuFilterApply = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // FuncTag
                divMenuId + "_FilterApply",
                "Apply filter & reload",
                g + ".menuFilterApply"));
        var menuFilterReset = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // FuncTag
                divMenuId + "_FilterClear",
                "Reset filter condition",
                g + ".menuFilterReset"));

        accordion.innerHTML += '<li class="hjnMenuLv1" id="menu_Filter">'
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"].getAccordionTag(that, ++_id, "Filter")
                + '<ul class="hjnMenuLv2">'    // #24
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].Filter.getHtml() // 設定HMTL #76
                + menuFilterApply.getFuncTag() // フィルターボタン
                + menuFilterReset.getFuncTag() // クリアボタン
                + '</ul>' + '</li>';

        // Simulator Menu #53
        var menuSimulatorSimulate = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // FuncTag
                divMenuId + "_SimulatorSimulate",
                "Simulate",
                g + ".menuSimulatorSimulate"));
        var menuSimulatorEditor = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // FuncTag
                divMenuId + "_SimulatorEditor",
                "JSON Editor(Open/Close)",
                g + ".menuSimulatorEditor"));
        accordion.innerHTML += '<li class="hjnMenuLv1" id="menu_Simulator">'
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"].getAccordionTag(that, ++_id, "Simulator")
                + '<ul class="hjnMenuLv2">'
                + menuSimulatorSimulate.getFuncTag()   // シミュレート実行ボタン
                + menuSimulatorEditor.getFuncTag()     // JSONエディタボタン
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].Simulator.getHtml()      // 設定HTML #74
                + '</ul>' + '</li>';
        // シミュレーション条件JSON Editエリアを設定する
        var divSimulator = document.getElementById("Simulator");
        var jsonEditor = document.createElement('div'); // 要素の作成
        jsonEditor.innerHTML = '<textarea id="SimulatorEditor" '
                + 'style="width:100%;border:none;resize:none;background:rgba(255,255,255,0.5);height:100%;">'
        divSimulator.appendChild(jsonEditor);
        var divSimulatorEditor = document.getElementById("SimulatorEditor");
        // divSimulatorEditor.readOnly = true; // #22
        divSimulatorEditor.value = __WEBPACK_IMPORTED_MODULE_1__simulator_simulator_js__["d" /* virtualSystemByJson */]
                .GetJsonConfig(); // デフォルトJSON

        // View Menu
        accordion.innerHTML += '<li class="hjnMenuLv1" id="menu_View">'
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"].getAccordionTag(that, ++_id, "View", true)
                + '<ul class="hjnMenuLv2">' //
                + '<li><div id="' + that.chartIdName + '_legend"></div></li>'
                + '</ul>' + '</li>';

        // Download Menu
        accordion.innerHTML += '<li class="hjnMenuLv1" id="menu_Download">'
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"].getAccordionTag(that, ++_id, "Download")
                + '<ul class="hjnMenuLv2">'
                + menuDownloadImg.getATag("Upper ")   // 上段画像ダウンロードボタン
                + menuDownloadCsv.getATag("Upper ")   // 上段グラフcsvダウンロードボタン
                + menuDownloadLog.getATag("Upper ")   // 上段生データダウンロードボタン
                + '</ul>' + '</li>';

        
        // メニュー登録
        divMenu.appendChild(accordion);
        // イベントリスナー登録
        document.getElementById(menuOpenCsv.menuId).addEventListener( //
                'change', that.menuOpenCsv.bind(that), false); // File Open用
        document.getElementById(menuLoadConfig.menuId).addEventListener(
                'change', that.menuLoadConfig.bind(that), false); // LoadConfig用

    } else { // 下段用グラフ機能のメニュー追加
        _id += 100;
        // Download Menu
        var chartDownloadUl = document.createElement('ul');
        chartDownloadUl.className = "hjnMenuLv2";
        chartDownloadUl.innerHTML = '' //
                + menuDownloadImg.getATag("Detail ")   // 下段画像ダウンロードボタン
                + menuDownloadCsv.getATag("Detail ")   // 下段グラフcsvダウンロードボタン
                + menuDownloadLog.getATag("Detail ")   // 下段生データダウンロードボタン
                + menuDownloadConc.getATag("Detail "); // 下段conc csvダウンロードボタン
        var chartDownload = document.getElementById("menu_Download");
        chartDownload.appendChild(chartDownloadUl);

        // View Menu
        var chartViewUl = document.createElement('ul');
        chartViewUl.className = "hjnMenuLv2";
        chartViewUl.innerHTML = '<li><div id="' + that.chartIdName
                + '_legend"></div></li>';
        var chartView = document.getElementById("menu_View");
        chartView.appendChild(chartViewUl);

        // "Bottom detail graph" Menu
        accordion.innerHTML = ''
                + '<li class="hjnMenuLv1">'
                +   __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"].getAccordionTag(that, ++_id, "Bottom detail graph", true)
                +   '<ul class="hjnMenuLv2">'
                +     '<ol><div id="detailTimeRange">'
                +     __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getHtml()     // 設定HMTL #76
                +     '</div></ol>' // #51
                +   '<li><div id="chartPlots"></div></li>' // Plot一覧用タグ
                +   '</ul>'
                + '</li>';

        // Help Menu
        var menuHelpUsage = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // DialogTag
                divMenuId + "_HelpUsage", // #84
                "Usage of TAT log diver",
                "HJN.init.Usage"))
            .makePopupable("HJN.dialogUsage", 70, 60);
        var menuHelpAbout = (new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"]( // DialogTag
                divMenuId + "_HelpAbout",
                "about TAT log diver",
                "HJN.init.Copyright"))
            .makePopupable("HJN.dialogAbout", 30, 50);

        
        accordion.innerHTML += '<li class="hjnMenuLv1">'
                + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Menu"].getAccordionTag(that, ++_id, "Help")
                + '<ul class="hjnMenuLv2" style="width: 100%;">' //
                + menuHelpUsage.getSubWindowTag() // #84 #95
                + menuHelpAbout.getDialogTag()
                + '</ul>' + '</li>';

        // メニュー登録
        divMenu.appendChild(accordion);
    }
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Copyright", function() { return Copyright; });
/**
 * @memberOf tatLogDiver
 * @class Copyright
 * @classdesc コピーライト定義と表示用メソッド
 * @prop {String} name - 名称："TAT log diver"
 * @prop {String} Version - バージョン
 * @prop {String} text - コピーライト表示文字列
 * @prop {String} url - GitHubリンク："https://github.com/hirosejn/"
 */

var Copyright = {
    name : "TAT log diver",
    Version : "b19.06.30",
    text : "&copy; 2017-" + (new Date()).getFullYear() + " Junichiroh Hirose",
    url : "https://github.com/hirosejn/",
};


/**
 * about tat Log Diver として表示する説明文をHTMLで取得する
 * 
 * @memberof tatLogDiver.Copyright
 * @return {String}表示用HTML
 */
Copyright.getAboutText = function(){
    return Copyright.name + " (" + Copyright.Version + ")<br>"
        + Copyright.text + " <br> "
        + Copyright.getGitHubHTML() + " <br> "
        + Copyright.getJSDocHTML() + " <br> "
        + Copyright.getHtmlHTML();  // #84
}

/**
 * GitHubリンク(HTML)を取得する
 * 
 * @memberof tatLogDiver.Copyright
 * @param {String}
 *            [text=Copyright.url] HTMLの表示文字列
 * @return {String} GitHubリンク(HTML)文字列
 */
Copyright.getGitHubHTML = function(text){
    text = text || Copyright.url;
    return '<a class="hjnLabel4Input" href="' + Copyright.url+ '"'
        + ' target=”_hirosejnGit”>' + text + '</a>'
}

/**
 * JSDOCリンク(HTML)を取得する
 * 
 * @memberof tatLogDiver.Copyright
 * @param {String}
 *            [name="JSDoc"] HTMLの表示文字列
 * @return {String} JSDOCリンク(HTML)文字列
 */
Copyright.getJSDocHTML = function(name){
    name = name || "JSDoc";
    return '<a class="hjnLabel4Input" href="../jsdoc/index.html"'
        +  'target=”_hirosejnJSDoc3”>' + name +'</a><BR>'
}

/**
 * HTMLページのリンク(HTML)を取得する
 * 
 * @memberof tatLogDiver.Copyright
 * @param {String}
 *            [name="HTML : " + Copyright.url] HTMLの表示文字列
 * @return {String} HTMLページのリンク(HTML)文字列
 */
Copyright.getHtmlHTML = function(name){ // #84
    var url = "https://hirosejn.github.io/HJN/";
    name = name || "HTML : " + url;
    return '<a class="hjnLabel4Input" href="' + url + '"'
        +  'target=”_hirosejnHTML”>' + name +'</a><BR>'
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = Plot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__ = __webpack_require__(5);




/**
 * グラフの点をクリックした際に決まる下段グラフの表示条件
 * 
 * @memberof tatLogDiver
 * @class Plot
 */
function Plot(){};
__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot = Plot;

/**
 * Plotの一覧
 * 
 * @type array.<String, Boolean, Boolean, index, xMs, Number, Number, Number>
 * @prop {String} label Plot一覧に表示する文字列
 * @prop {Boolean} ckBox チェックボックスの選択状態<br>
 *       （選択後すぐに削除されるのでtrueとなることはない）
 * @prop {Boolean} radio ラジオボタンの選択状態
 * @prop {index} n グラフ番号
 * @prop {xMs} x xの値
 * @prop {Number} y yの値
 * @prop {Number} rangeMinus 表示幅時間マイナス（秒）
 * @prop {Number} rangePlus 表示幅時間プラス（秒）
 * @prop {Number} rangeUnit 表示幅時間 単位（sec:1/min:60/hour:3600/day:86400)
 * 
 */
__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List = [];

/**
 * point/baloonクリック時呼出し用関数<br>
 * 詳細グラフを描画し、Plotを更新する
 * 
 * @param {Objcet}
 *            point dygraph の point
 */
Plot.PointClickCallback = function(point) {
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[0:PointClickCallback]start---------------","calc");
    var n = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.seriesConfig.findIndex(function(e){ return e.key === point.name; }),// シリーズ番号
        x = point.xval, // ミリ秒
        y = point.yval; // 秒

    // ETPS,EMPS,EAPSのとき、TATが幅に含まれるよう、幅(range)を拡大する #57
    var rangeTagUnit = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_UNIT"); 
    var rangeUnit  = rangeTagUnit  ? rangeTagUnit : __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE;
    if ((n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.ETPS.N || n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.EMPS.N || n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.EAPS.N) 
            && rangeUnit < __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE) {
        rangeUnit = __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE;
        __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setValueByKey("D_UNIT", rangeUnit);

        // selectリストの選択を、rangeUnitに合わせる #57
        var options = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getKeyConfig("D_UNIT"); // option一覧
        var valueArray = Object.keys(options).sort(function(a,b){return a - b}); // optionの値の一覧(降順)
        for (var i = 0; i < valueArray.length; i++) { // #27
            if (rangeUnit <= +valueArray[i]) {
               var optionKey = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getOptionKey("D_UNIT", valueArray[i]);
               __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setText("D_UNIT", optionKey)
               break;
            }
        }
    }

    // グラフの日時で、詳細グラフを再作成する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].init.SetDetailDateTime(x);
    var tat = new __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */](__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].init.GetSliderRangedEtat()); // #57
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.setSeriesSet(tat); // #75
    
    // 下段の残処理終了後、下段データを登録描画する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.graph.ready(function(){ __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.update(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.seriesSet, n); }); // #57
    // Hover表示しているplotを、Plot.Listに登録し、plotsアイコンを再描画する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.Add(n, x, y);
    // Balloonを再描画する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.ShowBalloon();
};

/**
 * point/baloonダブルクリック時呼出し用関数<br>
 * Plotを削除する
 * 
 * @param {object}
 *            plot dygraphのpoint
 */
Plot.PointDblClickCallback = function(point) {
    // 指定plotを削除する
    var n = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.seriesConfig.findIndex(function(e){ return e.key === point.name; }),
        x = point.xval, // ミリ秒
        i = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.findIndex(function(p){
                return(p.n === n && p.x === x) ||   // 完全一致
                        ("tpsPlot" in p &&          // 詳細一致
                        p.tpsPlot.n === n && p.tpsPlot.x === x); });
    if(0 <= i) __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.splice(i, 1);
    
    Plot.Render();
    // グラフ内の吹き出しを再表示する
    Plot.ShowBalloon();
};

/**
 * クリック時のHoverからPlot.Listを設定する
 * 
 * @param {index}
 *            n グラフのシリーズ番号
 * @param {xMs}
 *            x マウスクリック時のxの値（ミリ秒）
 * @param {Number}
 *            y マウスクリック時のyの値
 * @return {index} i plots内のplotの位置
 */
Plot.Add=function(n, x, y) {
    // 各plotを非選択状態とする
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.forEach(function(e){e.radio = false;});
    // ラベルフォーマットの設定
    var format = (n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.ETPS.N || n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.CTPS.N) ? "hh:mm:ss" : "hh:mm:ss.000", // #92
        label = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](x, format, true) + " " + // #61
                __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.seriesConfig[n].label.replace("%N",__WEBPACK_IMPORTED_MODULE_0__util_util_js__["N2S"](y));
    // 幅(range)を取り込む（秒）
    var rangePlusTag  =  document.getElementById("DetailRangePlus"),
        rangeMinusTag =  document.getElementById("DetailRangeMinus"),
        rangeUnitTag  =  document.getElementById("DetailRangeUnit"), // #48
        rangeUnit  = rangeUnitTag  ? +rangeUnitTag.value : __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE, // #57
        rangePlus  = rangePlusTag  ? +rangePlusTag.value  : 1,  // 幅
        rangeMinus = rangeMinusTag ? +rangeMinusTag.value : 1;

    // 既存Poltを検索する
    var i = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.findIndex(function(p){
                return(p.n === n && p.x === x) ||   // 完全一致
                        ("tpsPlot" in p &&          // 詳細一致
                        p.tpsPlot.n === n && p.tpsPlot.x === x); });
    // Plotを設定する
    var plot;
    if(0 <= i){ // 既存Plotsにある時、選択状態とし、rangeを再設定する
        plot = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List[i];
        plot.radio = true;
        plot.rangePlus  = rangePlus; // 秒
        plot.rangeMinus = rangeMinus;
        plot.rangeUnit  = rangeUnit; // #48
    }else{      // 既存に無いときPlotを追加する
        // ETAT,STATのとき、TATが幅に含まれるよう、幅(range)を拡大する #30 #48 #57
        if (n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.ETAT.N){
            rangeMinus = Math.max(rangeMinus, 
                    Math.floor(x / rangeUnit) - Math.floor((x - y) / rangeUnit)); // #48
            __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setText("D_RANGE_MINUS", rangeMinus);
        }else if (n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.STAT.N){
            rangePlus = Math.max(rangePlus,
                    Math.floor((x + y) / rangeUnit)) - Math.floor(x / rangeUnit) ; // #48
            __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setText("D_RANGE_PLUS", rangePlus);
        }
        // Plotを追加する
        plot = {label: label, ckBox:false,
                 radio:true, n: n, x: x, y: y, 
                 rangePlus: rangePlus, rangeMinus: rangeMinus, rangeUnit: rangeUnit };
        if (n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.CTPS.N){          // CTPSのとき秒内最大CONCとして登録する
            adjustPlotToY(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.conc, x, x + __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chart.cTpsUnit.unit, y, 
                    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.CONC.N, plot, rangePlus, rangeMinus, rangeUnit);
        }else if (n === __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.EMPS.N){    // EMPSのとき秒内最大ETATとして登録する
            adjustPlotToY(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.eTat, x, x + __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE, y, 
                    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.ETAT.N, plot, rangePlus, rangeMinus, rangeUnit);
        }else { // CTPS,EMPS以外の時、選択Plotを追加する
            __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.push(plot);
        }
        // Plotsを時刻順にソートする
        __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.sort(
                function(a, b) { return a.x - b.x; });
        i = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.findIndex(
                function(p){ return(p.n === n && p.x === x); });
    }
    Plot.Render();
    return i;   // plots内のplotの位置

    
    // 内部関数：プロット位置を、指定秒から詳細グラフの最大時刻に変更する #19
    function adjustPlotToY(conc, x, toX, y, n, plot, rangePlus, rangeMinus, rangeUnit){
        if (!conc) return;
        var maxTime = 0,
            concMax = 0,
            i = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["binarySearch"](x, conc, function(e){ return e.x; });
        for (; i < conc.length && conc[i].x < toX; i++){    // #26
            if (concMax <= conc[i].y){
                    maxTime = conc[i].x;
                    concMax = conc[i].y;
            }
        }
        if (concMax === y) { // 補正すべき時刻が求まったときCONC,ETATを追加する #23
            x = maxTime;
            format = "hh:mm:ss.000"; // #92
            label = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](x, format, true) + " " + // #61
                    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Tat.seriesConfig[n].label.replace("%N",__WEBPACK_IMPORTED_MODULE_0__util_util_js__["N2S"](y));
            __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.push( {label: label, ckBox:false,
                 radio:true, n: n, x: x, y: y, 
                 rangePlus: rangePlus , rangeMinus: rangeMinus, rangeUnit: rangeUnit,
                 tpsPlot: plot} );  // 詳細plotには、tpsのplot情報も保持する
        } else { // 補正すべき時刻がない場合、元のPlotを追加する
            __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.push(plot);
        }

    }
};

/**
 * Plot.Listを再表示する
 */
Plot.Render = function() {
    var divCheckedPlots =  document.getElementById(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartName + "Plots");
    // 既存のアイコンを削除する
    while (divCheckedPlots.firstChild){
        divCheckedPlots.removeChild(divCheckedPlots.firstChild);
    }
    // 登録されているplots分のアイコンを追加する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.forEach( function(e, i){
        var div = document.createElement('div'),        // 要素の作成
            radio = e.radio ? 'checked="checked"' : '', // radio選択指定
            ckBox = e.ckBox ? 'checked="checked"' : ''; // check boxのチェック指定
        div.className = "hjnPlot";
        div.innerHTML =
            '<input type="checkbox" value="' + e.x + '" id="checkBox_' + i + '" ' + ckBox +
                    ' title="delete" onclick="HJN.Plot.CheckBox(' + i + ')">' +
            '<label for="checkBox_' + i + '"></label>' +
            '<input type="radio" name="CheckedPlot" id="SaveTime_' + i + '" ' + radio +
                    ' onclick="HJN.Plot.CheckRadio(' + i + ')">' +
            '<label for="SaveTime_' + i + '">' + e.label + '</label>';
        divCheckedPlots.appendChild(div);
    } );
};
/**
 * PlotのChekBox変更時呼出用関数<br>
 * 指定Plotを削除し、PlotsとBaloonを再描画する
 * 
 * @param {index}
 *            i 削除対象plotの、plots内位置
 */
Plot.CheckBox = function(i) {
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.splice(i,1);      // checkされたplotを削除する
    Plot.Render();          // Plotsを再描画する
    Plot.ShowBalloon();     // グラフのBalloonを再描画する
};
/**
 * PlotのRadioボタン変更時呼出用関数<br>
 * radio選択時に下段グラフを更新する
 * 
 * @param {index}
 *            i 選択されたplotの、plots内位置
 */
Plot.CheckRadio = function(i) {
    // Plot.Listにradioの状態を反映する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List.forEach(function(e){ e.radio = false; });
    var plot = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].Plot.List[i];
    plot.radio = true;
    // グラフの日時で、詳細グラフを再作成する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].init.SetDetailDateTime(plot.x); // 中心時刻に設定する
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setText("D_RANGE_PLUS", plot.rangePlus); // 幅を設定する
                                                                        // #74
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setText("D_RANGE_MINUS", plot.rangeMinus);
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setText("D_UNIT", 
                __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getOptionKey("D_UNIT", plot.rangeUnit)); // #48
    var n = plot.tpsPlot ? plot.tpsPlot.n : plot.n; // #61
    var tat = new __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */](__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].init.GetSliderRangedEtat()); // #75
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.setSeriesSet(tat); // #57
    // 下段データを登録描画する
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.update(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.seriesSet, n); // #57
    // Balloonを再描画する
    Plot.ShowBalloon();
};
/**
 * Balloonを再描画する
 */
Plot.ShowBalloon =function(){
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chart.showBalloon();
    __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_HJN_js__["HJN"].chartD.showBalloon();
    // タッチデバイスでないとき、lineViewerに表示をクリップボードにコピーする #78
    if (!__WEBPACK_IMPORTED_MODULE_0__util_util_js__["TouchPanel"].isTouchableDevice()) { // #22
        __WEBPACK_IMPORTED_MODULE_0__util_util_js__["copyToClipboard"]("lineViewer"); // #61
    }
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = MenuConfigDetailGraph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Graph_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__ = __webpack_require__(5);




/**
 * @memberOf tatLogDiver
 * @class MenuConfigDetailGraph
 * @classdesc DetailGraph用メニューHTML定義
 * 
 */
function MenuConfigDetailGraph() {} // #27

MenuConfigDetailGraph.config = function () {
    var prefix = "DetailGraph";
    var c = new  __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"](prefix);
    // Config設定画面定義
    c 
        .name("D_RANGE").label(null,"Range:")
            .number("D_RANGE_MINUS", " - ", "", "1", 'style="width:40px;"', func_D)
            .number("D_RANGE_PLUS"  , " + ", "", "2", 'style="width:40px;"', func_D)
        .name("D_UNIT").startTag("select")
            .option(c.def("D_UNIT_SEC",         1000), null, "sec",   false, null, func_D) // #48
            .option(c.def("D_UNIT_10SEC",      10000), null, "10sec", true,  null, func_D)
            .option(c.def("D_UNIT_MIN",        60000), null, "min",   false, null, func_D)
            .option(c.def("D_UNIT_HOUR",     3600000), null, "hour",  false, null, func_D)
            .option(c.def("D_UNIT_6HOUR",   21600000), null, "6hour", false, null, func_D)
            .option(c.def("D_UNIT_DAY",     86400000), null, "day",   false, null, func_D)
            .option(c.def("D_UNIT_YEAR", 31536000000), null, "year",  false, null, func_D)
        .endTag()
    ;
}

// Config登録関数定義
function func_D(){
    clearTimeout(HJN.timer);
    HJN.timer = setTimeout(function(){
            __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogTextInit("[-:HJN.init.setDetailRange]start---------------","calc");
            // 表示中Plotsのrangeを更新する #30
            var i = HJN.Plot.List.findIndex(function(e){ return (e.radio === true); });
            var plot = HJN.Plot.List[i];
            plot.rangePlus  = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_RANGE_PLUS"); // #27
            plot.rangeMinus = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_RANGE_MINUS");
            plot.rangeUnit = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.getConfig("D_UNIT"); // #48
            plot.rangeUnit = plot.rangeUnit  ? plot.rangeUnit  : __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */].CYCLE; // #57
            __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].DetailGraph.setValueByKey("D_UNIT", plot.rangeUnit);

            // 下段データを登録する
            var tat = new __WEBPACK_IMPORTED_MODULE_2__timeSeries_timeSeries_js__["e" /* Tat */](HJN.init.GetSliderRangedEtat()); // #75
            HJN.chartD.setSeriesSet(tat);
            // 下段グラフを描画する
            __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Graph_js__["default"].prototype.update.call(HJN.chartD, HJN.chartD.seriesSet);
        }, 750);    // 750ms 値の変更がなかった時に、処理を開始する
 };

/***/ }),
/* 11 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(21);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(22);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(12)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./tatLogDiver.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./tatLogDiver.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Tat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeSeries_MappedETat_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeSeries_ETat_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timeSeries_Cash_js__ = __webpack_require__(17);






/**
 * @memberOf TimeSeries
 * @class Tat
 * @classdesc Tat 応答時間(Turnaround time)の時系列データ管理クラス
 * @param {ETAT}
 *            [eTat] [[終了時刻(ms), 処理時間(sec), （任意）ログレコード等], ...]<br>
 *            eTatが指定されているとき、this.seriesSet を設定する
 */
function Tat(eTat) {
    
    this.cTpsUnit = Tat.UNIT_CTPS[0];
    this.seriesSet = [];

    if (eTat){
        this.createSeries(eTat);
    }
}

/**
 * クラス定数
 */
Tat.UNIT_CTPS = [
        { label: "/sec",   unit: 1000 },
        { label: "/min",   unit: 60000 },
        { label: "/hour",  unit: 3600000 },
        { label: "/day",   unit: 86400000 }];
Tat.CYCLE = 60000;  // ミリ秒 #57

// グラフ定数
Tat.CONC = {
        key : 'conc',
        name : '多重度（詳細）',
        label : 'conc:%N',
        N : 0,
        scale : 0,
        color : 'rgba(  0,  0,127, 0.3)',
        tpsN : 1
    }; // #7
Tat.CTPS = {
        key : 'cTps',
        name : '多重度（区間最大）',
        label : 'conc(max):%N',
        N : 1,
        scale : 0,
        color : 'rgba(  0,  0,127, 0.1)',
        detailN : 0
    };
Tat.ETPS = {
        key : 'eTps',
        name : 'average tps / min (end) [line]', // #57
        label : 'end:%Ntps',
        N : 2,
        scale : 0,
        color : 'rgba(  0, 127, 127, 0.3)'
    };
Tat.STAT = {
        key : 'sTat',
        name : 'response by start time [Y2軸:plot]',
        label : 'start:%Nms',
        N : 3,
        scale : 1,
        color : 'rgba(127, 127, 0, 0.3)'
    };
Tat.ETAT = {
        key : 'eTat',
        name : 'response by end time   [Y2軸:plot]',
        label : 'end:%Nms',
        N : 4,
        scale : 1,
        color : 'rgba(127,  0,  0, 0.3)'
    };
Tat.EMPS = {
        key : 'eMps',
        name : 'max response / min (end) [Y2軸:line]', // #57
        label : 'max:%Nms',
        N : 5,
        scale : 1,
        color : 'rgba(127,   0,  64, 0.3)'
    };
Tat.EAPS = {
        key : 'eAps',
        name : 'average response / min (end) [Y2軸:line]', // #57
        label : 'ave:%Nms',
        N : 6,
        scale : 1,
        color : 'rgba(127,   0,  64, 0.1)'
    };
Tat.toSeriesArray = function(conc, cTps, eTps, sTat, eTat, eMps, eAps) {
    return [ conc, cTps, eTps, sTat, eTat, eMps, eAps ];
}
Tat.seriesConfig = Tat.toSeriesArray(
        Tat.CONC, Tat.CTPS, Tat.ETPS, Tat.STAT, Tat.ETAT,
        Tat.EMPS, Tat.EAPS);

/**
 * 終了時刻のTAT時系列データ(eTat)から、描画用時系列データ配列を作成する
 * 
 * @memberOf TimeSeries
 * @param {ETAT}
 *            eTat [[終了時刻(ms), 処理時間(sec), （任意）ログレコード等], ...]
 * @return {seriesSet} dygraph用時系列データ配列
 */
Tat.prototype.createSeries = function (eTat) {
    // 時系列データを初期化する
    var conc = [], cTps = [], eTps = [], sTat = [], eMps = [], eAps = [];

    // 集計対象データがないとき
    if (eTat.length === 0)
        return Tat.toSeriesArray(conc, cTps, eTps, sTat, eTat, eMps, eAps);

    /** eTatをソートする * */
    // 開始時刻でソートする #35
    eTat.sort(function (a, b) {
        return a.x - b.x;
    });
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[1:eTat sorten ] " + eTat.length + " plots",
            "calc");

    /** eTps(時間あたり処理件数),eMps,eAps(時間あたり最大/平均応答時間)時系列データを作成する * */
    var dFrom = Math.floor(eTat[0].x / Tat.CYCLE) * Tat.CYCLE,
        dTo = dFrom + Tat.CYCLE,
        num = 0, // #39
        maxTat = 0.0, // #19
        aveTmp = 0.0;
    eTat.forEach(function (e) {
        if (e.x < dTo) {
            num += 1;
            if (maxTat < e.y) maxTat = e.y; // #19
            aveTmp += e.y;
        } else {
            eTps.push({x : dFrom, y : num * 1000 / Tat.CYCLE}); // #57
            eMps.push({x : dFrom, y : maxTat}); // #19
            eAps.push({x : dFrom, y : aveTmp / num});
            dFrom = Math.floor(e.x / Tat.CYCLE) * Tat.CYCLE;
            dTo = dFrom + Tat.CYCLE;
            num = 1;
            maxTat = e.y; // #19 #39
            aveTmp = e.y; // #39
        }
    }, this);
    eTps.push({x : dFrom,             y : num * 1000 / Tat.CYCLE}); // #57
    eTps.push({x : dFrom + Tat.CYCLE, y : num * 1000 / Tat.CYCLE}); // #57
    eMps.push({x : dFrom,             y : maxTat}); // #19
    eMps.push({x : dFrom + Tat.CYCLE, y : maxTat}); // #57
    eAps.push({x : dFrom,             y : aveTmp / num});
    eAps.push({x : dFrom + Tat.CYCLE, y : aveTmp / num}); // #57
    
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[3:eTps,eMps,eAps created] " + eTps.length
            + " plots", "calc");

    /** sTat（開始時間）時系列データを作成する,同時に入力eTatを補正する * */
    // eTatからsTatを登録する
    eTat.forEach(function (e, i) {
        // 処理時間=0 のとき、1マイクロ秒とみなす(有効桁0.2マイクロ秒に切上される）
        if (e.y === 0) {
            e.y = 0.001;
            e.x += e.y;
        } // ミリ秒
        // sTatにeTatデータを登録する
        sTat.push({
            x : e.x - e.y,
            y : e.y,
            eTatIdx : i
        });
    });
    // 開始時刻でソートする
    sTat.sort(function (a, b) {
        return a.x - b.x;
    });
    // eTatにsTatの位置を設定する
    sTat.forEach(function (s, i) {
        eTat[s.eTatIdx].sTatIdx = i;
    });
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[2:sTat created] " + sTat.length + " plots",
            "calc");

    /** CONC(多重度)時系列データを作成する * */
    var concTmp = [];
    // eTatから、多重度が変化した時刻の一覧を作成する
    eTat.map(function (e, i) {
        // 開始時刻にカウントアップ情報を追加する
        concTmp.push({x : e.x - e.y, y : 1});
        // 終了時刻をカウントダウン情報を追加する
        concTmp.push({x : e.x, y : -1});
    });
    // concを変化した時刻（開始or終了）でソートする
    concTmp.sort(function (a, b) {
        return a.x - b.x;
    });
    // concに同時取引数を設定する
    var concNum = 0;
    concTmp.forEach(function (c, i, a) {
        // 重複削除用フラグを立てる #23
        if (i > 0 && c.x === a[i - 1].x) {
            a[i - 1].del = true;
        }
        // 同時取引数を集計する(前提：c.y に、開始なら1、終了なら(-1)が設定されている)
        concNum += c.y;
        c.y = concNum;
    });
    // concの同じ時刻の点を削除する #23
    conc = concTmp.filter(function (c) {
        return !c.del;
    });
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[4:conc created] " + conc.length + " plots",
            "calc");

    /** cTPS秒間同時処理件数（concurrent transactions/sec）時系列データを作成する #18 * */
    var XSec = floorTime(conc[0].x, Tat.CYCLE), // ミリ秒
    YMax = conc[0].y, YNext = conc[0].y;
    // concの先頭と末尾の時刻(x)の差よりPlot数を求め、Plot数が規定数(8000個)を超えたら、桁上げする #38
    var cTpsMaxPlots = 8000, // 桁上げするPlot数
    cTpsUnits = Tat.UNIT_CTPS, // #48
    concTerm = conc[conc.length - 1].x - conc[0].x, // ミリ秒
    cTpsIdx = 0;
    while (cTpsIdx < cTpsUnits.length
            && concTerm / cTpsUnits[cTpsIdx].unit > cTpsMaxPlots) {
        cTpsIdx++;
    }
    cTpsIdx = (cTpsUnits.length > cTpsIdx) ? cTpsIdx : cTpsUnits.length - 1;
    this.cTpsUnit = cTpsUnits[cTpsIdx];
    // メニューのViewのcTPSのラベルに単位を追加する
    var pos = (this === HJN.chart) ? 0 : 1;
    document.getElementsByName("cTps")[pos]
                .parentNode.lastChild.data = HJN.Tat.CTPS.name + this.cTpsUnit.label;

    // 規定時間単位の最大同時処理数cTPSを作成する
    conc.forEach(function (c) {
        if (floorTime(c.x, this.cTpsUnit.unit) === XSec) { // c.xは ミリ秒
            YMax = Math.max(YMax, c.y);
        } else {
            cTps.push({x : XSec, y : Math.max(YMax, YNext)});
            for (var t = XSec + this.cTpsUnit.unit;
                    t < floorTime(c.x, this.cTpsUnit.unit);
                    t += this.cTpsUnit.unit) { // c.xはミリ秒
                        cTps.push({x : t, y : YNext});
                if (YNext === 0) break;
            }
            XSec = floorTime(c.x, this.cTpsUnit.unit);
            YMax = Math.max(YNext, c.y);
        }
        YNext = c.y;
    }, this);
    cTps.push({x : XSec, y : YMax});
    cTps.push({x : XSec + this.cTpsUnit.unit, y : YNext});

    // Util.Logger.ShowLogText("[5-1:cTps created] " + cTps.length + "
    // plots","calc");

    // cTpsのxからindexを引くMapを作成する #18
    eTat = new __WEBPACK_IMPORTED_MODULE_2__timeSeries_ETat_js__["a" /* default */](eTat); // #75
    __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Logger"].ShowLogText("[5:cTps created] " + cTps.length + " plots("
            + +Math.floor(concTerm / 1000) + "sec" + cTpsUnits[cTpsIdx].label
            + ")", "calc");

    // 集計結果をHJN.Graphに設定する 注）this.SERIESESと同じ順番にすること
    this.seriesSet = Tat.toSeriesArray(conc, cTps, eTps, sTat, eTat, eMps, eAps);

    return this;

    
    // 時刻を指定ミリ秒間隔で切り捨てる（内部関数）
    function floorTime(t, cycle) {
        return Math.floor(Math.floor(t / cycle) * cycle);
    }
};

/**
 * cTpsの集計単位を取得する
 * 
 * @memberOf TimeSeries
 * @return {object} 単位構造体 { label: "/sec", unit: 1000 }
 */
Tat.prototype.getCTpsUnit = function () {
    return this.cTpsUnit;
}

/**
 * seriesSetを取得する
 * 
 * @memberOf TimeSeries
 * @return {array} seriesSet
 */
Tat.prototype.getSeriesSet = function () {
    return this.seriesSet;
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf TimeSeries
 * @class MappedETat
 * @classdesc 期間指定eTat取得用Map
 *            <p>
 *            指定期間に動いているeTatの一覧を、高速に取得するマップ
 * @param {ETAT}
 *            eTat インデックスを追加するETAT
 * @example eTat.tatMap = new HJN_util.MappedETat(eTat); var trans =
 *          eTat.tatMap.search(x, x, 1000);
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #18
    /** @static */
    MappedETat.prototype = {
            _abscissa: [],
            _conf :[{ms:      10, step:5, label:"0_10ms_"},
                    {ms:      50, step:2, label:"1_50ms_"},
                    {ms:     100, step:5, label:"2_100ms_"},
                    {ms:     500, step:2, label:"3_500ms_"},
                    {ms:    1000, step:5, label:"4_1sec_"},
                    {ms:    5000, step:4, label:"5_5sec_"},
                    {ms:   20000, step:3, label:"6_20sec_"},
                    {ms:   60000, step:5, label:"7_1min_"},
                    {ms:  300000, step:4, label:"8_5min_"},
                    {ms: 1200000, step:3, label:"9_20min_"},
                    {ms: 3600000, step:6, label:"10_1h_"},
                    {ms:21600000, step:4, label:"11_6h_"},
                    {ms:Number.MAX_VALUE, step:1, label:"12_overDay_"}] // 最後はstep:１
        };
    /** @constructor */
    function MappedETat(eTat){
        if(!(this instanceof MappedETat)) return new MappedETat(eTat);
        // MappedArrayを作成する
        this._tatMap = new MappedArray(eTat, this._getKey, true);
    }

    /** @private */
    MappedETat.prototype._row = function(label, step) {return label + step;};

    /** @private */
    // MapKey取得関数
    MappedETat.prototype._getKey = function(e, i) {        // MapedMap用Key配列関数
        var start = e.x - e.y,      // x,yはミリ秒
            end = e.x,
            _conf = MappedETat.prototype._conf,
            _row = MappedETat.prototype._row,
            term = _conf[0].ms,
            rowLv = 0;
        if(Math.ceil(end / term) - 1 === Math.floor(start / term)){ // 最小BOX
            return [_row(_conf[0].label, 0),
                    (Math.ceil(e.x / _conf[0].ms) - 1) * _conf[0].ms];
        }
        for (i = 1; i < _conf.length; i++) {                // 最下位から上に評価
            term = _conf[i].ms;
            if(Math.floor(end / term) === Math.floor(start / term) 
                    || end - start < term){                      // 上位BOXを起点
                term = _conf[i-1].ms;   // ひとつ下位のBOX期間（下から評価したので二段下となることは無い
                rowLv = Math.floor(end / term) - Math.floor(start / term);
                return [_row(_conf[i-1].label, rowLv),
                        (Math.ceil(e.x / _conf[i-1].ms) - 1) * _conf[i-1].ms];
            }
        }
        return "error";
    };

    // static メンバーの設定
    // _confから_abscissa(横軸）を生成する
    var c = MappedETat.prototype._conf,
        e2 = c[c.length - 2],
        
        e  = c[c.length - 1];
    MappedETat.prototype._abscissa.push(
            {label: MappedETat.prototype._row(e.label, e.step), ms: e.ms ,i: 1,
                step: e.step, from: e2.ms * e2.step, to: e.ms} );   // 末尾を先頭に追加
    for (var j = c.length - 1; 0 <= j; j--){    // 降順に追加
        e = c[j];
        for (var i = e.step; 0 < i; i--){ // #39
            MappedETat.prototype._abscissa.push(
                    {label: MappedETat.prototype._row(e.label, i), ms: e.ms, i: i, 
                                step: e.step, from: e.ms * i, to: e.ms * (i + 1)} );
        }
    }
    MappedETat.prototype._abscissa.push( 
            {label: MappedETat.prototype._row(c[0].label, 0), ms: c[0].ms, i: 0,
                step: 0, from: 0, to: c[0].ms} );   // 先頭を末尾に追加

    
    // public
    /**
     * 指定期間に動いているeTatを検索する
     * 
     * @memberOf Util.MappedETat
     * @parm {Number} from 指定期間(from)
     * @parm {Number} [to=from] 指定期間(to)
     * @parm {Number} [cap] cap件数となったら抽出を終了する（指定なしの時：全件）
     * @return {ETAT} eTatArr 指定期間内のeTat配列
     */
    MappedETat.prototype.search = function (from, to, cap) {
        to = to || from;    // to省略時は時刻指定(from=to)
        cap = cap || Number.MAX_VALUE; // 指定なしの時：全件
        var map = this._tatMap._map,
            eTat = this._tatMap._arr,
            abscissa = this._abscissa,
            eTatArr = [],
            start = 0,
            end = 0;
        // 検索対象のBOX一覧を生成する
        abscissa.forEach(function(e){   // 存在しうる横軸のうち（tatが長時間の方から）
            if (map[e.label]){          // 横軸が存在するものについて
                var boxNum = e.i + Math.ceil(to / e.ms) - Math.floor(from / e.ms), // #45
                    key = Math.floor(from / e.ms) * e.ms;
                // 存在しうるKey値を終了時間が早い方から集計する
                for(var j = 0; j <= boxNum; j++){
                    // Key値が存在するものみが集計対象
                    if (map[e.label][key]){ 
                        // かつ、Keyが持っている要素(eTatへの参照:k)が集計対象
                        map[e.label][key].forEach(function(k){
                            // かつ、from-toの期間に動いている要素(eTatのindex)が集計対象
                            start = eTat[k].x - eTat[k].y;
                            end   = eTat[k].x;
                            if((start <= to) && (from <= end)){
                                // かつ、戻り値の配列要素数がcap未満の場合が集計対象
                                if(eTatArr.length < cap){
                                    // 集計対象条件に合致する要素を、戻り値の配列に追加する
                                    eTatArr = eTatArr.concat(eTat[k]);
                                }
                            }
                        });
                    }
                    key += e.ms;    // 次のKey値
                }
            }
        }, this);
        return eTatArr;
    };
    
    // newの戻り値
    return MappedETat;
}());


/**
 * @memberOf TimeSeries
 * @class MappedArray
 * @classdesc 配列位置逆引きマップ
 *            <p>
 *            配列に格納されているオブジェクトのx値で、配列位置を高速検索するマップ<br>
 *            指定関数の戻り値(x)をキーとするマップを作成する
 *            <p>
 *            参考 {@link http://qiita.com/alucky0707/items/10052866719ba5c5f5d7}
 * 
 * @param {Array}
 *            arr インデクスをつける対象の配列
 * @param {String|function}
 *            [getKey=""] MappedArrayのKey値の取得方法
 *            <p>
 *            String指定のとき（デフォルト""を含む）、配列要素の値(valueOf)
 *            <p>
 *            注： 0,00,"0"は同値、1,01,"1"は同値 Stringのとき、 配列要素が持つ指定要素の値
 *            <p>
 *            functionのとき、配列要素に指定関数を適用した戻り値
 *            <p>
 *            関数の引数：(配列要素オブジェクト、配列のインデックス、作成中のMappedArrayへの参照）
 * @param {Boolean}
 *            [isMappedMap] getKeyが2段Map用の配列を返却する
 * @return {object} Index arrに対するインデックス（連想配列名で検索）
 * @example _tatMap = new HJN_util.MappedArray(eTat, this._getKey, true);
 */
var MappedArray = (function() {    // #18
    /** @constructor */
    function MappedArray(arr, getKey, isMappedMap){
        if(!(this instanceof MappedArray)) return new MappedArray();
        this._arr = arr;
        // getKeyによりIndex作成関数を設定する
        if(!getKey || getKey === ""){
            // getKey指定がないとき、配列の値
            this._getKey = function(e){ return e.valueOf(); };
        }else if ((typeof(getKey) === "string") && (getKey !== "")){    // #29
            // getKeyが文字列のとき、配列内オブジェクトのgetKey要素の値
            this._getKey = function(e){ return e[getKey]; };
        }else if (typeof(getKey) === "function" ){  // #29
            // getKeyが関数のとき、配列内オブジェクトに関数を適用した戻り値
            this._getKey = getKey;
        }else{  // 以外のときエラーログを出力し、getKey指定なしと同様、配列の値
            console.error("MappedArrayの第二引数エラー：[ %o ]を無視します ",getKey);
            this._getKey = function(e){ return e.valueOf(); };
        }
        // MappedArrayを作成する
        if(!isMappedMap){
            this._createMappedArray();          
        }else{
            this._createMappedMappedArray();
        }
    }

    /** @private */
    MappedArray.prototype._createMappedArray = function() {
        var key = ""; 
        this._map = this._arr.reduce(function(m, a, i) {
            key = this._getKey.call(a, a, i, m);
            m[key] = (m[key] || []).concat(i);
            return m;
        }, {});
    };
    /** @private */
    MappedArray.prototype._createMappedMappedArray = function() {
        var keys = [],
            key = "",
            mKey = "",
            _getKey = this._getKey;
        this._map = this._arr.reduce(function(m, a, i) {
            keys = _getKey.call(a, a, i, m);
            key = keys[1] || "error";
            mKey = keys[0] || "error";
            if(m[mKey] === undefined) m[mKey] = {};
            m[mKey][key] = (m[mKey][key] || []).concat(i);
            return m;
        }, {});
    };

    // public
    /**
     * 値の存在チェック
     * 
     * @memberOf TimeSeries.MappedArray
     */
    MappedArray.prototype.has = function (keyValue) {
        return keyValue in this._map;
    };
    /**
     * 該当位置を配列で返す
     * 
     * @memberOf TimeSeries.MappedArray
     */
    MappedArray.prototype.indexes = function (keyValue) {
        return this._map[keyValue] || [];
    };
    /**
     * 該当する要素を配列で返す
     * 
     * @memberOf TimeSeries.MappedArray
     */
    MappedArray.prototype.search = function (keyValue) {    
        var arr = this._arr;
        return this.indexes(keyValue).reduce(function(m, i) {
            m.push(arr[i]);
            return m;
        }, []);
    };
    /**
     * Array.prototype.indexOf() 同等
     * 
     * @memberOf TimeSeries.MappedArray
     */
    MappedArray.prototype.indexOf = function (keyValue) {
        var idxArr = this._map[keyValue],
            i = idxArr ? idxArr.length : -1;
        return (0 < i) ? idxArr[0] : -1;
    };
    /**
     * Array.prototype.lastIndexOf() 同等
     * 
     * @memberOf TimeSeries.MappedArray
     */
    MappedArray.prototype.lastIndexOf = function (keyValue) {
        var idxArr = this._map[keyValue],
            i = idxArr ? idxArr.length : -1;
        return (0 < i) ? idxArr[i-1] : -1;
    };
    
    
    return MappedArray;
}());

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ETat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timeSeries_MappedETat_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeSeries_Cash_js__ = __webpack_require__(17);



/**
 * @memberOf TimeSeries
 * @class ETat
 * @extends Array
 * @classdesc eTat管理クラス、Arrayのメソッドを継承
 * @param {Array}
 *            [that] ETAT構造の配列
 */
function ETat(that) {
    /** @private */
    // cTpsのxからindexを引くMapを作成する #18
    that.tatMap = new __WEBPACK_IMPORTED_MODULE_0__timeSeries_MappedETat_js__["a" /* default */](that);
    // キャッシュを作成する
    that.cash = Object(__WEBPACK_IMPORTED_MODULE_1__timeSeries_Cash_js__["a" /* default */])();

    /**
     * 指定期間のeTatを取得する<br>
     * 性能対策としてキャッシュを持っている
     * 
     * @memberof TimeSeries.ETat
     * @param {Number}
     *            [detailDateTime] 期間の基準時刻(ミリ秒)
     * @param {Number}
     *            [detailRangeMinus] 抽出開始時刻を求める基準時刻から引く時間(ミリ秒)
     * @param {Number}
     *            [detailRangePlus] 抽出終了時刻を求める基準時刻に足す時間(ミリ秒)
     * @param {Number}
     *            [detailRangeUnit] 抽出開始終了時刻を丸める時間の単位(ミリ秒)
     * @return {ETAT} 指定期間のETAT配列
     */
    that.sliceByRangeUnit = function (detailDateTime, detailRangeMinus, detailRangePlus, detailRangeUnit){
        var rangeUnit = detailRangeUnit || TimeSeries.Tat.CYCLE;
        var dt = Math.floor(detailDateTime / rangeUnit) * rangeUnit; // 中央時刻(ミリ秒)
        var from = dt - detailRangeMinus * rangeUnit;  // #48
        var to = dt + detailRangePlus  * rangeUnit;  // 幅（ミリ秒）
        var eTatDetail = [{x: 0, y: 0.001, sTatIdx: 0}];    // tatMapが無い場合の返却値
        if (this.tatMap){ // #18
            // eTatDetailがレンジキャッシュにあるか確認する #30
            eTatDetail = this.cash.getRangedCash(from, to);
            if(eTatDetail === undefined){
                // キャッシュヒットしないとき、eTatDetailを抽出し、キャッシュにセットする
                eTatDetail = this.tatMap.search(from,to);
                this.cash.setRangedCash(eTatDetail, from, to);
            }
        }
        return eTatDetail;
    }

    return that
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf TimeSeries
 * @class Cash
 * @classdesc キャッシュ
 *            <p>
 *            キャッシュを保持させるオブジェクト
 * @param {Number}
 *            [size=10] キャッシュ最大件数（未対応機能、設定は無視される）
 */
/* harmony default export */ __webpack_exports__["a"] = (function() {
    /** constructor */
    function Cash(size){
        size = size || 10;  // TODO 未使用
        if(!(this instanceof Cash)) return new Cash(size);
        // インスタンス変数
        this._cash = {};    // キャッシュ {data:, count:, lastTime:}
        this._ranges = [];  // RangedCash用 {key: ,from: , to:, }
        this._size = size;  // キャッシュ最大件数
    }
    
    /* method */
    /**
     * 第一引数のargumentsを配列に変換する<br>
     * （注：引数が１つ以上あることを前提）
     * 
     * @memberof Util.Cash
     * @param {Number}
     *            args 引数一覧（arguments）
     * @return {Array} 引数の配列
     */
    Cash._arg2arr = function(args) {
            return args.length === 1 ? [args[0]] : Array.apply(null, args);
        };
    /**
     * cash判定Keyを取得する<br>
     * （注：引数を'.'でつないだ文字列をkeyとするので、関数名長の上限を超える大きな配列は不可）
     * 
     * @memberof Util.Cash
     * @param {Number}
     *            args 引数一覧（argumentsオブジェクト）
     * @return {String} キャッシュキー用の文字列
     */
    Cash._getKey = function(args) {
            var argsArr = this._arg2arr(args);
            return argsArr.reduce(function(a,b){return a+'.'+b; });
        };
        
    /* private */

    /* public */
    /**
     * cashオブジェクトを、cashが無いときはundefinedを返却する<br>
     * cashヒットした場合、cashの使用回数をカウントアップする
     * 
     * @memberof Util.Cash
     * @param {Object}
     *            arguments 引数からキー文字列を定める
     * @return {Number|undefined} キャッシュデータ（デーがが無い場合は undefined)
     */
    Cash.prototype.getCash = function () {
            if (arguments.length < 1) return undefined;
            var args = Cash._arg2arr(arguments),
                key = Cash._getKey(args);
            if (key in this._cash){
                var cash = this._cash[key];
                cash.lastTime = new Date();
                cash.count++;
                return cash.data;
            }else{
                return undefined;
            }
        };
    /**
     * オブジェクトをcashする
     * 
     * @memberof Util.Cash
     * @param {Object}
     *            cashVal キャッシュするオブジェクト
     * @param {Object}
     *            arguments 第二引数以降の、引数からキー文字列を定める
     * @return {Object} キャッシュデータ（デーがが無い場合は undefined)
     */
    Cash.prototype.setCash = function () {
            if (arguments.length < 2) return undefined;
            var cashVal = arguments[0],
                args = Cash._arg2arr(arguments).slice(1, arguments.length),
                key = Cash._getKey(args);
            this._cash[key] = {data: cashVal, count: 0, lastTime:new Date()};
            return cashVal;
        };

    /**
     * レンジキー(form,to)範囲内でキーマッチするcashを、cashが無いときはundefinedを返却する<br>
     * キーは大小比較できる数値であることが前提
     * 
     * @memberof Util.Cash
     * @param {Number}
     *            from 抽出するキャッシュキー最小値
     * @param {Number}
     *            to 抽出するキャッシュキーの最大値
     * @return {Object} キャッシュデータ（デーがが無い場合は undefined)
     */
    Cash.prototype.getRangedCash = function (from, to) {
            var range = this._ranges.find(function(e){
                    return (e.from <= from && to <= e.to);
                });
            return (range !== undefined) ? this.getCash(range.from,range.to) : undefined;
        };
    /**
     * レンジキー(from,to)指定でキャッシュする<br>
     * キーは大小比較できること（通常、数値）、from-to期間内の既存のキャッシュは削除される
     * 
     * @memberof Util.Cash
     * @param {Object}
     *            cashVal キャッシュするオブジェクト
     * @param {Number}
     *            from 抽出するキャッシュキー最小値
     * @param {Number}
     *            to 抽出するキャッシュキーの最大値
     * @return {Object} キャッシュデータ（デーがが無い場合は undefined)
     */
    Cash.prototype.setRangedCash = function (cashVal, from, to) {
            if (arguments.length < 3) return undefined;
            // 登録キー範囲に包含される既存キャッシュを削除する
            var count = 0;
            this._ranges = this._ranges.filter(function(e){
                    if (from <= e.from && e.to <= to){
                        // 登録キャッシュ範囲内のキャッシュを削除する
                        count += this._cash[e.key].count;   // 削除分のカウンタ合算
                        delete this._cash[e.key];
                        return false;
                    }else{  // 登録キャッシュの範囲外の一覧を返却する
                        return true;
                    }
                }, this);
            // 引数をキャッシュに登録する
            var key = Cash._getKey([from, to]);
            this._ranges.push( {from: from, to: to, key: key} );
            this.setCash(cashVal, from, to);
            this._cash[key].count= count + 1;   // 再作成時はカウンタ合算値
            return cashVal;
        };

    // newの戻り値
    return Cash;
}());

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__simulator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util_js__ = __webpack_require__(0);



/**
 * @memberOf Simulator
 * @class VirtualSystem
 * @classdesc 仮想システム
 *            <p>
 *            Web3層(Web-AP-DB)をシミュレートしたWebのTATログ生成する
 *            <p>
 *            Webサーバ<br>
 *            最大スレッド数： Apache 2.4 [MaxClients = 1024]<br>
 *            JBossトランザクションタイムアウト [default-timeout = 300 秒]<br>
 *            キュー長 ： Apache 2.4 ListenBackLog (511) + Linux
 *            tcp_max_syn_backlog(769=1024*0.75+1)、タイムアウトなし<br>
 *            APサーバ<br>
 *            最大スレッド数(maxThreads)<br>
 *            JBossトランザクションタイムアウト [default-timeout=300 秒]<br>
 *            DBサーバ 最大コネクション数(max_connections)
 * 
 * @param {Number}
 *            [start = 1970/01/02 00:00:00)] シミュレート開始時刻（UNIX日付（ミリ秒））
 * @param {Number}
 *            [end = startの24時間後] シミュレート終了時刻（UNIX日付（ミリ秒））
 * @param {String}
 *            [resourcesJson] リソース指定JSONテキスト
 * @param {Boolean}
 *            [log=false] 詳細ログ出力有無
 * @example sim = simulator.VirtualSystem()
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #53　
    /** @constructor */
    function VirtualSystem(start, end, resourcesJson, log){
        if(!(this instanceof VirtualSystem)){
            return new VirtualSystem(start, end, resourcesJson, log);
        }
        if (!resourcesJson) {
            var jsonText =  '['
                +   '{"type" :"WEB","thread":1024,"timeout":300000, "q":1280, "qWait":0},'
                +   '{"type" :"AP", "thread":20,  "timeout":300000, "q":1280, "qWait":0},'
                +   '{"type" :"DB", "thread":2,   "timeout": 10000, "q":1000, "qWait":10000}'
                + ']';
            resourcesJson = JSON.parse(jsonText);
        }
        this.eTat = []; // シミュレートにより生成するTATログ出力先
        var _resources = resourcesJson;
        this._log = log ? log : false; // #53
        this._start = +start || new Date(1970, 1, 2);   // シミュレート開始時刻
        this._end = end || this._start + 24*60*60*1000; // シミュレート終了時刻（デフォルト：24時間後)
        this._simulator = __WEBPACK_IMPORTED_MODULE_1__util_util_js__["Heap"](                // イベント予約スケジュール（ヒープ）
                function(obj){ return obj.getTime(); }, // プライオリティの判定
                function(obj){ return obj; });  // 削除対象の判定 #61
        this._now = 0; // シミュレーション時の現在時刻
        // リソースを設定する
        this._resources = {}
        for (var i = 0; i < _resources.length; i++) {
            var e = _resources[i];
            e.log = e.log ? e.log : this._log; // #53
            this._resources[e.type] = Object(__WEBPACK_IMPORTED_MODULE_0__simulator_js__["c" /* VirtualResource */])(this, // #61
                    e.type, e.thread, e.timeout, e.q, e.qWait, e.log);
        };
        VirtualSystem.debug = this; // ★
    }

    /** @private */
    //

    // public
    /**
     * 仮想クライアントをスケジューラに登録する
     * 
     * @memberof Simulator.VirtualSystem
     * @param {String}
     *            [userName = "Default_"] ログに出力するユーザ名
     * @param {String}
     *            [message = ""] ログの末尾に出力するデータ
     * @param {Number}
     *            [num = 3] 期間内に生成する仮想クライアントの数
     * @param {Number}
     *            [start = Util.S2D("1970/01/02 00:00:00")]
     *            仮想クライアント生成開始時刻（UNIX時刻の数値、ミリ秒）
     * @param {Number}
     *            [end = startの0.1秒後] 仮想アプリケーション強制終了時刻（UNIX時刻の数値、ミリ秒）
     * @param {Object}
     *            model 仮想クライアントが実行する取引モデル
     */
    VirtualSystem.prototype.setClients = function(userName, message, num, start, end, model) {
        userName = userName || "Default_";
        message = message || "";
        num = (typeof(num) === "number") ? num : 1; // #61
        start = +start || __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2D"]("1970/01/02 00:00:00");
        end = +end || start + 100;
        // baseModelが指定されているとき、modelに展開する
        if (model.baseModel){
            model = VirtualSystem.getModel(
                model.baseModel.holds, model.baseModel.tatMin, model.baseModel.tat,
                model.sequence, model.times, model.thinkTimeMin, model.thinkTime);
        }
        // modelにmessageを設定する
        if (typeof(model.message) === "string") {
            model.message += message;
        } else {
            model.message = message;
        }
        // 仮想APを登録する
        var checkStart = start;
        var r = __WEBPACK_IMPORTED_MODULE_1__util_util_js__["Random"]((end - start) / num);
        var t = start;
        for (var i = 0; i < num; i++) {
            // 仮想APを作成する
            var vApp = Object(__WEBPACK_IMPORTED_MODULE_0__simulator_js__["b" /* VirtualApp */])(userName + i, model);
            // 仮想APに開始時刻（指数分布）を設定し、登録する
            t += Math.round(r.exponential());
            this.setEvent(vApp.start(t));
        }
    };
    
    /**
     * イベントをスケジューラに登録する
     * 
     * @memberof Simulator.VirtualSystem
     * @param {Object}
     *            event 仮想クライアントもしくは仮想リソースのイベント
     */
    VirtualSystem.prototype.setEvent = function(event) {
        this._simulator.push(event);
    }

    /**
     * スケジューラからイベントを削除する
     * 
     * @memberof Simulator.VirtualSystem
     * @param {Object}
     *            event 仮想クライアントもしくは仮想リソースのイベント
     */
    VirtualSystem.prototype.removeEvent = function(event) {
        this._simulator.del(event);
    }

    /**
     * シミュレーションを実行する
     * 
     * @memberof Simulator.VirtualSystem
     * @return {eTat} シミュレート実行結果のログ（this.eTat）
     */
    VirtualSystem.prototype.execute = function() {
        var event, events;
        // 処理対象がなくなるか、シミュレート終了時刻になるまでシミュレートする
        while(0 < this._simulator.size() &&
                this._simulator.top().getTime() <= this._end ) {
            // 次にイベントを迎える仮想APを取り出し、「次の処理」をシミュレートする
            event = this._simulator.pop();
            this._now = event.getTime(); // #59
            events = event.next(this);
            // 「次の処理」のシミュレートに伴い発生したイベントを、スケジュールする
            while (events.length) {
                this._simulator.push(events.pop());
            }
        }
        // シミュレーション終了後処理（処理中のvAppを強制終了する） #59
        while(0 < this._simulator.size()){
            event = this._simulator.pop();
            if (event._finish) {
                event._finish(this, "N_EoS", "", this._end);
            }
        }
        // シミュレーション終了後処理（リソース開放待ちのvAppを強制終了する） #59
        for (var key in this._resources){
            this._resources[key]._finish(this, "N_EoS", "", this._end);
        }
        
        return this.eTat;
    };

    /**
     * リソースを取得する
     * 
     * @memberof Simulator.VirtualSystem
     * @param {String}
     *            [name = "unlimited"] 仮想リソース名
     * @return {Object} 仮想リソース（登録されていないときは、新たにholdCapacity=1の仮想リソースを登録）
     */
    VirtualSystem.prototype.getResouce = function(name) {
        if (typeof(this._resources[name]) === "undefined") {
            this._resources[name] = Object(__WEBPACK_IMPORTED_MODULE_0__simulator_js__["c" /* VirtualResource */])(this, name);
        }
        return this._resources[name];
    };

    /**
     * シミュレーション現在時刻（処理中のイベントの時刻）を返却する
     * 
     * @memberof Simulator.VirtualSystem
     * @return {Number} イベント時刻（UNIX時刻：ミリ秒）
     */
    VirtualSystem.prototype.getTime = function() {
        return this._now;
    };


    // Static Method
    /**
     * 取引モデルを取得する（ユーティリティ）
     * 
     * @memberof Simulator.VirtualSystem
     * @param {Array}
     *            [baseModel = []] 使用リソースの一覧["WEB","AP","DB"]
     * @param {Number}
     *            [tat = 5] 使用リソースの平均取得時間＆平均開放時間
     * @param {Number}
     *            [tatMin = 2] 使用リソースの最小取得時間＆最小開放時間
     * @param {Array}
     *            [sequence = []] イベントシーケンス
     * @param {Number}
     *            [times = undefined] イベントシーケンスの繰り返し回数（未指定時:1)
     * @param {Number}
     *            [thinkTime= undefined] イベントシーケンス終了時に再実行する場合の平均再開時間（未指定時:500)
     * @param {Number}
     *            [thinkTimeMin = undefined]
     *            イベントシーケンス終了時に再実行する場合の最小再開時間（未指定時:thinkTimeと同じ）
     * @param {String}
     *            [message = ""] 自動生成ログの末尾に追加する文字列
     * @return {Object} 取引モデル
     */
    VirtualSystem.getModel = function(baseModel, tatMin, tat, sequence, times, thinkTimeMin, thinkTime, message) {
        baseModel = baseModel || [];
        tatMin = tatMin || 2;
        tat = tat || 5;
        message = message || "";
        sequence = sequence || [
                {tatMin:6,   tat:15,  note:"Req",     hold:"DB",    free:[]},
                {tatMin:70,  tat:100, note:"selectA", hold:"TBL_A", free:["TBL_A"]},
                {tatMin:150, tat:200, note:"updateB", hold:"TBL_B", free:[]},
                {tatMin:30,   tat:50,  note:"Res",     hold:"",      free:["TBL_B","DB"]}
            ];
        var model = {sequence :[], message : message}; // 戻り値
        if (typeof(times) === "number") model.times = times;
        if (typeof(thinkTimeMin) === "number") model.thinkTimeMin = thinkTimeMin;
        if (typeof(thinkTime) === "number") model.thinkTime = thinkTime;
        
        // baseModelを返却用シーケンスに展開する
        baseModel.forEach( function(e) {
            model.sequence.push({hold:e, tatMin:tatMin, tat:tat, free:[]});
        });
        // 指定シーケンスを返却用シーケンスに追加する
        model.sequence = model.sequence.concat(sequence);

        // 返却用シーケンスに、holdingを追加するとともにシーケンス終了時未開放リソースを取得する
        var resources = []; // #61
        var holding = []; // #59
        model.sequence.forEach( function(tran) { // #61
            // tatMinがtatより大きいとき、tatをtatMin一定とする #59
            if (tran.tat < tran.tatMin) tran.tat = tran.tatMin;
            // 処理開始時にholdしているリソース一覧をholdingに登録する #59
            tran.holding = [];
            resources.forEach(function(r) {tran.holding.push(r)});
            // 未開放リソース一覧を更新する
            if (typeof(tran.hold) !== "undefined" && tran.hold !== "") {
                resources.push(tran.hold);                
            }
            if (tran.free) {
                tran.free.forEach( function(free){
                    resources.some( function(r, i){
                        if (r == free) {
                            resources.splice(i,1);
                            return true;
                        }
                    })    
                })
            }
        }, this);
        // シーケンス終了時未開放リソースが残っているとき、返却用シーケンスにリソース開放処理を追加する
        if (0 < resources.length){
            model.sequence = model.sequence.concat(
                    [{hold: "", tatMin: tatMin * baseModel.length, tat: tat * baseModel.length,
                        free: resources.reverse()}]);
        }
        return model;
    };
    
    /* new */
    return VirtualSystem;
}());


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(20);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(12)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!./dygraph.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!./dygraph.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/**\n * Default styles for the dygraphs charting library.\n */\n\n.dygraph-legend {\n  position: absolute;\n  font-size: 14px;\n  z-index: 10;\n  width: 250px;  /* labelsDivWidth */\n  /*\n  dygraphs determines these based on the presence of chart labels.\n  It might make more sense to create a wrapper div around the chart proper.\n  top: 0px;\n  right: 2px;\n  */\n  background: white;\n  line-height: normal;\n  text-align: left;\n  overflow: hidden;\n}\n\n/* styles for a solid line in the legend */\n.dygraph-legend-line {\n  display: inline-block;\n  position: relative;\n  bottom: .5ex;\n  padding-left: 1em;\n  height: 1px;\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n  /* border-bottom-color is set based on the series color */\n}\n\n/* styles for a dashed line in the legend, e.g. when strokePattern is set */\n.dygraph-legend-dash {\n  display: inline-block;\n  position: relative;\n  bottom: .5ex;\n  height: 1px;\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n  /* border-bottom-color is set based on the series color */\n  /* margin-right is set based on the stroke pattern */\n  /* padding-left is set based on the stroke pattern */\n}\n\n.dygraph-roller {\n  position: absolute;\n  z-index: 10;\n}\n\n/* This class is shared by all annotations, including those with icons */\n.dygraph-annotation {\n  position: absolute;\n  z-index: 10;\n  overflow: hidden;\n}\n\n/* This class only applies to annotations without icons */\n/* Old class name: .dygraphDefaultAnnotation */\n.dygraph-default-annotation {\n  border: 1px solid black;\n  background-color: white;\n  text-align: center;\n}\n\n.dygraph-axis-label {\n  /* position: absolute; */\n  /* font-size: 14px; */\n  z-index: 10;\n  line-height: normal;\n  overflow: hidden;\n  color: black;  /* replaces old axisLabelColor option */\n}\n\n.dygraph-axis-label-x {\n}\n\n.dygraph-axis-label-y {\n}\n\n.dygraph-axis-label-y2 {\n}\n\n.dygraph-title {\n  font-weight: bold;\n  z-index: 10;\n  text-align: center;\n  /* font-size: based on titleHeight option */\n}\n\n.dygraph-xlabel {\n  text-align: center;\n  /* font-size: based on xLabelHeight option */\n}\n\n/* For y-axis label */\n.dygraph-label-rotate-left {\n  text-align: center;\n  /* See http://caniuse.com/#feat=transforms2d */\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n}\n\n/* For y2-axis label */\n.dygraph-label-rotate-right {\n  text-align: center;\n  /* See http://caniuse.com/#feat=transforms2d */\n  transform: rotate(-90deg);\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n}\n", ""]);

// exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "@CHARSET \"UTF-8\";\r\n/*   ****1**** ****2**** ****3**** ****4**** ****5**** ****6**** ****7***** */\r\n/* リセットCSS */\r\nhtml, body, h1, h2, h3, h4, ul, ol, dl, li, dt, dd, p, div, span, img, a, table, tr, th, td, selector{\r\n margin: 0; padding: 0; border: 0; font-weight: normal; font-size: 100%; vertical-align:baseline;\r\n -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; }\r\narticle, header, footer, aside, figure, figcaption, nav, section { display:block; }\r\nbody { line-height: 1; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; }\r\nol, ul { list-style: none; list-style-type: none; }\r\n*:focus { outline: 0; }\r\n\r\n/* TAT log diver */\r\nbody\t{ font-size: 12px; font-family: \"\\30E1\\30A4\\30EA\\30AA\",\"Meiriyo\",\"\\30D2\\30E9\\30AE\\30CE\\89D2\\30B4   ProN W3\",\"Hiragino Kaku Gothic ProN\",\"sans-serif\"; }\r\nnav \t{ height: 36px; }\r\ninput\t{ border-width: 1px; font-size: 12px; }\r\nselect  { background: #eee;}\r\n#Simulator {overflow: auto; resize: both; position: absolute; z-index: 100; background: rgba(255,255,255,0.5); }\r\n.statusbar\t{ z-index: 99; visibility:visible; padding: 5px; background: #fff; }\r\n.statusbar > iframe { overflow: hidden; border: 0; width: 100%; }\r\n.lineViewer {margin: 10px 0px 2px; overflow: hidden; padding: 0px; border: 1px #cccccc dotted; }\r\n.hjnCode { font-family: \"monospace\",\"Consolas\", \"\\FF2D\\FF33\\30B4\\30B7\\30C3\\30AF\";}\r\n/* draggable box */\r\n.hjnDraggableBox {}\r\n.hjnDraggableItem:hover {background: rgba(128, 128, 128, 0.2); transition: all 0.2s; }\r\nfooter { position: fixed; bottom: 0%; text-align: right; font-size: smaller; }\r\n\r\n/* ハンバーガーメニュー */\r\n.hjnBurgerTray { position :fixed; display: inline-block; visibility: hidden; z-index: 96;\r\n\ttop :0; right :0; width :305px; height:100%; padding :0 18px 0 0; background :#fff; }\r\n/* ハンバーガーボタン */\r\n.hjnCtrlBox { position: relative; float: right; cursor: pointer; z-index: 98;\r\n\twidth: 40px; height: 40px; background-color: #fff; visibility: visible;\r\n\tborder: 1px solid #ccc; box-shadow:\t1px 1px 1px #ccc; border-radius: 4px; \r\n\tline-height: 12px; box-sizing: border-box;\ttransition: all 0.1s; }\r\n.hjnCtrlBox:hover { border: #ccc; }\r\n.hjnCtrlBox:active { border: 1px solid #999;  }\r\n.hjnBurger { display: none; }\r\n.hjnBurger + label span { top: 17px; height: 4px; border-radius: 2px;\r\n\tposition: absolute; left: 6px; width: 69%; background-color: #888; }\r\n.hjnBurger + label span::before, .hjnBurger + label span::after { border-radius: 2px;\r\n\tposition: absolute; width: 26px; height: 4px; background: #888;\r\n\tdisplay: block; content: ''; transition: transform 0.1s; }\r\n.hjnBurger + label span::before { top: -8px; }\r\n.hjnBurger + label span::after { top: 8px; }\r\n.hjnBurger:checked + label span { background: transparent; }\r\n.hjnBurger:checked + label span::before { transform: translateY(8px) rotate(-45deg); }\r\n.hjnBurger:checked + label span::after { transform: translateY(-8px) rotate(45deg); }\r\n\r\n/* メニュー 全体 */\r\n.hjnBurgerTitle { /* ハンバーガーメニューオープン時の見出し */\r\n\tposition: absolute; visibility: visible; color: #999; background:#fff; width: 100%;\r\n\tpadding: 0 98px 0 15px; opacity: 0; z-index: 97; background-color: transparent;\r\n\ttransform: translate3d(0, -15px, 0); transition: transform 0.1s, opacity 0.5s; }\r\n.hjnBurgerTitle p { word-wrap: break-word; line-height: 18px; width: 160px; }\r\n.hjnBurger:checked ~ .hjnBurgerTitle { transform: none;  opacity: 1; }\r\n.hjnBurgerWrap { position: absolute;  visibility: visible; width :100%; height :100%;\r\n\tbackground: #fff; opacity: 0.9;\ttop: 0; right: -100%; transition: right 0.1s;\r\n\tpadding: 43px 0 0 0; overflow: scroll;}\r\n.hjnBurger:checked ~ .hjnBurgerWrap { right: 0; }\r\n/* Copyright表示 */\r\n.hjnBurgerTitle a {\r\n    color: #4d4e53; text-decoration: none; border-bottom: 1px dotted #afafaf; }\r\n/* モードボタン */\r\n.hjnBoxSwitch { display: none; }\r\n.hjnBoxSwitch + label span::before, .hjnBoxSwitch + label span::after\r\n\t\t{ display: inline-block; text-align:center; transition: all 0.1s; width: 100%}\r\n.hjnBoxSwitch + label span::before, .hjnBoxSwitch:checked + label span::after\r\n\t\t{ color: #ddd; }\r\n.hjnBoxSwitch + label span::after, .hjnBoxSwitch:checked + label span::before \r\n\t\t{ color: #888; font-weight: bold; }\r\n\r\n#hjnBoxPlaceOn + label span::before { content: \"Place on\"; }\r\n#hjnBoxPlaceOn + label span::after  { content: \"side\"; }\r\n#chartZoom + label span::before, #chartDZoom + label span::before  { content: \"reset zoom\"; }\r\n/* スイッチラベル */\r\n.hjnBoxOn { display: none; }\r\n.hjnBoxOn + label { text-align:center; color: #ddd; }\r\n.hjnBoxOn:checked + label { color: #888; font-weight: bold;}\r\n\r\n /* アコーデオンメニュー */\r\n.hjnAccordion { list-style-type: none; margin: 0; padding: 0; }\r\n.hjnMenuLv1 { position:rerative; margin: 0 0 0 10px; }\r\n.hjnMenuLv1 > input { display: none; }\r\n.hjnMenuLv1 > label::before { content: \"\"; transition: 0.1s; transform: rotate(-90deg);\r\n /* ▲ */border-style: solid; border-color: #aaa transparent transparent transparent; border-width: 10px 5px 0 5px;\r\n\t\tdisplay: inline-block; vertical-align: middle; margin: 10px 5px 10px 10px; }\r\n.hjnMenuLv1 > input:checked ~ label::before { transform: rotate(0deg); }\r\n\r\n.hjnMenuLv1 > label, .hjnMenuLv1 > a { display: block; cursor: pointer;\r\n\t\tborder-bottom: 1px solid #fff; background: #eee; transition: all 0.1s; }\r\n.hjnMenuLv1 > label:hover { background: rgba(0,0,0,0.2); }\r\n.hjnMenuLv1 > label:active { background: #999;  }\r\n.hjnMenuLv1 > input:checked ~ .hjnMenuLv2 { height: auto; padding: 10px; }\r\n\r\n/* 詳細メニューリスト   */\r\n.hjnMenuLv2 { transition: 0.1s; height: 0; overflow: hidden; padding: 0 10px; background: #ddd; }\r\n.hjnMenuLv2 ol { display: block; margin: 2px 0; }\r\n.hjnMenuLv2 label { height: 12px; }\r\n.hjnLabel4Input:hover,  .hjnButton4Input:hover { background: rgba(0,0,0,0.2); }\r\n.hjnLabel4Input:active, .hjnButton4Input:active { background: #999; }\r\n/* 詳細メニューリスト  ボタン */\r\n.hjnMenuLv2 .hjnButton4Input label, .hjnMenuLv2 label.hjnButton4Input, .hjnPlot \r\n\t\t{ display: block; padding: 8px 12px 8px 22px;}\r\n.hjnButton4Input { position: relative; display: block; overflow: hidden; transition: all 0.1s;\r\n\t\ttext-decoration: none; color: #000; border: outset #fff; border-radius: 14px; }\r\n.hjnButton4Input:active { border: inset #fff; }\r\n.hjnMenuLv2 li .hjnButton4Input { padding: 8px 12px 8px 22px; } /* Download用 */\r\n.hjnMenuLv2 .hjnButton4Input input[type=\"file\"] { display: none; } /* File Open用 */\r\n/* 詳細メニューリスト  文字 */\r\n.hjnMenuLv2 .hjnLabel4Input { display: inline-block; position: relative;\r\n\t\t border-radius: 14px; padding-left: 1em; cursor: pointer; transition: all 0.1s; }\r\n.hjnMenuLv2 input { height: 12px; text-align: right; border-radius: 5px; }\r\n.hjnMenuLv2 .hjnLabel4Input input[type=\"radio\"] { position: absolute;\r\n\t\t top: 0; bottom: 0; left: 0; margin: auto;  cursor: pointer; }\r\n.hjnMenuLv2 select.hjnLabel4Input  {padding-left: 0; }\r\n/* 詳細メニューリスト  Legend */\r\n.hjnMenuLv2 .legend {cursor: pointer; width:206px; height: auto;\r\n \t\tdisplay: inline-block; padding: 8px 12px 8px 22px; border-radius: 14px;}\r\n.hjnMenuLv2 .legend > input { display: inline; cursor: pointer; margin: auto -15px; }\r\n.hjnMenuLv1 > input:checked ~ .hjnMenuLv2 .legend > input { position: absolute; }\r\n.hjnMenuLv2 .legend:hover { font-style: oblique; } \r\n\r\n/* dygraph用設定 */\r\n.item.active{ background: rgba(0,0,0,0.2) !important; border: rgba(0,0,0,0.2) !important; }\r\n.column { display: inline-block; }\r\n.dygraph-annotation { color: rgba(0,0,0,0.8) !important;\r\n\t\tbackground-color: rgba(256,256,256,0.2) !important; width: 40px !important; }\r\n\r\n/* Bottom detail graph用設定 */\r\n#detailTimeRange { padding: 8px; }\r\n#chartPlots div { float: left; padding: 2px 0; top: 5vh; }\r\n.hjnPlot { margin: 2px 0; width:250px; }\r\n.hjnPlot > label { position:relative; margin: 2px 0px; background-color: #eee;\r\n\t\tpadding: 0px 5px; cursor: pointer; border-radius: 5px; }\r\n.hjnPlot > input[type=checkbox] { /* 削除アイコン */\r\n\t\tvisibility: hidden; z-index: 98; float: left; margin: -2px 0 0 0;\r\n\t\tbackground-color: #fff; box-shadow: 1px 1px 1px #ccc; height: 16px; width: 16px; }\r\n.hjnPlot > input[type=checkbox] + label{ /* 削除アイコンの横棒*/\r\n\t\tvisibility: hidden; z-index: 97; float: left; left: -13px; top: 2px;\r\n\t\tbackground: #aaa; height: 3px; width: 9px; padding: 0; border-radius: 2px; }\r\n.hjnPlot:hover > input[type=checkbox], .hjnPlot:hover > input[type=checkbox] + label\r\n\t\t{ visibility: visible; cursor: pointer; }\r\n.hjnPlot > input[type=radio] { display:none; }\r\n.hjnPlot > input[type=radio]:checked + label { background-color: #ccc; }\r\n.hjnPlot:hover { font-weight: bold; }\r\n", ""]);

// exports


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__(0);


/**
 * @memberOf Util
 * @class TouchPanel
 * @classdesc タッチパネル用ツール
 *            <p>
 *            参考 {@link https://code.i-harness.com/ja/q/4f2389}
 * 
 * @param {Number}
 *            [average=0.5] 平均値
 * @example var r = HJN_util.TouchPanel(10), val = r.exponential();
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #56
    /** @constructor */
    function TouchPanel(average){
        if(!(this instanceof TouchPanel)) return new TouchPanel(average);
        this._average = average || 0.5;
    }
    /** @private */

    // public
    /**
     * タッチデバイスか判定する
     * <p>
     * クラスロード後、touchstart と mouosemove の初回のイベントがどちらが先に発生したかにより判定する 参考
     * {@link https://lab.syncer.jp/Web/JavaScript/Snippet/44/}
     * 
     * @memberof TouchPanel
     * @return {String} 先に検出したイベントがマウス移動のとき false、以外のときtrue
     * 
     */
    TouchPanel.isTouchableDevice = function() {
        __WEBPACK_IMPORTED_MODULE_0__util_js__["Logger"].ShowText([TouchPanel._deviceType]);
        return  (TouchPanel._deviceType === "MOUSE") ? false : true; // #78
    }

    // タッチデバイスか判定する（クラス定数）
    TouchPanel._deviceType = "SHIMULATED_TOUCH";
    function detectDeviceType(event) {
        TouchPanel._deviceType = event.changedTouches ? "TOUCH" : "MOUSE" ;
        document.removeEventListener("touchstart", detectDeviceType) ;
        document.removeEventListener("mousemove", detectDeviceType) ;
    }
    document.addEventListener("touchstart", detectDeviceType) ;
    document.addEventListener("mousemove", detectDeviceType) ;

    /**
     * タッチパネル操作をマウス操作に転送する
     * <p>
     * 参考 {@link https://code.i-harness.com/ja/q/4f2389}
     * 
     * @memberof Util.TouchPanel
     * @param {Object}
     *            element 対象dom要素
     * @param {Boolean}
     *            [isStopTouch=false] 元のタッチのデフォルトイベントを消すか（個別に登録されているリスナーには無関係）
     * 
     * @example HJN_util.DispatchEventTouchToMouse();
     */
    TouchPanel.DispatchEventTouchToMouse = function(element, isStopTouch) { // #22
        element.addEventListener("touchstart", touchHandler, true);
        element.addEventListener("touchmove", touchHandler, true);
        element.addEventListener("touchend", touchHandler, true);
        element.addEventListener("touchcancel", touchHandler, true);
        return;

        function touchHandler(ev) {
            var bIgnoreChilds = false;
            if( !window.__TOUCH_TYPES ) {
                window.__TOUCH_TYPES  = { touchstart:'mousedown', touchmove:'mousemove', touchend:'mouseup' };
                window.__TOUCH_INPUTS = { INPUT: 1, TEXTAREA: 1, SELECT: 1, OPTION: 1,
                                         'input':1,'textarea':1,'select':1,'option':1 };
            }
            var bSame = (ev.target == this);
            if (bIgnoreChilds && !bSame) { return; }
            // Get if object is already tested or input type
            var b = (!bSame && ev.target.__ajqmeclk);
            // allow multi-touch gestures to work
            if (b === true || !ev.touches || ev.touches.length > 1 || !window.__TOUCH_TYPES[ev.type]) { return; }

            var oEv = (!bSame && typeof b != 'boolean') ? ev.target.getAttribute('events') : false;
            var b = (!bSame)
                  ? (ev.target.__ajqmeclk = oEv
                      ? (oEv['click'] || oEv['mousedown'] || oEv['mouseup'] || oEv['mousemove']) 
                      : false )
                  :false;
            // allow default clicks to work (and on inputs)
            if (b || window.__TOUCH_INPUTS[ev.target.tagName]) { return; } 

            var touch = ev.changedTouches[0];
            var tmpClientX = touch.clientX;
            var tmpClientY = touch.clientY;
            // クリックに変換するタップ誤差範囲
            var CLICK_MARGIN = 20; // px
            var CLICK_DELAY = 1000; // ms

            // 前回touchstart時の座標と時刻が一定範囲内の時、dygraphがクリックと判定するよう補正する
            if ((ev.type === "touchstart" || ev.type === "touchend") &&
                    this.startTouch &&
                    Math.abs(this.startTouch.x - touch.clientX) < CLICK_MARGIN && // タッチ補正幅(px)
                    Math.abs(this.startTouch.y - touch.clientY) < CLICK_MARGIN &&
                    +new Date() - this.startTouch.t < CLICK_DELAY) { // タッチ時間(ms)
                // 位置補正
                tmpClientX = this.startTouch.x;
                tmpClientY = this.startTouch.y;
            } else if (ev.type === "touchstart"){
                // touchstart時の座標と時刻を退避する
                this.startTouch = {x: touch.clientX, y: touch.clientY, t: +new Date()};
            } else if (ev.type === "touchend") {  
                // touchstart時の座標と時刻を初期化する
                this.startTouch = {};
            }
            // マウスイベントを発生させる
            var newEvent = document.createEvent("MouseEvent");
            newEvent.initMouseEvent(
                window.__TOUCH_TYPES[ev.type],    // type
                true,             // bubbles
                true,             // cancelable
                window,           // view
                1,                // detail
                touch.screenX,    // screenX スクリーンサイズ
                touch.screenY,    // screenY
                tmpClientX,       // clientX タッチ座標
                tmpClientY,       // clientY
                false,            // ctrlKey
                false,            // altKey
                false,            // shiftKey
                false,            // metaKey
                0,                // button
                null              // relatedTarget
              );
            touch.target.dispatchEvent(newEvent);

            // タッチイベントを止める #22
            if(isStopTouch) {
                ev.stopImmediatePropagation();
                ev.stopPropagation();
                ev.preventDefault();
                return false;
            }
        }
    };

    /* new */
    return TouchPanel;
}());

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DateToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return S2D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return D2S; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return N2S; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return S2N; });
/**
 * 日時(Date)から、ローカル時刻に基づく、指定フォーマットの文字列を取得する
 * 
 * @memberOf Util
 * @param {Date}
 *            dt Date型（内部実装はミリ秒単位）
 * @param {String}
 *            str フォーマット yyyy-MM-dd hh:mm:ss.000 （戻り値で上書きされる）
 * @return {String} str 編集後文字列
 */
var DateToString = function() {
    var dt = arguments[0],  // arg0
        str = arguments[1]; // arg1
    // if (typeof(dt) === "number") dt = new Date(dt);
    str = str.replace(/yyyy/, dt.getFullYear() );
    str = str.replace(/MM/, ('0' + (dt.getMonth() + 1) ).slice(-2) );
    str = str.replace(/dd/, ('0' + dt.getDate()).slice(-2) );
    str = str.replace(/hh/, ('0' + dt.getHours()).slice(-2) );
    str = str.replace(/mm/, ('0' + dt.getMinutes()).slice(-2) );
    str = str.replace(/ss/, ('0' + dt.getSeconds()).slice(-2) );
    str = str.replace(/000/,('00' + dt.getMilliseconds()).slice(-3) ); // #92
    // str = str.replace(/000/,('00' + Math.floor(dt % 1000)).slice(-3) ); #60
    return str;
};

/**
 * 日時文字列を指定フォーマットでパースして数値(ミリ秒単位）を取得する
 * 
 * @memberOf Util
 * @param {String}
 *            str
 * @param {Object|String}
 *            [conf={YYYY: 0, MM: 5, DD: 8, hh: 11, mm: 14, ss: 17, p000: 20}]
 *            Object指定のとき：年月日時分秒ミリ秒の先頭位置を示す構造体オブジェクト<br>
 *            String指定とき：フォーマットを示す文字列<br>
 *            デフォルト値は、"YYYY/MM/DD hh:mm:ss.000" 相当
 * @return {Number} timeNum 日時（１ミリ秒を１とする数値、エラーのときNumber.NaN）
 */
var S2D = function(str, conf){ // #34
    if(!str) return Number.NaN;

    if(typeof(conf) === "object"){ // #92
        // confが"object"のとき、指定された構造体オブジェクトの条件でパースする（最も高速な処理）
        return parse(str, conf);
    } else if (typeof(conf) === "string") {
        // confが"String"のとき、指定された文字列フォーマットから構造体オブジェクトを作成し、パースする（準高速処理）
        var config = {  // YYYY/MM/DD hh:mm:dd.ss.000 #41
                YYYY: conf.indexOf("YYYY"),
                MM: conf.indexOf("MM"),
                DD: conf.indexOf("DD"),
                hh: conf.indexOf("hh"),
                mm: conf.indexOf("mm"),
                ss: conf.indexOf("ss"),
                p000: conf.indexOf("0")}; // #92
        return parse(str, config);
    } else {
        // confが指定されていないとき、デフォルト条件でパースする（汎用処理）
        // デフォルトフォーマット："YYYY/MM/DD hh:mm:dd.ss.000" #42
        var config = {YYYY: 0, MM: 5, DD: 8, hh: 11, mm: 14, ss: 17, p000: 20};
        return parse(str, config);
    }

    // 内部関数：構造体オブジェクトで指定された条件でパースする
    function parse(str, conf){
        var y   = (0 <= conf.YYYY) ? parseInt( str.substr( conf.YYYY, 4), 10) : 1970,
                m   = (0 <= conf.MM)   ? parseInt( str.substr( conf.MM, 2), 10) - 1 : 0, // デフォルト1月
                // 1970/1/1だと時差でマイナスになることがあるので日付のデフォルトは2日
                d   = (0 <= conf.DD)   ? parseInt( str.substr( conf.DD, 2), 10) : 2,
                h   = (0 <= conf.hh)   ? parseInt( str.substr( conf.hh, 2), 10) : 0,
                min = (0 <= conf.mm)   ? parseInt( str.substr( conf.mm, 2), 10) : 0,
                sec = (0 <= conf.ss)   ? parseInt( str.substr( conf.ss, 2), 10) : 0,
                // ミリ秒以下を指定すると丸め誤差が生じるため、秒以下のミリ秒は個別に加算
                p   = (0 <= conf.p000)  
                    ? ("0." + str.substr( conf.p000).match(/[0-9]*/)[0]) * 1000.0 
                    : 0;
        return +(new Date( y, m, d, h, min, sec )) + p;  // #14
    }
};

/**
 * 日時(ミリ秒：Ｘ軸用）から、時差補正のない、指定フォーマットの文字列を取得する
 * 
 * @memberOf Util
 * @param {Number|Date}
 *            ds 時刻をUNIX経過時間（ミリ秒）で表した数値、もしくはDate(日付）
 * @param {String}
 *            [str=自動] フォーマット yyyy-MM-dd hh:mm:ss.000 （戻り値で上書きされる）<br>
 *            自動のとき 日数+ hh:mm:ss.000 表示単位に至らない単位は表示しない、ミリ秒は分単位以下の時表示<br>
 *            例： 日数表示："1 02:03:04",時表示"02:03:04" 分表示"0:03:04.567" 秒表示"04.567"
 * @param {Boolean}
 *            [isLocal=false] trueのとき時差補正をしない
 * @return {String} str 編集後文字列
 */
var D2S = function(ds, str, isLocal){ // #60
    var minus = "";
    var ret = "";
    if (ds < 0) {
        minus = "-";
        ds = -1 * ds;
    }
    var datetime = new Date(ds);
    if (!isLocal) { // #60
        datetime = new Date(+datetime + 60000 * datetime.getTimezoneOffset()); // 環境タイムゾーンの補正
    }
    if(str){ // フォーマット指定があるとき #93
        ret = DateToString(datetime, str);
    } else if (ds < 1000) { // 自動で1秒(1000)未満のとき
        ret = DateToString(datetime, "0.000"); 
    } else if (ds < 60000) { // 自動で1分(1*60*1000)未満のとき
        ret = DateToString(datetime, "ss.000").replace(/^0+/,""); // #92
    } else if (ds < 3600000) { // 自動で1分以上、1時間(1*60*60*1000)未満のとき
        ret = "0:" + DateToString(datetime, "mm:ss.000").replace(/^0+/,""); // #92
    } else if (ds < 86400000) { // 自動で1時間以上、1日(1*24*60*60*1000)未満のとき
        ret = DateToString(datetime, "hh:mm:ss").replace(/^0+/,"");
    } else { // 自動で1日以上のとき
        ret = Math.floor(ds / 86400000) + " ";
        ret += DateToString(datetime, "hh:mm:ss");
    }
    return minus + ret;
};

/**
 * 数値(Ｙ軸用）から、誤差のない表示用文字列を取得する<br>
 * （hover、legendなどでY軸の値を使うときに使用する）
 * 
 * @memberOf Util
 * @param {Number|Date}
 *            y 時刻をUNIX経過時間（ミリ秒）で表した数値、もしくはDate(日付）
 * @return {String} str 編集後文字列
 *         {@linkhttps://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat}
 */
var N2S = function(y){
    return Intl.NumberFormat().format(y); // #96
};

/**
 * 文字列を数値に変換する
 * 
 * @memberOf Util
 * @param {String|Number}
 *            [str = sub] 計算式（日時分秒ミリ秒(d,h,mim,sec,ms)の文字は、ミリ秒に変換する）
 * @param {String|Number}
 *            [sub] 第一引数が指定されていない(undefined)ときの代用
 * @return {Number} n eval(str||sub)で取得した数値
 * 
 */
var S2N = function(str, sub){ // #53
    var s = (typeof(str) !== "undefined") ? str : sub;
    var h = 3600000; // 1時間（ミリ秒）
    var min = 60000; // 1分（ミリ秒）
    var sec =  1000; // 1秒（ミリ秒）
    var ms =      1; // 1ミリ秒

    return eval(s);
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class Random
 * @classdesc Random 乱数取得
 *            <p>
 *            ある事象の単位時間あたりの発生回数がポアソン分布, その発生間隔が指数分布に従う<br>
 *            M/M/1モデルは、到着がポアソン過程となり、(したがって到着間隔は指数分布に従う)、サービス時間が指数分布に従う
 *            <p>
 *            参考 {@link http://www.ishikawa-lab.com/montecarlo/4shou.html}
 * 
 * @param {Number}
 *            [average=0.5] 平均値
 * @example var r = HJN_util.Random(10), val = r.exponential();
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #56
    /** @constructor */
    function Random(average){
        if(!(this instanceof Random)) return new Random(average);
        this._average = average || 0.5;
    }

    /** @private */

    // public
    /**
     * 一様分布となる乱数を返却する
     *
     * @memberof Util.Random
     * @param {Number}
     *            [average=this._average] 平均値<br>
     * @return {Number} 乱数
     */
    Random.prototype.uniform = function(average) {
        average = average || this._average;
        return  2.0 * average * Math.random();
    };

    /**
     * 指数分布となる乱数を返却する(lambda = 1/average)
     *
     * @memberof Util.Random
     * @param {Number}
     *            [average=this._average] 平均値=1/λ、分散=1/(λ^2)<br>
     * @return {Number} 乱数
     */
    Random.prototype.exponential = function(average) {
        average = average || this._average;
        return (-1.0 * average) * Math.log(1.0 - Math.random());
    };
    
    /**
     * ポアソン分布となる乱数を返却する(lambda = average)
     * 
     * @memberof Util.Random
     * @param {Number}
     *            [average=this._average] 平均値=分散=λ<br>
     * @return {Number} 乱数
     */
    Random.prototype.poisson = function(average) {
        var lambda = average || this._average;
        var xp = Math.random();
        var k = 0;
        while (xp >= Math.exp(-lambda)) {
            xp = xp * Math.random();
            k = k + 1;
        }
        return (k);
    };
    
    /* new */
    return Random;
}());

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class addEventListener
 * 
 * 1つのイベントターゲットにイベントリスナーを1つ登録する
 * 
 * @param {dom}
 *            element DOM要素、document.getElementById("xx");などで取得
 * @param {string}
 *            [type="click"] イベントの種類
 *            {@link https://developer.mozilla.org/en-US/docs/Web/Events}
 * @param {function}
 *            func 実行する関数
 */
/* harmony default export */ __webpack_exports__["a"] = (function(element, type, func) { // #74
    type = type || "click";
    if (element.addEventListener) {
        element.addEventListener(type, func, false);
    } else if (element.attachEvent) {
        element.attachEvent("on" + type, func); 
    } else {
        console.log("unable addEventListner %o", element);
    }
});;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class setZeroTimeout
 * 非同期化
 * 
 * @param {function}
 *            global 非同期化して実行する関数
 *            <p>
 *            参考 {@link https://jsfiddle.net/kou/j73tLum4/8/}
 *            {@link https://gist.github.com/mathiasbynens/579895}
 *            {@link http://dbaron.org/log/20100309-faster-timeouts}
 */
/* harmony default export */ __webpack_exports__["a"] = (function(global) {
    var timeouts = [], 
        messageName = "zero-timeout-message";
    function handleMessage(event) {
        if (event.source === global && event.data === messageName) {
            if (event.stopPropagation)  event.stopPropagation();
            if (timeouts.length) timeouts.shift()();
        }
    }
    if (global.postMessage) {
        if (global.addEventListener) {
            global.addEventListener("message", handleMessage, true); 
        }else if (global.attachEvent) {
            global.attachEvent("onmessage", handleMessage); 
        }
        return function (fn) { timeouts.push(fn); global.postMessage(messageName, "*"); };
    } 
    else {
        return function (fn) { setTimeout(fn, 0); }; 
    }
}(window));

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__(0);


/**
 * @memberOf Util
 * @class Logger
 * @classdesc ロガー
 *            <p>
 *            モードに応じたログを出力する。画面ログ表示領域、コンソールログへの出力に対応
 * 
 * @param {String}
 *            [mode=0] ログ出力モード
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #27
    /** @static */
    Logger.prototype = {
            _logText: [],
            _timestamp : new Date(),
            _logtime : new Date()
        };
    /** @constructor */
    function Logger(mode){
        if(!(this instanceof Logger)) return new Logger(mode);
        this._mode = mode || 0;
        // getKeyによりIndex作成関数を設定する
    }
    /**
     * 一定時間（１分）経過後、最初に本メソッドが呼ばれたときのみログ出力する（ループ用）
     * 
     * @memberof Util.Logger
     * @param {Number}
     *            i 参考番号<br>
     *            経過時間内のループ回数などの表示に使用することを想定
     * @param {String}
     *            text ログ出力文字列
     */
    Logger.ByInterval = function(i, text) {
        var ts = new Date(),
            freq = 60000;   // 1分毎
        if (freq < ts - Logger._logtime){
            var t = Object(__WEBPACK_IMPORTED_MODULE_0__util_js__["D2S"])(ts, "hh:mm:ss.000"); // #60 #92
            console.log(t + "[" + i + "]~~~~" + text);
            Logger._logtime = ts;
        }
    };
    /**
     * ログ出力： ログテキストおよびタイムスタンプを初期化する
     * 
     * @memberof Util.Logger
     * @param {String}
     *            text ログ出力文字列
     * @param {String}
     *            [type] ログ区分（"calc"：計算用ログ、"msg"：メッセージのみ（タイムスタンプなし））
     */
    Logger.ShowLogTextInit=function(text, type) {
        Logger._timestamp = new Date();
        Logger._logText = [];
        if(text) Logger.ShowLogText(text, type);
    };
    /**
     * ログ出力： タイムスタンプを初期化する
     * 
     * @memberof Util.Logger
     */
    Logger.ResetTimestamp=function() {
        Logger._timestamp = new Date();
    };
    /**
     * ログ出力： ログテキストをテキストアレイに追記し、表示する
     * 
     * @memberof Util.Logger
     * @param {String}
     *            text ログ出力文字列
     * @param {String}
     *            [type] ログ区分（"calc"：計算用ログ、"msg"：メッセージのみ（タイムスタンプなし））
     * @param {Boolean}
     *            [isSameline=false] 直前のログと同一ラインにするか
     */
    Logger.ShowLogText=function(text, type, isSameline) {
        if (type === "calc") return; // 集計時評価用ログ出力抑止
        // "msg"指定のときは経過時間を取らずに、ログのみ出力する
        if (type !== "msg"){
            // 処理時間情報を追加する
            var lastTimestamp = Logger._timestamp;
            Logger._timestamp = new Date();
            text = (Math.round( Logger._timestamp - lastTimestamp ) / 1000.0)
                    + "s " + text;
            // 数値のカンマ編集（小数部もカンマが入る）
            text = text.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        if (isSameline){
            var last = Logger._logText.length - 1;
            Logger._logText[last] += text;
        } else {
            Logger._logText.push(text);
        }
        Logger.ShowText(Logger._logText);
        if(true) console.log(Object(__WEBPACK_IMPORTED_MODULE_0__util_js__["D2S"])(Logger._timestamp, "hh:mm:ss.000     ") + text); // #60 #92
    };
    /**
     * 第一引数のテキストアレイの内容を#fileInfoのiframeに表示する
     * 
     * @memberof Util.Logger
     * @param {String}
     *            textArray 出力するログ（配列１行がログ１件）
     */
    Logger.ShowText=function(textArray) {
        var iHtmlBody = "";
        for (var i = textArray.length - 1; 0 <= i; i--){
            iHtmlBody += textArray[i] + "<BR>"; 
        }
        Logger.ShowIHtmlBody('fileInfo',iHtmlBody);
    };
    /**
     * 第一引数のID名のiframeに、第二引数のログ（HTML化）を表示する
     * 
     * @memberof Util.Logger
     * @param {String}
     *            elementId iframeのID名
     * @param {String}
     *            iHtmlBody ログ（HTML化）
     */
    Logger.ShowIHtmlBody=function(elementId, iHtmlBody){
        var body = document.createElement('body');
        body.innerHTML = ""
            + "<style>body{font-size: x-small; margin: 0; }</style>"
            + "<body id='iHtmlBody'>" + iHtmlBody + "</body>";
        var iframe = document.getElementById(elementId);
        iframe.contentDocument.body = body;
    };
    
    // newの戻り値
    return Logger;
}());

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = copyToClipboard;
/**
 * 指定されたelementIDのテキストをクリップボードにコピーする<br>
 * 一時的にdocument.bodyの下にコピー処理用要素を作成する<br>
 * スマフォ等で書き込み可能なtextareaにフォーカスが移らないよう一時的にreadonlyにする
 *
 * @memberof Util
 * @param {String}
 *            elementID textareaのID名
 */
function copyToClipboard(elementId) { // #61
    // コピー元要素を取得する
    var el = document.getElementById(elementId);
    // ワーク領域を作成する
    var input = document.createElement('textarea');
    input.setAttribute('id', 'copyinput');
    document.body.appendChild(input);
    // クリップボードにコピーする
    input.value = (el.innerText === "") ? el.value : el.innerText;
    copy2Clipboard(input); // 内部関数
    // ワーク領域を削除する
    document.body.removeChild(input);
}

/*
 * textareaをクリップボードにコピーする<br>
 * iOSに対応したtextareaのselect機能 #78
 * {@link https://marmooo.blogspot.jp/2018/02/javascript.html}
 */
function copy2Clipboard(el){
    // handle iOS as a special case
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        // save current contentEditable/readOnly status
        var editable = el.contentEditable;
        var readOnly = el.readOnly;
        // convert to editable with readonly to stop iOS keyboard opening
        el.contentEditable = true;
        el.readOnly = true;
        // create a selectable range
        var range = document.createRange();
        range.selectNodeContents(el);
        // select the range
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);
        // restore contentEditable/readOnly to original state
        el.contentEditable = editable;
        el.readOnly = readOnly;
    }
    else {
        el.select();
    }
    // execute copy command
    document.execCommand('copy');
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class binarySearch
 * @classdesc 配列二分木検索
 * 
 * @param {Number}
 *            val 検索する値
 * @param {Array}
 *            arr 検索対象の配列
 * @param {Function}
 *            [func=function(val){return val.valueOf();}] 配列要素に対して、値を取得する関数
 * @param {Index}
 *            [low=0] 配列の検査範囲の下限
 * @param {Index}
 *            [high=arr.length-1] 配列の下限検査範囲の上限
 * @param {Boolean}
 *            [isEqual=false] 完全一致しないときのリターン値：trueのとき-1、falseのとき値との差が最も少ない位置
 * @example i=Util.binarySearch(x,arrXY,function(e){return e.x;});
 */
/* harmony default export */ __webpack_exports__["a"] = (function (val, arr, func, low, high, isEqual) {
    func = func || function(val){ return val.valueOf(); };
    low = low || 0;
    if (!arr) return -1;
    high = high || arr.length - 1;
    isEqual = isEqual || false;
    var middle,
        valMiddle;
    while( low <= high ){
        middle = Math.floor(low + high) / 2 | 0;
        valMiddle = func(arr[middle]);
        if(valMiddle === val) return middle;
        else if(val < valMiddle) high = middle - 1;
        else low = middle + 1;
    }
    // 値が完全一致する要素がなかった場合の戻り値を編集する
    if (isEqual){
        return -1;  // 完全一致指定のとき(-1)をリターンする
    } else {        // 完全一致指定でないとき、値との差が最も少ない位置をリターンする #46
        // low,middle,high を補正する
        low = Math.min(Math.max(0, low), arr.length - 1);
        high = Math.max(0, Math.min(high, arr.length - 1));
        middle = Math.max(low, Math.min(middle, high));
        if(high < low){
            var tmp = high;
            high= low;
            low = tmp;
        }
        // low,middle,high のうち、値との差が最も少ない位置をリターンする
        if(func(arr[middle]) < val){
            if (val - func(arr[middle]) < func(arr[high]) - val) {
                return middle;
            } else {
                return high;
            }
        }else{
            if (func(arr[high]) <= val && val < func(arr[middle])){
                return high;
            } else if (val - func(arr[low]) < func(arr[middle]) - val){
                return low;
            } else {
                return middle;
            }
        }
        return -1;  // 指定範囲外
    }
});;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class Heap
 * @classdesc Heap ヒープ(二分ヒープ)
 *            <p>
 *            最小値(最大値)を効率よく取り出すことができるデータ構造
 *            <p>
 *            参考 {@link http://d.hatena.ne.jp/otaks/20121220/1355993039}
 * 
 * @param {Function}
 *            [func=function(obj){ return +obj; }]
 *            pushで登録するオブジェクトからヒープの大小比較判定値を取り出す関数
 * @param {Function}
 *            [delFunc=function(obj){ return obj; }] 削除対象ノードを特定する関数<br>
 *            「delの引数オブジェクト === delFunc(heapのノードのオブジェクト)」 で判定する
 * 
 * @example h = HJN_util.Heap( function(obj){ return +obj; } );<br>
 *          h.push("12.34") // データを登録する ;<br>
 *          h.push(0.12) // ;<br>
 *          h.pop() // => 0.12 最小値のオブジェクトを取り出す ;<br>
 *          h.pop() // => "12.34" ;<br>
 *          h.top() // =>undefined 最小値のオブジェクト ;<br>
 *          h.size() // =>0 登録オブジェクト数
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #55
    /** @constructor */
    function Heap(func, delFunc){ 
        if(!(this instanceof Heap)) return new Heap(func, delFunc);

        this._func = (typeof(func) === "function")
                ? func
                : function(node){
                    if (typeof(node.val) === "undefined") { return node }
                    else { return node.val}; 
                  };
        this._delFunc = (typeof(delFunc) === "function")
                ? delFunc
                : function(node){
                    if(typeof(node.obj) === "undefined"){ return node }
                    else { return node.obj};
                  };
        this._heap = []; // Heap構造体（大小比較数値用）
    }

    //
    /**
     * upheap：root方向へheapを再構築する
     * 
     * @private
     * @param {Number}
     *            k 起点の_heap配列位置
     */
    Heap.prototype._upHeap = function(k) {
        // 指定位置のオブジェクトとその値の控えを取る
        var obj = this._heap[k];
        var val = this._func(obj);
        while( 0 < k ) {
            // 親ノードの配列位置を求める
            var p = Math.floor( (k - 1) / 2 );
            // 逆転していなければ処理終了
            if( this._func(this._heap[p]) <= val ) break;
            // 親ノードと処理対象を入れ替える
            this._heap[k] = this._heap[p];
            this._heap[p] = obj;
            k = p;
        }
    };
    /**
     * downheap：reaf方向へheapを再構築する
     * 
     * @private
     * @param {Number}
     *            k 起点の_heap配列位置
     */
    Heap.prototype._downHeap = function(k) {
        // 指定位置のオブジェクトとその値を控えを取る
        var obj = this._heap[k];
        var val = this._func(obj);
        var size = this._heap.length;
        // 子ノードが無くなるまで繰り返す
        while( k * 2 + 1 < size) {
            var a = k * 2 + 1;  // 子ノード（左）
            var b = a + 1;      // 子ノード（右）
            // aが大小比較対象先となる小さい子ノードを指すようにする
            if( b < size && this._func(this._heap[a]) > this._func(this._heap[b]) ) a = b;
            // 逆転していなければ処理終了
            if( val < this._func(this._heap[a]) ) break;
            // 子ノード（比較対象）と処理対象を入れ替える
            this._heap[k] = this._heap[a];
            this._heap[a] = obj;
            k = a;
        }
    };
    /**
     * _heapのk番目を削除し、_heapを再構築する
     * 
     * @private
     * @param {Number}
     *            k 起点の_heap配列位置
     * @return {object|undefined} 削除したオブジェクト（削除対象が無いとき undefined）
     */
    Heap.prototype._del = function(k) {
        if (this._heap.length <= k) return undefined; // ヒープ外を指定したとき

        var ret = this._heap[k]; // 削除したオブジェクト
        var obj = this._heap.pop(); // 末尾ノードを取り出す
        var size = this._heap.length;
        if (k === size) return ret; // 末尾ノードを削除したとき再構築不要

        this._heap[k] = obj; // 末尾ノードを指定位置に移動する
        if (size === 1) return ret; // ヒープが１個のとき、再構築不要

        // upHeapの判定
        var val = this._func(obj); // 末尾ノードにあったオブジェクトの値
        var p = Math.floor( (k - 1) / 2 );
        if (0 < k && val < this._func(this._heap[p])) {
            // 親ノードより小さいときupheapする
            this._upHeap(k);
        } else {
            var a = k * 2 + 1;  // 子ノード（左）
            var b = a + 1;      // 子ノード（右）
            if (a < size) { // 子ノードがあるとき（末端の枝葉でないとき）のみdownHeapする
                // aに、子ノードの小さい方のノードを設定する
                if( b < size && (this._func(this._heap[a]) > this._func(this._heap[b])) ) a = b;
                // 自分より小さい子ノードがあるとき、downheapする
                if( this._func(this._heap[a]) < val ) this._downHeap(k);
            }
        }
        return ret;
    };
    // public
    /**
     * データを追加する
     * 
     * @memberOf Util.Heap
     * @param {Object}
     *            obj 登録オブジェクト
     */
    Heap.prototype.push = function(obj) {
        // 末尾に追加し、upHeapする
        this._heap.push(obj);
        this._upHeap(this._heap.length - 1);
        if (this._deletable) {
            this._deleteMap = {};
        }
    };
    /**
     * 最小値のデータを取り出す
     * 
     * @memberOf Util.Heap
     * @return {Object|undefined} 最小値
     */
    Heap.prototype.pop = function() {
        // 先頭ノードを戻り値用に退避する
        var ret = this._heap[0];
        // 末尾ノードを退避し削除する
        var obj = this._heap.pop();
        if(0 < this._heap.length){
            // ヒープが空でないとき、末尾ノードを先頭に移動し、downHeapする
            this._heap[0] = obj;
            this._downHeap(0);
        }
        return ret;
    };
    /**
     * 指定データを削除する
     * 
     * @memberOf Util.Heap
     * @param {Object}
     *            obj 削除対象と同一オブジェクト(=== で判定)
     * @return {Object|undefined} 削除したオブジェクト（undefined：合致するオブジェクトが無いとき）
     */
    Heap.prototype.del = function(obj) { // #59
        // 削除対象オブジェクトのHeap配列位置を取得する
        var k = -1;
        if (this._heap.some(find, this)){
            // 合致するオブジェクトのノードを削除し、合致ノードをリターンする
            return this._del(k);
        }
        // 合致するオブジェクトが無いとき
        return undefined;
        
        function find(e, i) {
            if(this._delFunc(e) === obj){
                k = i;
                return true;
            }
            return false;
        }
    };
    /**
     * 最小値を返却する（登録データは変更しない）
     * 
     * @memberOf Util.Heap
     * @return {Object|undefined} 最小値
     */
    Heap.prototype.top = function() {
        return this._heap[0];
    };
    /**
     * ヒープのサイズを返却する
     * 
     * @memberOf Util.Heap
     * @return {Number} ヒープサイズ（0以上）
     */
    Heap.prototype.size = function() {
        return this._heap.length;
    };
    
    /* new */
    return Heap;
}());

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Element;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__(0);


/**
 * @memberOf Util
 * @class Element
 * @classdesc 追加する挙動の操作要素は、後に記述した挙動の要素が上位になる 参考
 *            {@link https://q-az.net/elements-drag-and-drop/}
 * @param {DOM}
 *            element ドラッグ機能を付与するDOM要素
 * @constructor
 */
function Element(element){
    this._element = element;    // 挙動を追加する要素
    this._wrapper = {};         // マウスイベントを取得するdivを追加する下地要素

    // width,height :100%が有効となるようposition: absoluteを指定する
    element.style.position = "absolute";
    // ドラッグ＆ドロップ用divを作成する(下地のみクリック透過）
    this._wrapper = document.createElement('div');
    setStyles(this._wrapper, { background : "rgba(192,192,192,0.1)",
        position : "absolute", width : "100%", height : "100%", top : "0", left : "0",
        "pointer-events": "none"});
    // ドラッグ＆ドロップ用divを登録する
    this._element.appendChild(this._wrapper);
}

// グローバル（のような）変数
var pos = {};        // マウス押下時の位置情報の保管用

/**
 * CSSクラス名"hjnDraggableBox"が付いた要素をドラッグ＆ドロップで移動できるようにする
 * 
 * @memberOf Util.Element
 * @example .hjnDraggableBox {} .hjnDraggableItem:hover {cursor: move;
 *          background: rgba(128, 128, 128, 0.5); transition: all 0.2s; }
 * @example <div class="hjnDraggableBox"></div>
 */
Element.enableDraggableClass = function(){
    var elements = document.getElementsByClassName("hjnDraggableBox");  // 要素の取得
    // マウスが要素内で押されたとき、又はタッチされたとき発火
    for(var i = 0; i < elements.length; i++){
        var element = new Element(elements[i]);
        element     // 移動指定要素がリサイズ指定要素よりが下になるよう、移動を先に記述する
            .makeMoveable()
            .makeResizable();
    }
}

/**
 * ダイアログを生成し表示する
 * 
 * @memberOf Util.Element
 * @param {String}
 *            [iHtml="no message"] ダイアログのinnerHTMLに設定する文字列
 * @param {DOM}
 *            [element=document.body] ダイアログの位置とサイズを指定する際の基準となる要素
 * @param {String}
 *            [id="HJN.dialog"] ダイアログ要素のid名、同一名称のダイアログを閉じて作成する
 * @param {Number}
 *            [w=40] elementに対するダイアログの幅の比率％
 * @param {Number}
 *            [h=40] elementに対するダイアログの高さの比率％
 * @param {Object}
 *            [style={ width: w+"%", height: h+"%", left: 50-w/2+"%", top: 50-h/2+"%", position: "absolute", background: "rgba(255, 255, 255, 0.8)", border: "medium solid #aaa"}] 
 *            ダイアログ背景のCSSスタイル
 */
Element.createDialog = function(iHtml, element, id, w, h, style){
    iHtml = iHtml || "no message";
    element = element || document.body;
    style = style || {};
    id = id || "HJN.dialog";
    w = w || 40; // 幅40%
    h = h || 40; // 高さ40%
    // 既存の同一idの要素を削除する
    var div = document.getElementById(id);
    if (div) { div.parentElement.removeChild(div);}
    // ダイアログ要素を作成する
    div = document.createElement('div');
    div.id = id;
    element.appendChild(div);
    div.innerHTML ="<iframe></iframe>";
    setStyles(div.children[0],
            {width: "100%", height: "100%", border: 0, "pointer-events": "auto"});
    var body = document.createElement('body');
    var htmlText = "<body>" + iHtml + "</body>";
    body.textContent = ""; // #82
    body.insertAdjacentHTML('afterBegin', htmlText);
    
    div.children[0].contentDocument.body = body;
    // スタイルを設定する（デフォルト：縦横40%（親サイズに連動）で中央に配置）
    setStyles(div, style, 
            { width: w+"%", height: h+"%", left: 50-w/2+"%", top: 50-h/2+"%",
              position: "absolute", "z-index" : "80",
              background: "rgba(255, 255, 255, 0.8)", border: "medium solid #aaa"});
    var draggable = new Element(div);
    draggable        // 移動指定要素がリサイズ指定要素よりが下になるよう、×ボタン、移動、リサイズの順に記述する
        .makeRemovable(id)
        .makeMoveable()
        .makeResizable();
}

/**
 * ×ボタンによる要素削除機能を付与する
 * 
 * @memberOf Util.Element
 * @param {String}
 *            [id=""] ×ボタン要素のid名（重複すると先に作成された×ボタンのダイアログが閉じられる）
 * @param {Object}
 *            [style={cursor: "move", top:"0", left:"50%", width:"100%",height:"20px"};]
 *            ×ボタン要素のCSSスタイル
 * @return this
 */
Element.prototype.makeRemovable = function(id, style) {
    // inputタグを追加する
    // <input id="hjnDialog" type="checkbox" class="hjnBurger" checked="checked"
    // onChange="..."/>
    var input = document.createElement("input");
    input.type = "checkbox";
    input.id = (id || "") + "_BATSU"; // #86
    input.classList.add("hjnBurger");
    input.checked = true;
    input.onchange = function(){
        var e = this.parentElement.parentElement;
        e.parentElement.removeChild(e);
    };
    this._wrapper.appendChild(input);
    // ×ボタンlabelタグを追加する
    // <label for="hjnDialog"><span></span></label>
    var label = document.createElement("label");
    label.classList.add("hjnCtrlBox");
    label.htmlFor = input.id;
    label.appendChild(document.createElement("span"));
    setStyles(label, style, { top:"4px", right: "4px", 
        position: "absolute", background: "transparent"});
    this._wrapper.appendChild(label);
    return this;
}

/**
 * ドラッグによる移動機能を付与する
 * 
 * @memberOf Util.Element
 * @param {Object}
 *            [style={cursor: "move", top:"0", left:"50%", width:"100%", height:"20px"};] ドラッグ移動機能要素のCSSスタイル
 * @return this
 */
Element.prototype.makeMoveable = function(style) {
    // 制御用divを追加する
    this.addHandleElement(elementMove, style, // 上：20px
            {cursor: "move", top:"0",  left:"50%", width:"100%", height:"20px"},
            "inside");
    return this;
}
/**
 * ドラッグによる リサイズ機能を付与する
 * 
 * @memberOf Util.Element
 * @param {object}
 *            [style] リサイズ機能要素のCSSスタイルを、デフォルトから変更する際に指定
 * 
 * @return this
 */
Element.prototype.makeResizable = function(style) {
    // 制御用divを追加する
    this.addHandleElement(elementUpper,  style,  // 上:Upper
            {cursor: "ns-resize", top:"0",    left:"50%", width:"100%"});
    this.addHandleElement(elementBottom, style,  // 下:Bottom
            {cursor: "ns-resize", top:"100%", left:"50%", width:"100%"});
    this.addHandleElement(elementLeft,   style,  // 左:Left
            {cursor: "ew-resize", top:"50%",  left:"0",   height:"100%"});
    this.addHandleElement(elementRight,  style,  // 右:Right
            {cursor: "ew-resize", top:"50%",  left:"100%",height:"100%"});
    this.addHandleElement(elementUpperLeft,  style,  // 左上:UpperLeft
            {cursor: "nwse-resize", top:"0",    left:"0"});
    this.addHandleElement(elementUpperRight, style,  // 右上:UpperRight
            {cursor: "nesw-resize", top:"0",    left:"100%"});
    this.addHandleElement(elementBottomLeft, style,  // 左下:BottomLeft
            {cursor: "nesw-resize", top:"100%", left:"0"});
    this.addHandleElement(elementBottomRight,style,  // 右下:BottomRight
            {cursor: "nwse-resize", top:"100%", left:"100%"});
   return this;
}
/**
 * マウスクリック用要素を追加
 * 
 * @memberOf Util.Element
 * @param {Function}
 *            func マウス押下時に発火する処理
 * @param {object}
 *            [style] elementに設定するスタイル
 * @param {object}
 *            [styleD={top:"0", left:"0" width:"5px", height:"5px"}]
 *            elementに設定するデフォルトスタイル（styleに同じ属性がある場合styleが優先される）
 * @param {String}
 *            [transform="over"] paddingに対する要素の位置
 *            "onFrame":線上、"inside":内側、その他：指定文字列をtransformスタイルに設定
 * @param {String}
 *            [className="hjnDraggableItem"] マウスイベントを取得するdivに設定するCSSクラス名
 */
Element.prototype.addHandleElement = function(func, style, styleD, transform, className) {
    style = style || {};
    styleD = styleD || {};
    transform = transform || "onFrame";
    for (var property in style) styleD[property] = style[property];

    var div = document.createElement('div');
    div.classList.add(className || "hjnDraggableItem");
    // 要素がpaddingの内側になるtransform設定値を求める
    // 例：上下左右中央の時"translateY(-50%) translateX(-50%)"
    if (transform === "onFrame") {
        transform = 'translateX(-50%) translateY(-50%)';
    } else if (transform === "inside"){
        transform = 'translateX(-' + (styleD.left || 0) + ') translateY(-' + (styleD.top || 0) + ')';
    }
    // スタイルを設定する（デフォルト：縦横10pxで左上{top:0,ledt:0}に配置）
    setStyles(div, styleD, 
            { width : "5px", height : "5px", position : "absolute", transform : transform });
    // 要素を追加する
    this._wrapper.appendChild(div);
    // 追加した要素に、マウス押下時の処理を登録する
    div.addEventListener("mousedown", func, false);
    div.addEventListener("touchstart", func, false);
};


// マウス押下後の発火関数定義（イベントリスナーに登録する関数を指定）
function elementMove(e)       {dragStart(e, this, draggingMove,        dragEndMove       ); }
function elementUpper(e)      {dragStart(e, this, draggingUpper,       dragEndUpper      ); }
function elementBottom(e)     {dragStart(e, this, draggingBottom,      dragEndBottom     ); }
function elementLeft(e)       {dragStart(e, this, draggingLeft,        dragEndLeft       ); }
function elementRight(e)      {dragStart(e, this, draggingRight,       dragEndRight      ); }
function elementUpperLeft(e)  {dragStart(e, this, draggingUpperLeft,   dragEndUpperLeft  ); }
function elementUpperRight(e) {dragStart(e, this, draggingUpperRight,  dragEndUpperRight ); }
function elementBottomLeft(e) {dragStart(e, this, draggingBottomLeft,  dragEndBottomLeft ); }
function elementBottomRight(e){dragStart(e, this, draggingBottomRight, dragEndBottomRight); }
// マウスドラッグ時の挙動定義（マウス移動距離に乗算する値を定義）
function draggingMove(e)       {dragging(e, {posX: 1, posY: 1, width: 0, height: 0 }); }  // 移動
function draggingUpper(e)      {dragging(e, {posX: 1, posY: 1, width: 0, height:-1 }); }  // 上リサイズ
function draggingBottom(e)     {dragging(e, {posX: 0, posY: 0, width: 0, height: 1 }); }  // 下リサイズ
function draggingLeft(e)       {dragging(e, {posX: 1, posY: 0, width:-1, height: 0 }); }  // 左リサイズ
function draggingRight(e)      {dragging(e, {posX: 0, posY: 0, width: 1, height: 0 }); }  // 右リサイズ
function draggingUpperLeft(e)  {dragging(e, {posX: 1, posY: 1, width:-1, height:-1 }); }  // 左上リサイズ
function draggingUpperRight(e) {dragging(e, {posX: 0, posY: 1, width: 1, height:-1 }); }  // 右上リサイズ
function draggingBottomLeft(e) {dragging(e, {posX: 1, posY: 0, width:-1, height: 1 }); }  // 左下リサイズ
function draggingBottomRight(e){dragging(e, {posX: 0, posY: 0, width: 1, height: 1 }); }  // 右下リサイズ
// マウス解放後の発火関数定義（イベントリスナーから解放する関数を指定）
function dragEndMove(e)       {dragEnd(draggingMove,        dragEndMove       ); }
function dragEndUpper(e)      {dragEnd(draggingUpper,       dragEndUpper      ); }
function dragEndBottom(e)     {dragEnd(draggingBottom,      dragEndBottom     ); }
function dragEndLeft(e)       {dragEnd(draggingLeft,        dragEndLeft       ); }
function dragEndRight(e)      {dragEnd(draggingRight,       dragEndRight      ); }
function dragEndUpperLeft(e)  {dragEnd(draggingUpperLeft,   dragEndUpperLeft  ); }
function dragEndUpperRight(e) {dragEnd(draggingUpperRight,  dragEndUpperRight ); }
function dragEndBottomLeft(e) {dragEnd(draggingBottomLeft,  dragEndBottomLeft ); }
function dragEndBottomRight(e){dragEnd(draggingBottomRight, dragEndBottomRight); }

/**
 * DOM要素にスタイル設定
 * 
 * @memberOf Util.Element
 * @param {DOM}
 *            element CSSスタイルを設定するDOM要素
 * @param {object}
 *            [style] elementに設定するスタイル {top:"50%", left:"50%"}
 * @param {object}
 *            [styleD] elementに設定するデフォルトスタイル {top:"50%", left:"50%"}
 */
Element.SetStyles = setStyles;
function setStyles(element, style, styleD){
    // ポインタ操作の透過が指定されていないとき有効化にする（ダイアログなど上位レイヤで透過となっていることがあるため）
    styleD = styleD || {};
    styleD["pointer-events"] = styleD["pointer-events"] || "auto";
    // デフォルトスタイルを設定する
    for (var property in styleD) element.style[property] = styleD[property];
    // 指定スタイルを設定する
    for (var property in style) element.style[property] = style[property];
}

/**
 * マウス押下したときに発火する関数から呼ばれる
 * 
 * @private
 * @memberOf Util.Element
 * @param {Event}
 *            e 発火イベント
 * @param {DOM}
 *            element マウス押下を発火したDOM要素（CALL元のthis)
 * @param {function}
 *            dragging マウス移動イベントに登録する関数消去するイベントに登録されている関数
 * @param {function}
 *            dragEnd 消去するイベントに登録する関数
 */
function dragStart(e, element, dragging, dragEnd) {
    // タッチイベントとマウスのイベントの差異を吸収する
    var event = (e.type === "mousedown") ? e : e.changedTouches[0];
    pos.pageX = event.pageX; 
    pos.pageY = event.pageY;
    // 親の親要素(hjnDraggableBox指定)内の相対座標を取得
    var grandparent = element.parentNode.parentNode;
    pos.offsetLeft = grandparent.offsetLeft;
    pos.offsetTop = grandparent.offsetTop;
    // margin補正値、縦横を取得
    var style = document.defaultView.getComputedStyle(grandparent);
    pos.marginLeft = parseInt(style.getPropertyValue("margin-left")) || 0;
    pos.marginTop = parseInt(style.getPropertyValue("margin-top")) || 0;
    pos.width = grandparent.clientWidth || 0;
    pos.height = grandparent.clientHeight || 0;

    // 処理範囲外のとき何もしない
    // if (pos.y > 10) return;

    // 全画面にマウスアップ用要素を被せる
    var hjnDrag = document.getElementById("hjnDrag");
    if (!hjnDrag) {
        hjnDrag = document.createElement('div');
        hjnDrag.id = "hjnDrag";
        element.parentElement.appendChild(hjnDrag);
    }
    setStyles(hjnDrag,  
            { width  : window.innerWidth + "px",
              height : window.innerHeight + "px",
              position : "fixed", top : "0", left : "0",
              });
    // 親の親要素（hjnDraggableBox指定)に、CSSクラス"drag"を追加
    grandparent.classList.add("drag");
    // addEventListenerの第三引数を判定
    var isPassive = isSupportsPassive() ? {passive: false} : false;
    // ムーブイベントにコールバック
    document.body.addEventListener("mousemove", dragging, isPassive);
    document.body.addEventListener("touchmove", dragging, isPassive);
    // マウスボタンが離されたとき、またはカーソルが外れたときに発火するイベントを登録する
    hjnDrag.addEventListener("mouseup", dragEnd, isPassive);
    hjnDrag.addEventListener("touchend", dragEnd, isPassive);
    document.body.addEventListener("mouseleave", dragEnd, isPassive);
    document.body.addEventListener("touchleave", dragEnd, isPassive);
}

// addEventListenerの第三引数を判定するためにがpassive対応かどうか判定する
function isSupportsPassive(){
    var supportsPassive = false;
    try {
      var opt = {
        get passive() {
          supportsPassive = true;
        }
      },
      handler = function() {};

      window.addEventListener("checkpassive", handler, opt);
      window.removeEventListener("checkpassive", handler, opt);
    } catch (err) {}
    return supportsPassive; 
}
/**
 * 親の親要素をマウス押下後、マウスカーソルが動いたときに発火する関数から呼ばれる
 * 
 * @private
 * @memberOf Util.Element
 * @param {Event}
 *            e 発火イベント
 * @param {Object}
 *            multiply 補正スタイル毎のマウスカーソル移動幅の掛け目<br>
 *            要素を移動する場合 {posX:1, posY:1, width:0, height:0}<br>
 *            左上リサイズの場合 {posX:1, posY:1, width:-1, height:-1}<br>
 *            右下リサイズの場合 {posX:0, posY:0, width:1, height:1}
 */
function dragging(e, multiply) {
    // タッチイベントとマウスのイベントの差異を吸収する
    var event = (e.type === "mousemove") ? e : e.changedTouches[0];
    // フリックしたときに画面を動かさないようにデフォルト動作を抑制する
    e.preventDefault();
    // マウスが動いた場所に要素を動かす（"drag"は同時に一つしか存在しない前提）
    var drag = document.getElementsByClassName("drag")[0];
    if (drag) {
        drag.style.left = pos.offsetLeft - pos.marginLeft 
            + multiply.posX * (event.pageX - pos.pageX) + "px";
        drag.style.top  = pos.offsetTop  - pos.marginTop
            + multiply.posY * (event.pageY - pos.pageY) + "px";
        drag.style.width  = pos.width
            + multiply.width  * (event.pageX - pos.pageX) + "px";
        drag.style.height = pos.height
            + multiply.height * (event.pageY - pos.pageY) + "px";
    }
}
/**
 * マウスボタンが上がった場合、もしくは画面外にマウスが出た場合に発火する関数から呼ばれる
 * 
 * @private
 * @memberOf Util.Element
 * @param {function}
 *            dragging 消去するイベントに登録されている関数
 * @param {function}
 *            dragEnd 消去するイベントに登録されている関数
 */
function dragEnd(dragging, dragEnd) {
    // イベントハンドラを消去する
    document.body.removeEventListener("mousemove", dragging, false);
    document.body.removeEventListener("touchmove", dragging, false);
    document.body.removeEventListener("mouseleave", dragEnd, false);
    document.body.removeEventListener("touchleave", dragEnd, false);
    // クラス名 .drag を外す
    var drag = document.getElementsByClassName("drag")[0];
    if (drag) drag.classList.remove("drag");
    // マウスアップ検知用要素を削除する
    var hjnDrag = document.getElementById("hjnDrag");
    if (hjnDrag) { hjnDrag.parentElement.removeChild(hjnDrag);}
}


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Config_js__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__util_Config_js__["a"]; });


// import Config_addMenu from "./util-config_addMenu.js";
// Config.addMenu = Config_addMenu;



/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class Config
 * @classdesc 定数設定機能（設定HTML作成機能付き）
 *            <p>
 *            日時、TATフォーマット指定機能追加用に作成
 * 
 * @param {String}
 *            [prefix=''] 定数の名前空間を一位に指定する文字列、指定しない場合グローバル
 * @param {String}
 *            [ol='ol'] インデント(.nDown() .nUp())に使うHTMLタグ
 * @param {String}
 *            [globalName='HJN'] Configを登録するグローバル変数(window)の変数名
 * @example this._config = HjnConfig("m") // config設定画面定義
 *          .label(null,"------").n() // ラベルを表示し、改行
 *          .name("ENDIAN").label(null,"[endian(long field)]") //key:ENDIAN
 *          .radio(def("ENDIAN_LIL", true), null, "little", true) //表示ラベルと選択時設定値
 *          .radio(def("ENDIAN_BIG", false), null, "big");
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #24
    /** @static */
    Config.prototype.__config = {};   // config設定コンテナ
    Config.prototype.__config._onFunctions = {}; // 関数登録用
    Config.prototype.__config.__keyConfig = {};  // キー値登録用

    /** @constructor */
    function Config(prefix, ol, globalName){ 
        if(!(this instanceof Config)) return new Config(prefix, ol, globalName);

        // グローバル変数(window)にHJN.Configを登録する #74
        this._globalName = globalName || "HJN";
        var globalConfig = window[this._globalName].Config;
        globalConfig = globalConfig || Config;

        this._prefix = prefix; // #76
        this._pre = (prefix || '') + "."; // 各フィールド、要素の名称のプレフィックス(区切り文字".")
        this._ols = ol ? '<' + ol + '>' : '<ol>';   // リストに使用する要素（初期値 ol )
        this._ole = ol ? '</' + ol + '>' : '</ol>';
        this._html = this._ols; // config設定画面のHtml
        this._nameHtml = '';    // HTMLタグの name属性指定
        this._name = '';        // radioのConfig.get用

        if (globalConfig[prefix] === undefined){
            globalConfig[prefix] = this;
            return this;
        } else {
            return globalConfig[prefix]; 
        }
    }

    /**
     * HTML要素の値が変更した時に、configに当該要素を登録する
     * 
     * @memberof Util.Config
     */
    Config.on = function(t) {
        var funcId = t.id;
        if (t.type === "radio") { // radioのとき、nameに対して、選択されたキー値（idからprefixを削除した値）を登録
            this.prototype.__config[t.name] = t.id.substr(t.id.indexOf(".") + 1);
        }else if (t.type === "number") {    // numberのとき、idに、value(入力値)を数値として登録
            this.prototype.__config[t.id] = +t.value;
        } else if (t.type === "select-one") {    // selectのとき、idに、valueの設定値を登録
            this.prototype.__config[t.id] = t.value.substr(t.value.indexOf(".") + 1); // #96
            funcId = t.value;
        } else {                            // textのとき、idに、value(入力値)を登録
            this.prototype.__config[t.id] = t.value;
        }
        // on呼出し関数が登録されているとき、登録関数を呼び出す #51
        var func = Config.GetConfig().getFunctionById(funcId); // #59
        if(typeof(func) === "function") func();
    };

    /**
     * Configリポジトリ管理インスタンスを取得する
     * 
     * @memberof Util.Config
     * @example Config.GetConfig("File") === Config("File"); // true 既に登録されているとき
     */
    Config.GetConfig = function(prefix) { // #59
        return new Config(prefix);
    }
    
    /** @private */
    //

    // public
    /**
     * keyの値に指定されたvalue（なければkey値）を返却する
     * 
     * @memberof Util.Config
     * @param {String}
     *            key Conginのキー値
     */
    Config.prototype.getConfig = function(key) {
        var cKey = this.getValueByKey(key);
        var keyConfig = Config.prototype.__config.__keyConfig[this._pre + cKey];
        if(!keyConfig || keyConfig.value === undefined){
            return cKey;    // valueが定義されていないとき、keyの設定値を返却
        }else{
            return keyConfig.getConfig(); // keyの設定値のvalueが定義されているとき
        }
    };
    /**
     * configに登録されているid(=prefix+key)の設定値を取得する
     * 
     * @memberof Util.Config
     */
    Config.prototype.getObjctById = function(id) {
        // return this.__config[id];
        return Config.prototype.__config[id];
    };
    /**
     * configに登録されているkey(prefix補填)の設定値を取得する
     * 
     * @memberof Util.Config
     */
    Config.prototype.getValueByKey = function(key) { 
        var val = Config.prototype.__config[this._pre + key];
        // selectorでon未実行時に、選択項目の値を取り込む #96
        if (!val) {
            var e = document.getElementById(this._pre + key);
            if (e && typeof e.selectedIndex === "number") {
                var t = e[e.selectedIndex].value;
                val = t.substr(t.indexOf(".") + 1);
                Config.prototype.__config[this._pre + key] = val;
            }
        }
        return val;
    };
    /**
     * configにkey(prefix補填)に値を設定する
     * 
     * @memberof Util.Config
     */
    Config.prototype.setValueByKey = function(key, val) { 
        Config.prototype.__config[this._pre + key] = val;
    };
    /**
     * configの指定Idに登録されている関数を取得する<br>
     * 
     * @memberof Util.Config
     * @example // Config.onでradioボタン選択時に関数を呼ぶ場合に使用 var func =
     *          Config.GetConfig().getFunctionById(t.id);
     */

    Config.prototype.getFunctionById = function(id) { // #53
        return Config.prototype.__config._onFunctions[id];
    };
    /**
     * configに登録されているkey(prefix補填)の関数を取得する
     * 
     * @memberof Util.Config
     * @example Util.Config.GetConfig("Simulator").getFunctionByKey("S_SIMU")();
     */
    Config.prototype.getFunctionByKey = function(key) { // #59
        return Config.prototype.__config._onFunctions[this._pre + this.getValueByKey(key)];
    };
    /**
     * 指定keyに登録されている関数を取得する
     * 
     * @memberof Util.Config
     */
    Config.prototype.getFunction = function(key) { // #76
        return Config.prototype.__config._onFunctions[this._pre + key];
    };
    /**
     * 指定keyに関数を登録する
     * 
     * @memberof Util.Config
     */
    Config.prototype.setFunction = function(key, func) { // #76
        Config.prototype.__config._onFunctions[this._pre + key] = func;
    };
    

    /**
     * config設定用HTMLテキストを取得する
     * 
     * @memberof Util.Config
     */
    Config.prototype.getHtml = function() { 
        return this._html + this._ole;
    };
    /**
     * keyに値を設定する
     * 
     * @memberof Util.Config
     */
    Config.prototype.set = function(key, val) { 
        this.value[this._pre + key] = val;
    };
    
    // config作成用 メソッド
    /**
     * 定義＆設定画面作成用機能： 改行
     * 
     * @memberof Util.Config
     */
    Config.prototype.n = function (str) {
        str = str || "";
        this._html += this._ole + str + this._ols;
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： ネスト一つ下げ
     * 
     * @memberof Util.Config
     */
    Config.prototype.nDown = function () {
        this._html += this._ols;
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： ネスト一つ上げ
     * 
     * @memberof Util.Config
     */
    Config.prototype.nUp = function () {
        this._html += this._ole;
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： nameを変更する（radio等の先頭で指定）
     * 
     * @memberof Util.Config
     */
    Config.prototype.name = function (str) {
        this._nameHtml = str ? 'name="' + this._pre + str + '" ' : '';
        this._name = str;
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： ラベル要素(prefix+keyで関連付けるformのid属性となる)
     * 
     * @memberof Util.Config
     */
    Config.prototype.label = function (key, str, attribute) {
        this._html += '<label ' +
                        (key ? 'for="' + this._pre + key + '" ': '') +
                        (attribute || '') + '>' +
                        (str || '') +
                        '</label>\n'; // #51
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： ラベル付された各種入力フォーム
     * 
     * @memberof Util.Config
     */
    Config.prototype.labeledForm = function (key, type, typedAttribute,
                                pLabel, sLabel, val, attribute, check, cssClass) {
        var classStr = (cssClass) ? ' class="' + cssClass + '"' : ''; // #51
        // optionの時(select用）
        if (type === "option"){
            this._html += '<option value="' + this._pre + key + '"' + (typedAttribute || '') + '>' +
                    (pLabel ? pLabel : '') + (sLabel ? sLabel : '') + '</option>\n'
            return this;
        }
        // option以外の時
        this._html += '<label' + classStr + '>' + // #51
                    (pLabel ? pLabel : '') +
                    '<input type="' +type + '" ' +
                        (typedAttribute || '') + 
                        this._nameHtml +
                        'id="' + this._pre + key + '" '+ // idがユニークになるようkeyにprefixを付与
                        'onchange="' + this._globalName + '.Config.on(this);" ' + // #74
                        (val ? "value='" + val + "' " : "") +   // val は、キー値のまま
                                                                // #92
                        (attribute || '') + 
                        (check ? ' checked="checked;"' : '') +
                    '>' +
                    (sLabel ? sLabel : '') +
                    '</label>\n'; // #51
        // デフォルト指定があるとき configにデフォルト値を設定する
        if (type === "radio" && check) {    // radioのとき、nameに対して、選択状態のkeyを登録
            Config.prototype.__config[this._pre + this._name] = key;
        } else if (type === "number") { // numberのとき、keyに対する、val(入力値)を数値として登録
            Config.prototype.__config[this._pre + key] = +val;
        } else {    // textのとき、keyに対する、val(入力値)を登録
            Config.prototype.__config[this._pre + key] = val;
        }
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： テキストボックス要素で、文字列を設定
     * 
     * @memberof Util.Config
     */
    Config.prototype.number = function (key, pLabel, sLabel, val, attribute, func) {
        Config.prototype.labeledForm.call(this, key, "number", "", 
                                pLabel, sLabel, val, attribute);
        if (func) this.setFunction(key, func); // #74
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： テキストボックス要素で、数値を設定
     * 
     * @memberof Util.Config
     */
    Config.prototype.text = function (key, pLabel, sLabel, val, attribute) {
        Config.prototype.labeledForm.call(this, key, "text", "", 
                                pLabel, sLabel, val, attribute);
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： ラジオボタン要素で、選択肢の一つを設定
     * 
     * @memberof Util.Config
     */
    Config.prototype.radio = function (key, pLabel, sLabel, check, attribute, func) {
        Config.prototype.labeledForm.call(this, key, "radio", (check ? 'checked="checked;"' : ''),
                                pLabel, sLabel, "", attribute, check, "hjnLabel4Input");
        // 関数登録指定時、attributeを関数名として、指定関数を登録する #51
        if (func) this.setFunction(key, func);
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： セレクトボックス要素で、選択肢の一つを設定
     * 
     * @memberof Util.Config
     */
    Config.prototype.option = function (key, pLabel, sLabel, check, attribute, func) { // #74
        Config.prototype.labeledForm.call(this, key, "option", (check ? ' selected' : ''),
                                pLabel, sLabel, "", attribute, check, "hjnLabel4Input");
        // 関数登録指定時、attributeを関数名として、指定関数を登録する #51
        if (func) this.setFunction(key, func);
        // 逆引きリストに追加する
        var reverseList = Config.prototype.__config.__keyConfig[this._pre + this._name] || {};
        var reverseVal = this._pre + key;
        var reverseKey = this.__config.__keyConfig[reverseVal].getConfig(); 
        reverseList[reverseKey] = reverseVal;
        Config.prototype.__config.__keyConfig[this._pre + this._name] = reverseList; 
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： option用タグの開始宣言（selectタグ用）
     * 
     * @memberof Util.Config
     */
    Config.prototype.startTag = function (type) { // #74
        this._tag = type || "";
        this._html += '<' + this._tag 
                            + ' id="' + this._pre + this._name + '"'
                            + 'class="hjnLabel4Input" onchange="HJN.Config.on(this);">\n'  ;
        return this;
    };
    /**
     * 定義＆設定画面作成用機能： option用タグの終了宣言（selectタグ用）
     * 
     * @memberof Util.Config
     */
    Config.prototype.endTag = function (type) { // #74
        this._html += '</' + this._tag + '>\n'
        this._tag = undefined;
        return this;
    };

    /**
     * 定義＆設定画面作成用機能： keyConfigの設定値を取得する
     * 
     * @memberof Util.Config
     */
    Config.prototype.getKeyConfig = function (key) { // #74
        return this.__config.__keyConfig[this._pre + key];
    };
    /**
     * 定義＆設定画面作成用機能： option設定値からoptionキー値を逆引きする（selectタグ用）
     * 
     * @memberof Util.Config
     */
    Config.prototype.getOptionKey = function (key, val) { // #74
        return this.__config.__keyConfig[this._pre + key][val];
    };
    /**
     * 定義＆設定画面作成用機能： 固定値を取得するキーの宣言<br>
     * __keyConfig["File.SEP_COMMA"] = {value: ",", getConfig:
     * LF_ELSE.vから値を取得するfunction, onFunc: null}
     * 
     * @memberof Util.Config
     * @param {String}
     *            key キー値
     * @param {Object}
     *            [val=key] 取得する固定値（getValueByKeyの返却値、デフォルト：keyと同じ文字列）
     * @param {function}
     *            [onFunc] onイベント時に実行する処理（メニューのa属性などで利用）
     */
    Config.prototype.def = function(key, val, onFunc) { // #76
        var _keyConf = Config.prototype.__config.__keyConfig[this._pre + key] = {};
        _keyConf.value = (val === undefined) ? key : val; // 
        _keyConf.getConfig = function () { return (val === undefined) ? key : val; };
        _keyConf.onFunc = onFunc || null; 
        return key;
    }
    /**
     * 定義＆設定画面作成用機能： 画面より値を取得するキーの宣言<br>
     * __keyConfig["File.LF_ELSE"] = {value: "LF_ELSE", getConfig:
     * LF_ELSE.vから値を取得するfunction}
     * 
     * @memberof Util.Config
     * @param {String}
     *            key キー値
     * @param {String}
     *            [fieldId=key+".v"] 値を取得する画面フィールドのキー
     */
    Config.prototype.v = function (key, fieldId) { // #76
        var _keyConf = Config.prototype.__config.__keyConfig[this._pre + key] = {};
        _keyConf.value = key;           // getValueByKeyの返却値（デフォルト：keyと同じ文字列）
        _keyConf.getConfig = function () {
            _keyConf.getConfig = (function (_prefix, key, fieldId) {
                return window.HJN.Config(_prefix).getValueByKey(fieldId || key + ".v");
            }).bind(null, this._prefix, key, fieldId); // #96
        };
        return key;
    };


    /**
     * HTMLの入力フィールドに、指定値を設定し、Configに反映する
     * 
     * @memberof Util.Config
     * @param {String}
     *            key Conginのキー値
     */
    Config.prototype.setText = function(key, val) { // #76
        var id = this._pre + key;
        document.getElementById(id).value = val;
        document.getElementById(id).onchange();
    }    
    /**
     * HTMLのselectorを、指定値を選択し、Configに反映する
     * 
     * @memberof Util.Config
     * @param {String}
     *            key Conginのキー値
     */
    Config.prototype.setSelector = function(key) { // #76
        var id = this._pre + key;
        document.getElementById(id).checked = true;
        document.getElementById(id).onchange();
    }    
    
    /* new */
    return Config;
}());

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Encoding; });
/**
 * @memberOf Util
 * @class Encoding
 * @classdesc 文字コード変換 引用 {@link https://github.com/wealandwoe/ecl_array.js}
 */
var Encoding = {};
(function() {
//
// Escape Codec Library: ecl.js (Ver.041208)
//
// Copyright (C) http://nurucom-archives.hp.infoseek.co.jp/digital/
//

var GetEscapeCodeType=function(str){
    if(/%u[0-9A-F]{4}/i.test(str))return "Unicode";
    if(/%([0-9A-DF][0-9A-F]%[8A]0%|E0%80|[0-7][0-9A-F]|C[01])%[8A]0|%00|%[7F]F/i.test(str))return "UTF16LE";
    if(/%E[0-9A-F]%[8A]0%[8A]0|%[CD][0-9A-F]%[8A]0/i.test(str))return "UTF8";
    if(/%F[DE]/i.test(str))return /%8[0-9A-D]|%9[0-9A-F]|%A0/i.test(str)?"UTF16LE":"EUCJP";
    if(/%1B/i.test(str))return /%[A-D][0-9A-F]/i.test(str)?"JIS8":"JIS7";
    var S=str.substring(0,6143).replace(/%[0-9A-F]{2}|[^ ]| /ig,function(s){
        return s.length<3?"40":s.substring(1)
    }),c,C,i=0,T;
    while(0<=(c=parseInt(S.substring(i,i+=2),16))&&i<4092)if(128<=c){
        if((C=parseInt(S.substring(i,i+2),16))<128)i+=2;
        else if(194<=c&&c<240&&C<192){
            if(c<224){T="UTF8";i+=2;continue}
            if(2==parseInt(S.charAt(i+2),16)>>2){T="UTF8";i+=4;continue}
        }
        if(142==c&&161<=C&&C<224){if(!T)T="EUCJP";if("EUCJP"==T)continue}
        if(c<161)return "SJIS";
        if(c<224&&!T)
            if((164==c&&C<244||165==c&&C<247)&&161<=C)i+=2;
            else T=224<=C?"EUCJP":"SJIS";
        else T="EUCJP"
    }
    return T?T:"EUCJP"
};
var JISX0208=Function(
'var a="zKV33~jZ4zN=~ji36XazM93y!{~k2y!o~k0ZlW6zN?3Wz3W?{EKzK[33[`y|;-~j^YOTz$!~kNy|L1$353~jV3zKk3~k-4P4zK_2+~jY4y!xYHR~jlz$_~jk4z$e3X5He<0y!wy|X3[:~l|VU[F3VZ056Hy!nz/m1XD61+1XY1E1=1y|bzKiz!H034zKj~mEz#c5ZA3-3X$1~mBz$$3~lyz#,4YN5~mEz#{ZKZ3V%7Y}!J3X-YEX_J(3~mAz =V;kE0/y|F3y!}~m>z/U~mI~j_2+~mA~jp2;~m@~k32;~m>V}2u~mEX#2x~mBy+x2242(~mBy,;2242(~may->2&XkG2;~mIy-_2&NXd2;~mGz,{4<6:.:B*B:XC4>6:.>B*BBXSA+A:X]E&E<~r#z+625z s2+zN=`HXI@YMXIAXZYUM8X4K/:Q!Z&33 3YWX[~mB`{zKt4z (zV/z 3zRw2%Wd39]S11z$PAXH5Xb;ZQWU1ZgWP%3~o@{Dgl#gd}T){Uo{y5_d{e@}C(} WU9|cB{w}bzvV|)[} H|zT}d||0~{]Q|(l{|x{iv{dw}(5}[Z|kuZ }cq{{y|ij}.I{idbof%cu^d}Rj^y|-M{ESYGYfYsZslS`?ZdYO__gLYRZ&fvb4oKfhSf^d<Yeasc1f&a=hnYG{QY{D`Bsa|u,}Dl|_Q{C%xK|Aq}C>|c#ryW=}eY{L+`)][YF_Ub^h4}[X|?r|u_ex}TL@YR]j{SrXgo*|Gv|rK}B#mu{R1}hs|dP{C7|^Qt3|@P{YVV |8&}#D}ef{e/{Rl|>Hni}R1{Z#{D[}CQlQ||E}[s{SG_+i8eplY[=[|ec[$YXn#`hcm}YR|{Ci(_[ql|?8p3]-}^t{wy}4la&pc|3e{Rp{LqiJ],] `kc(]@chYnrM`O^,ZLYhZB]ywyfGY~aex!_Qww{a!|)*lHrM{N+n&YYj~Z b c#e_[hZSon|rOt`}hBXa^i{lh|<0||r{KJ{kni)|x,|0auY{D!^Sce{w;|@S|cA}Xn{C1h${E]Z-XgZ*XPbp]^_qbH^e[`YM|a||+=]!Lc}]vdBc=j-YSZD]YmyYLYKZ9Z>Xcczc2{Yh}9Fc#Z.l{}(D{G{{mRhC|L3b#|xK[Bepj#ut`H[,{E9Yr}1b{[e]{ZFk7[ZYbZ0XL]}Ye[(`d}c!|*y`Dg=b;gR]Hm=hJho}R-[n}9;{N![7k_{UbmN]rf#pTe[x8}!Qcs_rs[m`|>N}^V})7{^r|/E}),}HH{OYe2{Skx)e<_.cj.cjoMhc^d}0uYZd!^J_@g,[[[?{i@][|3S}Yl3|!1|eZ|5IYw|1D}e7|Cv{OHbnx-`wvb[6[4} =g+k:{C:}ed{S]|2M]-}WZ|/q{LF|dYu^}Gs^c{Z=}h>|/i|{W]:|ip{N:|zt|S<{DH[p_tvD{N<[8Axo{X4a.^o^X>Yfa59`#ZBYgY~_t^9`jZHZn`>G[oajZ;X,i)Z.^~YJe ZiZF^{][[#Zt^|]Fjx]&_5dddW]P0C[-]}]d|y {C_jUql] |OpaA[Z{lp|rz}:Mu#]_Yf6{Ep?f5`$[6^D][^u[$[6^.Z8]]ePc2U/=]K^_+^M{q*|9tYuZ,s(dS{i=|bNbB{uG}0jZOa:[-]dYtu3]:]<{DJ_SZIqr_`l=Yt`gkTnXb3d@kiq0a`Z{|!B|}e}Ww{Sp,^Z|0>_Z}36|]A|-t}lt{R6pi|v8hPu#{C>YOZHYmg/Z4nicK[}hF_Bg|YRZ7c|crkzYZY}_iXcZ.|)U|L5{R~qi^Uga@Y[xb}&qdbd6h5|Btw[}c<{Ds53[Y7]?Z<|e0{L[ZK]mXKZ#Z2^tavf0`PE[OSOaP`4gi`qjdYMgys/?[nc,}EEb,eL]g[n{E_b/vcvgb.{kcwi`~v%|0:|iK{Jh_vf5lb}KL|(oi=LrzhhY_^@`zgf[~g)[J_0fk_V{T)}I_{D&_/d9W/|MU[)f$xW}?$xr4<{Lb{y4}&u{XJ|cm{Iu{jQ}CMkD{CX|7A}G~{kt)nB|d5|<-}WJ}@||d@|Iy}Ts|iL|/^|no|0;}L6{Pm]7}$zf:|r2}?C_k{R(}-w|`G{Gy[g]bVje=_0|PT{^Y^yjtT[[[l!Ye_`ZN]@[n_)j3nEgMa]YtYpZy].d-Y_cjb~Y~[nc~sCi3|zg}B0}do{O^{|$`_|D{}U&|0+{J3|8*]iayx{a{xJ_9|,c{Ee]QXlYb]$[%YMc*]w[aafe]aVYi[fZEii[xq2YQZHg]Y~h#|Y:thre^@^|_F^CbTbG_1^qf7{L-`VFx Zr|@EZ;gkZ@slgko`[e}T:{Cu^pddZ_`yav^Ea+[#ZBbSbO`elQfLui}.F|txYcbQ`XehcGe~fc^RlV{D_0ZAej[l&jShxG[ipB_=u:eU}3e8[=j|{D(}dO{Do[BYUZ0/]AYE]ALYhZcYlYP/^-^{Yt_1_-;YT`P4BZG=IOZ&]H[e]YYd[9^F[1YdZxZ?Z{Z<]Ba2[5Yb[0Z4l?]d_;_)a?YGEYiYv`_XmZs4ZjY^Zb]6gqGaX^9Y}dXZr[g|]Y}K aFZp^k^F]M`^{O1Ys]ZCgCv4|E>}8eb7}l`{L5[Z_faQ|c2}Fj}hw^#|Ng|B||w2|Sh{v+[G}aB|MY}A{|8o}X~{E8paZ:]i^Njq]new)`-Z>haounWhN}c#{DfZ|fK]KqGZ=:u|fqoqcv}2ssm}.r{]{nIfV{JW)[K|,Z{Uxc|]l_KdCb%]cfobya3`p}G^|LZiSC]U|(X|kBlVg[kNo({O:g:|-N|qT}9?{MBiL}Sq{`P|3a|u.{Uaq:{_o|^S}jX{Fob0`;|#y_@[V[K|cw[<_ }KU|0F}d3|et{Q7{LuZttsmf^kYZ`Af`}$x}U`|Ww}d]| >}K,r&|XI|*e{C/a-bmr1fId4[;b>tQ_:]hk{b-pMge]gfpo.|(w[jgV{EC1Z,YhaY^q,_G[c_g[J0YX]`[h^hYK^_Yib,` {i6vf@YM^hdOKZZn(jgZ>bzSDc^Z%[[o9[2=/YHZ(_/Gu_`*|8z{DUZxYt^vuvZjhi^lc&gUd4|<UiA`z]$b/Z?l}YI^jaHxe|;F}l${sQ}5g}hA|e4}?o{ih}Uz{C)jPe4]H^J[Eg[|AMZMlc}:,{iz}#*|gc{Iq|/:|zK{l&}#u|myd{{M&v~nV};L|(g|I]ogddb0xsd7^V})$uQ{HzazsgxtsO^l}F>ZB]r|{7{j@cU^{{CbiYoHlng]f+nQ[bkTn/}<-d9q {KXadZYo+n|l[|lc}V2{[a{S4Zam~Za^`{HH{xx_SvF|ak=c^[v^7_rYT`ld@]:_ub%[$[m](Shu}G2{E.ZU_L_R{tz`vj(f?^}hswz}GdZ}{S:h`aD|?W|`dgG|if{a8|J1{N,}-Ao3{H#{mfsP|[ bzn+}_Q{MT{u4kHcj_q`eZj[8o0jy{p7}C|[}l){MuYY{|Ff!Ykn3{rT|m,^R|,R}$~Ykgx{P!]>iXh6[l[/}Jgcg{JYZ.^qYfYIZl[gZ#Xj[Pc7YyZD^+Yt;4;`e8YyZVbQ7YzZxXja.7SYl[s]2^/Ha$[6ZGYrb%XiYdf2]H]kZkZ*ZQ[ZYS^HZXcCc%Z|[(bVZ]]:OJQ_DZCg<[,]%Zaa [g{C00HY[c%[ChyZ,Z_`PbXa+eh`^&jPi0a[ggvhlekL]w{Yp^v}[e{~;k%a&k^|nR_z_Qng}[E}*Wq:{k^{FJZpXRhmh3^p>de^=_7`|ZbaAZtdhZ?n4ZL]u`9ZNc3g%[6b=e.ZVfC[ZZ^^^hD{E(9c(kyZ=bb|Sq{k`|vmr>izlH[u|e`}49}Y%}FT{[z{Rk}Bz{TCc/lMiAqkf(m$hDc;qooi[}^o:c^|Qm}a_{mrZ(pA`,}<2sY| adf_%|}`}Y5U;}/4|D>|$X{jw{C<|F.hK|*A{MRZ8Zsm?imZm_?brYWZrYx`yVZc3a@f?aK^ojEd {bN}/3ZH]/$YZhm^&j 9|(S|b]mF}UI{q&aM]LcrZ5^.|[j`T_V_Gak}9J[ ZCZD|^h{N9{~&[6Zd{}B}2O|cv]K}3s}Uy|l,fihW{EG`j_QOp~Z$F^zexS`dcISfhZBXP|.vn|_HYQ|)9|cr]<`&Z6]m_(ZhPcSg>`Z]5`~1`0Xcb4k1{O!bz|CN_T{LR|a/gFcD|j<{Z._[f)mPc:1`WtIaT1cgYkZOaVZOYFrEe[}T$}Ch}mk{K-^@]fH{Hdi`c*Z&|Kt{if[C{Q;{xYB`dYIX:ZB[}]*[{{p9|4GYRh2ao{DS|V+[zd$`F[ZXKadb*A] Ys]Maif~a/Z2bmclb8{Jro_rz|x9cHojbZ{GzZx_)]:{wAayeDlx}<=`g{H1{l#}9i|)=|lP{Qq}.({La|!Y{i2EZfp=c*}Cc{EDvVB|;g}2t{W4av^Bn=]ri,|y?|3+}T*ckZ*{Ffr5e%|sB{lx^0]eZb]9[SgAjS_D|uHZx]dive[c.YPkcq/}db{EQh&hQ|eg}G!ljil|BO]X{Qr_GkGl~YiYWu=c3eb}29v3|D|}4i||.{Mv})V{SP1{FX}CZW6{cm|vO{pS|e#}A~|1i}81|Mw}es|5[}3w{C`h9aL]o{}p[G`>i%a1Z@`Ln2bD[$_h`}ZOjhdTrH{[j_:k~kv[Sdu]CtL}41{I |[[{]Zp$]XjxjHt_eThoa#h>sSt8|gK|TVi[Y{t=}Bs|b7Zpr%{gt|Yo{CS[/{iteva|cf^hgn}($_c^wmb^Wm+|55jrbF|{9^ q6{C&c+ZKdJkq_xOYqZYSYXYl`8]-cxZAq/b%b*_Vsa[/Ybjac/OaGZ4fza|a)gY{P?| I|Y |,pi1n7}9bm9ad|=d{aV|2@[(}B`d&|Uz}B}{`q|/H|!JkM{FU|CB|.{}Az}#P|lk}K{|2rk7{^8^?`/|k>|Ka{Sq}Gz}io{DxZh[yK_#}9<{TRdgc]`~Z>JYmYJ]|`!ZKZ]gUcx|^E[rZCd`f9oQ[NcD_$ZlZ;Zr}mX|=!|$6ZPZYtIo%fj}CpcN|B,{VDw~gb}@hZg`Q{LcmA[(bo`<|@$|o1|Ss}9Z_}tC|G`{F/|9nd}i=}V-{L8aaeST]daRbujh^xlpq8|}zs4bj[S`J|]?G{P#{rD{]I`OlH{Hm]VYuSYUbRc*6[j`8]pZ[bt_/^Jc*[<Z?YE|Xb|?_Z^Vcas]h{t9|Uwd)_(=0^6Zb{Nc} E[qZAeX[a]P^|_J>e8`W^j_Y}R{{Jp__]Ee#e:iWb9q_wKbujrbR}CY`,{mJ}gz{Q^{t~N|? gSga`V_||:#mi}3t|/I`X{N*|ct|2g{km}gi|{={jC}F;|E}{ZZjYf*frmu}8Tdroi{T[|+~}HG{cJ}DM{Lp{Ctd&}$hi3|FZ| m}Kr|38}^c|m_|Tr{Qv|36}?Up>|;S{DV{k_as}BK{P}}9p|t`jR{sAm4{D=b4pWa[}Xi{EjwEkI}3S|E?u=X0{jf} S|NM|JC{qo^3cm]-|JUx/{Cj{s>{Crt[UXuv|D~|j|d{YXZR}Aq}0r}(_{pJfi_z}0b|-vi)Z mFe,{f4|q`b{}^Z{HM{rbeHZ|^x_o|XM|L%|uFXm}@C_{{Hhp%a7|0p[Xp+^K}9U{bP}: tT}B|}+$|b2|[^|~h{FAby[`{}xgygrt~h1[li`c4vz|,7p~b(|mviN}^pg[{N/|g3|^0c,gE|f%|7N{q[|tc|TKA{LU}I@|AZp(}G-sz{F |qZ{}F|f-}RGn6{Z]_5})B}UJ{FFb2]4ZI@v=k,]t_Dg5Bj]Z-]L]vrpdvdGlk|gF}G]|IW}Y0[G| /bo|Te^,_B}#n^^{QHYI[?hxg{[`]D^IYRYTb&kJ[cri[g_9]Ud~^_]<p@_e_XdNm-^/|5)|h_{J;{kacVopf!q;asqd}n)|.m|bf{QW|U)}b+{tL|w``N|to{t ZO|T]jF}CB|0Q{e5Zw|k |We}5:{HO{tPwf_uajjBfX}-V_C_{{r~gg|Ude;s+}KNXH}! `K}eW{Upwbk%ogaW}9EYN}YY|&v|SL{C3[5s.]Y]I]u{M6{pYZ`^,`ZbCYR[1mNg>rsk0Ym[jrE]RYiZTr*YJ{Ge|%-lf|y(`=[t}E6{k!|3)}Zk} ][G{E~cF{u3U.rJ|a9p#o#ZE|?|{sYc#vv{E=|LC}cu{N8`/`3`9rt[4|He{cq|iSYxY`}V |(Q|t4{C?]k_Vlvk)BZ^r<{CL}#h}R+[<|i=}X|{KAo]|W<`K{NW|Zx}#;|fe{IMr<|K~tJ_x}AyLZ?{GvbLnRgN}X&{H7|x~}Jm{]-| GpNu0}.ok>|c4{PYisrDZ|fwh9|hfo@{H~XSbO]Odv]%`N]b1Y]]|eIZ}_-ZA]aj,>eFn+j[aQ_+]h[J_m_g]%_wf.`%k1e#Z?{CvYu_B^|gk`Xfh^M3`afGZ-Z|[m{L}|k3cp[it ^>YUi~d>{T*}YJ{Q5{Jxa$hg|%4`}|LAgvb }G}{P=|<;Ux{_skR{cV|-*|s-{Mp|XP|$G|_J}c6cM{_=_D|*9^$ec{V;|4S{qO|w_|.7}d0|/D}e}|0G{Dq]Kdp{}dfDi>}B%{Gd|nl}lf{C-{y}|ANZr}#={T~|-(}c&{pI|ft{lsVP}){|@u}!W|bcmB{d?|iW|:dxj{PSkO|Hl]Li:}VYk@|2={fnWt{M3`cZ6|)}|Xj}BYa?vo{e4|L7|B7{L7|1W|lvYO}W8nJ|$Vih|{T{d*_1|:-n2dblk``fT{Ky|-%}m!|Xy|-a{Pz}[l{kFjz|iH}9N{WE{x,|jz}R {P|{D)c=nX|Kq|si}Ge{sh|[X{RF{t`|jsr*fYf,rK|/9}$}}Nf{y!1|<Std}4Wez{W${Fd_/^O[ooqaw_z[L`Nbv[;l7V[ii3_PeM}.h^viqYjZ*j1}+3{bt{DR[;UG}3Og,rS{JO{qw{d<_zbAh<R[1_r`iZTbv^^a}c{iEgQZ<exZFg.^Rb+`Uj{a+{z<[~r!]`[[|rZYR|?F|qppp]L|-d|}K}YZUM|=Y|ktm*}F]{D;g{uI|7kg^}%?Z%ca{N[_<q4xC]i|PqZC]n}.bDrnh0Wq{tr|OMn6tM|!6|T`{O`|>!]ji+]_bTeU}Tq|ds}n|{Gm{z,f)}&s{DPYJ`%{CGd5v4tvb*hUh~bf]z`jajiFqAii]bfy^U{Or|m+{I)cS|.9k:e3`^|xN}@Dnlis`B|Qo{`W|>||kA}Y}{ERYuYx`%[exd`]|OyiHtb}HofUYbFo![5|+]gD{NIZR|Go}.T{rh^4]S|C9_}xO^i`vfQ}C)bK{TL}cQ|79iu}9a];sj{P.o!f[Y]pM``Jda^Wc9ZarteBZClxtM{LW}l9|a.mU}KX}4@{I+f1}37|8u}9c|v${xGlz}jP{Dd1}e:}31}%3X$|22i<v+r@~mf{sN{C67G97855F4YL5}8f{DT|xy{sO{DXB334@55J1)4.G9A#JDYtXTYM4, YQD9;XbXm9SX]IB^4UN=Xn<5(;(F3YW@XkH-X_VM[DYM:5XP!T&Y`6|,^{IS-*D.H>:LXjYQ0I3XhAF:9:(==.F*3F1189K/7163D,:@|e2{LS36D4hq{Lw/84443@4.933:0307::6D7}&l{Mx657;89;,K5678H&93D(H<&<>0B90X^I;}Ag1{P%3A+>><975}[S{PZE453?4|T2{Q+5187;>447:81{C=hL6{Me^:=7ii{R=.=F<81;48?|h8}Uh{SE|,VxL{ST,7?9Y_5Xk3A#:$%YSYdXeKXOD8+TXh7(@>(YdXYHXl9J6X_5IXaL0N?3YK7Xh!1?XgYz9YEXhXaYPXhC3X`-YLY_XfVf[EGXZ5L8BXL9YHX]SYTXjLXdJ: YcXbQXg1PX]Yx4|Jr{Ys4.8YU+XIY`0N,<H%-H;:0@,74/:8546I=9177154870UC]d<C3HXl7ALYzXFXWP<<?E!88E5@03YYXJ?YJ@6YxX-YdXhYG|9o{`iXjY_>YVXe>AYFX[/(I@0841?):-B=14337:8=|14{c&93788|di{cW-0>0<097/A;N{FqYpugAFT%X/Yo3Yn,#=XlCYHYNX[Xk3YN:YRT4?)-YH%A5XlYF3C1=NWyY}>:74-C673<69545v {iT85YED=64=.F4..9878/D4378?48B3:7:7/1VX[f4{D,{l<5E75{dAbRB-8-@+;DBF/$ZfW8S<4YhXA.(5@*11YV8./S95C/0R-A4AXQYI7?68167B95HA1*<M3?1/@;/=54XbYP36}lc{qzSS38:19?,/39193574/66878Yw1X-87E6=;964X`T734:>86>1/=0;(I-1::7ALYGXhF+Xk[@W%TYbX7)KXdYEXi,H-XhYMRXfYK?XgXj.9HX_SX]YL1XmYJ>Y}WwIXiI-3-GXcYyXUYJ$X`Vs[7;XnYEZ;XF! 3;%8;PXX(N3Y[)Xi1YE&/ :;74YQ6X`33C;-(>Xm0(TYF/!YGXg8 9L5P01YPXO-5%C|qd{{/K/E6,=0144:361:955;6443@?B7*7:F89&F35YaX-CYf,XiFYRXE_e{}sF 0*7XRYPYfXa5YXXY8Xf8Y~XmA[9VjYj*#YMXIYOXk,HHX40YxYMXU8OXe;YFXLYuPXP?EB[QV0CXfY{:9XV[FWE0D6X^YVP*$4%OXiYQ(|xp|%c3{}V`1>Y`XH00:8/M6XhQ1:;3414|TE|&o@1*=81G8<3}6<|(f6>>>5-5:8;093B^3U*+*^*UT30XgYU&7*O1953)5@E78--F7YF*B&0:%P68W9Zn5974J9::3}Vk|-,C)=)1AJ4+<3YGXfY[XQXmT1M-XcYTYZXCYZXEYXXMYN,17>XIG*SaS|/eYJXbI?XdNZ+WRYP<F:R PXf;0Xg`$|1GX9YdXjLYxWX!ZIXGYaXNYm6X9YMX?9EXmZ&XZ#XQ>YeXRXfAY[4 ;0X!Zz0XdN$XhYL XIY^XGNXUYS/1YFXhYk.TXn4DXjB{jg|4DEX]:XcZMW=A.+QYL<LKXc[vV$+&PX*Z3XMYIXUQ:ZvW< YSXFZ,XBYeXMM)?Xa XiZ4/EXcP3%}&-|6~:1(-+YT$@XIYRBC<}&,|7aJ6}bp|8)K1|Xg|8C}[T|8Q.89;-964I38361<=/;883651467<7:>?1:.}le|:Z=39;1Y^)?:J=?XfLXbXi=Q0YVYOXaXiLXmJXO5?.SFXiCYW}-;|=u&D-X`N0X^,YzYRXO(QX_YW9`I|>hZ:N&X)DQXP@YH#XmNXi$YWX^=!G6YbYdX>XjY|XlX^XdYkX>YnXUXPYF)FXT[EVTMYmYJXmYSXmNXi#GXmT3X8HOX[ZiXN]IU2>8YdX1YbX<YfWuZ8XSXcZU%0;1XnXkZ_WTG,XZYX5YSX Yp 05G?XcYW(IXg6K/XlYP4XnI @XnO1W4Zp-9C@%QDYX+OYeX9>--YSXkD.YR%Q/Yo YUX].Xi<HYEZ2WdCE6YMXa7F)=,D>-@9/8@5=?7164;35387?N<618=6>7D+C50<6B03J0{Hj|N9$D,9I-,.KB3}m |NzE0::/81YqXjMXl7YG; [.W=Z0X4XQY]:MXiR,XgM?9$9>:?E;YE77VS[Y564760391?14941:0=:8B:;/1DXjFA-564=0B3XlH1+D85:0Q!B#:-6&N/:9<-R3/7Xn<*3J4.H:+334B.=>30H.;3833/76464665755:/83H6633:=;.>5645}&E|Y)?1/YG-,93&N3AE@5 <L1-G/8A0D858/30>8<549=@B8] V0[uVQYlXeD(P#ID&7T&7;Xi0;7T-$YE)E=1:E1GR):--0YI7=E<}n9|aT6783A>D7&4YG7=391W;Zx<5+>F#J39}o/|cc;6=A050EQXg8A1-}D-|d^5548083563695D?-.YOXd37I$@LYLWeYlX<Yd+YR A$;3-4YQ-9XmA0!9/XLY_YT(=5XdDI>YJ5XP1ZAW{9>X_6R(XhYO65&J%DA)C-!B:97#A9;@?F;&;(9=11/=657/H,<8}bz|j^5446>.L+&Y^8Xb6?(CYOXb*YF(8X`FYR(XPYVXmPQ%&DD(XmZXW??YOXZXfCYJ79,O)XnYF7K0!QXmXi4IYFRXS,6<%-:YO(+:-3Q!1E1:W,Zo}Am|n~;3580534*?3Zc4=9334361693:30C<6/717:<1/;>59&:4}6!|rS36=1?75<8}[B|s809983579I.A.>84758=108564741H*9E{L{|u%YQ<%6XfH.YUXe4YL@,>N}Tv|ve*G0X)Z;/)3@A74(4P&A1X:YVH97;,754*A66:1 D739E3553545558E4?-?K17/770843XAYf838A7K%N!YW4.$T19Z`WJ*0XdYJXTYOXNZ 1XaN1A+I&Xi.Xk3Z3GB&5%WhZ1+5#Y[X<4YMXhQYoQXVXbYQ8XSYUX4YXBXWDMG0WxZA[8V+Z8X;D],Va$%YeX?FXfX[XeYf<X:Z[WsYz8X_Y]%XmQ(!7BXIZFX]&YE3F$(1XgYgYE& +[+W!<YMYFXc;+PXCYI9YrWxGXY9DY[!GXiI7::)OC;*$.>N*HA@{C|}&k=:<TB83X`3YL+G4XiK]i}(fYK<=5$.FYE%4*5*H*6XkCYL=*6Xi6!Yi1KXR4YHXbC8Xj,B9ZbWx/XbYON#5B}Ue}+QKXnF1&YV5XmYQ0!*3IXBYb71?1B75XmF;0B976;H/RXU:YZX;BG-NXj;XjI>A#D3B636N;,*%<D:0;YRXY973H5)-4FXOYf0:0;/7759774;7;:/855:543L43<?6=E,.A4:C=L)%4YV!1(YE/4YF+ F3%;S;&JC:%/?YEXJ4GXf/YS-EXEYW,9;E}X$}547EXiK=51-?71C%?57;5>463553Zg90;6447?<>4:9.7538XgN{|!}9K/E&3-:D+YE1)YE/3;37/:05}n<}:UX8Yj4Yt864@JYK..G=.(A Q3%6K>3(P3#AYE$-6H/456*C=.XHY[#S.<780191;057C)=6HXj?955B:K1 E>-B/9,;5.!L?:0>/.@//:;7833YZ56<4:YE=/:7Z_WGC%3I6>XkC*&NA16X=Yz2$X:Y^&J48<99k8}CyB-61<18K946YO4{|N}E)YIB9K0L>4=46<1K0+R;6-=1883:478;4,S+3YJX`GJXh.Yp+Xm6MXcYpX(>7Yo,/:X=Z;Xi0YTYHXjYmXiXj;*;I-8S6N#XgY}.3XfYGO3C/$XjL$*NYX,1 6;YH&<XkK9C#I74.>}Hd`A748X[T450[n75<4439:18A107>|ET}Rf<1;14876/Yb983E<5.YNXd4149>,S=/4E/<306443G/06}0&}UkYSXFYF=44=-5095=88;63844,9E6644{PL}WA8:>)7+>763>>0/B3A545CCnT}Xm|dv}Xq1L/YNXk/H8;;.R63351YY747@15YE4J8;46;.38.>4A369.=-83,;Ye3?:3@YE.4-+N353;/;@(X[YYD>@/05-I*@.:551741Yf5>6A443<3535;.58/86=D4753442$635D1>0359NQ @73:3:>><Xn?;43C14 ?Y|X611YG1&<+,4<*,YLXl<1/AIXjF*N89A4Z576K1XbJ5YF.ZOWN.YGXO/YQ01:4G38Xl1;KI0YFXB=R<7;D/,/4>;$I,YGXm94@O35Yz66695385.>:6A#5}W7n^4336:4157597434433<3|XA}m`>=D>:4A.337370?-6Q96{`E|4A}C`|Qs{Mk|J+~r>|o,wHv>Vw}!c{H!|Gb|*Ca5}J||,U{t+{CN[!M65YXOY_*B,Y[Z9XaX[QYJYLXPYuZ%XcZ8LY[SYPYKZM<LMYG9OYqSQYM~[e{UJXmQYyZM_)>YjN1~[f3{aXFY|Yk:48YdH^NZ0|T){jVFYTZNFY^YTYN~[h{nPYMYn3I]`EYUYsYIZEYJ7Yw)YnXPQYH+Z.ZAZY]^Z1Y`YSZFZyGYHXLYG 8Yd#4~[i|+)YH9D?Y^F~Y7|-eYxZ^WHYdYfZQ~[j|3>~[k|3oYmYqY^XYYO=Z*4[]Z/OYLXhZ1YLZIXgYIHYEYK,<Y`YEXIGZI[3YOYcB4SZ!YHZ*&Y{Xi3~[l|JSY`Zz?Z,~[m|O=Yi>??XnYWXmYS617YVYIHZ(Z4[~L4/=~[n|Yu{P)|];YOHHZ}~[o33|a>~[r|aE]DH~[s|e$Zz~[t|kZFY~XhYXZB[`Y}~[u|{SZ&OYkYQYuZ2Zf8D~[v}% ~[w3},Q[X]+YGYeYPIS~[y}4aZ!YN^!6PZ*~[z}?E~[{3}CnZ=~[}}EdDZz/9A3(3S<,YR8.D=*XgYPYcXN3Z5 4)~[~}JW=$Yu.XX~] }KDX`PXdZ4XfYpTJLY[F5]X~[2Yp}U+DZJ::<446[m@~]#3}]1~]%}^LZwZQ5Z`/OT<Yh^ -~]&}jx[ ~m<z!%2+~ly4VY-~o>}p62yz!%2+Xf2+~ly4VY-zQ`z (=] 2z~o2",C={" ":0,"!":1},c=34,i=2,p,s="",u=String.fromCharCode,t=u(12539),m=[];while(++c<127)C[u(c)]=c^39&&c^92?i++:0;i=0;while(0<=(c=C[a.charAt(i++)]))if(16==c)if((c=C[a.charAt(i++)])<87){if(86==c)c=1879;while(c--){/*s+=u(*/++p/*)*/;m.push(p)}}else{/*s+=s.substr(8272,360);*/m=m.concat(m.slice(8272,8632))}else if(c<86){/*s+=u(*/p+=c<51?c-16:(c-55)*92+C[a.charAt(i++)]/*)*/;m.push(p)}else if((c=((c-86)*92+C[a.charAt(i++)])*92+C[a.charAt(i++)])<49152){/*s+=u(*/p=c<40960?c:c|57344/*)*/;m.push(p)}else{c&=511;while(c--){/*s+=t*/;m.push(12539)}p=12539}return {"array":m}')();

// var JCT8836=(JCT11280=JISX0208.s).substring(0,8836);

/**
 * U2CP,CP2U Unicode番号とJIS番号の対応テーブル
 * Unicode番号はスカラ値、JIS番号は区点位置(1面、1～119区、1～94点)を1+7+7bitの15bit整数にしたものを用いる。
 * 
 * JCT11280はWindows-31Jのテーブルで、重複登録された漢字がある。 重複登録された漢字の区点位置を求める場合はWindows
 * APIの仕様に従い (1)JIS X 0208-1990の登録文字である場合は、これに統一
 * (2)「NEC特殊文字」「IBM拡張文字」が重複する場合は、「NEC特殊文字」に統一
 * (3)「NEC選定IBM拡張文字」「IBM拡張文字」が重複する場合は、「IBM拡張文字」に統一 のルールでコードポイントに変換する。
 * 言い換えると,1～88区までは先に現れたコードポイントを優先し、89～92区のNEC選定IBM拡張文字は利用せず
 * 代わりに115～119区に現れるIBM拡張文字のコードポイントを利用する
 * 
 * @see http://ja.wikipedia.org/wiki/Microsoft%E3%82%B3%E3%83%BC%E3%83%89%E3%83%9A%E3%83%BC%E3%82%B8932#Windows-31J_.E3.81.AB.E9.87.8D.E8.A4.87.E7.99.BB.E9.8C.B2.E3.81.95.E3.82.8C.E3.81.9F.E3.82.B3.E3.83.BC.E3.83.89
 */
var U2CP={},CP2U={},P1=1<<14;
(function(array) {
    var sc,cp,i,il=array.length;
    for(i=0;i<il;i++) {
        sc = array[i];
        if(sc===12539&&i>5){continue;}
        cp = P1|(i/94|0)<<7|i%94;
        CP2U[cp] = sc;
        if((i<8272||10715<i) && U2CP[sc]===undefined) {U2CP[sc] = cp;}
    }
})(JISX0208.array);

var charset={Unicode:{},SJIS:{},EUCJP:{},JIS7:{},JIS8:{},UTF7:{},UTF8:{},UTF16LE:{},UTF16BE:{},MUTF7:{}},
        enc={Text:{},Unicode:{},URI:{},Base64:{}};

/**
 * 文字列を16bit整数の配列に変換する
 */
enc.Text.parse = function(str){
    var a=[],i,il=str.length;
    for(i=0;i<il;i++) {
        a.push(str.charCodeAt(i));
    }
    return a;
};
/**
 * 16bit整数の配列を文字列に変換する
 */
enc.Text.stringify = function(array) {
    var s="",i,il=array.length,c;
    for(i=0;i<il;i++) {
        s+=String.fromCharCode(array[i]);
    }
    return s;
};
/**
 * 文字列を24bit(0..0x10FFFF)整数の配列に変換する
 */
charset.Unicode.parse = function(str){
    var a=[],i,il=str.length,c;
    for(i=0;i<il;i++) {
        // scalar UTF-16
        // 000uuuuuxxxxxxyyyyyyyyyy 110110wwwwxxxxxx 110111yyyyyyyyyy wwww =
        // uuuuu - 1
        55295<(c=str.charCodeAt(i))&&c<56320&&(c=((c&1023)+64<<10)+(str.charCodeAt(++i)&1023));
        a.push(c);
    }
    return a;
};
/**
 * 24bit整数の配列を文字列に変換する
 */
charset.Unicode.stringify = function(array){
    var s="",i,il=array.length,c;
    for(i=0;i<il;i++) {
        s+=(c=array[i])>65535?String.fromCharCode((c>>>10)-64|55296,(c&1023|56320)):String.fromCharCode(c);
    }
    return s;
};
charset.Unicode.fromU=charset.Unicode.toU=function(a){return a;}
// http://charset.7jp.net/sjis.html
// http://ja.wikipedia.org/wiki/Microsoft%E3%82%B3%E3%83%BC%E3%83%89%E3%83%9A%E3%83%BC%E3%82%B8932
/**
 * UTF-16の配列からSJISの8bit配列に変換する
 * 
 * @param {Array}
 *            array Unicodeの24it配列
 * @return {Array} SJISの8bit配列
 */
charset.SJIS.fromU = function(array) {
    var a=[],i,il=array.length,c,s,m;
    for(i=0;i<il;i++) {
        c=array[i];
        c<128 ? a.push(c) : 
            65376<c&&c<65440 ? a.push(c-65216) : 
/*
 * (c=JCT11280.indexOf((s=String.fromCharCode(c))))<0 ? a.push(129,69) :
 * a.push( (m=((c<8272?c:(c=JCT11280.lastIndexOf(s)))-(c%=188))/188)<31 ?
 * m+129 : m+193, //mは(区-1)/2 c+=c<63?64:65 )
 */
                (c=U2CP[c]||-1)<0||c>31499 ? a.push(129,69) : a.push(
                    (m=(c>>>7&127),c=(c&127)+(m&1)*94,m=m>>>1)<31 ? m+129 : m+193,
                    c+=c<63?64:65
                )

    }
    return a;
};
/**
 * SJISの8bit配列をUnicodeの配列に変換する
 * 
 * @param {Array}
 *            array SJISの8bit配列
 * @return {Array} Unicodeの24bit配列
 */
charset.SJIS.toU = function(array) {
    var a=[],i,il=array.length,c;
    for(i=0;i<il;i++) {
        c = array[i];
        (c<128||160<c&&c<224) 
            ? a.push(160<c?c+65216:c) // ASCII+ｶﾅ
// : a.push(
// JCT11280.charAt((c<160?c-129:c-193)*188+(c=array[++i],c<127?c-64:c-65)).charCodeAt(0)
// )
            : a.push( CP2U[P1|(c<160?c-129:c-193)<<8|(c=array[++i],c<127?c-64:c<159?c-65:c-31)] )
    }
    return a;
};
// http://www.unixuser.org/~euske/doc/kanjicode/
// JIS区点位置からSJISに変換
charset.SJIS.fromJ = function(array) {
    var a=[],i,il=array.length,c,m;
    for(i=0;i<il;i++) {
        c=array[i];
        c<224 ? a.push(c)
            : c>31499 ? a.push(129,69)
                : a.push(
                    (m=(c>>>7&127),c=(c&127)+(m&1)*94,m=m>>>1)<31 ? m+129 : m+193,
                    c+=c<63?64:65
                )
    }
    return a;
};
charset.SJIS.toJ = function(array) {
    var a=[],i,il=array.length,c,k;
    for(i=0;i<il;i++) {
        c = array[i];
        (c<128||160<c&&c<224) ? a.push(c) // ASCII+ｶﾅ
            : a.push( P1|(c<160?c-129:c-193)<<8|(c=array[++i],c<127?c-64:c<159?c-65:c-31) )
    }
    return a;
};
// http://ja.wikipedia.org/wiki/EUC-JP, http://charset.7jp.net/euc.html
charset.EUCJP.fromU = function(array) {
    var a=[],i,il=array.length,c;
    for(i=0;i<il;i++) {
        (c=array[i])<128 ? a.push(c) : 
            65376<c&&c<65440 ? a.push(142,c-65216) : 
/*
 * (c=JCT8836.indexOf(String.fromCharCode(c)))<0 ? a.push(161,166) : (
 * a.push((c-(c%=94))/94+161, c+161)
 */
                (c=U2CP[c]||-1)<0||c>31499 ? a.push(161,166) : (
                    a.push((c>>>7&127)+161, (c&127)+161)
                )
    }
    return a;
};
charset.EUCJP.toU = function(array) {
    var a=[],i,il=array.length,c;
    for(i=0;i<il;i++) {
        c = array[i];
        (c<161)
            ? a.push(c<128 ? c : array[++i]+65216) // ASCII+ｶﾅ
// : a.push(JCT8836.charAt((c-161)*94 + array[++i]-161).charCodeAt(0))
                : a.push(CP2U[P1|(c-161)<<7|array[++i]-161])
    }
    return a;
};
charset.EUCJP.fromJ = function(array) {
    var a=[],i,il=array.length,c;
    for(i=0;i<il;i++) {
        (c=array[i])<224 ? a.push(c<128?c:c+65216)
            : c>31499 ? a.push(161,166)
                : a.push((c>>>7&127)+161, (c&127)+161)
    }
    return a;
};
charset.EUCJP.toJ = function(array) {
    var a=[],i,il=array.length,c;
    for(i=0;i<il;i++) {
        c = array[i];
        (c<161) ? a.push(c<128 ? c : array[++i]) // ASCII+ｶﾅ
            : a.push( P1|(c-161)<<7|array[++i]-161 )
    }
    return a;
};
// http://charset.7jp.net/jis.html,
// http://yasu.asuka.net/translations/RFC1468.html
charset.JIS7.fromU = function(array) {
    var a=[],i,il=array.length,c,es=[0,1,2],e=es[0]; // "\e(B":ASCIIの開始,"\e(I":半角カタカナの開始,"\e$B":漢字の開始
    for(i=0;i<il;i++) {
        (c=array[i])<128 ? ((e!=es[0] && (e=es[0],a.push(27,40,66))),a.push(c))
            : 65376<c&&c<65440 ? ((e!=es[1] && (e=es[1],a.push(27,40,73))),a.push(c-65344))
                : (e!=es[2] && (e=es[2],a.push(27,36,66)),
// (c=JCT8836.indexOf(String.fromCharCode(c)))<0 ? a.push(33,38) :
// a.push((c-(c%=94))/94+33,c+33))
                        (c=U2CP[c]||-1)<0||c>31499 ? a.push(33,38) : a.push((c>>>7&127)+33,(c&127)+33))
    }
    e!==es[0] && a.push(27,40,66); // ASCIIで終わっている必要がある
    return a;
};
charset.JIS7.toU = function(array) {
// "\e(B":ASCIIの開始,"\e(I":半角カタカナの開始,"\e$B":漢字の開始, "\e(J":ローマ字セット(≒ASCII)開始,
// "\e$@":漢字の開始(旧)
// 0x1b2842(27,40,66), 0x1b2849(27,40,73), 0x1b2442(27,36,66),
// 0x1b284a(27,40,74), 0x1b2440(27,36,64)
// [27,40,66]or[27,40,74]ならASCII、[27,40,73]なら半角カナ、[27,36,66]or[27,36,64]なら漢字としてデコードする
    var a=[],i,il=array.length,c,es=[0,1,2],e=es[0];
    for(i=0;i<il;i++) {
        array[i]===27 && (array[++i]===36?(e=es[2],i+=2):(e=(array[++i]===73?es[1]:es[0]),i++));
        (i<il)&&(c=array[i]) && ( 
// e===es[2] ? a.push(JCT8836.charAt((c-33)*94+array[++i]-33).charCodeAt(0))
                e===es[2] ? a.push(CP2U[P1|c-33<<7|array[++i]-33])
                : e===es[1] ? a.push(c+65344)
                    : a.push(c<128 ? c : c+65216)
        );
    }
    return a;
};
charset.JIS7.fromJ = function(array) {
    var a=[],i,il=array.length,c,es=[0,1,2],e=es[0];
    for(i=0;i<il;i++) {
        (c=array[i])<128 ? ((e!=es[0] && (e=es[0],a.push(27,40,66))),a.push(c))
            : 160<c&&c<224 ? ((e!=es[1] && (e=es[1],a.push(27,40,73))),a.push(c))
                : (e!=es[2] && (e=es[2],a.push(27,36,66)),
                    c<P1||c>31499 ? a.push(33,38) : a.push((c>>>7&127)+33,(array[++i]&127)+33))
    }
    e!==es[0] && a.push(27,40,66); // ASCIIで終わっている必要がある
    return a;
};
charset.JIS7.toJ = function(array) {
    var a=[],i,il=array.length,c,es=[0,1,2],e=es[0];
    for(i=0;i<il;i++) {
        array[i]===27 && (array[++i]===36?(e=es[2],i+=2):(e=(array[++i]===73?es[1]:es[0]),i++));
        (i<il)&&(c=array[i]) && ( 
            e===es[2] ? a.push(P1|c-33<<7|array[++i]-33)
                : e===es[1] ? a.push(c+128) : a.push(c)
        );
    }
    return a;
};
charset.JIS = charset.JIS7;
// JIS7と違い半角カナは ASCIIシーケンス[\e(B]のA1-DFに入る
charset.JIS8.fromU = function(array) {
    var a=[],i,il=array.length,c,es=[0,1,2],e=es[0];
    for(i=0;i<il;i++) {
        (c=array[i])<128||65376<c&&c<65440 ? ((e!=es[0] && (e=es[0],a.push(27,40,66))),a.push(c<128?c:c-65216))
            : (e!==es[2] && (e=es[2],a.push(27,36,66)),
// (c=JCT8836.indexOf(String.fromCharCode(c)))<0 ? a.push(33,38) :
// a.push((c-(c%=94))/94+33,c+33))
                    (c=U2CP[c]||-1)<0||c>31499 ? a.push(33,38) : a.push((c>>>7&127)+33,(c&127)+33))
    }
    e!==es[0] && a.push(27,40,66);
    return a;
};
// 半角カナシーケンスも念のため考慮する
charset.JIS8.toU = function(array) {
    var a=[],i,il=array.length,c,es=[0,1,2],e=es[0];
    for(i=0;i<il;i++) {
        array[i]===27&&(array[++i]===36?(e=es[2],i+=2):(e=(array[++i]===73?es[1]:es[0]),i++));
        (i<il)&&(c=array[i]) && (
// e===es[2] ? a.push(JCT8836.charAt((c-33)*94+array[++i]-33).charCodeAt(0))
                e===es[2] ? a.push(CP2U[P1|c-33<<7|array[++i]-33])
                : e===es[1] ? a.push(c+65344)
                    : a.push(c<128 ? c : c+65216)
        );
    }
    return a;
};
charset.JIS8.fromJ = function(array) {
    var a=[],i,il=array.length,c,es=[0,1,2],e=es[0];
    for(i=0;i<il;i++) {
        (c=array[i])<128||160<c&&c<224 ? ((e!=es[0] && (e=es[0],a.push(27,40,66))),a.push(c))
            : (e!==es[2] && (e=es[2],a.push(27,36,66)),
                c<P1||c>31499 ? a.push(33,38) : a.push((c>>>7&127)+33,(array[++i]&127)+33))
    }
    e!==es[0] && a.push(27,40,66);
    return a;
};
charset.JIS8.toJ = charset.JIS7.toJ;
// http://ja.wikipedia.org/wiki/UTF-7
// http://suika.fam.cx/~wakaba/wiki/sw/n/UTF-7
// 62のアルファベットと9の記号 ['(),-./:?] はそのまま表記する。
// [\t\n\r !"#$%&*;<=>@[]^_`{|}]は表記してもいいし符号化してもいい(fromUでは符号化する)
charset.UTF7.fromU = function(array) {
    var a=[],i,il=array.length,c,tmp=[];
    for(i=0;i<il;i++) {
        c = array[i];
        38<c&&c<59&&c!=42||c===63||64<c&&c<91||96<c&&c<123 ? (a.push(c),c===43&&a.push(45)) : (a.push(43),tmp.push(c))
        if (tmp.length>0) {
            while((c=array[i+1]) && !(38<c&&c<59&&c!=42||c===63||64<c&&c<91||96<c&&c<123)) {tmp.push(c);i++;}
            a = a.concat(enc.Base64.fromU(tmp,charset.UTF16BE));
            a.push(45);
            tmp=[];
        }
    }
    return a;
};
charset.UTF7.toU = function(array) {
    var a=[],i,il=array.length,c,tmp=[];
    for(i=0;i<il;i++) {
        c = array[i];
        8<c&&c<11||c===13||31<c&&c<126&&c!==43&&c!==92
            ? a.push(c) // (?![^+\\~])[ !-}]
            : c===43 // "+"
                ? (c=array[++i])===45 // "-"
                    ? a.push(c)   // "+-" => "+"
                    : tmp.push(c) // Base64
                : a.push(63); // 不正な文字は?に
        if (tmp.length>0) {
            while((c=array[i+1]) && (c===43||46<c&&c<58||64<c&&c<91||96<c&&c<123)) {tmp.push(c);i++;}
            array[i+1]===45 && i++; // 直後がBase64以外の文字なら-を省略可能(直後が-だったら-はスキップしそれ以外だったら次に読む)
            a = a.concat(enc.Base64.toU(tmp,charset.UTF16BE));
            tmp=[];
        }
    }
    return a;
};
// Modified UTF-7 の実装 http://tools.ietf.org/rfc/rfc3501.txt
/*
 * 5.1.3. Mailbox International Naming Convention By convention, international
 * mailbox names in IMAP4rev1 are specified using a modified version of the
 * UTF-7 encoding described in [UTF-7]. Modified UTF-7 may also be usable in
 * servers that implement an earlier version of this protocol. In modified
 * UTF-7, printable US-ASCII characters, except for "&", represent themselves;
 * that is, characters with octet values 0x20-0x25 and 0x27-0x7e. The character
 * "&" (0x26) is represented by the two-octet sequence "&-". All other
 * characters (octet values 0x00-0x1f and 0x7f-0xff) are represented in modified
 * BASE64, with a further modification from [UTF-7] that "," is used instead of
 * "/". Modified BASE64 MUST NOT be used to represent any printing US-ASCII
 * character which can represent itself. "&" is used to shift to modified BASE64
 * and "-" to shift back to US-ASCII. There is no implicit shift from BASE64 to
 * US-ASCII, and null shifts ("-&" while in BASE64; note that "&-" while in
 * US-ASCII means "&") are not permitted. However, all names start in US-ASCII,
 * and MUST end in US-ASCII; that is, a name that ends with a non-ASCII
 * ISO-10646 character MUST end with a "-").
 */
charset.MUTF7.fromU = function(array) {
    var a=[],i,il=array.length,c,tmp=[];
    for(i=0;i<il;i++) {
        c = array[i];
        31<c&&c<127 ? (a.push(c),c===38&&a.push(45)) : (a.push(38),tmp.push(c))
        if (tmp.length>0) {
            while((c=array[i+1]) && (c<32||126<c)) {tmp.push(c);i++;}
            tmp = enc.Base64.fromU(tmp,charset.UTF16BE);
            for(j=0;j<tmp.length;j++){tmp[j]===47&&(tmp[j]=44)}; // "/" =>
                                                                    // ","
            a = a.concat(tmp);
            a.push(45);
            tmp=[];
        }
    }
    return a;
};
charset.MUTF7.toU = function(array) {
    var a=[],i,il=array.length,c,tmp=[];
    for(i=0;i<il;i++) {
        c = array[i];
        31<c&&c<127&&c!==38
            ? a.push(c) // &以外
            : c===38 // "&"
                ? (c=array[++i])===45 // "-"
                    ? a.push(38)   // "&-" => "&"
                    : tmp.push(c) // Base64
                : a.push(65533); // 不正な文字は\ufffdに
        if (tmp.length>0) {
            while((c=array[i+1]) && (42<c&&c<45||47<c&&c<58||64<c&&c<91||96<c&&c<123)) {tmp.push(c===44?47:c);i++;}
            array[i+1]===45 && i++;
            a = a.concat(enc.Base64.toU(tmp,charset.UTF16BE));
            tmp=[];
        }
    }
    return a;
};
charset.UTF8.fromU = function(array) {
    var a=[],i,il=array.length,c;
    for(i=0;i<il;i++) {
        (c=array[i])<128 ? a.push(c)
            : c<2048 ? a.push(c>>>6|192,c&63|128)
                : c<65536 ? a.push(c>>>12|224,c>>>6&63|128,c&63|128)
                    : a.push(c>>>18|240,c>>>12&63|128,c>>>6&63|128,c&63|128)
    }
    return a;
};
charset.UTF8.toU = function(array) {
    var a=[],i=0,il=array.length,c;
    array[0]===239&&array[1]===187&&array[2]===191&&(i=3);// BOM
    for(;i<il;i++) a.push(
        (c=array[i])<128 ? c
            : c<224 ? (c&31)<<6|array[++i]&63
                : c<240 ? ((c&15)<<6|array[++i]&63)<<6|array[++i]&63
                    : (((c&7)<<6|array[++i]&63)<<6|array[++i]&63)<<6|array[++i]&63
    );
    return a;
};
charset.UTF16LE.fromU = function(array) {
    var a=[],i,il=array.length,c,m;
    for(i=0;i<il;i++) {
        // scalar UTF-16
        // 000uuuuuxxxxxxyyyyyyyyyy 110110wwwwxxxxxx 110111yyyyyyyyyy wwww =
        // uuuuu - 1
        (c=array[i])>65535&&(m=(c>>>10)-64|55296,a.push(m&255,m>>>8),c=(c&1023|56320));
        a.push(c&255,c>>>8);
    }
    return a;
};
charset.UTF16LE.toU = function(array) {
    var a=[],i=0,il=array.length,c;
    array[0]===255&&array[1]===254&&(i=2);
    for(;i<il;i++) {
        c=array[i]|array[++i]<<8;
        55295<c&&c<56320&&(c=((c&1023)+64<<10)+((array[++i]|array[++i]<<8)&1023));
        a.push(c);
    }
    return a;
};
charset.UTF16BE.fromU = function(array) {
    var a=[],i,il=array.length,c,m;
    for(i=0;i<il;i++) {
        (c=array[i])>65535&&(m=(c>>>10)-64|55296,a.push(m>>>8,m&255),c=(c&1023|56320));
        a.push(c>>>8,c&255);
    }
    return a;
};
charset.UTF16BE.toU = function(array) {
    var a=[],i=0,il=array.length,c;
    array[0]===254&&array[1]===255&&(i=2);
    for(;i<il;i++) {
        c=array[i]<<8|array[++i];
        55295<c&&c<56320&&(c=((c&1023)+64<<10)+((array[++i]<<8|array[++i])&1023));
        a.push(c);
    }
    return a;
};
charset.UTF16 = charset.UTF16BE;
/**
 * convert_array 他の文字コード配列に変換する
 * 
 * @memberof Util.Encoding
 * @param {Array}
 *            array 変換前配列
 * @param {String|Object}
 *            to 変換先の文字コード('SJIS','UTF8',Encoding.charset.SJIS,など)
 * 
 * @param {String|Object}
 *            from 変換元の文字コード('SJIS','UTF8',Encoding.charset.SJIS,など)<BR>
 *            "SJIS","EUCJP","JIS7","JIS8","Unicode","UTF7","UTF8","UTF16LE","UTF16BE","MUTF7"
 * @return {Array} 変換後配列
 */
charset.convert_array = function(array, to, from) {
    from=from||charset.Unicode;
    (!from.hasOwnProperty("toU")) && (from=charset[from]);
    (!to.hasOwnProperty("fromU")) && (to=charset[to]);
    if (to==from) {return array;}
    if(from.hasOwnProperty("toJ") && to.hasOwnProperty("fromJ")) return to.fromJ(from.toJ(array));
    return to.fromU(from.toU(array));
}
/**
 * convert 他の文字コードに変換する
 * 
 * @memberof Util.Encoding
 * @param {String}
 *            str 変換前文字列
 * @param {String|Object}
 *            to 変換先の文字コード('SJIS','UTF8',Encoding.charset.SJIS,など)
 * @param {String|Object}
 *            from 変換元の文字コード('SJIS','UTF8',Encoding.charset.SJIS,など)<BR>
 *            "SJIS","EUCJP","JIS7","JIS8","Unicode","UTF7","UTF8","UTF16LE","UTF16BE","MUTF7"
 * 
 * @return {String} 変換後文字列
 */
charset.convert = function(str, to, from) {
    var array,parser;
    from=from||charset.Unicode;
    (!from.hasOwnProperty("toU"))&&(from=charset[from]);
    (!to.hasOwnProperty("fromU"))&&(to=charset[to]);
    if (to==from) {return str;}
    parser = from===charset.Unicode ? from : enc.Text;
    array = parser.parse(str);
    return charset.Unicode.stringify(charset.convert_array(array, to, from));
};
/**
 * Unicode配列をBase64符号化する
 * 
 * @memberof Util.Encoding
 * @param {Array}
 *            array 24bit配列
 * @param {String|Object}
 *            to 変換する文字コード(default:UTF8)
 * @return {Array} Base64符号化された6bit配列
 */
enc.Base64.fromU = function(array, to) {
    (!(to=to||'UTF8').hasOwnProperty("fromU"))&&(to=charset[to]);
    return enc.Base64.fromB(to.fromU(array));
};
/**
 * Base64符号化された6bit配列をUnicode配列にする
 * 
 * @memberof Util.Encoding
 * @param {Array}
 *            array Base64符号化された6bit配列
 * @param {String|Object}
 *            from 変換する文字コード(default:UTF8)
 * @return {Array} 24bit配列
 */
enc.Base64.toU = function(array, from) {
    (!(from=from||'UTF8').hasOwnProperty("toU"))&&(from=charset[from]);
    return from.toU(enc.Base64.toB(array));
};
/**
 * 8bit配列をBase64符号化する
 * 
 * @memberof Util.Encoding
 * @param {Array}
 *            8bit配列
 * @return {Array} Base64符号化された6bit配列
 */
enc.Base64.fromB = function(array) {
    var a=[],i=0,il=array.length,
            b="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",B=[],c;
    for(i=0;i<64;i++) B.push(b.charCodeAt(i));
    for(i=0;i<il;i++) a.push(B[(c=array[i])>>>2],B[(c&3)<<4|(c=array[++i])>>>4],B[(c&15)<<2|(c=array[++i])>>>6],B[63&c]);
    (i=il%3)!==0&&(a.pop(),i===1&&a.pop());
    return a;
};
/**
 * Base64符号化された6bit配列を8bit配列にする
 * 
 * @memberof Util.Encoding
 * @param {Array}
 *            Base64符号化された6bit配列
 * @return {Array} 8bit配列
 */
enc.Base64.toB = function(array) {
    var i=0,a=[],il=array.length,B={},b,c;
    while(i<64)B["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(i)]=i++;
    for(i=0;i<il;i++) a.push((c=B[array[i]])<<2|(c=B[array[++i]])>>>4,(c&15)<<4|(c=B[array[++i]])>>>2,(c&3)<<6|B[array[++i]]);
    (i=il%4)!==0&&(a.pop(),i<3&&a.pop());
    return a;
};
enc.Base64.parse = function(str) {
    str=str.replace(/=+$/,'');
    return enc.Base64.toB(enc.Text.parse(str));
};
enc.Base64.stringify = function(array) {
    return enc.Text.stringify(enc.Base64.fromB(array));
};
/**
 * 文字列をBase64エンコードする この関数はpaddingの=を追加する
 * 
 * @memberof Util.Encoding
 * @param {String}
 *            str 変換する文字列
 * @param {String|Object}
 *            cs1 strの文字セット default:Unicode
 * @param {String|Object}
 *            cs2 cs1がUnicodeだった場合の変換先文字セット default:UTF8
 * @return {String} Base64符号化された文字列
 * 
 * @example // JS文字列をUTF8としてBase64符号化 Encoding.encodeBase64("文字列"); //=>
 *          "5paH5a2X5YiX===" Encoding.encodeBase64("文字列", "Unicode", "UTF8"); //
 *          上記と同じ // SJIS文字列をエンコード(引数は省略不可)
 *          Encoding.encodeBase64(Encoding.convert("文字列", "SJIS"), "SJIS"); //=>
 *          "lbaOmpfx==="
 * 
 */
enc.Base64.encode = function(str, cs1, cs2) {
    var array,parser,b;
    (!(cs1=cs1||'Unicode').hasOwnProperty("parse"))&&(cs1=charset[cs1]);
    (!(cs2=cs2||'UTF8').hasOwnProperty("fromU"))&&(cs2=charset[cs2]);
    parser = cs1===charset.Unicode ? cs1 : enc.Text;
    array = parser.parse(str);
    b=enc.Base64.stringify(cs1===charset.Unicode?cs2.fromU(array):array);
    b+="===".substring(0,4-b.length%4);
    return b;
};
/**
 * Base64文字列をデコードする この関数はpaddingの=を削除する
 * 
 * @memberof Util.Encoding
 * @param {String}
 *            str Base64文字列
 * @param {String|Object}
 *            from 元の文字セット指定すればJS文字列に変換する default:UTF8
 * @return {String} デコードされた文字列
 * 
 * @example // Base64符号化されたUTF8文字列をJS文字列に
 *          Encoding.decodeBase64("5paH5a2X5YiX==="); //=> "文字列"
 *          Encoding.decodeBase64("5paH5a2X5YiX===", "UTF8"); //=> "文字列" //
 *          エンコードされたSJIS文字列 Encoding.decodeBase64("lbaOmpfx===", ""); //=>
 *          "\x95\xb6\x8e\x9a\x97\xf1" Encoding.decodeBase64("lbaOmpfx===",
 *          "SJIS"); //=> "文字列"
 * 
 */
enc.Base64.decode = function(str, from) {
    str=str.replace(/=+$/,'');
    var array = enc.Base64.parse(str)
    if (from==="") {
        return enc.Text.stringify(array);
    }
    (!(from=from||'UTF8').hasOwnProperty("toU"))&&(from=charset[from]);
    return charset.Unicode.stringify(from.toU(array));
};
/**
 * enc.URI.escape RFC3986に準じて [A-Za-z0-9_.~-] 以外を%エスケープする
 * RFC2396準拠のencodeURIComponent()と違い [!*'()] もエスケープする
 * arrayは8bitを想定しているのでUnicode(24bit)配列を渡すと正しい結果にならない
 * 
 * @param {Array}
 *            array 8bit配列
 * @param {Boolean}
 *            asRFC2396 [!*'()]をエスケープしない (default:false)
 * @return {String} encoded エスケープされた文字列
 * 
 * @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
 *      encodeURIComponent は、次を除く全ての文字をエスケープします。: アルファベット、数字、- _ . ! ~ * ' ( )
 *      ... より厳格に RFC 3986に従う場合には、「!」・「'」・「(」・「)」・「*」の各文字が予約されています
 * @see http://www.ipa.go.jp/security/fy21/reports/tech1-tg/b_09.html なお、上記の
 *      "!", "'", "(", ")", "*" が sub-delims の文字であるが、これらは RFC 2396 では unreserved
 *      に属していた。
 */
enc.URI.escape = function(array, asRFC2396) {
    var s="",i,il=array.length,c;
    if (asRFC2396) {
            for(i=0;i<il;i++) s+=(c=array[i])<58&&c>38||64<c&&c<91||96<c&&c<123&&c!=43&&c!=44&&c!=47||c===33||c===95||c===126?String.fromCharCode(c):(c<16?"%0":"%")+c.toString(16).toUpperCase();
    } else {
        for(i=0;i<il;i++) s+=(c=array[i])<58&&c>47||64<c&&c<91||96<c&&c<123||c===45||c===46||c===95||c===126?String.fromCharCode(c):(c<16?"%0":"%")+c.toString(16).toUpperCase();
    }
    return s;
};
enc.URI.unescape = function(str) {
    var a=[],i,il=str.length,c;
    for(i=0;i<il;i++)a.push((c=str.charCodeAt(i))===37?parseInt(str.substring(++i,++i+1),16):c===43?20:c);
    return a;
};
/**
 * encodeURIComponent 互換の関数
 * 
 * @param {String}
 *            str JS文字列
 * @param {String|Object}
 *            変換先文字コード(default:'UTF8')
 * @return {String} encoded
 */
enc.URI.encodeURIComponent = function(str, to) {
    (!(to||"UTF8").hasOwnProperty("fromU"))&&(to=charset[to]);
    return enc.URI.escape(to.fromU(charset.Unicode.parse(str)));
};
enc.URI.decodeURIComponent = function(str, from) {
    (!(from||"UTF8").hasOwnProperty("toU"))&&(from=charset[from]);
    return charset.Unicode.stringify(from.toU(enc.URI.unescape(str)));
};
/**
 * enc.Unicode.escape Unicode(24bit整数)配列を%エスケープする(0xff以上は%uXXXXになる)
 * [*+\-\.\/@_0-9A-Za-z] 以外はエスケープされる
 * 
 * @param {Array}
 *            u24array 24bit整数の配列(String#charCodeAt() で取得した整数など)
 * @return {String} escaped %エスケープされた文字列
 */
enc.Unicode.escape = function(u24array) {
    var s="",i,il=u24array.length,c;
    for(i=0;i<il;i++) {
        c=u24array[i];
        s += 41<c&&c<58&&c!=44||63<c&&c<91||94<c&&c<123&&c!=96?String.fromCharCode(c):(c<16?"%0":c<256?"%":c<4096?"%u0":"%u")+c.toString(16).toUpperCase();
    }
    return s;
};
/**
 * enc.Unicode.unescape %エスケープされた文字列をUnicode(24bit整数)配列にする
 * 
 * @return {String} escaped %エスケープされた文字列
 * @param {Array}
 *            u24array 24bit整数の配列
 */
enc.Unicode.unescape = function(str) {
    var a=[],i,il=str.length,c;
    for(i=0;i<il;i++){
        a.push(
            (c=str.charCodeAt(i))===37 // %
            ? (c=str.charCodeAt(++i))===117 // %u
                ? parseInt(str.charAt(++i)+str.charAt(++i)+str.charAt(++i)+str.charAt(++i)+((c=str.charAt(i+1))!=="%"?(++i,c):''),16)
                : parseInt(str.charAt(i)+str.charAt(++i),16)
            : c
        );
    }
    return a;
};
/**
 * enc.TextEncoder class Encoding StandardのTextEncoderのように振る舞うクラス
 * 
 * @see https://encoding.spec.whatwg.org/
 * @see https://developer.mozilla.org/ja/docs/Web/API/TextEncoder
 */
enc.TextEncoder = function(encoding) {
    var en, map = {'UTF8':[], 'UTF16LE':['UTF16'], 'UTF16BE':[], 'SJIS':['SHIFTJIS','WINDOWS31J','XSJIS'], 'EUCJP':['XEUCJP'], 'JIS7':['iso2022jp']}, m={}, x, i;
    if (!encoding) {encoding = 'UTF-8';}
    for(x in map) {
        m[x] = x;
        for(i=0; i<map[x].length; i++) {m[map[x][i]] = x;}
    }
    en = m[encoding.toUpperCase().replace(/[^A-Z0-9]/g,'')];
    if (!en) {throw new TypeError(encoding+" is not supported encoding");}
    this.encoding = encoding;
    this.encode = function(text) {
        return new Uint8Array(charset[en].fromU(enc.Text.parse(text)));
    };
};
/**
 * enc.TextDecoder class Encoding StandardのTextDecoderのように振る舞うクラス
 * 
 * @see https://encoding.spec.whatwg.org/
 * @see https://developer.mozilla.org/ja/docs/Web/API/TextEncoder
 */
enc.TextDecoder = function(encoding) {
    var en, map = {'UTF8':[], 'UTF16LE':['UTF16'], 'UTF16BE':[], 'SJIS':['SHIFTJIS','WINDOWS31J','XSJIS'], 'EUCJP':['XEUCJP'], 'JIS7':['iso2022jp']}, m={}, x, i;
    if (!encoding) {encoding = 'UTF-8';}
    for(x in map) {
        m[x] = x;
        for(i=0; i<map[x].length; i++) {m[map[x][i]] = x;}
    }
    en = m[encoding.toUpperCase().replace(/[^A-Z0-9]/g,'')];
    if (!en) {throw new TypeError(encoding+" is not supported encoding");}
    this.encoding = encoding;
    this.decode = function(u8array) {
        return enc.Text.stringify(charset[en].toU(u8array));
    };
};
/**
 * 配列から文字コードを推測する ecl.jsのGetEscapeCodeType(str)に丸投げしている
 */
charset.guess_array = function(array) {
    var i,il=array.length,c=array[0],cs=null,p,a,m,u7,mu7,pm,am,b64,mb64;
    // BOM 0xEFBBBF:UTF8, 0xFEFF:UTF16BE, 0xFFFE:UTF16LE
    cs=c===239&&array[1]===187&&array[2]===191?"UTF8":c===255&&array[1]===254?"UTF16LE":c===254&&array[1]===255?"UTF16BE":null;
    if(cs!=null) return cs;
    // Unicode or ASCII(maybe UTF7,MUTF7) or ...?
    cs="ASCII",p=a=m=-1,u7=mu7=true,pm=am=b64=mb64=0;
    for(i=0;i<il;i++){
        c=array[i];
        if(255<c){cs="Unicode";break;}
        if(c<32&&c!==9&&c!==10&&c!==13||126<c){cs=null;break;} // 未定
        if (!u7&&!mu7) continue; // UTF-7でもModified UTF-7でもないならこの先を省略
        c===126&&(u7=false); // UTF-7は~を符号化するがModifiedUTF-7は~をそのまま印字する
        8<c&&c<11||c===13 && (mu7=false); // Modified UTF-7は\t\n\rを符号化する
        // "+-" or "\+[A-Za-z0-9\+\/]+-" があればUTF7 "&" ならMUTF7
        if (c===45) { // [+&]- の出現数をカウント
            p>=0&&u7 ? (i===p+1&&(pm++),(p=-1)) : a>=0&&mu7 && (i===a+1&&(am++),(a=-1));
            p = a = -1;
        } else {
            if (u7&&p>=0) { // Base64 [A-Za-z0-9+/] かどうか
                (u7 = (c===43||46<c&&c<58||64<c&&c<91||96<c&&c<123)) ? b64++ : (p=-1);
            }
            if (mu7&&a>=0) { // Modified Base64 [A-Za-z0-9+,] かどうか
                (mu7 = (42<c&&c<45||47<c&&c<58||64<c&&c<91||96<c&&c<123)) ? mb64++ : (a=-1);
            }
        }
        c===43&&p<0 ? (p=i) : c===38&&a<0 ? (a=i) : c===45 && (m=i);
    }
    if (cs==="ASCII") {
        cs = u7&&(b64>0||pm>0) ? "UTF7" : mu7&&(mb64>0||am>0) ? "MUTF7" : "ASCII";
    }
    // TODO: GetEscapeCodeTypeの代替処理が未実装
    return cs?cs:GetEscapeCodeType(enc.URI.escape(array));
};
charset.guess = function(str) {
    return charset.guess_array(enc.Text.parse(str));
};
var names=["SJIS","EUCJP","JIS7","JIS8","Unicode","UTF7","UTF8","UTF16LE","UTF16BE","MUTF7"],i,il=names.length;
Encoding.charset=charset;
for(i=0;i<il;i++) {
    if (names[i]==='Unicode') {
        Encoding["escapeUnicode"] = function(str){return enc.Unicode.escape(charset.Unicode.parse(str));};
        Encoding["unescapeUnicode"] = function(str){return charset.Unicode.stringify(enc.Unicode.unescape(str));};
    } else {
        Encoding["escape"+names[i]] = (function(fnc,cs){return function(str){return fnc(str,cs);};})(enc.URI.encodeURIComponent, charset[names[i]]);
        Encoding["unescape"+names[i]] = (function(fnc,cs){return function(str){return fnc(str,cs);};})(enc.URI.decodeURIComponent, charset[names[i]]);
        Encoding.charset[names[i]].parse = (function(fnc){return function(str){return fnc(enc.Text.parse(str));};})(charset[names[i]].toU);
        Encoding.charset[names[i]].stringify = (function(fnc){return function(array){return enc.Text.stringify(fnc(array));};})(charset[names[i]].fromU);
    }
}
Encoding.convert = charset.convert;
Encoding.convert_array = charset.convert_array;
Encoding.enc=enc;
Encoding.escape = Encoding.escapeUnicode;
Encoding.unescape = Encoding.unescapeUnicode;
Encoding.encodeURIComponent = enc.URI.encodeURIComponent;
Encoding.decodeURIComponent = enc.URI.decodeURIComponent;
Encoding.encodeBase64 = enc.Base64.encode;
Encoding.decodeBase64 = enc.Base64.decode;
Encoding.TextEncoder = enc.TextEncoder;
Encoding.TextDecoder = enc.TextDecoder;
// Encoding.getEscapeCodeType = GetEscapeCodeType;
// Encoding.JCT11280 = JCT11280;
// Encoding.JCT8836 = JCT8836;

Encoding.JISX0208={"U2CP":U2CP, "CP2U":CP2U};

})();

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class SubWindow
 * @classdesc SubWindow サブウィンドウ
 *            <p>
 *            サブウィンドウを操作する
 * 
 * @param {String}
 *            [name="HJN_subwindow"] サブウィンドウの名前（ウィンドウをユニークに指定する名前）
 * 
 * @example // TopHogeBottom と表示するサブウィンドウを表示し、閉じる<br>
 *          var sub = new SubWindow("SUB_NAME");
 *          sub.openHtml("hoge").appendHtml("Bottom").prependHtml("Top");
 *          sub.close();
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #95
    /** @constructor */
    function SubWindow(name){ 
        if(!(this instanceof SubWindow)) return new SubWindow(name);

        this._name = name || "HJN_subwindow";
        SubWindow._map[name] = {};
    }

    // private
    // クラス変数
    SubWindow._map = {};
    // メソッド
    
    // public
    /**
     * サブウィンドウを表示する(HTML指定）<br>
     * Element.createDialog と同一引数
     * 
     * @memberOf Util.SubWindow
     * @param {String}
     *            [iHtml="no message"] サブウィンドウのbodyに設定する文字列
     * @param {DOM}
     *            [element=window] サブウィンドウの位置とサイズを指定する際の基準となるウィンドウ
     * @param {String}
     *            [id="HJN_subwindow"] サブウィンドウのid名、同一名称のダイアログを閉じて作成する
     * @param {Number}
     *            [w=40] ウィンドウに対するサブウィンドウの幅の比率％
     * @param {Number}
     *            [h=40] ウィンドウに対するサブウィンドウの高さの比率％
     * @param {Object}
     *            [style={bgColor: "rgba(255, 255, 255, 0.8)"}] ダイアログ背景のCSSスタイル
     */
    SubWindow.createSubWindow = function(iHtml, win, id, w, h, style){
        iHtml = iHtml || "no message";
        win = win || window;
        style = style || {};
        id = id || "HJN_subwindow";
        w = w || 40; // 幅40%
        h = h || 40; // 高さ40%

        // サブウィンドウ表示オプションを編集する
        var width  = Math.round(win.innerWidth  * ( w / 100 ));
        var height = Math.round(win.innerHeight * ( h / 100 ));
        var top    = Math.round(win.screenTop  + (win.innerHeight / 2) - (height / 2));
        var left   = Math.round(win.screenLeft + (win.innerWidth / 2) - (width  / 2));
        var opt = "width=" + width + ", height=" + height 
                + ", top=" + top + ", left=" + left
                + ", menubar=no, toolbar=no, location=no"
                + ", status=yes, resizable=yes, scrollbars=yes";

        // サブウィンドウを作成する
        var sub = new SubWindow(id);
        // サブウィンドウにHTMLを表示する（別ウィンドウ処理なのでスケジュールが反転しないよう非同期）
        HJN.Util.setZeroTimeout( function(){
            // HTMLを表示する
            sub.openHtml(iHtml, opt);

            // デフォルトスタイルを設定する
            var body = SubWindow._map[id].document.body;
            var styleD = {bgColor: "rgba(255, 0, 255, 0.8)"};
            for (var property in styleD) body.style[property] = styleD[property];
            // 指定スタイルを設定する
            for (var property in style) body.style[property] = style[property];
        });
    }
    
    /**
     * サブウィンドウを表示する(URI指定）
     * 
     * @memberOf Util.SubWindow
     * @param {String}
     *            [uri="about:blank"] サブウィンドウに表示するURI
     * @param {String}
     *            [opt="width=600, height=450 ,menubar=no, toolbar=no,
     *            location=no, status=yes, resizable=yes, scrollbars=yes"]
     *            サブウィンドウ生成時に指定するオプション
     * @return {Object} Window サブウィンドウ
     */
    SubWindow.prototype.openUri = function(uri, opt) {
        uri = uri || "about:blank";
        opt = opt || "width=600, height=450 "
            + ",menubar=no, toolbar=no, location=no, status=yes, resizable=yes, scrollbars=yes";
        // サブウィンドウが既に開いている時、閉じる
        var sub = SubWindow._map[this._name]; // サブウィンドウへの参照
        if (sub && (typeof sub.close === "function") && !sub.closed){
                sub.close();
        }
        // サブウィンドウを開く
        SubWindow._map[this._name] = sub = window.open(uri, this._name, opt);
        // サブウィンドウを最前面にする
        sub.blur();
        window.focus();
        window.blur();
        sub.focus();
        // サブウィンドウを返却する
        return sub;
    };
    /**
     * サブウィンドウを表示する(HTML指定）
     * 
     * @memberOf Util.SubWindow
     * @param {String}
     *            [body=""] サブウィンドウに表示するHTML
     * @param {String}
     *            [opt="width=600, height=450 ,menubar=no, toolbar=no,
     *            location=no, status=yes, resizable=yes, scrollbars=yes"]
     *            サブウィンドウ生成時に指定するオプション
     * @return {Object} this 自オブジェクト
     */
    SubWindow.prototype.openHtml = function(body, opt) {
        body = body || "";
        opt = opt || "width=600, height=450 "
            + ",menubar=no, toolbar=no, location=no, status=yes, resizable=yes, scrollbars=yes";
        // サブウィンドウを開く
        var sub = this.openUri("about:blank" ,opt);
        // サブウィンドウのHTML bodyを設定する
        sub.document.body.innerHTML = body;
        // 自オブジェクトを返却する
        return this;
    };
    /**
     * サブウィンドウを閉じる
     * 
     * @memberOf Util.SubWindow
     */
    SubWindow.prototype.close = function() {
        var sub = SubWindow._map[this._name]; // サブウィンドウへの参照
        // サブウィンドウを閉じる
        sub.close();
    };
    /**
     * サブウィンドウのHTML body の末尾にHTMLを追記する
     * 
     * @memberOf Util.SubWindow
     * @param {String}
     *            [html=""] 追記するHTML文字列
     * @return {Object} this 自オブジェクト
     */
    SubWindow.prototype.append = function(html) {
        html = html || "";
        var sub = SubWindow._map[this._name]; // サブウィンドウへの参照
        // サブウィンドウのHTML bodyに追記する
        sub.document.body.innerHTML += html;
        // サブウィンドウを返却する
        return win;
    };
    /**
     * サブウィンドウのHTML body の先頭にHTMLを追記する
     * 
     * @memberOf Util.SubWindow
     * @param {String}
     *            [html=""] 追記するHTML文字列
     * @return {Object} this 自オブジェクト
     */
    SubWindow.prototype.prepend = function(html) {
        html = html || "";
        var sub = SubWindow._map[this._name]; // サブウィンドウへの参照
        // サブウィンドウのHTML bodyに追記する
        sub.document.body.innerHTML = html + sub.document.body.innerHTML;
        // サブウィンドウを返却する
        return win;
    };
    
    /* new */
    return SubWindow;
}());

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @memberOf Util
 * @class Menu
 * @classdesc Menu メニュー
 *            <p>
 *            メニューを操作する
 * @param {String}
 *            menuId メニューのID（メニュー要素をユニークに指定するID）
 * @param {String}
 *            [menuLabel=""] メニューのラベル
 * @param {String}
 *            funcName メニュー要素選択時に発行する関数名
 * 
 * @example // TopHogeBottom と表示するサブウィンドウを表示し、閉じる<br>
 *          var menu1 = new Util.Menu( "Usage of TAT log diver", divMenuId +
 *          "_HelpUsage", "HJN.init.Usage"); menu1.mekeAsDialog(
 *          "HJN.dialogUsage", 50 , 40);
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #95
    /** @constructor */
    function Menu(menuId, menuLabel, funcName){ 
        if(!(this instanceof Menu)) return new Menu(id, label, funcName);

        this.menuId = menuId;
        this.menuLabel = menuLabel;
        this.funcName = funcName;
    }

    // private
    // クラス変数
    
    // メソッド
    
    // public
    /**
     * アコーディオンラベル用タグを取得する
     * 
     * @memberOf Util.Menu
     * @param {Object}
     *            that ラベル押下時のアコーディオン開閉ラジオボタン連動用の接頭語
     * @param {String}
     *            id ラベル押下時のアコーディオン開閉ラジオボタン連動用の接尾語（ユニークな英数字）
     * @param {String}
     *            labelText ラベル表示文字列
     * @param {Boolean}
     *            [isChecked=閉じた状態て初期表示] trueを指定したとき展開して初期表示
     * @return {String} html アコーディオンラベル用HTMLテキスト
     */
    Menu.getAccordionTag = function(that, id, labelText, isChecked) { // #31
        var isAccordion = true, // true:アコーディオン型 false:折りたたみ型 #21
        typeStr = isAccordion ? ' type="checkbox" name="accordion" '
                : ' type="radio" name="accordion" ', //
        checkedStr = ' checked="checked" ';

        return ''
                + '<input id="ac-' + that.chartIdName + id + '"' // 
                + typeStr + (isChecked ? checkedStr : '') + '">' // 
                + '<label for="ac-' + that.chartIdName + id + '">' //
                + labelText + '</label>';
    };

    /**
     * File Open用タグを取得する
     * 
     * @example
     * <ol>
     * <a><label>Child Menu<input type="file" id="xxx" multiple/></label></a>
     * </ol>
     * @memberOf Util.Menu
     * @param {String}
     *            [preLabel=""] ラベルの先頭文字列
     * @return {String} html メニュー要素の表示用HTMLテキスト
     */
    Menu.prototype.getFileOpenTag = function(preLabel) {
        preLabel = preLabel || "";

        return ''
                + '<ol><a><label class="hjnButton4Input">' + this.menuLabel // #51
                + '<input type="file" id="' + this.menuId + '"  multiple />'
                + '</label></a></ol>';
    };
    
    /**
     * ダウンロード処理に対応する
     * 
     * @memberOf Util.Menu
     * @param {String}
     *            [fileName="HJN_download"] ダウンロードファイル名
     * @return {Object} this
     */
    Menu.prototype.makeDownloadable = function(fileName) {
        this["fileName"] = fileName || "HJN_download";

        return this;
    };
    /**
     * ダウンロード用アンカータグを取得する
     * 
     * @example
     * <li><a id="xxx" href="#">Child Menu</a><li/>
     * @memberOf Util.Menu
     * @param {String}
     *            [preLabel=""] ラベルの先頭文字列
     * @return {String} html メニュー要素の表示用HTMLテキスト
     */
    Menu.prototype.getATag = function(preLabel) {
        preLabel = preLabel || "";

        return '' + '<li><a id="' + this.menuId + '" '
                + 'class="hjnButton4Input" href="#" ' // #51
                + 'download="' + this.fileName + '" ' //
                + 'onclick="' + this.funcName + '(' + "'" + this.menuId + "', '"
                + this.fileName + "'" + ')" ' + '>' + preLabel + this.menuLabel
                + '</a></li>';
    };

    /**
     * グローバルメソッド呼出用アンカータグを取得する
     * 
     * @example
     * <li><a id="xxx" href="#" onclick="funcName()">Child Menu</a></li>
     * @memberOf Util.Menu
     * @param {String}
     *            [preLabel=""] ラベルの先頭文字列
     * @return {String} html メニュー要素の表示用HTMLテキスト
     */
    Menu.prototype.getFuncTag = function(preLabel) { // #34
        preLabel = preLabel || "";
        
        return ''
                + '<li><a id="' + this.menuId + ' "'
                + 'class="hjnButton4Input" href="#" ' // #51
                + 'onclick="' + this.funcName + '()">' //
                + preLabel + this.menuLabel + '</a></li>';
    };
    
    
    /**
     * ポップアップダイアログ処理に対応する
     * 
     * @memberOf Util.Menu
     * @param {String}
     *            dialogId ダイアログのID（同一IDのダイアログは上書きされる）
     * @param {Number}
     *            [w=40] ダイアログの幅
     * @param {Number}
     *            [h=40] ダイアログの高さ
     * @return {Object} this
     */
    Menu.prototype.makePopupable = function(dialogId, w, h) {
        this["dialogId"] = dialogId;
        this["w"] = w || 40;
        this["h"] = h || 40;

        return this;
    };
    /**
     * ダイアログ用タグを取得する
     * 
     * @example
     * <ol>
     * <a id="xxx" class="hjnButton4Input"
     * onclick="HJN.init.ShowDialog(FUNC_NAME(), 'DIALOG_ID', w , h)">
     * <label>Child Menu</label></a>
     * </ol>
     * @memberOf Util.Menu
     * @param {String}
     *            [preLabel=""] ラベルの先頭文字列
     * @return {String} html メニュー要素の表示用HTMLテキスト
     */
    Menu.prototype.getDialogTag = function(preLabel) {
        preLabel = preLabel || "";

        return ''
            + '<ol><a id="' + this.menuId + '" '
            + 'class="hjnButton4Input" ' // #51
            + ' onclick="HJN.Util.Element.createDialog(' // #95
                + this.funcName + "()"+ ", " // #84
                + "false, " 
                + "'" + this.dialogId + "',"
                + this.w + ","
                + this.h +")" 
            + '"' + '>' // #79
            + '<label>' + preLabel + this.menuLabel + '</label></a></ol>';
    };
    /**
     * サブウィンドウ用タグを取得する
     * 
     * @example
     * <ol>
     * <a id="xxx" class="hjnButton4Input"
     * onclick="HJN.init.ShowDialog(FUNC_NAME(), 'DIALOG_ID', w , h)">
     * <label>Child Menu</label></a>
     * </ol>
     * @memberOf Util.Menu
     * @param {String}
     *            [preLabel=""] ラベルの先頭文字列
     * @return {String} html メニュー要素の表示用HTMLテキスト
     */
    Menu.prototype.getSubWindowTag = function(preLabel) { // #95
        preLabel = preLabel || "";

        return ''
        + '<ol><a id="' + this.menuId + '" '
        + 'class="hjnButton4Input" ' // #51
        + ' onclick="HJN.Util.SubWindow.createSubWindow(' // #95
            + this.funcName + "()"+ ", " // #84
            + "false, " 
            + "'" + this.dialogId + "',"
            + this.w + ","
            + this.h +")" 
        + '"' + '>' // #79
        + '<label>' + preLabel + this.menuLabel + '</label></a></ol>';
    };


    /* new */
    return Menu;
}());

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_HJN_js__ = __webpack_require__(2);



/**
 * @memberof TimeSeries
 * @class FileParser
 * @classdesc ファイルをパースして読み込む
 *            <p>
 *            パース条件指定画面生成つき
 */
/* harmony default export */ __webpack_exports__["a"] = (function() {
    /** @static */

    /** constructor */
    function FileParser(){
        if(!(this instanceof FileParser)) return new FileParser();
    }
    
    /** @private */

    // public
    /**
     * ファイルが新たに指定された時、eTatOriginalを再構築するか否（データを追加する）か
     * 
     * @memberof TimeSeries.FileParser
     * @return {boolean} 再構築モードするときtrue、データを追加するときfalse
     */
    FileParser.prototype.isNewETAT = function() { // #23
        return __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getConfig("NEWFILE") === "NEWDATA"; // #76
    }
    
    /**
     * 「ファイルから次の1レコードを取得するutil」 を取得する
     * 
     * @memberof TimeSeries.FileParser
     */
    FileParser.prototype.createGetterOfLine = function(file) {

        /**
         * @memberof TimeSeries.FileParser
         * @class GetterOfLine
         * @classdesc ファイルから１レコード取得する
         *            <p>
         *            ファクトリのFileParserが保持する改行コードを用いて、ファイルから１レコードを取得する
         * 
         * @example try{ var getterOfLine = FileParser.createGetterOfLine(file),
         *          fileInfo;<br>
         *          for(var i = 0; i < n; i++) { <br>
         *          line = getterOfLine.next(); fileInfo += line.str + "<BR>"; }<br>
         *          }catch (e) {<br>
         *          console.error("改行コードの無いファイルは扱えません]%o",e); }
         */
        function GetterOfLine(file, maxLength){ /* constructor */
            if(!(this instanceof GetterOfLine)) return new GetterOfLine(file, maxLength);

            this.file = file;
            this.buf = new Uint8Array(file);
            this.maxLength = maxLength || this.buf.length,
            this.confLF = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getConfig("LF");  // 改行コードor固定レコード長
                                                                // #76
            this.from = 0;
            this.to = 0;
            this.len = 0;
            this.line = {file: this.file, pos: 0, array: null, str: "", isEoF: false };
        }
        // public
        /**
         * 次の1レコードを取得する
         * 
         * @memberof TimeSeries.FileParser.GetterOfLine
         * @name next
         */
        if (__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].File.getValueByKey("LF") === "LF_FIX"){ // 固定長のとき #76
            GetterOfLine.prototype.next = function () { // 次の1レコードを取得する
                if(this.from >= this.maxLength ){   // ファイル末尾のとき
                    this.line = {file: this.file, pos: this.maxLength, array: null, str: "", isEoF: true };
                } else {
                    this.len = Math.min(this.maxLength - this.from, this.confLF);
                    var array = new Uint8Array(this.file, this.from, this.len);
                    this.line = {
                            file: this.file,
                            pos: this.from,
                            array: array,
                            str: String.fromCharCode.apply(null, array),
                            isEoF: false };
                }
                this.from += this.confLF;   // 次の行を指しておく
                return this.line;
            };
        } else { // 可変長のとき
            GetterOfLine.prototype.next = function () { // 次の1レコードを取得する
                if(this.from >= this.maxLength ){   // ファイル末尾のとき
                    this.line = {file: this.file, pos: this.maxLength, array: null, str: "", isEoF: true };
                } else {
                    this.to = this.buf.indexOf(this.confLF, this.from);
                    if(this.to < 0) this.to = this.maxLength;   // 最終レコード（EOFで改行コードなし）のとき
                    this.len = Math.min(this.to - this.from, 1024);
                    var array = new Uint8Array(this.file, this.from, this.len);
                    this.line = {
                            file: this.file,
                            pos: this.from,
                            array: array,
                            str: String.fromCharCode.apply(null, array),
                            isEoF: false };
                }
                this.from = this.to + 2;    // 次の行を指しておく
                return this.line;
            };
        }
        return new GetterOfLine(file);
    };
    
    
    /**
     * eTatのフィルター
     * 
     * @memberof TimeSeries
     */
    FileParser.prototype.createFilter = function() { // #34
       /**
         * @memberof TimeSeries.FileParser
         * @class Filter
         * @classdesc FileParserのフィルター
         *            <p>
         *            ファクトリのFileParserが保持するフィルタ条件を用いるフィルターを取得する
         */
        function Filter(){ /* constructor */
            if(!(this instanceof Filter)) return new Filter();
            var c = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"].Filter; // #76
            
            this.confF_TIME_FROM = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["S2D"](c.getConfig("F_TIME_FROM"));    // 時刻(X)の最小値フィルター
            this.confF_TIME_TO   = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["S2D"](c.getConfig("F_TIME_TO"));      // 時刻(X)の最大値フィルター
            this.confF_TIME = (isNaN(this.confF_TIME_FROM) && isNaN(this.confF_TIME_TO))
                            ? false : true; // 時刻(x）フィルター指定の有無
            
            this.confF_TAT_FROM = c.getConfig("F_TAT_FROM") || 0; // 時間(Y)の最小値フィルター
            this.confF_TAT_TO   = c.getConfig("F_TAT_TO") || Number.MAX_VALUE; // 時間(Y)の最大値フィルター
            this.confF_TAT = (this.confF_TAT_FROM === 0 && this.confF_TAT_TO === Number.MAX_VALUE)
                            ? false : true; // 時間(ｙ）フィルター指定の有無

            this.confF_TEXT = c.getConfig("F_TEXT") || null; // テキストフィルタの条件（使用しない、Include,Exclude
            if (this.confF_TEXT === "F_TEXT_INCLUDE") {
                this.confF_TEXT = true;
            } else if (this.confF_TEXT === "F_TEXT_EXCLUDE") {
                this.confF_TEXT = false;
            } else { // "F_TEXT_NON"
                this.confF_TEXT = null;
            }
            
            this.confF_TEXT_LEN = c.getConfig("F_TEXT_LEN") || null;    // フィルタテキストのバイト長
            this.confF_TEXT_POS = c.getConfig("F_TEXT_POS") || 0;       // フィルタテキストの先頭バイト位置
            this.confF_TEXT_COL = (c.getConfig("F_TEXT_COL") || 3) - 1; // フィルタテキストのカラム位置（先頭：０）
            this.confF_TEXT_REG = new RegExp(c.getConfig("F_TEXT_REG") || ".*");    // フィルタテキストの正規表現
            
            this.confF_IS = (this.confF_TIME === true 
                            || this.confF_TAT === true || this.confF_TEXT != null)
                          ? true : false; // フィルタ指定の有無
            
            c = new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"]("File"); // #76
            this.confF_SEP = c.getConfig("SEP").charCodeAt(0);
        }
        
        // class method
        // private
        /**
         * フィルター条件で判定する
         * 
         * @memberof TimeSeries.Filter
         */
        Filter.prototype._isIn = function (e) {
            // フィルタ指定が無いときフィルタしない（初期表示時に無駄な処理をしない）
            if (this.confF_IS === false) return true;
            // 時刻（ｘ）フィルタの判定 （conf指定なしのとき NaNとの比較となりfalseとなる）
            if (e.x < this.confF_TIME_FROM || this.confF_TIME_TO < e.x ) {
                return false;
            }
            // 時間（ｙ）フィルタの判定
            if (e.y < this.confF_TAT_FROM || this.confF_TAT_TO < e.y){
                return false;
            }
            // テキストフィルタの判定
            if (this.confF_TEXT === null) {
                return true; // フィルタ指定なし
            }
            var text = "";
            if (e.pos === undefined) { // テキスト読み込みでないとき（自動生成データのとき）
                // レコードを取得する #62
                text = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_HJN_js__["HJN"].chart.fileParser.getRecordAsText(e); // #61
                // 指定正規表現に合致するか判定し、Include/Exclude指定に応じてリターンする
                return this.confF_TEXT === this.confF_TEXT_REG.test(text);
            } else { // ファイル読み込みのとき
                // レコードを取得する
                var arr = new Uint8Array(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_HJN_js__["HJN"].filesArrayBuffer[e.fileIdx+1], e.pos, e.len);
                // CSVレコードの指定カラムを取得する(arr)
                var colPos = 0;
                for (var i = 0; i < this.confF_TEXT_COL; i++) {
                    colPos = arr.indexOf(this.confF_SEP,colPos + 1);
                }
                if (colPos === -1){
                    // 指定数のカラムが無い場合、Includeは処理対象外、Excludeは処理対象
                    return !this.confF_TEXT;
                }
                var col = arr.slice(colPos, arr.length);
                // 判定用文字列を取得する
                text = col.slice(this.confF_TEXT_POS, this.confF_TEXT_POS + this.confF_TEXT_LEN);
                // 指定正規表現に合致するか判定し、Include/Exclude指定に応じてリターンする
                return this.confF_TEXT === this.confF_TEXT_REG.test(String.fromCharCode.apply(null, text));
            }
            return true;
        };
        
        // public
        /**
         * eTatをフィルターする
         * 
         * @memberof TimeSeries.Filter
         * @param {eTat}
         *            eTat フィルター処理対象のeTat
         * @return {eTat} eTat フィルターされたeTat
         * 
         */
        Filter.prototype.filter = function (eTat) {
            if (!eTat) return [];
            return eTat.filter(this._isIn, this);
        };

        return new Filter();
    };


    /**
     * 「１レコードからx:時刻（数値：ミリ秒）,y:Tat(数値：秒)を取得するutil」を取得する
     * 
     * @memberof TimeSeries.Filter
     */
    FileParser.prototype.createGetterOfXY = function() {

        /**
         * @memberof TimeSeries.FileParser
         * @class GetterOfXY
         * @classdesc １レコードをパースし、XとYをレコード取得する
         *            <p>
         *            ファクトリのFileParserが保持するレコードフォーマット情報を用いて、ファイルの指定レコードからＸ(data)とＹ(value)を取得する
         */
        function GetterOfXY(){ /* constructor */
            if(!(this instanceof GetterOfXY)) return new GetterOfXY();

            var c = new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"]("File"); // #76
            this.confSEP = c.getConfig("SEP");   // セパレータ
            
            this.confTIME_COL = c.getConfig("TIME_COL") - 1 || 0;    // 時刻(X)のカラム位置
            this.confTIME_POS = (c.getConfig("TIME_POS") || 1) - 1;  // 時刻(X)の先頭バイト位置
            this.confTIME_LEN = (c.getConfig("TIME_LEN") || 0);      // 時刻(X)のバイト長
            this.confTIME_FORM = c.getConfig("TIME_FORM");           // 時刻(X)の文字フォーマット指定
            this.confTIME_YMD = (c.getConfig("TIME_YMD") || '"YYYY/MM/DD hh.mm.ss.000"'); // #42
                                                                    // 時刻(X)のYMDフォーマット
                                                                    // #92
            this.paseDateConf = {  // YYYY/MM/DD hh:mm:dd.ss.000 #41
                YYYY: this.confTIME_YMD.indexOf("YYYY"),
                MM: this.confTIME_YMD.indexOf("MM"),
                DD: this.confTIME_YMD.indexOf("DD"),
                hh: this.confTIME_YMD.indexOf("hh"),
                mm: this.confTIME_YMD.indexOf("mm"),
                ss: this.confTIME_YMD.indexOf("ss"),
                p000: this.confTIME_YMD.indexOf("0"), // #92
            };
            this.isYMD = (this.confTIME_FORM === "TIME_FORM_YMD");
            // 時刻(X)の数値単位(1or1000,YMDのとき1)
            this.confTIME_UNIT = this.isYMD? 1 : (c.getConfig("TIME_UNIT") || 1);
            
            
            this.confTAT_COL = c.getConfig("TAT_COL") - 1 || 1;      // 時間(Y)のカラム位置
            this.confTAT_POS = (c.getConfig("TAT_POS") || 1) - 1;    // 時間(Y)の先頭バイト位置
            this.confTAT_LEN = (c.getConfig("TAT_LEN") || 0);        // 時間(Y)のバイト長
            this.confTAT_FORM = c.getConfig("TAT_FORM");             // 時間(Y)のフォーマット指定
            this.confTAT_UNIT = c.getConfig("TAT_UNIT") || 1;        // 時間(Y)の数値単位(1/1000)
            this.confENDIAN =  c.getConfig("ENDIAN");    // リトルエンディアンはtrue、ビッグエンディアンはfalse
            this.isLittle = (function(){
                // long用に4バイト取得する
                var buf = new ArrayBuffer(4);               
                // true:bufに、リトルエンディアン指定で1を書き込む
                new DataView(buf).setUint32(0, 1, true);
                // プラットフォームのエンディアンを使用するUint32Arrayと比較する
                return (new Uint32Array(buf)[0] === 1);     
            }());
            
            this.dateAndValue = {date: 0, value: 0, isError: false };
        }
        
        // class method
        /**
         * 数値(秒)、時間（時分秒)をパースして数値（秒*unit）を取得する<br>
         * 数値でない場合 NaN を返却する<br>
         * /[0-9,:\. ]+/ に合致する文字列のみを処理する 例： argY: "-1:1:1.2" unit:1000 ->
         * -3661200 ms = -(1*60*60 + 1*60 + 1.2)*1000
         * 
         * @memberof TimeSeries.FileParser.GetterOfXY
         */
        GetterOfXY.parseNumber = function (){ // argY, unit,
            var argY = arguments[0],
                unit = arguments[1];
            if(!argY) {console.log("data Y parse error"); return 0; }
            // 数値を含まないとき NaN を返却する
            var nums =  argY.match(/[0-9,:\. ]+/); // #92
            if (!nums) return NaN; // #93
            // 時分秒(hh:mm:ss.000)を秒にする
            var str = nums[0];
            var ds = (str.indexOf(":") < 0) ? [str] : str.split(":"),   // #40
                pm = (0 <= ds[0]) ? 1 : -1,
                sec = 0.0;
            for(var i = 0; i < ds.length; i++){
                sec += pm * Math.abs(ds[i]) * Math.pow(60, ds.length - i - 1);
            }
            // 単位補正する（ミリ秒指定の場合 unit = 1000）
            return sec * (unit || 1);
        };

        /**
         * Long(4バイトバイナリ）数字をパースして数値（ミリ秒）を取得する
         * 
         * @private
         */
        GetterOfXY.prototype._parseLong = function (arr){
            if (4 <= arr.length ) { // Long(4byte)以上のときunsigned longとして処理する
                // bufの先頭4byteを、指定バイトオーダ(endian)で、符号無32bit intとして参照
                return (new DataView(arr.buffer, 0 , 4)).getUint32(0, this.confENDIAN);
            } else {
                // Long(4バイト）より短いとき、Byte単位に処理する
                if (this.confENDIAN) { // little endianのとき
                    return arr.reduceRight(function(a, b){ return a*256 + b; });
                } else {               // big endianのとき
                    return arr.reduce(function(a, b){ return a*256 + b; });
                }
            }
        };

        // public
        /**
         * レコードからXとYを取得する
         * 
         * @memberof TimeSeries.FileParser.GetterOfXY
         */
        GetterOfXY.prototype.parse = function (line) {
            // セパレータでカラム分割する
            var posMax = Math.max(this.confTIME_COL, this.confTAT_COL),
                sep = this.confSEP.charCodeAt(0),   // 区切り文字のUint値
                pos = 0,
                nextPos = line.array.indexOf(sep),  // 行末（次の区切り文字位置）
                x = 0,
                y = -1;
            for (var i = 0; i <= posMax; i++) {
                if (i === this.confTIME_COL){
                    // パース対象フィールドを切り出す
                    var posX =  pos + this.confTIME_POS;
                    var arrX = (0 < this.confTIME_LEN) 
                             ? line.array.slice(posX, posX + this.confTIME_LEN)
                             : line.array.slice(posX, nextPos);
                    var strX = "";
                    // フィールドをパースする
                    if (this.isYMD){    // 年月日時分秒の文字列のとき
                        strX = String.fromCharCode.apply(null,arrX);
                        x = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["S2D"](strX, this.paseDateConf);
                    } else if (this.confTIME_FORM === "TIME_FORM_TEXT"){    // テキスト数字のUNIX経過時間のとき
                        strX = String.fromCharCode.apply(null,arrX);
                        x = GetterOfXY.parseNumber(strX);
                    } else{ // this.confTIME_FORM === "TIME_FORM_LONG"
                            // longのUNIX経過時間のとき
                        x = this._parseLong(arrX);
                    }
                    // 単位を補正する
                    x *= this.confTIME_UNIT;
                }
                if (i === this.confTAT_COL){
                    // パース対象フィールドを切り出す
                    var posY =  pos + this.confTAT_POS;
                    var arrY = (0 < this.confTAT_LEN) 
                             ? line.array.slice(posY, posY + this.confTAT_LEN)
                             : line.array.slice(posY, nextPos);
                    // フィールドをパースする
                    if (this.confTAT_FORM === "TAT_FORM_TEXT"){
                        // テキスト数字によるUNIX経過時間のとき
                        var strY = String.fromCharCode.apply(null,arrY);
                        y = GetterOfXY.parseNumber(strY);
                    } else{
                        // TAT_FORM_TEXT === "TAT_FORM_LONG" 数値によるUNIX経過時間のとき
                        y = this._parseLong(arrY);
                    }
                    // 単位を補正する
                    y *= this.confTAT_UNIT;
                }
                pos = nextPos + 1;
                nextPos = line.array.indexOf(sep, pos);
                if (nextPos < 0) nextPos = line.array.length;
            }
            
            if(0 < x && 0 <= y){ // 正常時
                return {x: x, y: y, isError: false };
            } else {            // エラー時、（ NaN の場合を含む）
                return {x: x, y: y, isError: true };
            }
        };
        
        return new GetterOfXY();
    };
    
    /**
     * eTatの指定行の編集元レコードを、テキストフォーマットに変換して取得する
     * 
     * @memberof TimeSeries.FileParser
     * @param {Object}
     *            e eTat[n]：eTatの指定行
     * @return {String} eTatの指定行の表示用テキスト
     */
    FileParser.prototype.getRecordAsText = function (e) { // #62 ADD
        if (!e) return "";
        var text = "";
        if (typeof e.pos === "undefined") { // 生成データのとき
            // 生成データをCSVのログデータとして編集する #61
            text = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](e.x, "yyyy/MM/dd hh:mm:ss.000", true) // #92
                    + ", " + e.y + ", " + e.message; // #53
            // 状態遷移履歴を追加する #62
            if (e.history){
                e.history.forEach(function(h){
                    var timeStr = "";
                    if (typeof(h.time) === "number") {
                        timeStr = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](h.time, "mm:ss.000", true) + " seq:" // #92
                    }
                    text += " [" + h.sequenceIdx + ":" + h.status + "]" // #61
                        + timeStr + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](h.sequenceTime, "mm:ss.000", true); // #92
                }, this);
            }
        } else { // ファイル読込のとき
            // ファイルの該当行を Uint8Arrayに登録する
            var buff = new Uint8Array(e.len + 2);
            var file = __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_HJN_js__["HJN"].filesArrayBuffer[e.fileIdx]; // #23
            buff.set(new Uint8Array(file, e.pos,
                    Math.min(e.len + 2, file.byteLength - e.pos)));
            // ログデータを編集する
            text = String.fromCharCode.apply(null, buff);
        }
        return text;
        
    };
 
    // new
    return FileParser;
}());

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MenuConfigFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Graph_js__ = __webpack_require__(1);



/**
 * @memberOf TimeSeries
 * @class MenuConfigFile
 * @classdesc FileParser用メニューHTML定義
 * 
 */
function MenuConfigFile() {}  // #76
  

MenuConfigFile.config = function () {
    // File Format Config設定画面定義 #51
    var prefix = "File";
    var c = new  __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"](prefix);
    c // #53
        .name("NEWFILE").label(null,"Open file as ") // #23
            .radio("NEWDATA", null, "newly", true)
            .radio("ADDDATA", null, "append").n()
//        .startTag("select")
//            .option("NEWDATA", null, "newly", true)
//            .option("ADDDATA", null, "append")
//        .endTag().n()
        .label(null,"<B>----- File format definition --------</B>").n()
        .name("CHAR").label(null, "<B>[Charset]</B>") // #82
//          .n()        
//            .radio(c.def("CHAR_SJIS", "SJIS"), null, "Shift-JIS", true)
//            .radio(c.def("CHAR_EUCJP", "EUCJP"), null, "EUC-JP")
//            .radio(c.def("CHAR_UTF8", "UTF8"), null, "UTF-8")
//            .radio(c.def("CHAR_UNICODE", "Unicode"), null, "Unicode")
//        .n("<br>")
        .startTag("select")
            .option(c.def("CHAR_SJIS", "SJIS"), null, "Shift-JIS", true)
            .option(c.def("CHAR_EUCJP", "EUCJP"), null, "EUC-JP")
            .option(c.def("CHAR_UTF8", "UTF8"), null, "UTF-8")
            .option(c.def("CHAR_UNICODE", "Unicode"), null, "Unicode")
        .endTag().n()
        .name("LF").label(null, "<B>[Line feed code]</B>").n()
            .radio(c.v("LF_FIX"), null, "Fixed Length")
                .number("LF_FIX.v",  null, "byte","80",'style="width:60px;"').n()
            .radio(c.def("LF_WIN",  13), null, "Windows:CR(13)+LF(10)", true).n()
            .radio(c.def("LF_UNIX", 10), null, "Unix/Linux:LF(10)").n()
            .radio(c.def("LF_ZOS",  15), null, "zOS:NEL(15)").n()
            .radio(c.def("LF_MAC",  13), null, "Mac:CR(13)").n()
            .radio(c.v("LF_ELSE"), null, "other charcode")
                .number("LF_ELSE.v", "(", ")", "10", 'style="width:40px;"').n()
        .n("<br>")
        .name("SEP").label(null,"<B>[CSV delimiter]</B>")
        .startTag("select")
            .option(c.def("SEP_COMMA", ','), null, "comma")
            .option(c.def("SEP_TAB", '\t'),   null,"tab", true)
            .option(c.v("SEP_ELSE"), null, "other :")
        .endTag()
//            .radio(c.def("SEP_COMMA", ','), null, "comma")
//            .radio(c.def("SEP_TAB", '\t'),   null,"tab", true)
//            .radio(c.v("SEP_ELSE"), null, "other")
                .text("SEP_ELSE.v", '"', '"', ',', 'size="2" placeholder=","').n()
        .n("<br>")
        .label(null,"<B>----- Data format definition --------</B>").n()
        .name("DATATYPE").label(null,"") // #89
            .radio("DATATYPE_TATSTART", null, "TAT & START time")
            .radio("DATATYPE_TATEND", null, "TAT & END time", true)
            .radio("DATATYPE_START_END", null, "START & END time").n()
        .n("<br>")
        .name("TIME").label(null, "<B>[TIMESTAMP field]</B>").n()
        .number("TIME_COL", "", "th column of CSV", "1", 'style="width:40px;"').n()
        // .name("TIME_POS")
        .number("TIME_POS", "& Position(byte): from", null, "1", 'style="width:40px;"')
        .number("TIME_LEN", "length", null, null, 'style="width:40px;"').n()
        .name("TIME_FORM").label(null,"Format:").n()
            .radio("TIME_FORM_YMD", "text", null, true)
                .text("TIME_YMD", null, null, '"YYYY/MM/DD hh:mm:ss.000"',
                        'size="23" placeholder=' + "'" +'"YYYY/MM/DD hh:mm:ss.000"'+ "'" ).n() // #92
            .radio("TIME_FORM_TEXT", "(num)", "text")
            .radio("TIME_FORM_LONG", null, "long").n()
            .nDown()
                .name("TIME_UNIT").label(null, "Units of numbers:")
                    .radio(c.def("TIME_UNIT_MS", 1), null, "msec")
                    .radio(c.def("TIME_UNIT_SEC", 1000), null, "sec", true)
            .nUp()
        .n("<br>")
        .n("<br>") // #89
        .name("CSV_TAT_LABEL").label(null,"<B>[TAT or START/END judgment field]</B>").n() // #89
        .number("TAT_COL", "", "th column of CSV", "2", 'style="width:40px;"').n()
        // .name("TAT_POS")
        .number("TAT_POS", "& Position(byte): from", null, "1", 'style="width:40px;"')
        .number("TAT_LEN", "length", null, null, 'style="width:40px;"').n()
        .n("<br>") // #89
        .name("TAT_CONF").label(null,"<B>for TAT(turnaround time) condition</B>").n() // #89
        .name("TAT_UNIT").label(null, "Units of numbers:")
            .radio(c.def("TAT_UNIT_MS", 1), null, "msec", true)
            .radio(c.def("TAT_UNIT_SEC", 1000), null, "sec").n()
        .name("TAT_FORM").label(null,"Format: ")
            .radio("TAT_FORM_TEXT", null, "text", true)
            .radio("TAT_FORM_LONG", null, "long").n()
            .nDown()
                .name("ENDIAN").label(null, "for long Endian: ")
                    .radio(c.def("ENDIAN_LIL", true), null, "little", true)
                    .radio(c.def("ENDIAN_BIG", false), null, "big")
            .nUp()
        .n("<br>")
        // 開始 ／終了時刻指定 #89
        .n("<br>")
        .name("CSV_SE_LABEL1").label(null,"<B>for START/END judgment condition</B>").n() 
        .text("CSV_SE_S_REG", 'START record: Matches /', '/', 'START', 
                'size="8" placeholder="START"').n()
        .text("CSV_SE_E_REG", 'END record: Matches /', '/', 'END',
                'size="8" placeholder="END"').n()
        .n("<br>")
        // 開始-終了ペアリングキー定 #89
        .n("<br>")
        .name("CSV_SE_LABEL2").label(null, "<B>[START-END pairing KEY field]</B>").n()
        .number("CSV_SE_COL", "", "th column of CSV", "3", 'style="width:40px;"').n()
        // .name("CSV_SE_POS")
            .number("CSV_SE_POS", "& Position(byte): from", null, "1", 'style="width:40px;"')
            .number("CSV_SE_LEN", "length", null, null, 'style="width:40px;"').n()
        .name("CSV_SE_LABEL3").label(null, "& Position(Matches reg. exp.):").n()
        .nDown()
            .text("CSV_SE_FROM_REG", 'between /', '/', '',   'size="8" placeholder=""')
            .text("CSV_SE_TO_REG", 'and /', '/', '',   'size="8" placeholder=""').n()
        .nUp()
        .text("CSV_SE_MATCH_REG", '& Adopt as KEY: Matches /', '/', '[0-9A-Z]+',
                'size="8" placeholder="[0-9A-Z]+"').n()
        .n("<br>")
    ;
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);

/**
 * @memberOf Simulator
 * @class VirtualApp
 * @classdesc 仮想アプリケーション
 * 
 * @param {String}
 *            [userName = "dafault"] ログに出力するユーザ名
 * @param {Array}
 *            [sequence = SQL３個のオン処理] 取引の処理シーケンスを格納した配列
 * @param {Number}
 *            [times = 2 回] 繰返し回数
 * @param {Number}
 *            [thinkTime = 300 ms] 繰返し時の次回処理開始までの平均時間(ミリ秒）
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #53
    /** @constructor */
    function VirtualApp(userName, model){
        if(!(this instanceof VirtualApp)){
            return new VirtualApp(userName, model);
        }
        this._userName = userName || "default"; // ログ出力テキスト
        // 定数の設定
        // イベントシーケンスを取得する
        if (typeof(model) === "undefined") model = {}
        model.baseModel = model.baseModel || {"holds": []};
        this._sequence = model.sequence;
        // イベントシーケンスの繰り返し回数
        this._times = (typeof(model.times) !== "undefined") ? model.times : 1;
        // イベントシーケンス終了時に再実行する場合の平均再開時間
        this._thinkTime = Math.max(0,
                (typeof(model.thinkTime) !== "undefined") ? model.thinkTime : 500);
        // イベントシーケンス終了時に再実行する場合の最小再開時間
        this._thinkTimeMin = Math.max(0,
                (typeof(model.thinkTimeMin) !== "undefined") ? model.thinkTimeMin : 500);
        // メッセージ（ログ末尾に付与する文字列）
        this._baseMessage = model.message; // + "\n"; // #88
        this._message = "";
        this._history = []; // #62

        // 変数の設定
        this._startTime = Number.MIN_SAFE_INTEGER; // イベントシーケンス開始時刻（UNIX時刻：ミリ秒）
        this._sequenceTime = Number.MIN_SAFE_INTEGER; // シミュレータに登録したイベントの時刻（現在時刻）
        this._sequenceIdx = 0;    // シミュレータに登録したイベントシーケンスの位置
    }

    /** @private */
    //

    // public

    /**
     * シミュレータのログを出力する
     * 
     * @memberof Simulator.VirtualApp
     * @param {Number}
     *            logLv ログレベル（isLog <= logLvのときログ出力する）<br>
     *            (0:なし, 1:エラー時のみ, 2:+ETAT, 3:+push/pop, 4:+HOLD/FREE)
     * @param {boolean}
     *            isLog ログ出力レベル
     * @param {Number}
     *            time 日時を表す数値（ミリ秒）
     * @param {Object}
     *            vApp 仮想アプリ
     * @param {Object}
     *            resource リソース
     * @param {String}
     *            text ログテキスト
     * @param {String}
     *            highText 強調表示テキスト
     */
    VirtualApp.prototype.logger = function(logLv, isLog, time, vApp, resource, text, highText) {
        // 0:なしの時
        if (!isLog) return;
        var errCode = 0;
        if (resource && (resource._holdHeap.size() !== resource._holdingQty)) {
            // エラー時★
            errCode = 1;
            highText = highText ? highText + "　unkown error!!" : "　unkown error!!";
        } else if (logLv > +isLog) {
            return; 
        }

        // エラーログ編集
        var user = vApp ? " " + vApp._userName : " ";
        var resourceText = resource ? (" [" + resource._name + " wait:"
                + resource._waitHeap.size() + "hold:"
                + resource._holdHeap.size() + "="
                + resource._holdingQty + " qty] ") : " ";
        text = text || "";
        var logText = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](this.getTime(),"hh:mm:ss.000",true) 
                    + user +"(" + this._times + "-" + this._sequenceIdx + ")"
                    + resourceText 
                    + text;
        highText = highText || "";

        // エラー時の強制補正★
        var modify = "";
        if (errCode === 1) { // リソースヒープもしくはリソース量を強制補正する
            var deleted = undefined;
            if (resource._holdHeap.size() < resource._holdingQty) {
                deleted = resource._holdHeap.del(this);
            }
            if (deleted){
                modify = "FORCE★: holdHeap.del(" + deleted.userName + ")";
            } else {
                modify = "FORCE★: holdingQty modified"
                    resource._holdingQty = resource._holdHeap.size();
            }
        }

        // エラーログ出力
        if (highText || modify){
            console.log(logText + " %o", highText + " " + modify);
        } else {
            console.log(logText);
        }
    }

    /**
     * 取引を開始する
     * 
     * @memberof Simulator.VirtualApp
     * @param {Number}
     *            startTime 開始時刻（UNIX時刻：ミリ秒）
     * @return {Object}仮想アプリケーション(this)
     */
    VirtualApp.prototype.start = function(startTime) {
        this._times--; // イベントシーケンスの繰り返し回数を1減らす
        this._sequenceIdx = 0;    // シミュレータに登録したイベントシーケンスの位置
        this._startTime = startTime;      // イベントシーケンス開始時刻（UNIX時刻：ミリ秒）
        this._sequenceTime = startTime;   // シミュレータに登録したイベントの時刻
        this._message = this._baseMessage; // ログ末尾に出力する文字列の初期化
        this._history = []; // ログ末尾に出力する状態遷移履歴情報の初期化 #62
        this.addHistory("start");
        return this;
    };

    /**
     * イベント時刻を返却する
     * 
     * @memberof Simulator.VirtualApp
     * @return {Number} イベント時刻（UNIX時刻：ミリ秒）
     */
    VirtualApp.prototype.getTime = function() {
        return this._sequenceTime;
    };

    /**
     * リソース使用量を返却する
     * 
     * @memberof Simulator.VirtualApp
     * @param {Object}
     *            [resource| 指定なしのとき1.0を返却する] リソース
     * @return {Number} リソース使用量
     */
    VirtualApp.prototype.getAmount = function(resource) {
        return 1.0;
    };

    /**
     * 次の状態に遷移する、シーケンス終了時TATログを出力する
     * 
     * @memberof Simulator.VirtualApp
     * @param {Object}
     *            system VirtualSystem
     * @return {Array}再スケジュールするイベント（仮想アプリケーションorリソース）の配列、登録処理完了時はthisを含まない
     */
    VirtualApp.prototype.next = function(system) {
        this.logger(4, system._log, system.getTime(), this, undefined, 'NEXT', undefined);
        var events = []; // 戻り値
        var ret = {result: true, events: [this]};

        if (this._sequenceIdx < this._sequence.length) { // イベントシーケンス処理途中のとき
            var seq = this._sequence[this._sequenceIdx]; // 現在の処理シーケンス位置
            // holdリソースを取得する
            if (seq.hold && seq.hold !== "") {
                // holdリソースが指定されているとき、指定リソースを確保する（確保できたとき[this]が戻り値）
                ret = system.getResouce(seq.hold).hold(system, this); // #61
                events = ret.events;
            } else {
                // holdリソースが指定されていないとき、無条件に自身をスケジュール対象に加える
                events = [this];
            }
            // リソースを確保できたとき、該当シーケンスを完了させる
            if (0 < events.length && (0 <= this._times) && ret.result) { // #61
                // 完了した処理の処理時間を加える
                var tatAdd = Math.ceil(__WEBPACK_IMPORTED_MODULE_0__util_util_js__["Random"]().exponential(seq.tat - seq.tatMin));
                this.setSequenceTime(this._sequenceTime += seq.tatMin + tatAdd, seq.hold); // #61
                // シーケンスのfreeで指定されているリソースの解放
                if (seq.free) {
                    for (var i = 0; i < seq.free.length; i++) {
                        events = events.concat(system.getResouce(seq.free[i]).free(this));
                    }
                }
                // 次の処理を参照する（ シミュレータに登録したイベントシーケンスの位置）
                this._sequenceIdx++;
            }
            return events;
        }

        // イベントシーケンスを終えたときTATログを出力する(this._sequenceIdx >= this._sequence.length)
        var vApp = this._finish(system, "N_000");
        // シーケンスをstart状態に設定する
        // this._sequenceTime = system.getTime(); はfinishで更新されるので不可
        // this._startTime = this._sequenceTime; finishで設定する
        // 繰返し処理を継続する場合、自アプリケーションを再スケジュールする
        if (vApp) {
            events.push(this);
        }
        return events;
    };

    /**
     * Freeに伴い、次の状態に遷移する
     * 
     * @memberof Simulator.VirtualApp
     * @param {Number}
     *            [time | 変更しない} イベント時刻（UNIX時刻：ミリ秒）
     * @param {String}
     *            status ログに追記する時刻設定理由文字列
     * @return {Object} 仮想アプリケーション(this)
     */
    VirtualApp.prototype.setSequenceTime = function(time, status) {
        status = status || ""; 
        // 解放された時刻をイベント時刻に設定する
        this._sequenceTime = time;
        // ログに状態遷移履歴を追記する
        return this.addHistory(status);
    };

    /**
     * ログにステータス変更履歴を追記する
     * 
     * @memberof Simulator.VirtualApp
     * @param {String}
     *            status ログに追記する状態遷移の理由文字列
     * @param {Number}
     *            time 状態遷移時刻（ミリ秒）
     * @return {Object} 仮想アプリケーション(this)
     */
    VirtualApp.prototype.addHistory = function(status, time) {
// var timeStr = "";
// if (typeof(time) === "number") {
// timeStr = Util.D2S(time, "mm:ss.000", true) + " seq:"
// }
// this._message += " [" + this._sequenceIdx + ":" + status + "]" // #61
// + timeStr + Util.D2S(this._sequenceTime, "mm:ss.000", true);
        // 状態遷移履歴（ログ出力用）を追加する
        this._history.push({ // #62
            sequenceIdx : this._sequenceIdx,
            status : status,
            time : time,
            sequenceTime : this._sequenceTime
        });
        return this;
    };

    /**
     * アベンド処理（holdしている可能性のあるリソースを解放し、イベントシーケンスを強制終了する）
     * 
     * @memberof Simulator.VirtualApp
     * @param {Object}
     *            system VirtualSystem
     * @param {Object}
     *            holdedResource アベンドさせたVirtualResource
     * @param {String}
     *            [logID="E_600"] ログID
     * @param {String}
     *            [logMesseage=""] ログメッセージ
     * @param {Boolean}
     *            [isHolding=true] リソース(holdedResource)をholdしているか否か<br>
     * @param {Number}
     *            [abendTime=sytem.getTime()] abend時刻
     * @return {Array}再スケジュールするイベント（仮想アプリケーションorリソース）の配列、登録処理完了時はthisを含まない
     */
    VirtualApp.prototype.abend = function(system, holdedResource, 
                                    logID, logMesseage, isHolding, abendTime) {
        logID = logID || "E_600";
        abendTime = abendTime || system.getTime();
        isHolding = (typeof(isHolding) === "boolean") ? isHolding : true; // #61
        var events = []; // 戻り値
        this.logger(3, system._log, this._sequenceTime, this, holdedResource, 'abend', undefined);
        var seq = this._sequence[this._sequenceIdx];
        // 現在のシーケンスでholdするリソースがあるとき、waitしている可能性があるため、waitから削除する
        if (seq && seq.hold) { // #61
            system._resources[seq.hold].release(this);
        }
        // holdingリソースを開放する
        var holdings;
        // シーケンスから、holdingリソース一覧を取得する #59
        if (seq) holdings = seq.holding;
        if (holdings) { // シーケンス上holdingリソースがあるとき(undefined対策） #61
            for (var i = holdings.length - 1; 0 <= i; i--) { // #61
                // holdedResourceは削除処理対象外（呼び出し元リソースは、呼び出し前に削除済なので）
                if (holdings[i] !== holdedResource._name || isHolding){ // #61
                    // holdingリソースを開放し、使用リソース減に伴って新たにスケジュールするvAppを取得 #59
                    events = events.concat(system._resources[holdings[i]].free(this));
                }
            }
        }
        // イベントシーケンスを強制終了する
        this.setSequenceTime(abendTime, logID); // #59
        var vApp = this._finish(system, logID, logMesseage);
        // 自vAppに継続処理があれば、自vAppをスケジュール対象に加える
        if (vApp && (0 <= this._times)) { // #61
            events = events.concat([vApp]);
        }
        return events;
    };

    /**
     * イベント終了時処理（ログ出力と、繰り返し判定）
     * 
     * @memberof Simulator.VirtualApp
     * @param {Object}
     *            system VirtualSystem
     * @param {String}
     *            [logID="N_000"] ログID（ログメッセージの先頭文字）
     * @param {String}
     *            [logMesseage=""] ログメッセージ
     * @param {Number}
     *            [forceTime] 強制終了時刻を指定する（ミシュレーション停止後のeTat強制出力用）
     * @return {Object|undefined} 再スケジュールするときthis、再スケジュールしないときundefined
     */
    VirtualApp.prototype._finish = function(system, logID, logMesseage, forceTime) {
        logID = logID || "N__00";
        logMesseage = logMesseage || "";
        var events = []; // 戻り値
        var logText = logID + " " + this._userName + " " + logMesseage + " " + this._message;
        var now = this._sequenceTime;

        // 強制終了時（シミュレーション終了時刻到来時）、自APのシミュレーションを強制終了する
        if (typeof(forceTime) === "number") {
            // 起動済処理はTATログを出力する #59
            if (this._startTime <= forceTime) { 
                // TATログを出力する
                system.eTat.push( { x: forceTime, 
                                    y: Math.round(forceTime - this._startTime),
                                    sTatIdx: 0,
                                    message: logText,
                                    history: this._history} ); // #62
                this.logger(2, system._log, forceTime, this, undefined, 'finish() FORCE"', logText);
            }
            this._sequenceIdx = this._sequence.length; // #61 処理完了状態にする
            this._startTime = this._sequenceTime; // #61 念のため設定
            return undefined;
        }

        // 起動済処理はTATログを出力する #59
        if (this._startTime <= now ) { // || this._sequenceIdx ===
                                        // this._sequence.length) {
            system.eTat.push( { x: now,
                                y: Math.round(now - this._startTime),
                                sTatIdx: 0,
                                message: logText,
                                history: this._history} ); // #62
            this.logger(2, system._log, now, this, undefined, 'finish() "', logText);
        } else  {
            this.logger(0, system._log, now, this, undefined,
                    'finish() Unexpected error★ _startTime > _sequenceTime:'
                    + __WEBPACK_IMPORTED_MODULE_0__util_util_js__["D2S"](this._startTime, "hh:mm:ss.000", true)
                            + " " + this._startTime + " > " + now
                            + " Idx:" + this._sequenceIdx 
                    , logText);
        }
        this._message = this._baseMessage; // ログ末尾に追加するメッセージの初期化
 
        // 継続判定
        if (0 < this._times) { // イベントシーケンスを繰り返すとき
            // イベント時刻にThink time（指数分布）を加える
            var nextTime = this.getTime() + this._thinkTimeMin;
            if (this._thinkTimeMin < this._thinkTime) {
                nextTime += Math.ceil(Math.abs( // #61
                        __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Random"]().exponential(this._thinkTime - this._thinkTimeMin)));
            }
            // 処理の先頭に戻る
            return this.start(nextTime);
        }
        // イベントシーケンスを継続しない時(this._times < 0)
        this._times--;       // イベントシーケンスの繰り返し回数を1減らす
        this._sequenceIdx = this._sequence.length; // #61 処理完了状態にする
        this._startTime = this._sequenceTime; // #61
        return undefined;
    };

    /* new */
    return VirtualApp;
}());

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);

/**
 * @memberOf Simulator
 * @class VirtualResource
 * @classdesc 仮想リソース
 * 
 * @param {Object}
 *            system 仮想システム（シミュレーション中の現在時刻取得等に用いる）
 * @param {String}
 *            [name = "unlimited"] リソース名（"unlimited"はリソース解放待ちを管理しない）
 * @param {Number}
 *            [holdCapacity = 1.0] 保有リソース総量（数）
 * @param {Number}
 *            [timeout = 10秒] 処理のタイムアウト時間（未使用）
 * @param {Number}
 *            [waitCapacity = Number.MAX_SAFE_INTEGER]
 *            リソース取得待ちキューの深さ（数）、キュー溢れ時は即時エラー終了しリソース処理しない
 * @param {Number}
 *            [queueWait = 10秒] 最大キュー滞留時間（リソース取得待ちタイムアウト時間）
 * @param {Boolean}
 *            [log=false] 詳細ログ出力有無
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #53
    /** @constructor */
    function VirtualResource(system, name,
                        holdCapacity, timeout, waitCapacity, queueWait, log){
        if(!(this instanceof VirtualResource)){
            return new VirtualResource(system, name,
                        holdCapacity, timeout, waitCapacity, queueWait, log);
        }
        this._system = system;
        this._name = name || "unlimited";
        this._log = log ? +log : 0; // #59

        // 処理待ち管理用
        this._waitTimeout = (typeof(queueWait) !== "undefined")
                                ? queueWait : 10000;   // キュー滞留時間上限
        this._waitCapacity  = (typeof(waitCapacity) !== "undefined")
                                ? waitCapacity : Number.MAX_SAFE_INTEGER; // キューの深さ
        this._waitHeap = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Heap"](    // リソース解放待ちキュー（登録時間順）
                function(obj){ return obj.getTime(); });
        
        // リソース管理用
        this._holdTimeout  = (typeof(timeout)  !== "undefined") 
                                ? timeout : 10000;   // 処理のタイムアウト時間
        this._holdCapacity = (typeof(holdCapacity) !== "undefined")
                                ? holdCapacity : 1.0;   // 保有リソース量（数）
        this._holdingQty = 0;   // 使用リソース量
        this._holdHeap = __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Heap"]( // 処理のタイムアウト管理用ヒープ{obj:,val:} #59
                 function(node){ return node.val; }, // valはタイムアウト時刻
                 function(node){ return node.obj; }); // objはvApp
        
        // イベントスケジュール制御用
        this._sequenceTime = 0;   // シミュレータに登録したイベントの時刻（タイムアウトチェック用）
        this._isScheduled = false; // シミュレータにタイムアウトチェックイベントをスケジュールしたか
        if (0 < this._waitTimeout && 0 < this._holdTimeout){ // スケジュール間隔 #61
            this._interval = Math.min(this._waitTimeout, this._holdTimeout);
        } else if (0 < this._waitTimeout) {
            this._interval = this._waitTimeout;
        } else if (0 < this._holdTimeout) {
            this._interval = this._holdTimeout;
        } else {
            this._interval = 0;
        }
    }

    /** @private */
    //

    // public
    /**
     * リソースチェックイベント（タイムアウトチェック）を開始する
     * 
     * @memberof Simulator.VirtualResource
     * @param {Number}
     *            startTime 開始時刻（UNIX時刻：ミリ秒）
     * @param {Object}
     *            system VirtualSystem
     * @return {Object} イベント(this)
     */
    VirtualResource.prototype.start = function(startTime, system) { // #59
        this._sequenceTime = startTime + this._interval; // シミュレータに登録するイベントの時刻
        system.setEvent(this);    // シミュレータにタイムアウトチェックイベントをスケジュールする
        this._isScheduled = true; // 「シミュレータにタイムアウトチェックイベントをスケジュールしたかフラグ」をON
        return this;
    };
    
    /**
     * イベント時刻を返却する
     * 
     * @memberof Simulator.VirtualResource
     * @return {Number} イベント時刻（UNIX時刻：ミリ秒）
     */
    VirtualResource.prototype.getTime = function() {
        return this._sequenceTime;
    };
    
    /**
     * タイムアウトチェック用仮想イベント
     * 
     * @memberof Simulator.VirtualResource
     * @param {Object}
     *            system VirtualSystem
     * @return {Array}再スケジュールするイベント（仮想アプリケーションorリソース）の配列、登録処理完了時はthisを含まない
     */
    VirtualResource.prototype.next = function(system) {
        var events = []; // 戻り値
        var now = this.getTime();
        // リソース解放待ち時間がタイムアウトしたappをタイムアウトさせる
        var queuedTime = Number.MIN_SAFE_INTEGER; 
        while (0 < this._waitHeap.size() && this._waitTimeout <= now - queuedTime) {
            queuedTime = this._waitHeap.top().getTime();
            if (this._waitTimeout <= now - queuedTime) { // キューイング取引がタイムアウトしているとき
                // リソース解放待ちHeapからfreeするappを取り出す
                var app = this._waitHeap.pop();
                // appをアベンドさせる(holdリソース解放なし）
                var apps = app.abend(system, this, "E_QTO", this._name + " queue timeout",
                        false, queuedTime + this._waitTimeout); // appにfree時刻をセットする
                // appsをスケジュールイベント登録対象に加える
                if (apps.length){
                    events = events.concat(apps);
                }
            }
        }
        // リソース使用時間がタイムアウトしたappをタイムアウトさせる #59
        var holdTimeoutTime = Number.MIN_SAFE_INTEGER;
        while (0 < this._holdHeap.size() && holdTimeoutTime <= now) {
            var top = this._holdHeap.top();
            holdTimeoutTime = top.val;
            if (holdTimeoutTime <= now) { // 処理中取引がタイムアウトしているとき #61
                var app = top.obj;
                // appがスケジュールされている場合削除する（スケジューラに登録されていない場合何も起きない）
                system.removeEvent(app);
                // appの使用時間がタイムアウトしたリソースを解放する（注：abendで解放させると永久ループする）
                events = events.concat(this.free(app));                
                // appをタイムアウト時刻にアベンドさせる(holdリソース解放を伴う）
                events = events.concat(app.abend(system, this,"E_HTO", 
                            this._name + " hold timeout", false, holdTimeoutTime));
            }
        }
        // 次回タイムアウトチェック時刻を設定する
        if ((0 < this._waitHeap.size()) || (0 < this._holdHeap.size())) {
            // タイムアウトの設定があるとき、 #61
            // リソース解放待ちvAppがあるとき、(タイムアウトしていない)最古vAppのタイムアウト時刻
            // リソース解放待ちvAppがないとき、現在からタイムアウト時刻後 にスケジュールする
            var nextWaitTimeout = Number.MAX_SAFE_INTEGER;
            if (0 < this._waitTimeout) {
                if ( 0 < this._waitHeap.size() 
                        && now <= this._waitTimeout + this._waitHeap.top().getTime()) {
                    nextWaitTimeout = this._waitHeap.top().getTime() + this._waitTimeout; 
                } else {
                    nextWaitTimeout = now + this._waitTimeout;
                }
            }            
            var nextHoldTimeout = Number.MAX_SAFE_INTEGER;
            if (0 < this._holdTimeout) {
                if(0 < this._holdHeap.size()) {
                    nextHoldTimeout = this._holdHeap.top().val;
                } else {
                    nextHoldTimeout = now + this._holdTimeout;
                }
            }
            this._sequenceTime = Math.min(nextWaitTimeout, nextHoldTimeout);
            if (this._sequenceTime < Number.MAX_SAFE_INTEGER) {
                events.push(this); // タイムアウトチェックイベントをケジュールイベント登録対象に加える
            } else {
                this._isScheduled = false;
            }
        } else { 
            // 以外のとき、シミュレータにタイムアウトチェックイベントを再スケジュールしない
            this._isScheduled = false;
        }
        return events;
    };

    /**
     * リソースを取得する
     * 
     * @memberof Simulator.VirtualResource
     * @param {Object}
     *            system VirtualSystem
     * @param {Object}
     *            vApp リソースにhold要求する仮想AP
     * @return {Objcet} 処理結果{result:boolean, events:Array}<br>
     *         {boolean} result :
     *         true:正常（リソース取得、取得待ち、取得不要）、false:エラー（リソース枯渇E_QOF)）<br>
     *         {Array} :events リソース取得後、スケジューラに登録するイベントの配列<br>
     *         [vApp]： リソースを取得できたとき、もしくはリソース枯渇時でvApp再処理の場合、スケジュール対象の vApp
     *         が登録された配列[vApp]を返却<br>
     *         []： リソース待ちに登録されたとき、既にリソースが管理するスケジューラに登録さているので、空の配列[]を返却<br>
     *         もしくはリソース枯渇時で繰返し完了時、再スケジュールしないので[]を返却
     */
    VirtualResource.prototype.hold = function(system, vApp) {
        var ret = { result : true,
                    events : [vApp] }; // 戻り値 #61
        if (this._name === "unlimited") return ret; // [vApp] リソース解放待ちを管理しないとき
        vApp.logger(4, this._log, vApp._sequenceTime, vApp, this, 'HOLD' , undefined);
        // タイムアウトチェックイベントがスケジュールされていないとき、スケジュールする
        if (!this._isScheduled && (0 < this._interval)) {
            this.start(system.getTime(), system);
        }
        // リソースを取得できるとき、使用リソース量（数）を増やし、実行中処理管理ヒープに登録し、スケジュール対象とする
        var amount = vApp.getAmount(this); // 消費リソース量(デフォルト1.0）
        if (amount <= (this._holdCapacity - this._holdingQty)) {
            // 使用リソースを増やす
            this._holdingQty += amount;
            // タイムアウト管理対象リソースのとき、vAppをタイムアウト管理対象に加える #59
            if (0 < this._holdTimeout) {
                this._holdHeap.push({obj: vApp, val: system.getTime() + this._holdTimeout});
            }
            vApp.logger(3, this._log, system.getTime(), vApp, this, 'hold' , undefined);
            return ret; // [vApp]
        }

        // リソース解放待ちキューに空きがあるとき、vAppをリソース解放待ちに 登録する（スケジュールしない）
        if ((this._waitHeap.size() < this._waitCapacity) && (0 < this._waitTimeout)){
            // リソース解放待ちタイムアウト管理対象に加える
            this._waitHeap.push(vApp);
            vApp.addHistory("wait:" + this._name, system.getTime()); // #61
            vApp.logger(3, this._log, system.getTime(), vApp, this, 'wait' , undefined);
            return { result: true, events: [] };
        }
        
        // リソース解放待ちキューが溢れていた時、リソースを取得できずにアベンド（リソース解放なし、自AP継続の場合[vApp]をリターン） #61
        var apps = vApp.abend(system, this, "E_QOF",
                    "[" + this._name + "] over flow", false);
        vApp.logger(3, this._log, system.getTime(), vApp, this, 'over' , undefined);
        return { result: false, events: apps }; // #61
    };

    /**
     * 引数vAppが使用していたリソースを解放する
     * 
     * @memberof Simulator.VirtualResource
     * @param {Object}
     *            vApp リソースにfree要求する仮想AP
     * @param {Boolean}
     *            [isHolding=true] 該当vAppが自リソースをholdしているか否か<br>
     *            false指定時、指定vAppはリソースをholdしていない前提で、hold vApp一覧からの削除処理を行わない
     * @return {Array} スケジューラに登録するイベントの配列([vApp] | [])
     */
    VirtualResource.prototype.free = function(vApp, isHolding) { // #59
        vApp.logger(4, this._log, this._system.getTime(), vApp, this, 'FREE' , undefined);
        isHolding = (typeof(isHolding) === "boolean") ? isHolding : true;
        if (this._name === "unlimited") return []; // リソース解放待ちを管理しないとき
        var vApps = []; // 戻り値
        // 自リソースを使用している可能性があるとき、使用リソースを解放する
        // 解放したvAppが使用していたリソース量(デフォルト1.0）を、使用リソース量（数）から減らす #59
        if (isHolding === true) { // #61
            this._holdingQty -= vApp.getAmount(this);
            // タイムアウト管理対象リソースのとき、vAppをタイムアウト管理対象から削除する #61
            if (0 < this._holdTimeout) { // #61
                var app = this._holdHeap.del(vApp);
            }
            vApp.addHistory("free:" + this._name, this._system.getTime());
            vApp.logger(3, this._log, this._system.getTime(), vApp, this, 'del' , undefined);
        }
        // リソース解放待ちキューから、空きリソースで処理できるようになったvAppを取り出しスケジュールする #61
        var marginQty = this._holdCapacity - this._holdingQty;
        var addQty = this._waitHeap.top()
                    ? this._waitHeap.top().getAmount(this) // 次のリソース解放待ちキューの使用量
                    : Number.MAX_SAFE_INTEGER;
        for (var i = this._waitHeap.size() && addQty <= marginQty; 0 < i; i--) {
            // リソース解放待ちキューからfreeするappを取り出す
            var app = this._waitHeap.pop();
            // appにfree時刻をセットし、スケジュールイベント登録対象に加える
            // (注：リソース取得はスケジュール後、E_HTOに伴う他のリソースの時刻は将来）
            app.setSequenceTime(this._system.getTime(), "release:" + this._name);
            vApps.push(app);
            // 次のappのリソース量を加える
            addQty += this._waitHeap.top() 
                    ? this._waitHeap.top().getAmount(this) // 次のリソース解放待ちキューの使用量
                    : Number.MAX_SAFE_INTEGER;
        }
        return vApps;
    };


    /**
     * 引数vAppをリソース開放待ちキューからリリースする
     * 
     * @memberof Simulator.VirtualResource
     * @param {Object}
     *            vApp リリースする仮想AP
     * @return {Object | undefined} リリースした仮想AP
     */
    VirtualResource.prototype.release = function(vApp) { // #61
        var app = this._waitHeap.del(vApp);
        if (app) vApp.addHistory("release", this._system.getTime());
        return app;
    }

    
    
    /**
     * イベント終了時処理（リソースが管理しているvAppをfinishさせる（強制終了させ処理中vAppはTATログ出力する）
     * 
     * @memberof Simulator.VirtualResource
     * @param {Object}
     *            system VirtualSystem
     * @param {String}
     *            [logID="N_000"] ログID（ログメッセージの先頭文字）
     * @param {String}
     *            [logMesseage=""] ログメッセージ
     * @param {Number}
     *            forceTime 強制終了時刻を指定する（ミシュレーション停止後のeTat強制出力用）
     * @return {null}
     */
    VirtualResource.prototype._finish = function(system, logID,
                                        logMesseage, forceTime) { // #59
        // シミュレーション終了後処理（処理中のvAppを強制終了する）
        logID = logID || "N_EoS";
        logMesseage = logMesseage || "";
        while(0 < this._waitHeap.size()){
            event = this._waitHeap.pop();
            if (event._finish) {
                event._finish(system, logID,
                        "[" + this._name + "] " + logMesseage , forceTime);
            }
        }
    }

    /* new */
    return VirtualResource;
}());

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__simulator_VirtualSystem_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util_js__ = __webpack_require__(0);


/**
 * @memberOf Simulator
 * @class virtualSystemByJson
 * @classdesc 仮想システム生成ツール(virtualSystemByJson)
 *            <p>
 *            Util管理用クラス（スタティックメソッドのみ）のためコンストラクタは使用しない
 */
/* harmony default export */ __webpack_exports__["a"] = (function() { // #53
    /** @constructor */
    function virtualSystemByJson(){
        if(!(this instanceof virtualSystemByJson)){
            return new virtualSystemByJson();
        }
    }

    /** @private */
    //

    // public

    // static
    /**
     * 初期表示用サンプルデータ(ETAT)を自動生成する
     * 
     * @memberof Simulator.VirtualSystemByJson
     * @param {String}
     *            [jsonText] シミュレーション条件JSONテキスト
     * @return {ETAT} 終了時刻のTAT（応答時間）時系列データ [{x:終了時刻(UNIX時刻の経過時間(秒)),
     *         y:レスポンス(秒)}]
     */
    // CreateSampleTatLog
    virtualSystemByJson.Execute = function(jsonText){ // #53
        var vSys = {};
        // parse
        var json = JSON.parse(jsonText)
        // virtual system と resources の設定
        var log = (json.log !== undefined) ? json.log : false; // #59
        var start = (json.start !== undefined) 
                    ? __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2D"](json.start) : new Date(1970,1,2);
        var end = start + __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](json.end, "24*h");
        var resources = json.resources;
        for (var i = 0; i < resources.length; i++) {
            resources[i].timeout = __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](resources[i].timeout, "10*sec");
            resources[i].qWait = __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](resources[i].qWait, "10*sec");
        }
        vSys = Object(__WEBPACK_IMPORTED_MODULE_0__simulator_VirtualSystem_js__["a" /* default */])(start, end, json.resources, log);
        // model の取得
        var models = json.models;
        for (var i = 0; i < models.length; i++) {
            var model = models[i];
            var name = Object.keys(model)[0]; // モデルの名称
            var m = model[name]; // モデル
            var baseModel = m.baseModel; // baseModel
            for (var j = 0; j < m.sequence.length; j++) {
                // 時間指定文字列を、ミリ秒数値に変換する（例："3*sec"->3000)
                m.sequence[j].tatMin = __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](m.sequence[j].tatMin);
                m.sequence[j].tat = __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](m.sequence[j].tat);
            }
            // sequenceに、baseModelを展開し、未開放リソースの開放処理を登録する
            models[name] = __WEBPACK_IMPORTED_MODULE_0__simulator_VirtualSystem_js__["a" /* default */].getModel(
                        baseModel.holds, 
                        __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](baseModel.tatMin), __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](baseModel.tat),
                        m.sequence, 
                        (typeof(m.times) === "number") ? m.times : 1, // #61
                        __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](m.thinkTimeMin), __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](m.thinkTime)); 
        }
        // client の設定
        var clients = json.clients;
        for (var i = 0; i < clients.length; i++) {
            var c = clients[i];
            var cStart = start + __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](c.start, 0);
            var cEnd   = start + __WEBPACK_IMPORTED_MODULE_1__util_util_js__["S2N"](c.end, 24*60*60*1000);
            vSys.setClients(c.user, c.message, c.num, cStart, cEnd, models[c.model]);
        }
        if (1 < log) console.log(vSys); // #59
        return vSys.execute();
    }

    /**
     * シミュレーション条件JSONテキストを作成する
     * 
     * @memberof Simulator.VirtualSystemByJson
     * @param {Number}
     *            [n = 0] シナリオ番号
     * @return {String} シミュレーション条件JSONテキスト
     */
    // CreateSampleTatLogJson
    virtualSystemByJson.GetJsonConfig = function(n){ // #53
        n = (typeof(n) !== "undefined") ? n : 0;
        var jsonText = "";
        if (n === 0) {
            jsonText =  '{\n'
                + '"log" : 1,\n'
                + '"start" : "2017/01/02 00:00:00.000",\n'
                + '"end"   : "17.0*h",\n'
                + '"resources" : [\n'
                + '  {"type" :"WEB", "thread":1024,"timeout":"300*sec", "q":1280, "qWait":0},\n'
                + '  {"type" :"AP",  "thread":20,  "timeout":"300*sec", "q":1280, "qWait":0},\n'
                + '  {"type" :"DB",  "thread":10,  "timeout": "10*sec", "q":10,  "qWait":"10*sec"}\n'
                + '],\n'
                + '\n'
                + '"models" : [\n' // 取引モデル一覧
                + '  { "ON-1" : {\n' // オンライン取引1
                + '    "times": 60, "thinkTimeMin":"3*sec", "thinkTime": "10*sec",\n'
                + '    "baseModel":  {"holds": ["WEB","AP","DB"], "tatMin": "2*ms", "tat":"5*ms"},\n'
                + '    "sequence": [\n'
                + '      {"tatMin":30, "tat":50, "note":"select A"},\n'
                + '      {"tatMin":50, "tat":50, "note":"updateB", "hold":"TBL_B"},\n'
                + '      {"tatMin":80, "tat":100,"note":"updateC", "hold":"TBL_C"}\n'
                + '    ]}},\n'
                + ' { "ON-2" : {\n' // オンライン取引2
                + '    "times": 60, "thinkTimeMin":"500*ms", "thinkTime": "1*sec",\n'
                + '    "baseModel":  {"holds": ["WEB","AP","DB"], "tatMin": "2*ms", "tat":"5*ms"},\n'
                + '    "sequence": [\n'
                + '      {"tatMin":"100*ms", "tat":"500*ms", "hold":""}\n'
                + '    ]}},\n'
                + ' { "BATCH-1" : {\n' // バッチ取引3
                + '    "baseModel":  {"holds": ["DB"], "tatMin": "2*ms", "tat":"5*ms"},\n'
                + '    "sequence": [\n'
                + '      {"tatMin":"2*sec","tat":"5*sec","note":"updateB","hold":"TBL_B"}\n'
                + '    ]}}\n'
                + '],\n'
                + '\n'
                + '"clients" : [\n' // ユーザ作成条件
                + '  {"num":100,"start":"16.0*h", "end":"17.0*h", "model":"ON-1",  "user" :"userU", "message":"select A update B,C"},\n'
                + '  {"num": 20,"start":"16.5*h", "end":"16.6*h", "model":"ON-1",  "user" :"userT", "message":"select A update B,C 【増】"},\n'
                + '  {"num":100,"start":"16.0*h", "end":"17.0*h", "model":"ON-2",  "user" :"userS", "message":"排他なし(WEBのみ)"},\n'
                + '  {"num": 20,"start":"16.0*h", "end":"17.0*h", "model":"BATCH-1","user":"userB", "message":"バッチ処理 update B＊＊＊＊＊"}\n'
                + ']\n'
                + '}\n';
        } else if (n === 1) {
            // test用
            jsonText =  '{\n'
                + '"//" : "log（任意、デフォルト3）:詳細ログ出力指定(0:なし, 1:エラー時のみ, 2:+ETAT, 3:+push/pop, 4:+HOLD/FREE)",\n'
                + '"//" : "start/end:シミュレーション開始時刻/終了時刻",\n'
                + '"log" : 1,\n'
                + '"start" : "1970/01/02 00:00:00.000",\n'
                + '"end"   : "30.0*sec",\n'
                + '\n'
                + '"//" : "resources:sequenceのhold/freeで指定するリソース名の定義",\n'
                + '"//" : "type:リソース名、thread:最大同時hold数、timeout：holdタイムアウト時間",\n'
                + '"//" : "　　　　　　　　　　　q:最大hold待ち数、qWait:最大hold待ち時間",\n'
                + '"resources" : [\n'
                + '  {"type" :"DB",  "thread":2,  "timeout": "5*sec", "q":1,  "qWait":"2*sec"}\n'
                + '],\n'
                + '\n'
                + '"//" : "models:clientsで指定するモデル名(model)の定義、以下modelsで指定できる項目",\n'
                + '"//" : "baseModel:複数リソースのsequenceをまとめて宣言できる、sequenceに展開した後処理される、任意指定",\n'
                + '"//" : "sequence:指定された順にリソースを取得する、配列内に複数指定可、sequenceも複数指定可",\n'
                + '"//" : "hold：リソース名、holds(baseModelのみ指定可）：リソース一覧、各々にtat/tatMinが適用される",\n'
                + '"//" : "tat/tatMin：リソースの取得に要する平均/最小時間、tatMinのデフォルトはtat",\n'
                + '"//" : "　　　　　　★注：tatはリソースの使用時間ではない、リソース使用時間を指定す場合はfreeで指定",\n'
                + '"//" : "数値はミリ秒単位、*ms,*sec,*min,*h,*day 指定可",\n'
                + '"//" : "times：繰返し回数",\n'
                + '"//" : "thinkTime/thinkTimeMin：繰返し時の間隔の平均/最小時間、thinkTimeMinのデフォルトはthinkTime",\n'
                + '"//" : "free：[リソース名の配列]、指定リソースを開放する、free指定の無いリソースはシーケンスの最後にfreeされる",\n'
                + '"models" : [\n' // 取引モデル一覧
                + ' { "TEST-AB" : {\n' // テスト取引
                + '    "baseModel":  {"holds": ["DB"], "tatMin": "2*ms", "tat":"2*ms"},\n'
                + '    "sequence": [{"hold":"TBL_A", "tatMin":"1*sec", "tat":"1*sec"}],\n'
                + '    "sequence": [{"hold":"TBL_B", "tatMin":"3*sec", "tat":"3*sec"}],\n'
                + '    "times": 2, "thinkTimeMin":"1*sec", "thinkTime": "1*sec"}},\n'
                + ' { "TEST-BA" : {\n' // テスト取引
                + '    "baseModel":  {"holds": ["DB"], "tatMin": "2*ms", "tat":"2*ms"},\n'
                + '    "sequence": [{"hold":"TBL_B", "tatMin":"1*sec", "tat":"1*sec"}],\n'
                + '    "sequence": [{"hold":"TBL_A", "tatMin":"3*sec", "tat":"3*sec"}],\n'
                + '    "times": 2, "thinkTimeMin":"1*sec", "thinkTime": "1*sec"}}\n'
                + '    ],\n'
                + '\n'
                + '"//" : "clients：仮想アプリケーションの起動クライアントの定義",\n'
                + '"//" : "num:作成クライアント数、start～endの間で、ランダム（指数分布）に指定回数起動する",\n'
                + '"//" : "start/end:仮想クライアント作成/終了時刻、先頭で宣言したstartからの相対時刻",\n'
                + '"//" : "model:modelsで宣言したモデル名",\n'
                + '"//" : "user:user+通番 のユーザ名で仮想クライアントが作成される",\n'
                + '"clients" : [\n' // ユーザ作成条件
                + '  {"num": 1,"start":"0*sec", "end":"0*sec", "model":"TEST-AB","user" :"testAB1"},\n'
                + '  {"num": 1,"start":"1*sec", "end":"1*sec", "model":"TEST-AB","user" :"testAB2"},\n'
                + '  {"num": 1,"start":"3*sec", "end":"3*sec", "model":"TEST-BA","user" :"testBA3"},\n'
                + '  {"num": 1,"start":"4*sec", "end":"4*sec", "model":"TEST-BA","user" :"testBA4"}\n'
                + ' ]\n'
                + '}\n';
        }

        return jsonText; 
    }

    /* new */
    return virtualSystemByJson;
}());

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MenuConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Init_js__ = __webpack_require__(3);



/**
 * @memberOf Simulator
 * @class MenuConfig
 * @classdesc シミュレータ用メニューHTML定義
 * 
 */
function MenuConfig() {} // #74

MenuConfig.config = function() {
    // Simulator Config用関数定義(radio用） #53
    var func_S_SIMU_000 = function(){ Object(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Init_js__["CreateSampleTatLogAndChartShow"])(0); };
    var func_S_SIMU_001 = function(){ Object(__WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Init_js__["CreateSampleTatLogAndChartShow"])(1); };
    // Simulator Config設定画面定義 #53
    var prefix = "Simulator";
    var c = new  __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"](prefix);
        c    // #53
         .n("<br>")
         .label(null," If you change the scenario below,").n()
         .label(null,"JSON is initialized and re-simulated.").n()
         .n("<br>")
         .name("S_SIMU")
             .radio("S_SIMU_000", null, 
                       "1 hour with table(B) lock.<br>"
                     + "- online[100-500ms 2-5tps]<br>" 
                     + "- batch[2-5sec evry3min]",
                     true ,null, func_S_SIMU_000).n()
             .radio("S_SIMU_001", null, "for test", 
                     false ,null, func_S_SIMU_001).n()
     ;
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MenuConfigFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Graph_js__ = __webpack_require__(1);



/**
 * @memberOf TimeSeries
 * @class MenuConfigFilter
 * @classdesc FileParser用メニューHTML定義
 * 
 */
function MenuConfigFilter() {} // #76

MenuConfigFilter.config = function () {
    var prefix = "Filter";
    var c = new  __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"](prefix);
    // Filter Config用関数定義(radio用） #51
    var func_F_SYNC_UPPER = function(){ __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Graph_js__["default"].DrawCallback(HJN.chart.graph); };
    var func_F_SYNC_DETAIL = function(){ __WEBPACK_IMPORTED_MODULE_1__tatLogDiver_tatLogDiver_Graph_js__["default"].DrawCallback(HJN.chartD.graph); };
    // Filter Config設定画面定義 #51
    c // #53
        .name("F_SYNC").label(null,"Sync") // #50
            .radio("F_SYNC_UPPER", null, "Upper", false ,null, func_F_SYNC_UPPER) // #51
            .radio("F_SYNC_DETAIL", null, "Detail", false, null, func_F_SYNC_DETAIL)
            .radio("F_ASYNC", null, "Async", true).n()
        .label(null,"<B>----- Data filter condition--------</B>").n()
            .n("<br>")
            .name("F_TIME").label(null, "<B>[Date filter]</B>").n()
            .label(null,"Include if end time is between").n()
                .text("F_TIME_FROM", null, null, null, 'size="23" placeholder="YYYY/MM/DD hh.mm.ss.000"') // #92
                .label(null,"and").n()
                .text("F_TIME_TO", null, null, null, 'size="23" placeholder="YYYY/MM/DD hh.mm.ss.000"').n() // #92
            .n("<br>")
            .name("F_TAT").label(null,"<B>[Turnaround time(TAT) filter]</B>").n()
            .label(null,"Include if TAT is between").n()
                .number("F_TAT_FROM", null, null, "0", 'style="width:80px;"')
                .number("F_TAT_TO", "and", null, null, 'style="width:80px;"').n()
            .n("<br>")
            .name("F_TEXT").label(null,"<B>[Text filter]</B>").n()
                .radio("F_TEXT_NON", null, "Don't use.", true)
                .radio("F_TEXT_INCLUDE", null, "Include ")
                .radio("F_TEXT_EXCLUDE", null, "Exclude ").n()
                .number("F_TEXT_LEN", "if ", " bytes", null, 'style="width:40px;"')
                .number("F_TEXT_POS", "from the ", "th byte", "1", 'style="width:40px;"').n()
                .number("F_TEXT_COL", "from head of the", "th column of CSV", "3", 'style="width:40px;"').n()
                .text("F_TEXT_REG", "match the regular expression", null, null, 'size="7" placeholder=".*"').n()
            .n("<br>")
    ;
}

MenuConfigFilter.reset = function () {
    // メニュー画面フィルタ条件に、初期値を設定する
    var c = new __WEBPACK_IMPORTED_MODULE_0__util_util_js__["Config"]("Filter");
    c.setText("F_TIME_FROM", null);
    c.setText("F_TIME_FROM", null);
    c.setText("F_TIME_TO", null);
    c.setText("F_TAT_FROM", 0);
    c.setText("F_TAT_TO", null);
    c.setSelector("F_TEXT_NON");
    c.setText("F_TEXT_LEN", null);
    c.setText("F_TEXT_POS", 1);
    c.setText("F_TEXT_COL", 3);
    c.setText("F_TEXT_REG", null);
}


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tatLogDiver": 6,
	"./tatLogDiver-Copyright": 8,
	"./tatLogDiver-Copyright.js": 8,
	"./tatLogDiver-Graph": 1,
	"./tatLogDiver-Graph.js": 1,
	"./tatLogDiver-HJN": 2,
	"./tatLogDiver-HJN.js": 2,
	"./tatLogDiver-Init": 3,
	"./tatLogDiver-Init.js": 3,
	"./tatLogDiver-Menu": 7,
	"./tatLogDiver-Menu.js": 7,
	"./tatLogDiver-MenuConfigDetailGraph": 10,
	"./tatLogDiver-MenuConfigDetailGraph.js": 10,
	"./tatLogDiver-Plot": 9,
	"./tatLogDiver-Plot.js": 9,
	"./tatLogDiver-Usage.html": 46,
	"./tatLogDiver.css": 13,
	"./tatLogDiver.js": 6
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n<meta charset=\"UTF-8\">\r\n<title>Insert title here</title>\r\n</head>\r\n<body>\r\n<p>Ver. b19.06.30, Last update: 2019/06/30, (c)2017-2019 hirosejn </p>\r\n<h1 id=\"index\">Index</h1>\r\n<p><a href=\"#environment\"><strong>Environment　動作環境</strong></a></p>\r\n<p><a href=\"#items\"><strong>Items　画面の構成要素</strong></a></p>\r\n<p><a href=\"#graph\"><strong>Graph　グラフの操作方法</strong></a></p>\r\n<p><a href=\"#menu\"><strong>Menu　メニューの操作方法</strong></a></p>\r\n<ol>\r\n<li><a href=\"#menu-file\">&gt; File</a></li>\r\n<li><a href=\"#menu-filter\">&gt; Filter</a></li>\r\n<li><a href=\"#menu-simulator\">&gt; Simulator</a></li>\r\n<li><a href=\"#menu-view\">&gt; View</a></li>\r\n<li><a href=\"#menu-download\">&gt; Download</a></li>\r\n<li><a href=\"#menu-bottomdetailgraph\">&gt; Bottom detail graph</a></li>\r\n<li><a href=\"#menu-help\">&gt; Help</a></li>\r\n</ol>\r\n<p><a href=\"#simulator\"><strong>Simulator　シミュレーションシナリオの仕様</strong></a></p>\r\n<ol>\r\n<li><a href=\"#simulator-01\">Simulator-01　サンプル01(1 hour with table block.)の仕様</a></li>\r\n<li><a href=\"#simulator-99\">Simulator-99　サンプル99(for test)の仕様</a></li>\r\n</ol>\r\n<hr>\r\n<h2 id=\"environment\">Environment</h2>\r\n<h2 id=\"動作環境-↑\">動作環境　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n\t<li><p>Chrome：Ver74以降にて動作検証（推奨）</p></li>\r\n\t<li><p>Edge：基本動作検証済</p></li>\r\n\t<li><p>ie8 ：基本動作検証済、注：Chroneに比べ5倍程度遅い。</p></li>\r\n</ul>\r\n<hr>\r\n<h2 id=\"items\">Items</h2>\r\n<h2 id=\"画面の構成要素-↑\">画面の構成要素　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n\t<li><strong>右メニュー</strong>\r\n\t\t<br>：機能をアコーディオンメニュー形式で表示</li>\r\n\t<li><strong>右上メッセージエリア</strong>\r\n\t\t<br>：ファイル読込処理結果等のメッセージを表示（ダイアログの操作で移動／リサイズ可）</li>\r\n\t<li><strong>上段全体グラフ</strong>\r\n\t\t<br>：指定ファイルを、フィルター条件でフィルターしたデータを表示</li>\r\n\t<li><strong>下段詳細グラフ</strong>\r\n\t\t<br>：上段表示データのうち「下段詳細グラフ表示条件」による指定期間のデータを表示</li>\r\n\t<li><strong>下段データ表示エリア</strong>\r\n\t\t<br>：下段詳細グラフで、マウスオーバにより選択されたプロットに該当する、ファイルのレコードを表示。（ダイアログの操作で移動／リサイズ可）</li>\r\n\t<li><strong>ダイアログ</strong>：\r\n\t\t<br>【閉じる】：ダイアログ右上のバツボタン。\r\n\t\t<br>【移動】：上部にマウスオーバすると表示されるグレーのバーをドラッグする。\r\n\t\t<br>【リサイズ】：四隅四辺にマウスオーバし、マウスがリサイズアイコンになった状態からドラッグする。</li>\r\n</ul>\r\n<hr>\r\n<h2 id=\"graph\">Graph</h2>\r\n<h2 id=\"グラフの操作方法-↑\">グラフの操作方法　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n\t<li><p><strong>マウスオーバー</strong> ：X軸の最も近い時刻のプロットが選択され強調表示される。</p>\r\n\t<blockquote>\r\n\t\t<p>　下段グラフの場合は、選択プロットの時刻に同時処理(CONC)している処理の開始時刻―終了時刻を結ぶ線が表示される（同時処理が視認し易く表示されるので、容易に排他解放待ちの有無を特定できる）。下部データ表示エリアに、選択プロットの元ファイルのレコードが表示される（排他処理を容易に特定できる）。</p>\r\n\t</blockquote>\r\n\t</li>\r\n\t<li><p><strong>マウスクリック／タッチ</strong> ：選択されたプロットを基準に、下段詳細グラフが更新され、「下段詳細グラフ表示条件」アイコンが追加される。</p></li>\r\n\t<li><p><strong>マウスドラッグ（横／縦）</strong> ：指定範囲を横幅／縦幅としてグラフを拡大表示する。</p></li>\r\n\t<li><p><strong>マウスダブルクリック</strong> ：マウスドラッグによるグラフの拡大表示をリセットする。（左上の「reset zoom」ボタンも同一機能）</p></li>\r\n</ul>\r\n<hr>\r\n<h2 id=\"menu\">Menu</h2>\r\n<h2 id=\"メニューの操作方法-↑\">メニューの操作方法　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n\t<li><strong>メッセージ表示エリア</strong> ：処理結果メッセージを表示する。マウスによる移動（エリア上部選択）／リサイズに対応。</li>\r\n\t<li><strong>Place on/side</strong> ボタン：メニューをグラフに「重ねる／重ねない」を切り替える。</li>\r\n\t<li><strong>reset zoom</strong> ボタン：グラフの描画サイズを初期化する。（Androidでグラフのダブルクリックができないため設置）</li>\r\n\t<li><strong>バツ／ハンバーガー</strong> ボタン：メニューの「表示／非表示」を切り替える</li>\r\n</ul>\r\n<h3 id=\"menu-file\">Menu-File</h3>\r\n<h2 id=\"メニュー／fileの操作方法-↑\">メニュー／Fileの操作方法　<a href=\"#\">↑</a></h2>\r\n<h4>ボタン</h4>\r\n<ul>\r\n\t<li><p><strong>Open csv data file</strong> ボタン：CSVファイルを選択。ファイルを選択するとグラフを表示する。</p></li>\r\n</ul>\r\n<h4>指定項目</h4>\r\n<ul>\r\n\t<li><p><strong>Open file as</strong> ：データ読込モード指定</p>\r\n\t<blockquote>\r\n\t\t<p> <strong>◎newly</strong> ：新規に読み込む（既存データを破棄） <strong>○append</strong> ：既存データに指定ファイルの内容を追加する</p>\r\n\t</blockquote>\r\n\t</li>\r\n</ul>\r\n<h4>----- File format definition --------</h4>\r\n<ul>\r\n\t<li><p><strong>[Line feed code]</strong> ：CSVファイルの改行コードを指定</p>\r\n\t<blockquote>\r\n\t\t<p><strong>○固定長 &quot;80&quot;byte</strong> ／ <strong>◎Windows:CR(13)+CF(10)</strong>\r\n\t\t\t ／ <strong>○UNIX/Linux:LF(10)</strong> ／ <strong>○zOS:NEL(15)</strong> ／ <strong>○Max:CR(13)</strong>\r\n\t\t\t  ／ <strong>○other charcode (&quot; &quot;)</strong> 文字コード番地を10進で指定</p>\r\n\t</blockquote>\r\n\t</li>\r\n\t<li><p><strong>[Charset]</strong> ：CSVファイルの文字コードを指定（レコードデータ表示時に指定文字コードからUnicodeに変換して表示）</p>\r\n\t<blockquote>\r\n\t\t<p><strong>○Shift-JIS</strong> ／<strong>○EUC-JP</strong> ／  <strong>◎UTF-8</strong> ／ <strong>○Unicode</strong></p>\r\n\t</blockquote>\r\n\t</li>\r\n\t<li><p><strong>[CSV delimiter]</strong> ：CSVファイルのデリミタを指定</p>\r\n\t<blockquote>\r\n\t\t<p><strong>○comma</strong> ：カンマ区切り／ <strong>◎tab</strong> ：タブ区切り／ <strong>○other &quot;,&quot;</strong>  区切り文字を指定する</p>\r\n\t</blockquote>\r\n\t</li>\r\n</ul>\r\n<h4>----- Data format definition --------</h4>\r\n<ul>\r\n\t<li><p><strong>　</strong>CSVのカラムが保有するデータ構成を指定</p>\r\n\t<blockquote>\r\n\t\t<p><strong>○TAT &amp; START time</strong> ／<strong>◎TAT &amp; END time</strong> ／  <strong>○START &amp; END time</strong></p>\r\n\t</blockquote>\r\n\t</li>\r\n\t<li><p><strong>[Timestamp field]</strong> ：終了時刻のフィールドの位置とフォーマットを指定</p>\r\n\t<blockquote>\r\n\t\t<p><strong>&quot;1&quot;th column of CSV</strong>：CSVのカラム位置を指定（デフォルト1カラム目、固定長レコードの場合1を指定）</p>\r\n\t\t<p><strong>Position(byte): from &quot;1&quot; length &quot; &quot;</strong>\r\n\t\t\t：レコード内の固定バイト位置指定　レコードのfromバイト目から、length指定バイト長</p>\r\n\t\t<p><strong>Format</strong> :時刻のフォーマット</p>\r\n\t\t<p><strong>◎text &quot;YYYY/MM/DD hh.mm.ss.000&quot;</strong>\r\n\t\t\t ：指定カラムのYYYY MM DD hh mm ss 000の位置から値を取得（エクセルの表示フォーマット： YYYY/MM/DD hh:mm:ss.000 に相当）</p>\r\n\t\t<p>　／ <strong>◎(num)text</strong> ／ <strong>○long</strong>\r\n\t\t\t ：text：ユリウス日0:00との時差数値　テキスト数値／long(4バイト)数値（別途エンディアン指定)</p>\r\n\t\t<p><strong>Units of numbers:</strong> <strong>○msec</strong> ／ <strong>◎sec</strong>\r\n\t\t\t ：(num)textもしくはlong選択時に、数値の単位をmsec/secから選択</p>\r\n\t</blockquote>\r\n\t</li>\r\n</ul>\r\n<ul>\r\n\t<li><p><strong>[TAT or START/END judgment field]</strong> ：処理時間(TAT)フィールド　もしくは、開始／終了レコード判定フィールド の位置とフォーマットを指定</p>\r\n\t<blockquote>\r\n\t\t<p><strong>&quot;2&quot;th column of CSV</strong>：CSVのカラム位置を指定（デフォルト2カラム目、固定長レコードの場合1を指定）</p>\r\n\t\t<p><strong>Position(byte): from &quot;1&quot; length &quot; &quot;</strong>：固定バイト位置指定　指定カラムのfromバイト目から、length指定バイト長</p>\r\n\t</blockquote>\r\n\t\t<strong>for TAT(turnaround time) condition</strong> ：処理時間(TAT)フィールド　の条件\r\n\t<blockquote>\r\n\t\t<p><strong>Units of numbers:</strong> <strong>○msec</strong> ／ <strong>◎sec</strong>\r\n\t\t\t ：処理時間の単位　msec/secから選択</p>\r\n\t\t<p><strong>Format:◎(num)text</strong> ／ <strong>○long</strong>\r\n\t\t\t ：処理時間のフォーマット　テキスト数値／long(4バイト)数値</p>\r\n\t\t<p><strong>for long Endian:  ◎little</strong> ／ <strong>○big</strong>\r\n\t\t\t ：long指定時のエンディアンを選択　リトルエンディアン／ビッグエンディアン</p>\r\n\t</blockquote>\r\n\t<strong>for START/END judgment condition</strong> ：開始／終了レコード判定フィールド　の条件\r\n\t<blockquote>\r\n\t\t<p><strong>START record: Matches:/\"START\"/</strong>：指定正規表現（デフォルト/START/）に合致するレコードを開始レコードとする</p>\r\n\t\t<p><strong>END record: Matches:/\"END\"/</strong>：指定正規表現(デフォルト/END/)に合致するレコードを終了レコードとする</p>\r\n\t</blockquote>\r\n</ul>\r\n<ul>\r\n<li><p><strong>[START-END pairing KEY field]</strong>\r\n\t\t ：開始／終了レコードなど同一取引と判定するキーフィールドを指定</p>\r\n<blockquote>\r\n\t<p><strong>&quot;3&quot;th column of CSV</strong>\r\n\t\t：CSVのカラム位置を指定（デフォルト2カラム目、固定長レコードの場合1を指定）</p>\r\n\t<p><strong>Position(byte): from &quot;1&quot; length &quot; &quot;</strong>\r\n\t\t：固定バイト位置指定　指定カラムのfromバイト目から、length指定バイト長</p>\r\n\t<p><strong>&amp;Position(Matches reg. exp.):</strong>\r\n\t\t：かつ、以下の正規表現に合致する文字列に間（空欄のときは先頭～末尾）、</p>\r\n\t<p><strong>between /\" \"/ and /\" \"/</strong></p>\r\n\t<p><strong>&amp;Adopt as KEY: Matches /\"[0-9A-Z]+\"/</strong>\r\n\t\t:かつ、指定の正規表現に合致する文字列</p>\r\n</blockquote>\r\n</ul>\r\n<h4>ボタン</h4>\r\n<ul>\r\n\t<li><p><strong>save format (.json)</strong> ボタン\r\n\t\t：メニュー指定項目を、JSON形式のファイルでダウンロードする</p></li>\r\n\t<li><p><strong>load format (.json)</strong> ボタン\r\n\t\t： JSON形式のファイルから、メニュー指定項目を読み込む</p></li>\r\n</ul>\r\n<h3 id=\"menu-filter\">Menu-Filter</h3>\r\n<h2 id=\"メニュー／filterの操作方法-↑\">メニュー／Filterの操作方法　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n<li><p><strong>Sync ○Upper ○Detail ◎Async</strong> 指定：表示しているグラフの条件をフィルター条件に取り込む</p>\r\n<blockquote>\r\n<p>　Upperを選択したタイミングで上段グラフを取り込む／Detailを選択したタイミングで下段グラフ／Asyncを選択した際には何も変更しない</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>[Date filter]</strong> 指定機能</p>\r\n<blockquote>\r\n<p><strong>Include if end time is between &quot;YYYY/MM/DD hh.mm.ss.000&quot; and &quot;YYYY/MM/DD hh.mm.ss.000&quot;</strong> ：</p>\r\n<p>　指定期間のデータのみを上段グラフの表示対象とする。時刻を手入力する作業は時間がかかるので Sync Upper/Detail で現在描画している情報を取り込んでから修正する操作を想定</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>[Turnaround time(TAT) filter]</strong> 指定機能：</p>\r\n<blockquote>\r\n<p><strong>Include if TAT is between &quot;0①&quot; and &quot;数値②&quot;</strong> ：</p>\r\n<p>　処理時間(TAT)が①～②のデータのみを上段グラフの表示対象とする</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>[Text filter]</strong> 指定機能：</p>\r\n<blockquote>\r\n<p><strong>◎Don&#39;t use. ○Include ○Exclude</strong></p>\r\n<p> <strong>if &quot;数値①&quot; bytes from the &quot;1②&quot;th byte from head of the &quot;3③&quot;th column of CSV match the regular expression &quot;④&quot;</strong> ：</p>\r\n<p>　テキストフィルターを使わない／正規表現に合致するデータを処理対象とする／正規表現に合致しないデータを処理対象とする</p>\r\n<p>　CSVレコードの、③番目のカラムの、先頭②バイト目から、①バイトの文字列を、正規表現④に照らして評価</p>\r\n</blockquote>\r\n</li>\r\n</ul>\r\n<h3 id=\"menu-simulator\">Menu-Simulator</h3>\r\n<h2 id=\"メニュー／simulatorの操作方法-↑\">メニュー／Simulatorの操作方法　<a href=\"#\">↑</a></h2>\r\n<p>TAT log diver を起動すると、サンプルシミュレーションシナリオ１を初期表示する。</p>\r\n<ul>\r\n<li><strong>Simulate</strong> ボタン：指定したシミュレーションシナリオを実行しグラフを表示する。</li>\r\n<li><strong>JSON Editor(Open/Close)</strong> ボタン：シミュレーションシナリオ編集画面を開く／編集画面が開いている場合は閉じる。</li>\r\n<li><strong>サンプルシナリオ選択機能</strong> ：サンプルシナリオを選択します。異なるシナリオを選択したタイミングでシミュレーション実行しグラフを再描画する。</li>\r\n</ul>\r\n<h3 id=\"menu-view\">Menu-View</h3>\r\n<h2 id=\"メニュー／viewの操作方法-↑\">メニュー／Viewの操作方法　<a href=\"#\">↑</a></h2>\r\n<p>上4つのチェックボックス（一部機能）で、上段全体グラフ上の表示有無を指定</p>\r\n<p>下7つのチェックボックス（全機能）で、下段詳細グラフ上の表示有無を指定</p>\r\n<ul>\r\n<li><p><strong>多重度（詳細）</strong> ：青　左Y軸　上段なし／下段☒</p>\r\n<blockquote>\r\n<p>同時処理数（多重度）をヒストグラム形式で表示</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>多重度（区間最大）/sec</strong> ：水色　左Y軸　上段☒／下段☒</p>\r\n<blockquote>\r\n<p>1秒間の区間の多重度の最大値</p>\r\n<p>上段グラフ：透過プロットで表示。同一多重度が連続するとプロットが重なり濃く見える</p>\r\n<p>下段グラフ：ヒストグラム形式で表示。多重度（詳細）と重ねて表示すると秒間最大値との関係を把握できる</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>average tps / min (end) [line]</strong> ：緑　左Y軸　上段☒／下段☒</p>\r\n<blockquote>\r\n<p>1分間の平均tps。コンピュータの処理数は1分毎にとられることが多いため、突合しやすいように表示</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>response by start time [Y2軸:plot]</strong> ：黄　右Y軸　上段なし／下段☒</p>\r\n<blockquote>\r\n<p>X軸：処理開始時刻、Y軸(点の高さ)は処理時間</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>response by end time [Y2軸:plot]</strong> ：茶　右Y軸　上段なし／下段☒</p>\r\n<blockquote>\r\n<p>X軸：処理終了時刻、Y軸(点の高さ)は処理時間</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>max response / min (end) [Y2軸:line]</strong> ：赤　右Y軸　上段☒／下段☒</p>\r\n<blockquote>\r\n<p>1分間の最大レスポンス（処理終了時刻ベース）、ヒストグラム風折れ線で表示</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>average response / min (end) [Y2軸:line]</strong> ：ピンク　右Y軸　上段☒／下段☐</p>\r\n<blockquote>\r\n<p>1分間の平均レスポンス（処理終了時刻ベース）、ヒストグラム風折れ線で表示。コンピュータの処理数は1分毎にとられることが多いため、突合しやすいように表示機能を設けているがデフォルト非表示</p>\r\n</blockquote>\r\n</li>\r\n</ul>\r\n<h3 id=\"menu-download\">Menu-Download</h3>\r\n<h2 id=\"メニュー／downloadの操作方法-↑\">メニュー／Downloadの操作方法　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n<li><strong>Upper graph image(.png)</strong> ボタン：上段グラフの図をpng形式で、初期ファイル名 graph.png でダウンロード。</li>\r\n<li><strong>Upper graph data(.csv)</strong> ボタン：上段グラフに表示しているデータを、CSV形式で（改行コード、デリミタはFileメニューの指定値を適用）初期ファイル名 graph.csv でダウンロード。</li>\r\n<li><strong>Upper graph log records(.csv)</strong> ボタン：上段グラフに表示しているデータの元データを、処理終了時刻順に、入力ファイルのレコードフォーマット（改行コード、デリミタ等も元ファイルのまま加工せずに適用）で、初期ファイル名 tatlog.csv でダウンロード。<blockquote>\r\n</blockquote>\r\n</li>\r\n<li><strong>Detail graph image(.png)</strong> ボタン：下段グラフに対して上段と同じ処理。</li>\r\n<li><strong>Detail graph data(.csv)</strong> ボタン：下段グラフに対して上段と同じ処理。</li>\r\n<li><strong>Detail graph log records(.csv)</strong> ボタン：下段グラフに対して上段と同じ処理。</li>\r\n<li><strong>Detail conc log records(.csv)</strong> ボタン：下段グラフに表示用に選択したCONC（同時処理数）時に処理しているデータを、処理終了時刻順に、入力ファイルのレコードフォーマットで、初期ファイル名 conclog.csv でダウンロード。（CONC指定時以外の場合はCONC最大値を基準）。</li>\r\n</ul>\r\n<h3 id=\"menu-bottomdetailgraph\">Menu-BottomDetailGraph</h3>\r\n<h2 id=\"メニュー／bottom-detail-graphの操作方法-↑\">メニュー／Bottom detail graphの操作方法　<a href=\"#\">↑</a></h2>\r\n<p>下段詳細グラフの表示条件を指定する</p>\r\n<ul>\r\n<li><p><strong>Range: - &quot;1①&quot; + &quot;2②&quot; &quot;10sec③&quot;</strong> 指定機能：下段グラフの期間を指定する</p>\r\n<blockquote>\r\n<p>「下段詳細グラフ表示条件」の基準時刻を③単位で切り捨てた時刻を基準に、-①数値×③単位　～ +②数値×③単位　を下段グラフの表示データ抽出期間とする。③単位はsec/10sec/min/hour/6hour/day/year から選択</p>\r\n<p>指定値を変更する都度、指定値を「下段詳細グラフ表示条件」に反映し下段グラフを再描画する。なお、グラフ上の範囲指定による表示期間変更は描画のみで「下段詳細グラフ表示条件」には反映されない。</p>\r\n</blockquote>\r\n</li>\r\n<li><p><strong>「下段詳細グラフ表示条件」</strong> アイコン ：下段グラフに表示する条件を選択する機能（初期表示：同時処理数が最大となるタイミングを１つ）</p>\r\n<blockquote>\r\n<p>上段／下段グラフの任意の点をクリックすると、「下段詳細グラフ表示条件」アイコン　が追加される。アイコンは基準時刻順に縦に並ぶ。</p>\r\n<p>下段グラフに表示している「下段詳細グラフ表示条件」アイコンは背景グレー。他のアイコンは背景白</p>\r\n<p>アイコンにマウスをのせると、アイコンの左側にマイナス「－」アイコンが表示され、「－」をクリックすると該当「下段詳細グラフ表示条件」アイコンが削除される。</p>\r\n</blockquote>\r\n</li>\r\n</ul>\r\n<h3 id=\"menu-help\">Menu-Help</h3>\r\n<h2 id=\"メニュー／helpの操作方法-↑\">メニュー／Helpの操作方法　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n<li><strong>Usage of TAT log diver</strong> ボタン：&quot;TAT log diver&quot;の使用方法をサブウィンドウで表示</li>\r\n<li><strong>about TAT log diver</strong> ボタン：&quot;TAT log diver&quot;のコピーライト、関連ＵＲＬをダイアログで表示</li>\r\n</ul>\r\n<hr>\r\n<h2 id=\"simulator\">Simulator</h2>\r\n<h2 id=\"シミュレーションシナリオの仕様-↑\">シミュレーションシナリオの仕様　<a href=\"#\">↑</a></h2>\r\n<h3 id=\"simulator-01\">Simulator-01</h3>\r\n<h2 id=\"サンプル011-hour-with-table-blockの仕様-↑\">サンプル01(1 hour with table block.)の仕様　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n<li>概要</li>\r\n</ul>\r\n<p><strong>数秒のバッチが、通常0.5秒以下の更新系オンのレスポンス遅延を起こす。更新系集中時に滞留増により遅延長時間化</strong></p>\r\n<p>online[100-500ms 2-5tps]：レスポンス100～500ミリ秒のオンライン取引を２～５tpsで発行。16:30～16:36に更新系オン2割増</p>\r\n<p>batch[2-5sec evry3min]：処理時間２～５秒のオン中バッチ取引（DB更新あり）を３分毎に起動</p>\r\n<ul>\r\n<li>詳細</li>\r\n</ul>\r\n<p>{\r\n&quot;log&quot; : 1,</p>\r\n<blockquote>\r\n<p>エラーログのみ出力</p>\r\n<p>　log（任意、デフォルト3）:詳細ログ出力指定(0:なし, 1:エラー時のみ, 2:+ETAT, 3:+push/pop, 4:+HOLD/FREE)</p>\r\n</blockquote>\r\n<p>&quot;start&quot; : &quot;2017/01/02 00:00:00.000&quot;,\r\n&quot;end&quot;   : &quot;17.0*h&quot;,</p>\r\n<blockquote>\r\n<p>2017/01/02 00:00:00.000 を基準、最大17時間後までシミュレーション実行</p>\r\n<p>シミュレーション開始時刻/終了時刻&quot;,</p>\r\n</blockquote>\r\n<p>&quot;resources&quot; : [</p>\r\n<blockquote>\r\n<p>システム構成定義： &quot;type:リソース名、thread:最大同時hold数、timeout：holdタイムアウト時間&quot;、q:最大hold待ち数、qWait:最大hold待ち時間&quot;</p>\r\n</blockquote>\r\n<p>  {&quot;type&quot; :&quot;WEB&quot;, &quot;thread&quot;:1024,&quot;timeout&quot;:&quot;300*sec&quot;, &quot;q&quot;:1280, &quot;qWait&quot;:0},</p>\r\n<blockquote>\r\n<p>WEBサーバ：1024スレッド、タイムアウトエラー：300秒、スレッド溢れ時：即時エラー</p>\r\n</blockquote>\r\n<p>  {&quot;type&quot; :&quot;AP&quot;,  &quot;thread&quot;:20,  &quot;timeout&quot;:&quot;300*sec&quot;, &quot;q&quot;:1280, &quot;qWait&quot;:0},</p>\r\n<blockquote>\r\n<p>APサーバ：20スレッド、タイムアウトエラー：300秒、スレッド溢れ時：即時エラー</p>\r\n</blockquote>\r\n<p>  {&quot;type&quot; :&quot;DB&quot;,  &quot;thread&quot;:10,  &quot;timeout&quot;: &quot;10<em>sec&quot;, &quot;q&quot;:10,  &quot;qWait&quot;:&quot;10</em>sec&quot;}</p>\r\n<blockquote>\r\n<p>DBサーバ：10スレッド、SQL処理タイムアウトエラー：10秒、コネクションプール：10個、コネクション取得待ち：10秒でエラー</p>\r\n</blockquote>\r\n<p>],</p>\r\n<p>&quot;models&quot; : [</p>\r\n<blockquote>\r\n<p> &quot;models:clientsで指定するモデル名(model)の定義、以下modelsで指定できる項目&quot;,</p>\r\n<p> &quot;baseModel:複数リソースのsequenceをまとめて宣言できる、sequenceに展開した後処理される、任意指定&quot;,</p>\r\n<p> &quot;sequence:指定された順にリソースを取得する、配列内に複数指定可、sequenceも複数指定可&quot;,</p>\r\n<p> &quot;hold：リソース名、holds(baseModelのみ指定可）：リソース一覧、各々にtat/tatMinが適用される&quot;,</p>\r\n<p> &quot;tat/tatMin：リソースの取得に要する平均/最小時間、tatMinのデフォルトはtat&quot;,</p>\r\n<p> &quot;　　　　　　★注：tatはリソースの使用時間ではない、リソース使用時間を指定す場合はfreeで指定&quot;,</p>\r\n<p> &quot;数値はミリ秒単位、<em>ms,</em>sec,<em>min,</em>h,*day 指定可&quot;,</p>\r\n<p> &quot;times：繰返し回数&quot;,</p>\r\n<p> &quot;thinkTime/thinkTimeMin：繰返し時の間隔の平均/最小時間、thinkTimeMinのデフォルトはthinkTime&quot;,</p>\r\n<p> &quot;free：[リソース名の配列]、指定リソースを開放する、free指定の無いリソースはシーケンスの最後にfreeされる&quot;,</p>\r\n</blockquote>\r\n<p>  { &quot;ON-1&quot; : {\r\n    &quot;times&quot;: 60, &quot;thinkTimeMin&quot;:&quot;3<em>sec&quot;, &quot;thinkTime&quot;: &quot;10</em>sec&quot;,\r\n    &quot;baseModel&quot;:  {&quot;holds&quot;: [&quot;WEB&quot;,&quot;AP&quot;,&quot;DB&quot;], &quot;tatMin&quot;: &quot;2<em>ms&quot;, &quot;tat&quot;:&quot;5</em>ms&quot;},\r\n    &quot;sequence&quot;: [\r\n      {&quot;tatMin&quot;:30, &quot;tat&quot;:50, &quot;note&quot;:&quot;select A&quot;},\r\n      {&quot;tatMin&quot;:50, &quot;tat&quot;:50, &quot;note&quot;:&quot;updateB&quot;, &quot;hold&quot;:&quot;TBL_B&quot;},\r\n      {&quot;tatMin&quot;:80, &quot;tat&quot;:100,&quot;note&quot;:&quot;updateC&quot;, &quot;hold&quot;:&quot;TBL_C&quot;}\r\n    ]}},</p>\r\n<blockquote>\r\n<p>オンライン取引１(ON-1)：１ユーザあたり3～10秒の取引を60回発行、Web-AP-DBの３層AP、各レイヤ呼出し時に2～5msの通信遅延あり、\r\n　処理内容 30～50ms 参照排他なしSQL　＞　50ms TBL_B排他SQL　＞ 80~100ms TBL_C排他SQL（更新処理を想定）</p>\r\n</blockquote>\r\n<p> { &quot;ON-2&quot; : {\r\n    &quot;times&quot;: 60, &quot;thinkTimeMin&quot;:&quot;500<em>ms&quot;, &quot;thinkTime&quot;: &quot;1</em>sec&quot;,\r\n    &quot;baseModel&quot;:  {&quot;holds&quot;: [&quot;WEB&quot;,&quot;AP&quot;,&quot;DB&quot;], &quot;tatMin&quot;: &quot;2<em>ms&quot;, &quot;tat&quot;:&quot;5</em>ms&quot;},\r\n    &quot;sequence&quot;: [\r\n      {&quot;tatMin&quot;:&quot;100<em>ms&quot;, &quot;tat&quot;:&quot;500</em>ms&quot;, &quot;hold&quot;:&quot;&quot;}\r\n    ]}},</p>\r\n<blockquote>\r\n<p>オンライン取引２(ON-2)：１ユーザあたり500ミリ秒~1秒の取引を60回発行、Web-AP-DBの３層AP、各レイヤ呼出し時に2～5msの通信遅延あり、\r\n　処理内容 100～500ms 排他なし（一覧参照処理を想定）</p>\r\n</blockquote>\r\n<p> { &quot;BATCH-1&quot; : {\r\n    &quot;baseModel&quot;:  {&quot;holds&quot;: [&quot;DB&quot;], &quot;tatMin&quot;: &quot;2<em>ms&quot;, &quot;tat&quot;:&quot;5</em>ms&quot;},\r\n    &quot;sequence&quot;: [\r\n      {&quot;tatMin&quot;:&quot;2<em>sec&quot;,&quot;tat&quot;:&quot;5</em>sec&quot;,&quot;note&quot;:&quot;updateB&quot;,&quot;hold&quot;:&quot;TBL_B&quot;}\r\n    ]}}</p>\r\n<blockquote>\r\n<p>バッチ取引２(BATCH-1)：１ユーザあたり１ジョブ実行、DB更新のみ、各レイヤ呼出し時に2～5msの通信遅延あり、\r\n処理内容 2～5秒 TBL_Bを排他（長時間トランザクションのオン中バッチを想定）</p>\r\n</blockquote>\r\n<p>],</p>\r\n<p>&quot;clients&quot; : [</p>\r\n<blockquote>\r\n<p> &quot;clients：仮想アプリケーションの起動クライアントの定義&quot;,\r\n &quot;num:作成クライアント数、start～endの間で、ランダム（指数分布）に指定回数起動する&quot;,\r\n &quot;start/end:仮想クライアント作成/終了時刻、先頭で宣言したstartからの相対時刻&quot;,\r\n &quot;model:modelsで宣言したモデル名&quot;,\r\n &quot;user:user+通番 のユーザ名で仮想クライアントが作成される&quot;,</p>\r\n</blockquote>\r\n<p>  {&quot;num&quot;:100,&quot;start&quot;:&quot;16.0<em>h&quot;, &quot;end&quot;:&quot;17.0</em>h&quot;, &quot;model&quot;:&quot;ON-1&quot;,  &quot;user&quot; :&quot;userU&quot;, &quot;message&quot;:&quot;select A update B,C&quot;},</p>\r\n<blockquote>\r\n<p>16:00～17:00の 1時間に、userU00～userU99の100ユーザが、各々ON-1（更新系）を100回発行</p>\r\n</blockquote>\r\n<p>  {&quot;num&quot;: 20,&quot;start&quot;:&quot;16.5<em>h&quot;, &quot;end&quot;:&quot;16.6</em>h&quot;, &quot;model&quot;:&quot;ON-1&quot;,  &quot;user&quot; :&quot;userT&quot;, &quot;message&quot;:&quot;select A update B,C 【増】&quot;},</p>\r\n<blockquote>\r\n<p>16:30～16:36 の6分間に、userT00～userT19の20ユーザが、各々ON-1（更新系）を20回発行（一時的に更新オン取引200%増）</p>\r\n</blockquote>\r\n<p>  {&quot;num&quot;:100,&quot;start&quot;:&quot;16.0<em>h&quot;, &quot;end&quot;:&quot;17.0</em>h&quot;, &quot;model&quot;:&quot;ON-2&quot;,  &quot;user&quot; :&quot;userS&quot;, &quot;message&quot;:&quot;排他なし(WEBのみ)&quot;},</p>\r\n<blockquote>\r\n<p>16:00～17:00 の1時間に、userS00～userS99の100ユーザが、各々ON-2（参照系）を100回発行</p>\r\n</blockquote>\r\n<p>  {&quot;num&quot;: 20,&quot;start&quot;:&quot;16.0<em>h&quot;, &quot;end&quot;:&quot;17.0</em>h&quot;, &quot;model&quot;:&quot;BATCH-1&quot;,&quot;user&quot;:&quot;userB&quot;, &quot;message&quot;:&quot;バッチ処理 update B＊＊＊＊＊&quot;}</p>\r\n<blockquote>\r\n<p>16:00～17:00 に、userBが、BATCH-1（更新系）を20回発行</p>\r\n</blockquote>\r\n<p>]\r\n}</p>\r\n<blockquote>\r\n</blockquote>\r\n<h3 id=\"simulator-99\">Simulator-99</h3>\r\n<h2 id=\"サンプル99for-testの仕様-↑\">サンプル99(for test)の仕様　<a href=\"#\">↑</a></h2>\r\n<ul>\r\n<li>概要</li>\r\n</ul>\r\n<p><strong>デッドロックが発生し、タイムアウトで解消</strong></p>\r\n<p>デグレードテスト用シナリオを兼ねる（描画バリエーションの網羅率の高い短いシナリオ）</p>\r\n<ul>\r\n<li>詳細</li>\r\n</ul>\r\n<p>{\r\n&quot;log&quot; : 1,\r\n&quot;start&quot; : &quot;1970/01/02 00:00:00.000&quot;,\r\n&quot;end&quot;   : &quot;30.0*sec&quot;,</p>\r\n<blockquote>\r\n<p>2017/01/02 00:00:00.000 を基準、最大30秒後までシミュレーション実行、エラーログのみ出力</p>\r\n</blockquote>\r\n<p>&quot;resources&quot; : [\r\n  {&quot;type&quot; :&quot;DB&quot;,  &quot;thread&quot;:2,  &quot;timeout&quot;: &quot;5<em>sec&quot;, &quot;q&quot;:1,  &quot;qWait&quot;:&quot;2</em>sec&quot;}\r\n],</p>\r\n<blockquote>\r\n<p>DBサーバ：2スレッド、DBトランザクションタイムアウトエラー：5秒、コネクションプール：1個、コネクション取得待ち：2秒でエラー</p>\r\n</blockquote>\r\n<p>&quot;models&quot; : [\r\n { &quot;TEST-AB&quot; : {\r\n    &quot;baseModel&quot;:  {&quot;holds&quot;: [&quot;DB&quot;], &quot;tatMin&quot;: &quot;2<em>ms&quot;, &quot;tat&quot;:&quot;2</em>ms&quot;},\r\n    &quot;sequence&quot;: [{&quot;hold&quot;:&quot;TBL_A&quot;, &quot;tatMin&quot;:&quot;1<em>sec&quot;, &quot;tat&quot;:&quot;1</em>sec&quot;}],\r\n    &quot;sequence&quot;: [{&quot;hold&quot;:&quot;TBL_B&quot;, &quot;tatMin&quot;:&quot;3<em>sec&quot;, &quot;tat&quot;:&quot;3</em>sec&quot;}],\r\n    &quot;times&quot;: 2, &quot;thinkTimeMin&quot;:&quot;1<em>sec&quot;, &quot;thinkTime&quot;: &quot;1</em>sec&quot;}},</p>\r\n<blockquote>\r\n<p>バッチ取引AB(TEST-AB)：１ユーザあたり１秒毎に２回迄ジョブ起動、DB更新のみ、</p>\r\n<p>処理内容 3.007秒処理（開始 ＞ 1+2ms&gt;DB排他&gt;TBL_A排他 ＞ 1+2ms+３秒&gt;TBL_B排他 ＞ 1ms&gt;排他解放 ＞ 1ms終了）＋1秒＋3.008秒処理</p>\r\n</blockquote>\r\n<p> { &quot;TEST-BA&quot; : {\r\n    &quot;baseModel&quot;:  {&quot;holds&quot;: [&quot;DB&quot;], &quot;tatMin&quot;: &quot;2<em>ms&quot;, &quot;tat&quot;:&quot;2</em>ms&quot;},\r\n    &quot;sequence&quot;: [{&quot;hold&quot;:&quot;TBL_B&quot;, &quot;tatMin&quot;:&quot;1<em>sec&quot;, &quot;tat&quot;:&quot;1</em>sec&quot;}],\r\n    &quot;sequence&quot;: [{&quot;hold&quot;:&quot;TBL_A&quot;, &quot;tatMin&quot;:&quot;3<em>sec&quot;, &quot;tat&quot;:&quot;3</em>sec&quot;}],\r\n    &quot;times&quot;: 2, &quot;thinkTimeMin&quot;:&quot;1<em>sec&quot;, &quot;thinkTime&quot;: &quot;1</em>sec&quot;}}\r\n    ],</p>\r\n<blockquote>\r\n<p>バッチ取引BA(TEST-BA)：１ユーザあたり１秒毎に２回迄ジョブ起動、DB更新のみ、</p>\r\n<p>処理内容 3.007秒処理（開始 ＞ 1+2ms&gt;DB排他&gt;TBL_B排他 ＞ 1+2ms+３秒&gt;TBL_A排他 ＞ 1ms&gt;排他解放 ＞ 1ms終了）＋1秒＋3.008秒処理</p>\r\n</blockquote>\r\n<p>&quot;clients&quot; : [</p>\r\n<blockquote>\r\n</blockquote>\r\n<p>  {&quot;num&quot;: 1,&quot;start&quot;:&quot;0<em>sec&quot;, &quot;end&quot;:&quot;0</em>sec&quot;, &quot;model&quot;:&quot;TEST-AB&quot;,&quot;user&quot; :&quot;testAB1&quot;},</p>\r\n<blockquote>\r\n<p>1回目：0.001秒に、ユーザtestAB10が、TEST-AB起動（排他待ちなし、3.007秒で正常終了:N_000)</p>\r\n<p>2回目：4.007秒に、ユーザtestAB10が、TEST-AB起動（DBコネクションキューオーバフロー、0.001秒で終了:E_QoF）</p>\r\n</blockquote>\r\n<p>  {&quot;num&quot;: 1,&quot;start&quot;:&quot;1<em>sec&quot;, &quot;end&quot;:&quot;1</em>sec&quot;, &quot;model&quot;:&quot;TEST-AB&quot;,&quot;user&quot; :&quot;testAB2&quot;},</p>\r\n<blockquote>\r\n<p>1回目：1.000秒に、ユーザtestAB20が、TEST-AB起動（デッドロック DBトランザクションタイムアウト5.000秒でエラー終了:E_HTO）</p>\r\n<p>2回目：7.000秒に、ユーザtestAB20が、TEST-AB起動（3.007秒で正常終了:N_000）</p>\r\n</blockquote>\r\n<p>  {&quot;num&quot;: 1,&quot;start&quot;:&quot;3<em>sec&quot;, &quot;end&quot;:&quot;3</em>sec&quot;, &quot;model&quot;:&quot;TEST-BA&quot;,&quot;user&quot; :&quot;testBA3&quot;},</p>\r\n<blockquote>\r\n<p>1回目：3.000秒に、ユーザtestBA30が、TEST-BA起動（testAB10のDB解放待ち0.007秒を加えた、3.014秒で正常終了:N_000）</p>\r\n<p>2回目：7.014秒に、ユーザtestBA30が、TEST-BA起動（5.005秒で正常終了:N_000）</p>\r\n</blockquote>\r\n<p>  {&quot;num&quot;: 1,&quot;start&quot;:&quot;4<em>sec&quot;, &quot;end&quot;:&quot;4</em>sec&quot;, &quot;model&quot;:&quot;TEST-BA&quot;,&quot;user&quot; :&quot;testBA4&quot;}</p>\r\n<blockquote>\r\n<p>1回目：4.001秒に、ユーザtestBA40が、TEST-BA起動（5.014秒で正常終了:N_000）</p>\r\n<p>2回目：3.000秒に、ユーザtestBA40が、TEST-BA起動（デッドロック DBトランザクションタイムアウト5.000秒でエラー終了:E_HTO）</p>\r\n</blockquote>\r\n<p> ]\r\n}</p>\r\n<blockquote>\r\n</blockquote>\r\n<p>　<a href=\"#\">go to top ↑</a></p>\r\n</body>\r\n</html>\r\n\r\n'; */";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// tatLogDiver.min.js